/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string; }
  /** Represents a date, ignoring timezone */
  LocalDate: { input: string; output: string; }
  /** Civil date/time in the format yyyy-MM-dd'T'HH:mm:ss.SSS */
  LocalDateTime: { input: string; output: string; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: { input: any; output: any; }
  /**
   * Represents a date and time with explicit timezone information
   * Ex: An RFC-3339 compliant date time scalar that accepts string
   * values like 1996-12-19T16:39:57-08:00
   * See https://github.com/graphql-java/graphql-java-extended-scalars?tab=readme-ov-file#date--time-scalars
   */
  OffsetDateTime: { input: any; output: any; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ActivityDefaultPayload = {
  __typename?: 'ActivityDefaultPayload';
  keywords: Array<Maybe<Scalars['String']['output']>>;
  targetActionCount: Scalars['Int']['output'];
};

export type ActivityLevel = {
  __typename?: 'ActivityLevel';
  /** Factor (numeric multiplier) associated with the Activity level */
  activityLevelFactor: Scalars['Float']['output'];
  /** Current activity level */
  activityLevelName: ActivityLevelName;
};

/** ActivityLevel is an enum of available options for the Activity level */
export enum ActivityLevelName {
  Dynamic = 'DYNAMIC',
  SomewhatActive = 'SOMEWHAT_ACTIVE',
  VeryActive = 'VERY_ACTIVE'
}

/**
 * A single ad selected for a placement.
 * Maps to AdProto in noom_contracts/offers/ads/model/ad.proto.
 */
export type Ad = {
  __typename?: 'Ad';
  /** Unique identifier for this ad. */
  adName: Scalars['String']['output'];
  /** Renderable content for this ad. Null when not set. */
  content?: Maybe<AdContent>;
  /** Stable identifier for the internal offer backing this ad (e.g. product__healthy-weight). */
  offerName: Scalars['String']['output'];
  /** The kind of offer backing this ad. */
  offerType: OfferType;
  /** Recommendation context for attribution. Pass unchanged to impression, click, and dismiss events. Null when not set by the server. */
  recommendationContext?: Maybe<RecommendationContext>;
  /** Destination URL the user is routed to when they engage with this ad. */
  targetUrl: Scalars['String']['output'];
};

/**
 * Generic card content shared across placements.
 * Maps to CardContentProto in noom_contracts/offers/ads/model/ad.proto.
 */
export type AdCardContent = {
  __typename?: 'AdCardContent';
  /** Optional background image rendered behind the entire card. */
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  /** CTA button label. The destination lives on Ad.targetUrl. */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Body copy shown under the title. */
  description: Scalars['String']['output'];
  /** Optional fine-print disclaimer shown on the card. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Optional pill (bordered text with an optional leading icon). */
  pill?: Maybe<AdCardPill>;
  /** Optional product image shown as content within the card. */
  productImageUrl?: Maybe<Scalars['String']['output']>;
  /** Primary heading of the card. */
  title: Scalars['String']['output'];
};

/**
 * Pill shown on an ad card: bordered text with an optional leading icon/image.
 * Maps to CardPillProto in noom_contracts/offers/ads/model/ad.proto.
 */
export type AdCardPill = {
  __typename?: 'AdCardPill';
  /** Optional leading icon/image URL. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Pill text. */
  text: Scalars['String']['output'];
};

/**
 * Design type/variant of cards rendered in a carousel section.
 * Maps to CardVariantEnumProto.Value in noom_contracts/offers/ads/shared.proto.
 */
export enum AdCardVariant {
  /** Ad-style cards. */
  Ad = 'AD',
  /** Product-style cards. */
  Product = 'PRODUCT',
  Unknown = 'UNKNOWN'
}

/**
 * Union of renderable ad content types.
 * Maps to AdProto.content oneof in noom_contracts/offers/ads/model/ad.proto.
 */
export type AdContent = AdCardContent;

export type AddAssessmentReportInput = {
  labs?: InputMaybe<AddLabsAssessmentInput>;
};

export enum AddAssessmentReportPublishStatus {
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN'
}

export type AddAssessmentReportResponse = {
  __typename?: 'AddAssessmentReportResponse';
  /** Lab order context used when EM seeded a simulated lab order. Populated for LABS. */
  labOrderContext?: Maybe<LabOrderContext>;
  /**
   * SUCCESS means all events were published to EM's EDA proxy.
   * This does not guarantee downstream healthcare consumer processing.
   */
  status: AddAssessmentReportPublishStatus;
};

export type AddLabsAssessmentInput = {
  /** Optional base64-encoded PDF for results-ready; placeholder if empty. */
  base64EncodedPdf?: InputMaybe<Scalars['String']['input']>;
  /** Shipping IDs — auto-generated by EM if not provided. */
  inboundShippingId?: InputMaybe<Scalars['String']['input']>;
  kitId?: InputMaybe<Scalars['String']['input']>;
  /** Core identifiers — auto-generated by EM if not provided. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  outboundShippingId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  /** Results metadata. Required for scenarios ending in results-ready. */
  resultInfo: ResultInfoInput;
  /** Biomarker test results. Required for scenarios ending in results-ready. */
  results: Array<TestResultInput>;
  /** Which lifecycle scenario to run. */
  scenario: LabLifecycleScenario;
};

/** Promo shown when the user needs to add a phone number. */
export type AddPhoneNumberPromo = {
  __typename?: 'AddPhoneNumberPromo';
  /** Entry point URL for the add-phone-number flow. */
  url: Scalars['String']['output'];
};

/** A postal address. */
export type Address = {
  __typename?: 'Address';
  /** The first address line, typically street number and street. */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** The second address line, often for an apartment or house number. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** A 2-character country code using ISO 3166-1 alpha-2. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Unique address identifier. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Phone number associated with the address. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The zip code in the U.S. or other postal code. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The recipient name. */
  recipient?: Maybe<Scalars['String']['output']>;
  /** The state, region, or province. */
  zoneCode?: Maybe<Scalars['String']['output']>;
};

/**
 *  These values should be aligned with:
 *  - food/shared.proto (AdjustmentModeProto.Value)
 */
export enum AdjustmentMode {
  Advanced = 'ADVANCED',
  Custom = 'CUSTOM',
  HighProtein = 'HIGH_PROTEIN',
  LowCarb = 'LOW_CARB',
  Optimal = 'OPTIMAL',
  Relaxed = 'RELAXED',
  Standard = 'STANDARD',
  Unknown = 'UNKNOWN'
}

export type AggregatedBloodGlucoseData = {
  __typename?: 'AggregatedBloodGlucoseData';
  /**
   *  Total number of glucose level measurements in
   *  the aggregation (considering duplicates)
   */
  glucoseLevelsCount: Scalars['Int']['output'];
  /**
   *  The most recent glucose level measurement recorded in
   *  the aggregation period
   */
  mostRecentGlucoseData?: Maybe<BloodGlucoseData>;
  /**
   *  Range statistics used in the aggregation to define what is
   *  considered normal
   */
  normalRangeStatistics: AggregatedBloodGlucoseRangeStatisticsData;
  /**
   *  The distinct list of glucose level (in mg/dL) measurements
   *  considered in the aggregation. Only one entry is added for
   *  multiple occurrences of the same glucose level. For example,
   *  in a daily aggregation, if two glucose measurements of '130'
   *  are recorded, only one '130' will be included in the list
   */
  uniqueGlucoseLevelsMgDl: Array<Scalars['Int']['output']>;
};

export type AggregatedBloodGlucoseRangeStatisticsData = {
  __typename?: 'AggregatedBloodGlucoseRangeStatisticsData';
  /**
   *  Total percentage (0-100) of glucose level (in mg/dL)
   *  measurements within the range across the aggregation
   *  period
   */
  percentageInRange: Scalars['Float']['output'];
  /**
   *  The glucose level (in mg/dL) range used to calculate
   *  the percentage
   */
  rangeMgDl: BloodGlucoseRangeData;
};

export type AggregatedLessonsData = {
  __typename?: 'AggregatedLessonsData';
  sumLessonsCompleted: Scalars['Int']['output'];
  sumSecondsRead: Scalars['Int']['output'];
};

export type AggregatedMealData = {
  __typename?: 'AggregatedMealData';
  /**  Fields below are nullable because older meal data may not have this nutrient tracked. */
  sumCalciumMg?: Maybe<Scalars['Float']['output']>;
  sumCalories: Scalars['Float']['output'];
  sumCarbohydrateMg: Scalars['Float']['output'];
  sumDietaryFiberMg: Scalars['Float']['output'];
  sumGreenCalories: Scalars['Float']['output'];
  sumOrangeCalories: Scalars['Float']['output'];
  sumOtherCalories: Scalars['Float']['output'];
  sumPotassiumMg: Scalars['Float']['output'];
  sumProteinMg: Scalars['Float']['output'];
  sumSaturatedFatsMg?: Maybe<Scalars['Float']['output']>;
  sumSodiumMg: Scalars['Float']['output'];
  sumSugarMg?: Maybe<Scalars['Float']['output']>;
  sumTotalFatMg: Scalars['Float']['output'];
  sumYellowCalories: Scalars['Float']['output'];
};

export type AggregatedMeasurementData = {
  __typename?: 'AggregatedMeasurementData';
  aggregatedMeasurementDataOneOf: AggregatedMeasurementDataOneOf;
  beginningTimeOfAggregation: Scalars['LocalDateTime']['output'];
  endTimeOfAggregation: Scalars['LocalDateTime']['output'];
};

export type AggregatedMeasurementDataList = {
  __typename?: 'AggregatedMeasurementDataList';
  aggregatedMeasurements: Array<AggregatedMeasurementData>;
};

export type AggregatedMeasurementDataOneOf = {
  __typename?: 'AggregatedMeasurementDataOneOf';
  aggregatedBloodGlucoseData?: Maybe<AggregatedBloodGlucoseData>;
  aggregatedLessonsData?: Maybe<AggregatedLessonsData>;
  aggregatedMealData?: Maybe<AggregatedMealData>;
  aggregatedMedicationData?: Maybe<AggregatedMedicationsData>;
  aggregatedMoodData?: Maybe<AggregatedMoodData>;
  aggregatedStepsData?: Maybe<AggregatedStepsData>;
  aggregatedWaterData?: Maybe<AggregatedWaterData>;
  aggregatedWeightData?: Maybe<AggregatedWeightData>;
};

export type AggregatedMedicationData = {
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
};

export type AggregatedMedicationGData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationGData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseG: Scalars['Float']['output'];
};

export type AggregatedMedicationMcgData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMcgData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMcg: Scalars['Float']['output'];
};

export type AggregatedMedicationMgData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMgData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMg: Scalars['Float']['output'];
};

export type AggregatedMedicationMlData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMlData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMl: Scalars['Float']['output'];
};

export type AggregatedMedicationPercentData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationPercentData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDosePercent: Scalars['Float']['output'];
};

export type AggregatedMedicationsData = {
  __typename?: 'AggregatedMedicationsData';
  medications: Array<AggregatedMedicationData>;
};

export type AggregatedMoodData = {
  __typename?: 'AggregatedMoodData';
  averageMoodLevel: Scalars['Float']['output'];
};

/** Aggregated measurements of a related user (friend) that might be visible to a caller */
export type AggregatedRelationMeasurements = {
  __typename?: 'AggregatedRelationMeasurements';
  /** Beginning time of the aggregation period */
  beginningTimeOfAggregation: Scalars['LocalDateTime']['output'];
  /** End time of the aggregation period */
  endTimeOfAggregation?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Sum of the green calories logged for a specific period of time */
  sumGreenCalories?: Maybe<Scalars['Float']['output']>;
};

/** Aggregated seeds earned by a related user for a specific date, sourced from the shared rewards aggregate. */
export type AggregatedRelationSeeds = {
  __typename?: 'AggregatedRelationSeeds';
  /** Sum of seeds earned by the related user on the requested date. */
  totalSeeds?: Maybe<Scalars['Int']['output']>;
};

export type AggregatedStepsData = {
  __typename?: 'AggregatedStepsData';
  sumSteps: Scalars['Int']['output'];
};

export type AggregatedWaterData = {
  __typename?: 'AggregatedWaterData';
  sumWaterLiters: Scalars['Float']['output'];
};

export type AggregatedWeightData = {
  __typename?: 'AggregatedWeightData';
  averageWeightLevel: Scalars['Float']['output'];
};

/** AI generated insight based on user activity. */
export type AiInsight = {
  __typename?: 'AiInsight';
  /** Suggested quick replies. */
  actions: Array<InsightCallToAction>;
  /** CTA header */
  ctaHeader?: Maybe<Scalars['String']['output']>;
  /** The user feedback for the insight */
  feedback?: Maybe<InsightFeedback>;
  /** Unique ID of the insight. */
  id: Scalars['ID']['output'];
  /** Text message that contains the main insight. If null, that means nothing was generated by ML. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Subtitle to show to the user for the insight */
  insightSubtitle: Scalars['String']['output'];
  /** Title to show to the user for the insight */
  insightTitle: Scalars['String']['output'];
  /** Welli profile image URL. Excluding Welli from the name on purpose since the name is changeable. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

/** Edible information */
export type AiMealIdentificationEdible = {
  __typename?: 'AiMealIdentificationEdible';
  /** Name of the edible (e.g. 'Apple', 'Mom's Apple Pie') */
  name: Scalars['String']['output'];
  /** Unique identifier of an edible in the food database */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Edible information for input */
export type AiMealIdentificationEdibleInput = {
  /** Name of the edible (e.g. 'Apple', 'Mom's Apple Pie') */
  name: Scalars['String']['input'];
  /** Unique identifier of an edible in the food database */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Edible with portion information */
export type AiMealIdentificationEdibleWithPortion = {
  __typename?: 'AiMealIdentificationEdibleWithPortion';
  /** Edible information */
  edible: AiMealIdentificationEdible;
  /** Portion information */
  portion: AiMealIdentificationPortion;
};

/** Error codes for AI meal identification */
export enum AiMealIdentificationErrorCode {
  /** Content guardrail was activated */
  GuardrailActivated = 'GUARDRAIL_ACTIVATED',
  /** No food was detected in the input */
  NoFoodDetected = 'NO_FOOD_DETECTED',
  /** The meal description contains more food items than can be processed */
  TooManyFoodItems = 'TOO_MANY_FOOD_ITEMS',
  /** Unknown error */
  Unknown = 'UNKNOWN'
}

/** Error details for AI meal identification */
export type AiMealIdentificationErrorDetails = {
  __typename?: 'AiMealIdentificationErrorDetails';
  /** The error code */
  errorCode: AiMealIdentificationErrorCode;
  /** The error message */
  errorMessage: Scalars['String']['output'];
};

/**
 * Input for AI Meal Identification request body.
 * Either s3Key or mealLogText must be provided, but not both.
 */
export type AiMealIdentificationInput = {
  /** The text of the meal log in natural language (for textual meal identification) */
  mealLogText?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the meal logging session */
  mealLoggingSessionId: Scalars['String']['input'];
  /** The S3 key identifying the meal log image (for photo meal identification) */
  s3Key?: InputMaybe<Scalars['String']['input']>;
  /** Context about the user */
  userContext: AiMealIdentificationUserContextInput;
};

/** Meal identification item with primary edible and alternatives */
export type AiMealIdentificationItem = {
  __typename?: 'AiMealIdentificationItem';
  /** Alternative edible items */
  alternativeItems: Array<AiMealIdentificationEdibleWithPortion>;
  /** The main edible item logged in a meal */
  primaryItem: AiMealIdentificationEdibleWithPortion;
};

/** Locale information for AI meal identification */
export type AiMealIdentificationLocaleInput = {
  /** ISO 3166 alpha-2 country code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** ISO 639 alpha-2 or alpha-3 language code */
  language: Scalars['String']['input'];
};

/** Portion with unit and quantity */
export type AiMealIdentificationPortion = {
  __typename?: 'AiMealIdentificationPortion';
  /** Unit quantity (e.g. 0.75) */
  quantity: Scalars['Float']['output'];
  /** Total calories in the portion */
  totalCalories?: Maybe<Scalars['Float']['output']>;
  /** Unit name (e.g. '1 cup') */
  unitName: Scalars['String']['output'];
};

/** Response for AI Meal Identification */
export type AiMealIdentificationResponse = {
  __typename?: 'AiMealIdentificationResponse';
  /** Error details if the request failed */
  error?: Maybe<AiMealIdentificationErrorDetails>;
  /** The meal identification items generated by the model */
  mealIdentificationItems: Array<AiMealIdentificationItem>;
  /** Request ID for tracing and event joining */
  requestId: Scalars['String']['output'];
};

/** User context for AI meal identification */
export type AiMealIdentificationUserContextInput = {
  /** User's custom dishes */
  customDishes: Array<AiMealIdentificationEdibleInput>;
  /** User's custom foods */
  customFoods: Array<AiMealIdentificationEdibleInput>;
  /** User's version of the food database */
  foodDbVersion?: InputMaybe<Scalars['String']['input']>;
  /** User's frequently logged food items */
  frequentlyLoggedFoodItems: Array<AiMealIdentificationEdibleInput>;
  /** User's locale */
  locale?: InputMaybe<AiMealIdentificationLocaleInput>;
};

/** AI generated meal insight based on a user's meal log. */
export type AiMealInsight = {
  __typename?: 'AiMealInsight';
  /** Suggested quick replies. */
  actions: Array<InsightCallToAction>;
  /** CTA header */
  ctaHeader?: Maybe<Scalars['String']['output']>;
  /** The user feedback for the insight */
  feedback?: Maybe<InsightFeedback>;
  /** Unique ID of the meal insight. */
  id: Scalars['ID']['output'];
  /** Text message that contains an insight into the meal. If null, that means nothing was generated. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Subtitle to show to the user for the insight */
  insightSubtitle: Scalars['String']['output'];
  /** Title to show to the user for the insight */
  insightTitle: Scalars['String']['output'];
  /** Welli profile image URL. Excluding Welli from the name on purpose since the name is changeable. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type AiacConfigForUser = {
  __typename?: 'AiacConfigForUser';
  isAiacAvailable?: Maybe<Scalars['Boolean']['output']>;
};

/** Name value pair that marks an analytics property and it's value, to be used in an analytics properties list */
export type AnalyticsProperty = {
  __typename?: 'AnalyticsProperty';
  /** Analytics property name */
  name: Scalars['String']['output'];
  /** Analytics property value */
  value: Scalars['String']['output'];
};

export type AnnotatedMeasurementTrendChart = {
  __typename?: 'AnnotatedMeasurementTrendChart';
  entries: Array<TrendChartEntry>;
  xAxis: LocalDateTimeRange;
  yAxis: FloatRange;
};

/** A prescribed anti-obesity medication for a user */
export type AntiObesityMedication = {
  __typename?: 'AntiObesityMedication';
  /** Human-readable name of the medication */
  displayName: Scalars['String']['output'];
};

/** Response containing the user's prescribed anti-obesity medications */
export type AntiObesityMedicationList = {
  __typename?: 'AntiObesityMedicationList';
  /** The list of anti-obesity medications */
  medications: Array<AntiObesityMedication>;
};

export type AnuraConfiguration = {
  __typename?: 'AnuraConfiguration';
  /** UUID generated to be used as an identifier for a user in Anura */
  partnerId: Scalars['UUID']['output'];
  /** Study identifier, study is a set of measurements to be taken for specific scan */
  studyId: Scalars['String']['output'];
};

export enum AnuraGender {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE'
}

export type AnuraMeasurement = {
  /** Any notes provided by Anura for a specific measurements */
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of the Anura signal (specific measurement) */
  type: AnuraMeasurementType;
  /** The value of the measurement */
  value: Scalars['String']['input'];
  /** Optional array of measurement values */
  valuesArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnuraMeasurementError = {
  /** Error code from Anura */
  code: Scalars['String']['input'];
  /** Map of errors happened during scan processing */
  errors?: InputMaybe<Array<AnuraMeasurementErrorEntry>>;
};

export type AnuraMeasurementErrorEntry = {
  /** Error messages for a specific signal */
  errors: Array<Scalars['String']['input']>;
  /** Signal type name */
  type: AnuraMeasurementType;
};

export enum AnuraMeasurementType {
  /** Body shape index */
  Absi = 'ABSI',
  /** Skin age in years */
  Age = 'AGE',
  /** Body Mass Index */
  BmiCalc = 'BMI_CALC',
  /** Cardiovascular Disease Risk */
  BpCvd = 'BP_CVD',
  /** Diastolic blood pressure */
  BpDiastolic = 'BP_DIASTOLIC',
  /** Risk of heart attack */
  BpHeartAttack = 'BP_HEART_ATTACK',
  /** Cardiac workload */
  BpRpp = 'BP_RPP',
  /** Risk of stroke */
  BpStroke = 'BP_STROKE',
  /** Systolic blood pressure */
  BpSystolic = 'BP_SYSTOLIC',
  /** Vascular elasticity */
  BpTau = 'BP_TAU',
  /** Breathing rate */
  BrBpm = 'BR_BPM',
  /** Risk of type 2 diabetes */
  DbtRiskProb = 'DBT_RISK_PROB',
  /** Facial body age */
  FacialBodyAge = 'FACIAL_BODY_AGE',
  /** Facial body age index */
  FacialBodyAgeIdx = 'FACIAL_BODY_AGE_IDX',
  /** Risk of fatty liver disease */
  FldRiskProb = 'FLD_RISK_PROB',
  /** Estimated gender */
  Gender = 'GENDER',
  /** Risk of prediabetes */
  Hba1CRiskProb = 'HBA1C_RISK_PROB',
  /** Risk of high cholesterol */
  HdltcRiskProb = 'HDLTC_RISK_PROB',
  /** General Wellness Score */
  HealthScore = 'HEALTH_SCORE',
  /** Estimated height */
  Height = 'HEIGHT',
  /** Risk of high blood pressure */
  HptRiskProb = 'HPT_RISK_PROB',
  /** Heart rate variability */
  HrvSdnn = 'HRV_SDNN',
  /** Heart rate */
  HrBpm = 'HR_BPM',
  /** Irregular heartbeats */
  IhbCount = 'IHB_COUNT',
  /** Mental score */
  MentalScore = 'MENTAL_SCORE',
  /** Fasting blood glucose risk */
  MfbgRiskProb = 'MFBG_RISK_PROB',
  /** Mental stress level */
  Msi = 'MSI',
  /** Overall Metabolic Health Risk */
  OverallMetabolicRiskProb = 'OVERALL_METABOLIC_RISK_PROB',
  /** Physical score */
  PhysicalScore = 'PHYSICAL_SCORE',
  /** Physio score */
  PhysioScore = 'PHYSIO_SCORE',
  /** Risks score */
  RisksScore = 'RISKS_SCORE',
  /** Signal-to-noise ratio */
  Snr = 'SNR',
  /** Risk of high triglycerides */
  TgRiskProb = 'TG_RISK_PROB',
  /** Vital score */
  VitalScore = 'VITAL_SCORE',
  /** Waist circumference */
  WaistCircum = 'WAIST_CIRCUM',
  /** Waist-to-height ratio */
  WaistToHeight = 'WAIST_TO_HEIGHT',
  /** Estimated weight */
  Weight = 'WEIGHT'
}

export type AnuraQuestionnaire = FacialBloodScanQuestionnaire & {
  __typename?: 'AnuraQuestionnaire';
  /** User's age in years */
  age: Scalars['Int']['output'];
  /** Whether the user takes blood pressure medication */
  bloodPressureMedication: Scalars['Boolean']['output'];
  /** User's diabetes type (none, type 1, type 2) */
  diabetesType: AnuraQuestionnaireDiabetesType;
  /** User's sex assigned at birth (from the buyflow) */
  gender: AnuraGender;
  /** User's height value */
  heightInCm: Scalars['Float']['output'];
  /** Server time of when the questionnaire has been saved */
  serverTimeCreated: Scalars['LocalDateTime']['output'];
  /** Whether the user smokes */
  smoking: Scalars['Boolean']['output'];
  /** User's weight value */
  weightInKg: Scalars['Float']['output'];
};

export enum AnuraQuestionnaireDiabetesType {
  /** No diabetes */
  None = 'NONE',
  /** Diabetes of type 1 */
  Type_1 = 'TYPE_1',
  /** Diabetes of type 2 */
  Type_2 = 'TYPE_2'
}

export type AnuraQuestionnaireInput = {
  /** User's date of birth */
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Whether the user takes blood pressure medication */
  bloodPressureMedication: Scalars['Boolean']['input'];
  /** User's diabetes type (none, type 1, type 2) */
  diabetesType: AnuraQuestionnaireDiabetesType;
  /** User's height value */
  heightInCm?: InputMaybe<Scalars['Float']['input']>;
  /**
   * User's sex assigned at birth (from the buyflow). It is mapped to the AnuraGender,
   * named so to be in line with the Anura property name.
   * On Anura side the measurements will be relevant only if we specify MALE or FEMALE sex,
   * so other values are not valid for initiating a scan.
   */
  sexAssignedAtBirth: Sex;
  /** Whether the user smokes */
  smoking: Scalars['Boolean']['input'];
  /** User's weight value */
  weightInKg?: InputMaybe<Scalars['Float']['input']>;
};

export type AnuraTokenInput = {
  /** Mobile application name */
  appName: Scalars['String']['input'];
  /** Mobile application version */
  appVersion: Scalars['String']['input'];
  /** Bundle identifier (e.g. DFX Client) */
  bundleIdentifier: Scalars['String']['input'];
  /** Client platform */
  platform: TargetPlatform;
};

/** Represents an API key. */
export type ApiKey = {
  __typename?: 'ApiKey';
  /** The expiration date and time of the API key. */
  expirationDate: Scalars['DateTime']['output'];
  /** The value of the API key. */
  key: Scalars['String']['output'];
  /** The type of API key. */
  keyType: ApiKeyType;
};

/** Enum representing the different types of API keys. */
export enum ApiKeyType {
  /** The API key is for the Claude API. */
  ClaudeApiKey = 'CLAUDE_API_KEY',
  /** The API key is for the OpenAI API. */
  OpenaiApiKey = 'OPENAI_API_KEY'
}

/**
 * Input for applying a diff overlay on a baseline. Typically at least one baseline source
 * (flow uuid or inline baseline JSON) is required; the server validates.
 */
export type ApplyNoomFlowDiffInput = {
  /** Inline baseline configuration as JSON text. */
  flowAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Baseline from this persisted flow instance. */
  flowUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Diff overlay to apply on the baseline, as JSON text. */
  variationFlowDiffAsJsonString: Scalars['String']['input'];
};

/** Art Break content for creative mindfulness tasks. */
export type ArtBreaksContent = {
  __typename?: 'ArtBreaksContent';
  /** Text to overlay on top of the hero image, e.g. 'Mountain majesty' */
  galleryTitle?: Maybe<Scalars['String']['output']>;
  /** Cover image URL for the art break UI */
  primaryImageUrl?: Maybe<Scalars['String']['output']>;
  /** Image URL for completion state */
  secondaryImageUrl?: Maybe<Scalars['String']['output']>;
};

/** An art gallery that groups a set of curated art pieces and supporting metadata. */
export type ArtGallery = {
  __typename?: 'ArtGallery';
  /** The list of art pieces that belong to this gallery */
  artPieces?: Maybe<Array<ArtPiece>>;
  /** URL to background music for the gallery experience */
  backgroundMusicUrl?: Maybe<Scalars['String']['output']>;
  /** URL to the cover photo for the gallery (larger image used for the gallery cover) */
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the art gallery */
  id: Scalars['ID']['output'];
  /** Reflection question associated with the gallery */
  reflectionQuestion?: Maybe<Scalars['String']['output']>;
  /** URL to the thumbnail image for the gallery (cropped smaller image for task cards) */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the art gallery */
  title?: Maybe<Scalars['String']['output']>;
};

/** Art gallery content implementation */
export type ArtGalleryContent = SchedulableContent & {
  __typename?: 'ArtGalleryContent';
  /** Unique identifier for the art gallery */
  id: Scalars['ID']['output'];
  /** URL or path to the art gallery thumbnail */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the art gallery */
  title: Scalars['String']['output'];
};

/** An individual art piece within a gallery. */
export type ArtPiece = {
  __typename?: 'ArtPiece';
  /** Names of the artists who created this piece */
  artistNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the art piece */
  description?: Maybe<Scalars['String']['output']>;
  /** Display time period for the art piece (e.g. "early 17th century") */
  displayTimePeriod?: Maybe<Scalars['String']['output']>;
  /** Location hosting the art */
  hostedAt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the art piece */
  id: Scalars['ID']['output'];
  /** URL to the image of the art piece */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Medium/type of the artwork */
  medium?: Maybe<ArtPieceMedium>;
  /** Title of the art piece */
  title?: Maybe<Scalars['String']['output']>;
  /** Year the art piece was created */
  yearCreated?: Maybe<Scalars['Int']['output']>;
};

/** Response containing the presigned URL for uploading an art piece image. */
export type ArtPieceImageUploadUrlResponse = {
  __typename?: 'ArtPieceImageUploadUrlResponse';
  /** Time in seconds until the URL expires. */
  expiresIn: Scalars['Int']['output'];
  /** The presigned URL for uploading the image via HTTP PUT. */
  uploadUrl: Scalars['String']['output'];
};

/** Medium/type of the artwork. */
export enum ArtPieceMedium {
  Ceramic = 'CERAMIC',
  Digital = 'DIGITAL',
  Drawing = 'DRAWING',
  Installation = 'INSTALLATION',
  MixedMedia = 'MIXED_MEDIA',
  Painting = 'PAINTING',
  Performance = 'PERFORMANCE',
  Photography = 'PHOTOGRAPHY',
  Print = 'PRINT',
  Sculpture = 'SCULPTURE',
  Textile = 'TEXTILE',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export type ArticleAssignment = {
  __typename?: 'ArticleAssignment';
  articleDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  articleTriggers: Array<Maybe<ArticleTrigger>>;
  audioResource?: Maybe<AudioResource>;
  contentId: Scalars['String']['output'];
  contentUrl: Scalars['String']['output'];
  feedbackText: Scalars['String']['output'];
  hideMenuButton?: Maybe<Scalars['Boolean']['output']>;
  moduleId?: Maybe<Scalars['String']['output']>;
  repeatable?: Maybe<Scalars['Boolean']['output']>;
  targetPlatform?: Maybe<TargetPlatform>;
  title: Scalars['String']['output'];
  titleCompleted?: Maybe<Scalars['String']['output']>;
};

export enum ArticleTrigger {
  Autoopen = 'AUTOOPEN',
  BrainDump = 'BRAIN_DUMP',
  ColorSystem = 'COLOR_SYSTEM',
  CreatePositiveExperiences = 'CREATE_POSITIVE_EXPERIENCES',
  CreateSpace = 'CREATE_SPACE',
  DefuseThoughts = 'DEFUSE_THOUGHTS',
  FeelFeelings = 'FEEL_FEELINGS',
  FreeFeelings = 'FREE_FEELINGS',
  Gametime = 'GAMETIME',
  GenerateTasks = 'GENERATE_TASKS',
  GetGrounded = 'GET_GROUNDED',
  GratitudeRemix = 'GRATITUDE_REMIX',
  GuidedBreathing = 'GUIDED_BREATHING',
  HideFromCurriculum = 'HIDE_FROM_CURRICULUM',
  Intro = 'INTRO',
  MeetYourGroup = 'MEET_YOUR_GROUP',
  Move = 'MOVE',
  NoomCoinIntro = 'NOOM_COIN_INTRO',
  Practice = 'PRACTICE',
  PromptToContinueOrStop = 'PROMPT_TO_CONTINUE_OR_STOP',
  Reframe = 'REFRAME',
  RefreshProgramProgress = 'REFRESH_PROGRAM_PROGRESS',
  Retro = 'RETRO',
  RideWaves = 'RIDE_WAVES',
  SelfCompassionBreak = 'SELF_COMPASSION_BREAK',
  SetUp = 'SET_UP',
  SharpenToolkit = 'SHARPEN_TOOLKIT',
  ShowInMyLibrary = 'SHOW_IN_MY_LIBRARY',
  Sleep = 'SLEEP',
  Soothe = 'SOOTHE',
  Tool = 'TOOL',
  UnlockFoodLogging = 'UNLOCK_FOOD_LOGGING',
  WaterGoal = 'WATER_GOAL',
  WaterLoggingIntro = 'WATER_LOGGING_INTRO',
  WeightLossZoneIntro = 'WEIGHT_LOSS_ZONE_INTRO',
  WeighIn = 'WEIGH_IN',
  Welcome = 'WELCOME'
}

export type Assessment = {
  __typename?: 'Assessment';
  /** Date and time of the assessment, used for displaying the assessment time in the health report. */
  assessmentDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  assessmentId?: Maybe<Scalars['String']['output']>;
  assessmentType?: Maybe<HealthMetricSource>;
  /** Whether this assessment's report has been viewed by the user. */
  hasReportBeenViewed?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Generic admin assessment report metadata container.
 * At the moment, only labs metadata is supported.
 */
export type AssessmentReportMetadata = {
  __typename?: 'AssessmentReportMetadata';
  metadata: AssessmentReportMetadataVariant;
};

/** List of metadata-level assessment reports for admin tooling. */
export type AssessmentReportMetadataList = {
  __typename?: 'AssessmentReportMetadataList';
  assessmentReports: Array<AssessmentReportMetadata>;
};

export type AssessmentReportMetadataVariant = PatientDiagnosticReportMetadata;

/** Represents a list of asset registry entries with pagination. */
export type AssetRegistryEntries = Pageable & {
  __typename?: 'AssetRegistryEntries';
  /** The list of asset registry entries. */
  entries: Array<AssetRegistryEntry>;
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for getting asset registry entries. */
export type AssetRegistryEntriesFilterInput = {
  /** The creator of the asset. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The configuration for paginating the filtered results. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** The filename to filter by. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** The MIME type of the asset (partial search). */
  mimeTypeLike?: InputMaybe<Scalars['String']['input']>;
  /** The path of the asset. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** A search string to filter results (e.g., filename, path). */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /**
   * The status of the asset registry entry.
   * If not set, no status filtering will be applied.
   */
  status?: InputMaybe<AssetRegistryStatus>;
  /**
   * The type of the asset (e.g. image vs agent artifact).
   * If not set, no type filtering will be applied.
   */
  type?: InputMaybe<AssetRegistryType>;
  /** The uuid of the asset registry entry to retrieve. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents an asset registry entry. */
export type AssetRegistryEntry = {
  __typename?: 'AssetRegistryEntry';
  /** The size of the asset in bytes. */
  byteSize?: Maybe<Scalars['Int']['output']>;
  /** When the asset was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the asset. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** When the asset was soft-deleted (null if not deleted). */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description of the asset that is manually entered by the user. */
  description?: Maybe<Scalars['String']['output']>;
  /** The filename of the asset. */
  filename: Scalars['String']['output'];
  /** A JSON string representing the metadata of the asset. */
  metadataAsJsonString?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the asset. */
  mimeType: Scalars['String']['output'];
  /** The storage path of the asset. */
  path: Scalars['String']['output'];
  /** The public URL for accessing the asset. */
  publicUrl: Scalars['String']['output'];
  /** The status of the asset. */
  status: AssetRegistryStatus;
  /** The storage bucket (empty means default bucket). */
  storageBucket?: Maybe<Scalars['String']['output']>;
  /** The type of the asset (e.g. image vs agent artifact for UI filtering). */
  type: AssetRegistryType;
  /** When the asset was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The unique identifier for the asset. */
  uuid: Scalars['UUID']['output'];
};

/** Status of an asset registry entry. */
export enum AssetRegistryStatus {
  /** Asset has been approved. */
  Approved = 'APPROVED',
  /** Asset has been disabled. */
  Disabled = 'DISABLED',
  /** Asset is waiting for approval. */
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

/** Type of an asset registry entry (e.g. image vs agent artifact for UI filtering). */
export enum AssetRegistryType {
  /** Agent-generated artifact (may be suppressed in the asset registry UI). */
  AgentArtifact = 'AGENT_ARTIFACT',
  /** Image asset shown in the asset registry UI. */
  Image = 'IMAGE'
}

export type Assignment = ArticleAssignment | ContentSectionAssignment | StandaloneContentSectionAssignment | TrackerAssignment;

/**
 * Attribution data is used by any action with an external source. This data
 * model is a contracted version of the Attribution Data model in CoachServer,
 * with the difference being that here, we use a one-of to model polymorphism,
 * while there, a special `type` field is used.
 *
 * IMPORTANT: When adding new attribution sources or fields, also update
 * AttributionDataMatchInput to keep both types in sync.
 */
export type AttributionDataInput = {
  bodyTrace?: InputMaybe<BodyTraceAttributionDataInput>;
  googleFit?: InputMaybe<GoogleFitAttributionDataInput>;
  healthConnect?: InputMaybe<HealthConnectAttributionDataInput>;
  healthKit?: InputMaybe<HealthKitAttributionDataInput>;
  noom?: InputMaybe<NoomAppAttributionDataInput>;
  prismBodyScan?: InputMaybe<PrismBodyScanAttributionDataInput>;
  sHealth?: InputMaybe<SHealthAttributionDataInput>;
  typedAttribution?: InputMaybe<TypedAttributionDataInput>;
  validic?: InputMaybe<ValidicAttributionDataInput>;
  validicV2?: InputMaybe<ValidicV2AttributionDataInput>;
};

/**
 * Attribution data for matching measurements. All fields are optional.
 * Only the attribution source type needs to be specified; unspecified fields match any value.
 * To match any measurement from a source, provide the attribution type with empty/null fields.
 *
 * This is a variant of AttributionDataInput with all fields optional for matching purposes.
 * Keep this type in sync with AttributionDataInput when adding new attribution sources.
 */
export type AttributionDataMatchInput = {
  bodyTrace?: InputMaybe<BodyTraceAttributionDataMatchInput>;
  googleFit?: InputMaybe<GoogleFitAttributionDataMatchInput>;
  healthConnect?: InputMaybe<HealthConnectAttributionDataMatchInput>;
  healthKit?: InputMaybe<HealthKitAttributionDataMatchInput>;
  noom?: InputMaybe<NoomAppAttributionDataMatchInput>;
  prismBodyScan?: InputMaybe<PrismBodyScanAttributionDataMatchInput>;
  sHealth?: InputMaybe<SHealthAttributionDataMatchInput>;
  typedAttribution?: InputMaybe<TypedAttributionDataMatchInput>;
  validic?: InputMaybe<ValidicAttributionDataMatchInput>;
  validicV2?: InputMaybe<ValidicV2AttributionDataMatchInput>;
};

export type AudioResource = {
  __typename?: 'AudioResource';
  url: Scalars['String']['output'];
};

/**  Address structure for autocomplete address responses  */
export type AutocompleteAddress = {
  __typename?: 'AutocompleteAddress';
  /** The first address line, typically street number and street. */
  addressLine1: Scalars['String']['output'];
  /** The second address line, often for an apartment or house number. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city or town */
  city: Scalars['String']['output'];
  /** A 2-character country code using ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['output'];
  /** The county for the address. Only populated for international addresses. */
  county?: Maybe<Scalars['String']['output']>;
  /** A full address concatenated and formatted as a single string. */
  fullAddress: Scalars['String']['output'];
  /** The full state, region or province (e.g. Illinois, Virginia, Connecticut) */
  fullZoneCode: Scalars['String']['output'];
  /** The zip code in the U.S. or other postal code */
  postalCode: Scalars['String']['output'];
  /** The state, region, or province. Abbreviated version (e.g. IL, VA, CT) */
  zoneCode: Scalars['String']['output'];
};

/** The response from an address autocomplete request. */
export type AutocompleteAddressResponse = {
  __typename?: 'AutocompleteAddressResponse';
  /** List of address suggestions. */
  addresses: Array<AutocompleteAddress>;
  /** The autocomplete service that was used for this request. */
  autocompleteService: AutocompleteService;
};

/** The external service used to perform the autocomplete. */
export enum AutocompleteService {
  /**
   * Legacy address autocomplete service.
   * https://www.here.com/docs/bundle/geocoding-and-search-api-developer-guide/page/README.html
   */
  HereGeocode = 'HERE_GEOCODE',
  /** https://www.smarty.com/docs/cloud/us-autocomplete-pro-api */
  SmartyUsAutocomplete = 'SMARTY_US_AUTOCOMPLETE'
}

export type AvailableTargetsResponse = {
  __typename?: 'AvailableTargetsResponse';
  /** List of available target values for the goal */
  availableTargets: Array<GoalMetadata>;
  /** Current goal metadata */
  currentGoal: GoalMetadata;
};

export type BatchMeasurementData = {
  __typename?: 'BatchMeasurementData';
  measurement: MeasurementDataOneOf;
  operation: BatchMeasurementOperation;
};

export type BatchMeasurementDataInput = {
  measurement: MeasurementDataInput;
  operation: BatchMeasurementOperation;
};

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum BatchMeasurementOperation {
  Delete = 'DELETE',
  Unknown = 'UNKNOWN',
  Upsert = 'UPSERT'
}

export type BatchMeasurementsData = {
  __typename?: 'BatchMeasurementsData';
  measurements: Array<BatchMeasurementData>;
};

export type BatchMeasurementsDataInput = {
  operations: Array<BatchMeasurementDataInput>;
};

/** Determines how the switch affects the user's billing date */
export enum BillingCycleBehavior {
  /** The user will immediately start a full billing cycle of their new plan (default) */
  StartNew = 'START_NEW',
  UnspecifiedBillingCycleBehavior = 'UNSPECIFIED_BILLING_CYCLE_BEHAVIOR'
}

/** Payload added to Biomarkers Tracker Assignments */
export type BiomarkersTrackerPayload = {
  __typename?: 'BiomarkersTrackerPayload';
  /** The date when the user's blood sample was collected */
  collectionDate: Scalars['LocalDate']['output'];
  /** The full URL of the health report */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** Has the user viewed the health report */
  reportViewed: Scalars['Boolean']['output'];
};

/**
 * Overview data broken down by day. Includes a distinct list of blood
 * glucose level readings (in mg/dL) for a specific day and the range
 * statistics used to calculate the percentage of blood glucose readings
 * within the normal range for that day
 */
export type BloodGlucoseDailyBreakdownData = {
  __typename?: 'BloodGlucoseDailyBreakdownData';
  /** The date to which this breakdown of overview data refers */
  breakdownDay: Scalars['LocalDate']['output'];
  /**
   * Statistics data used to define the percentage of blood glucose
   * level (in mg/dL) readings that fall within a range considered normal
   */
  normalRangeStatistics: BloodGlucoseRangeStatisticsData;
  /**
   * The distinct list of blood glucose level readings (in mg/dL). Only one
   * entry is added for multiple occurrences of the same blood glucose level.
   * For example, if two glucose measurements of '130' were recorded on a day,
   * only one '130' will be included in this list
   */
  uniqueGlucoseLevelsMgDl: Array<Scalars['Int']['output']>;
};

export type BloodGlucoseData = {
  __typename?: 'BloodGlucoseData';
  /**  Glucose level in mg/dL which is a numerical value between 0-800 */
  glucoseLevelMgDl: Scalars['Int']['output'];
  /**  Meal context when blood glucose measurement was taken */
  mealContext: MealContext;
  /**  date_time when blood glucose measurement was taken */
  measurementCivilDateTime: Scalars['LocalDateTime']['output'];
};

export type BloodGlucoseDataInput = {
  /**  Glucose level in mg/dL which is a numerical value between 0-800 */
  glucoseLevelMgDl: Scalars['Int']['input'];
  /**  Meal context when blood glucose measurement was taken */
  mealContext: MealContext;
  /**  date_time when blood glucose measurement was taken */
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
};

/**
 * The overview of a user's blood glucose data for a specified time period,
 * starting from a given date
 */
export type BloodGlucoseOverviewData = {
  __typename?: 'BloodGlucoseOverviewData';
  /**
   * A list of all blood glucose level readings (in mg/dL) along with their
   * respective measurement times for the specified period
   */
  completeGlucoseReadings?: Maybe<Array<Maybe<BloodGlucoseReadingData>>>;
  /**
   * Overview data broken down by day. Includes a distinct list of blood
   * glucose level readings (in mg/dL) for a specific day and the range
   * statistics used to calculate the percentage of blood glucose readings
   * within the normal range for that day
   */
  dailyBreakdown?: Maybe<Array<Maybe<BloodGlucoseDailyBreakdownData>>>;
  /** The end date for the period considered for the overview data */
  endDate: Scalars['LocalDate']['output'];
  /**
   * Statistics data used to define the percentage of blood glucose
   * level (in mg/dL) readings that fall within a range considered normal
   */
  normalRangeStatistics?: Maybe<BloodGlucoseRangeStatisticsData>;
  /** The period considered for the overview data */
  period: BloodGlucoseOverviewPeriod;
  /** The start date for the period considered for the overview data */
  startDate: Scalars['LocalDate']['output'];
};

/**
 * The possible periods that can be considered for the blood
 * glucose overview data
 */
export enum BloodGlucoseOverviewPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type BloodGlucoseRangeData = {
  __typename?: 'BloodGlucoseRangeData';
  /**  Lower bound of the range (inclusive) */
  lower: Scalars['Int']['output'];
  /**  Upper bound of the range (inclusive) */
  upper: Scalars['Int']['output'];
};

/**
 * Statistics data used to define the percentage of blood glucose
 * level (in mg/dL) readings that fall within a range considered normal
 */
export type BloodGlucoseRangeStatisticsData = {
  __typename?: 'BloodGlucoseRangeStatisticsData';
  /**
   * Total number of glucose measurements within the range
   * (optional for backwards compatibility)
   */
  countInRange?: Maybe<Scalars['Int']['output']>;
  /**
   * Total percentage (0-100) of glucose level (in mg/dL) measurements within
   * the range
   */
  percentageInRange: Scalars['Float']['output'];
  /** The glucose level (in mg/dL) range used to calculate the percentage */
  rangeMgDl: BloodGlucoseRangeData;
  /**
   * Total number of glucose measurements considered for the statistics
   * (optional for backwards compatibility)
   */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Blood glucose reading data */
export type BloodGlucoseReading = {
  __typename?: 'BloodGlucoseReading';
  /** Glucose level in mg/dL (numerical value between 0-800) */
  glucoseLevelMgDl: Scalars['Int']['output'];
  /** Indicates whether the reading is within the acceptable range */
  isInRange: Scalars['Boolean']['output'];
  /** Date and time when blood glucose reading was recorded */
  measurementDateTime: Scalars['LocalDateTime']['output'];
};

/** The data of a blood glucose reading */
export type BloodGlucoseReadingData = {
  __typename?: 'BloodGlucoseReadingData';
  /** The blood glucose level reading value (in mg/dL) */
  glucoseLevelsMgDl: Scalars['Int']['output'];
  /** The meal context the blood glucose level reading was measured */
  mealContext: MealContext;
  /** The date and time when the blood glucose level reading was measured */
  readingDateTime: Scalars['LocalDateTime']['output'];
};

/** Payload added to Blood Glucose Tracker Assignments */
export type BloodGlucoseTrackerPayload = {
  __typename?: 'BloodGlucoseTrackerPayload';
  /** Indicates whether the minimum number of glucose readings required for the task has been met */
  minGlucoseReadingsCountAchieved: Scalars['Boolean']['output'];
  /** Subtitle of the task card */
  subTitle: Scalars['String']['output'];
  /** Title of the task card */
  title: Scalars['String']['output'];
};

/** Payload added to Blood Glucose Tracker V2 Assignments */
export type BloodGlucoseTrackerV2Payload = {
  __typename?: 'BloodGlucoseTrackerV2Payload';
  /** Total number of blood glucose readings logged within the tracked period */
  glucoseReadingsCount: Scalars['Int']['output'];
  /** The most recent blood glucose reading recorded within the tracked period */
  mostRecentGlucoseReading?: Maybe<BloodGlucoseReading>;
  /** Percentage (0-100) of blood glucose readings within the acceptable range during the tracked period */
  percentageInRange: Scalars['Float']['output'];
};

/** Lab test SKU, mirrors `BloodTestSkuEnumProto.Value`. */
export enum BloodTestSku {
  /** Noom Tasso Vitality blood test panel. */
  NoomTassoVitality = 'NOOM_TASSO_VITALITY',
  /** Noom Tasso Vitality panel excluding Lp(a). */
  NoomTassoVitalityExLpa = 'NOOM_TASSO_VITALITY_EX_LPA',
  /** Default unknown value. */
  Unknown = 'UNKNOWN'
}

/** Body age analysis comparing biological age to chronological age. */
export type BodyAgeReport = {
  __typename?: 'BodyAgeReport';
  /** Calculated biological age based on health metrics. */
  bodyAge: Scalars['Float']['output'];
  /** User's predicted healthy body age at ideal BMI. */
  healthyBodyAge?: Maybe<Scalars['Float']['output']>;
  /** User's actual chronological age. */
  realAge: Scalars['Float']['output'];
  /**
   * Trend comparison with the previous body scan.
   * Only populated if user has multiple scans.
   */
  trendSinceLastScan?: Maybe<Trend>;
};

/** Response from a successfully deleted body scan */
export type BodyScanDeletionResponse = {
  __typename?: 'BodyScanDeletionResponse';
  /** Unique identifier for the scan that was deleted */
  scanUuid: Scalars['UUID']['output'];
};

export type BodyScanInfo = {
  __typename?: 'BodyScanInfo';
  /** Unique identifier for the body scan */
  scanUuid: Scalars['UUID']['output'];
  /** The current status for the body scan */
  status: BodyScanStatus;
};

/**
 * Indicates what data points (if any) need to be gathered from the user
 * when they enter the body scan flow
 */
export type BodyScanIngressChecks = {
  __typename?: 'BodyScanIngressChecks';
  /**
   * If we need to show additional screen to ask user for a review of a recently
   * made body scan video to ensure everything is ok (legs position, body
   * movement, etc.)
   */
  accuracyReviewRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If we don't already have this information recorded, prompt the user to
   * confirm their sex
   */
  assignedSexRequired: Scalars['Boolean']['output'];
  /**
   * If we don't already have the user's birth date in the system,
   * then prompt them to enter it
   */
  birthDateRequired: Scalars['Boolean']['output'];
  /**
   * If we don't already have this information recorded, prompt the user to
   * confirm body scan mode (one of NORMAL/ATHLETE)
   */
  bodyScanModeRequired: Scalars['Boolean']['output'];
  /**
   * If the user doesn't have a recent enough weigh-in then they need
   * to confirm their current weight before creating a new body scan
   */
  currentWeightRequired: Scalars['Boolean']['output'];
  /** First time body scan users need to confirm their goal weight */
  goalWeightRequired: Scalars['Boolean']['output'];
  /** Indicates whether the user has created a body scan before */
  isNewBodyScanUser: Scalars['Boolean']['output'];
  /**
   * If the user must accept (or re-accept, in the case of updated terms)
   * the privacy policy
   */
  termsAcceptanceRequired: Scalars['Boolean']['output'];
};

/** Encapsulates a list of body scans */
export type BodyScanList = Pageable & {
  __typename?: 'BodyScanList';
  /** The body scans */
  bodyScans: Array<BodyScanSummary>;
  /** Metadata for fetching the next page of body scan results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Whether the avatar preview images should be rendered by default */
  showAvatars: Scalars['Boolean']['output'];
  /** The total number of body scans which match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * A metric which was computed from a user's body scan. Fields declared using this type should
 * be named explicitly after the measurement (ex: massInKgMetric, fatPercentMetric)
 */
export type BodyScanMetric = {
  __typename?: 'BodyScanMetric';
  /**
   * Each metric has an associated label (ex: LOW/HIGH/etc), based on how the user's
   * measured value compares to their demographic. Only populated if the user's
   * demographic info is available
   */
  label?: Maybe<BodyScanMetricHealthLabel>;
  /** The actual measured value for the metric */
  value: Scalars['Float']['output'];
};

/**
 * Enumerates the qualitative tags that can be assigned to a health metric.
 * Ex: leanMass=HIGH, fatMass=IN_RANGE, etc.
 */
export enum BodyScanMetricHealthLabel {
  High = 'HIGH',
  InRange = 'IN_RANGE',
  Low = 'LOW',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export enum BodyScanMode {
  /** For users who have regular training */
  Athlete = 'ATHLETE',
  /** The default mode for users who do not have regular training */
  Normal = 'NORMAL'
}

/** Encapsulates the data for a body scan user settings */
export type BodyScanSettingsResponse = {
  __typename?: 'BodyScanSettingsResponse';
  mode?: Maybe<BodyScanMode>;
  showAvatar?: Maybe<Scalars['Boolean']['output']>;
};

export enum BodyScanStatus {
  /** Default status for a newly-created body scan record */
  AwaitingSubmission = 'AWAITING_SUBMISSION',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has completed
   */
  ProcessingComplete = 'PROCESSING_COMPLETE',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has failed
   */
  ProcessingFailed = 'PROCESSING_FAILED',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has begun
   */
  ProcessingStarted = 'PROCESSING_STARTED',
  /**
   * The Noom backend has completed post-processing the Prism body scan
   * and the resulting Health Report is ready for the user to view
   */
  ReportReady = 'REPORT_READY',
  /** The user has viewed the health report generated for the body scan */
  ReportViewed = 'REPORT_VIEWED'
}

/** Encapsulates the data for a single body scan */
export type BodyScanSummary = {
  __typename?: 'BodyScanSummary';
  /**
   * The body fat percent computed from the user's body scan
   * @deprecated Use bodyFatPercentMetric instead
   */
  bodyFatPercent: Scalars['Float']['output'];
  /** The user's body fat as computed by the body scan. Only populated for successful scans. */
  bodyFatPercentMetric?: Maybe<BodyScanMetric>;
  /**
   * The date and time the body scan was created, from the subjective
   * point of view of the client, that is, ignoring TZ
   */
  clientCivilDate: Scalars['LocalDate']['output'];
  /** The user's fat mass as computed by the body scan. Only populated for successful scans. */
  fatMassInKgMetric?: Maybe<BodyScanMetric>;
  /** The user's lean mass as computed by the body scan. Only populated for successful scans. */
  leanMassInKgMetric?: Maybe<BodyScanMetric>;
  /** The lean mass percent computed from the user's body scan */
  leanMassPercent: Scalars['Float']['output'];
  /**
   * URL to retrieve the image byte stream, the image will be shown if the
   * show avatars toggle is on
   */
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  scanUuid: Scalars['UUID']['output'];
  status: BodyScanStatus;
  /** The user's waist to height ratio as computed by the body scan. Only populated for successful scans. */
  waistToHeightRatioMetric?: Maybe<BodyScanMetric>;
  /** The user's weight at the time of the body scan */
  weightInKg: Scalars['Float']['output'];
};

/**
 * Encapsulates the data needed to render the body scan home screen
 * tracker
 */
export type BodyScanTrackerState = {
  __typename?: 'BodyScanTrackerState';
  /** The number of completed body scans for the user */
  bodyScanCount: Scalars['Int']['output'];
  /**
   * Status of the user's current body scan, or null if the user
   * does not have an in-progress body scan
   */
  bodyScanInfo?: Maybe<BodyScanInfo>;
  /**
   * The taskList endpoint will return the body scan tracker assignment
   * every day for a user, even if it's not time to prompt that user to start
   * a new body scan. The mobile client should use this field to conditionally
   * hide the body scan home screen task card if the user should not actually
   * receive the body scan assignment for the given date
   */
  isValidAssignment: Scalars['Boolean']['output'];
};

export type BodyScanUploadMetadata = {
  __typename?: 'BodyScanUploadMetadata';
  scanUuid: Scalars['UUID']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** The client may specify any of these filter to control which body scans are returned from the backend */
export type BodyScansListFilters = {
  /**
   * If set to true, the response will only contain successfully completed body scans. By default all scans will be
   * included in the response.
   */
  onlySuccessful?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BodyTraceAttributionDataInput = {
  timestamp: Scalars['Int']['input'];
};

/**
 * Variant of BodyTraceAttributionDataInput with all fields optional for matching.
 * Keep in sync with BodyTraceAttributionDataInput.
 */
export type BodyTraceAttributionDataMatchInput = {
  timestamp?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies the user business type - B2B or B2C */
export enum BusinessType {
  B2B = 'B2B',
  B2C = 'B2C'
}

/** Button configuration for weight graph content. */
export type Button = {
  __typename?: 'Button';
  /** The size for the button. */
  size?: Maybe<ButtonSize>;
  /** The style for the button. */
  style?: Maybe<ButtonStyle>;
  /**
   * Target for the button. Acceptable targets are:
   * - Another screen via #<screen_id> ie #first
   * - An action via ?<action> acceptable actions are:
   * - CLOSE (ie ?CLOSE)
   * - BACK (ie ?BACK)
   * - A deeplink (ie https://link.noom.com/app?open=UPGRADE_OFFER&offer_id=plateau_ad)
   */
  target: Scalars['String']['output'];
  /** Text to put on the button. */
  text: Scalars['String']['output'];
};

/** Button size options. */
export enum ButtonSize {
  /** Large button size. */
  Large = 'LARGE',
  /** Medium button size. */
  Medium = 'MEDIUM',
  /** Small button size. */
  Small = 'SMALL',
  /** Default status for enums. */
  Unknown = 'UNKNOWN'
}

/** Button style options. */
export enum ButtonStyle {
  /** Brand button style. */
  Brand = 'BRAND',
  /** Primary button style. */
  Primary = 'PRIMARY',
  /** Secondary button style. */
  Secondary = 'SECONDARY',
  /** Tertiary button style. */
  Tertiary = 'TERTIARY',
  /** Default status for enums. */
  Unknown = 'UNKNOWN'
}

/** Survey answer entry */
export type BuyflowSurveyAnswer = {
  /** The answer as a JSON string */
  answerJson: Scalars['String']['input'];
  /** The question id */
  questionId: Scalars['String']['input'];
};

/**
 * Full b.well health records card payload.
 * `content` may be null when the card should not be shown.
 */
export type BwellCard = {
  __typename?: 'BwellCard';
  /**
   * Renderable card content/body.
   * Null when the card should not be shown.
   */
  content?: Maybe<BwellCardContent>;
  /** Lifecycle state of the card. */
  state: BwellCardState;
};

/** Renderable content for the b.well health records card. */
export type BwellCardContent = {
  __typename?: 'BwellCardContent';
  /**
   * Webview destination opened when the card is tapped.
   * Null when the card is not tappable.
   */
  destinationUrl?: Maybe<Scalars['String']['output']>;
  /** Secondary supporting text shown on the card. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Primary text shown on the card. */
  title: Scalars['String']['output'];
};

/**
 * Lifecycle state of the b.well health records card shown to the user.
 * Maps the backend retrieval job status to a client-facing display state.
 */
export enum BwellCardState {
  /**
   * Records have been retrieved and health information has been verified
   * and saved (externally_verified_health_information is populated).
   * The card should not be shown.
   */
  Completed = 'COMPLETED',
  /**
   * User is eligible but has not yet initiated a connection.
   * Show the card prompting them to connect.
   */
  Connect = 'CONNECT',
  /**
   * No connection was completed within the allowed timeframe
   * so the card was automatically dismissed.
   */
  Dismissed = 'DISMISSED',
  /**
   * A retrieval job is actively in progress.
   * Show the card in a loading/pending state.
   */
  InProgress = 'IN_PROGRESS',
  /**
   * User is not eligible for b.well.
   * The card should not be shown.
   */
  None = 'NONE',
  /**
   * The retrieval job completed and records have been fetched.
   * Show the card indicating records are ready to review.
   */
  RecordsReady = 'RECORDS_READY'
}

/** Additional input data for [Mutation.calculateSmartDose] */
export type CalculateSmartDoseInput = {
  /** Prescription catalog drug identifier to send going forward to support Product Switching. */
  internalDrugId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional side effect data indicated by the user. */
  sideEffects?: InputMaybe<MedicationSideEffectInput>;
};

/**
 *  These values should be aligned with:
 *  - macros.proto (CalorieBudgetMacroTargetsProto)
 */
export type CalorieBudgetMacroTargets = {
  __typename?: 'CalorieBudgetMacroTargets';
  /**
   *  This value is used to calculate the recommended carbohydrate intake
   *  based on the total calorie budget.
   */
  carbsTargetPercentage: Scalars['Float']['output'];
  /**
   *  This value is used to calculate the recommended fat intake based on
   *  the total calorie budget.
   */
  fatTargetPercentage: Scalars['Float']['output'];
  /**
   *  This value is used to calculate the recommended protein intake based on
   *  the total calorie budget.
   */
  proteinTargetPercentage: Scalars['Float']['output'];
};

/**
 *  These values should be aligned with:
 *  - type CalorieBudgetMacroTargets (above)
 */
export type CalorieBudgetMacroTargetsInput = {
  carbsTargetPercentage: Scalars['Float']['input'];
  fatTargetPercentage: Scalars['Float']['input'];
  proteinTargetPercentage: Scalars['Float']['input'];
};

export type CancelMicroChallengeResponse = {
  __typename?: 'CancelMicroChallengeResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Variants definitions used to determine home card appearance and emphasis in the client UI. */
export enum CardVariant {
  /** A simple and small card variant for standard display */
  Default = 'DEFAULT',
  /** A high emphasis variant for greater attention on the screen */
  Hero = 'HERO'
}

/** Represents the Care Tab notification state for a patient. */
export type CareTabNotification = {
  __typename?: 'CareTabNotification';
  /** True if there are unread SHIPPED, RESHIPPED, or DELIVERED shipment updates on the Care Tab. */
  hasUnread: Scalars['Boolean']['output'];
};

/**
 * Placement-level content for a carousel section.
 * Maps to CarouselSectionContentProto in noom_contracts/offers/ads/api/ad_service.proto.
 */
export type CarouselSectionContent = {
  __typename?: 'CarouselSectionContent';
  /** Design type/variant of the cards in this carousel. */
  cardVariant: AdCardVariant;
  /** Optional description shown under the carousel section title. */
  description?: Maybe<Scalars['String']['output']>;
  /** Fine-print disclaimers shown for the carousel section. */
  disclaimers: Array<Scalars['String']['output']>;
  /** Title for the entire carousel section. */
  title: Scalars['String']['output'];
};

/** Personal time off record for a CDU. */
export type CduPersonalTimeOff = {
  __typename?: 'CduPersonalTimeOff';
  /** CDU access code for the coach. */
  cduAccessCode: Scalars['String']['output'];
  /** PTO end date. */
  dateEnded: Scalars['LocalDate']['output'];
  /** PTO start date. */
  dateStarted: Scalars['LocalDate']['output'];
  /** Unique identifier for the PTO record. */
  id: Scalars['Int']['output'];
  /** PTO first seen date. */
  requestFirstSeen: Scalars['LocalDate']['output'];
};

/** List of PTOs for a CDU. */
export type CduPersonalTimeOffList = {
  __typename?: 'CduPersonalTimeOffList';
  /** PTO records for the CDU. */
  ptos: Array<CduPersonalTimeOff>;
};

/** Scheduled working hours record for a CDU. */
export type CduScheduledWorkHours = {
  __typename?: 'CduScheduledWorkHours';
  /** CDU access code for the coach. */
  cduAccessCode: Scalars['String']['output'];
  /** Date the schedule ends, if any. */
  dateEnded?: Maybe<Scalars['LocalDate']['output']>;
  /** Date the schedule starts. */
  dateStarted: Scalars['LocalDate']['output'];
  /** Whether the coach works on Friday. */
  friday: Scalars['Boolean']['output'];
  /** Unique identifier for the schedule record. */
  id: Scalars['Int']['output'];
  /** Whether the coach works on Monday. */
  monday: Scalars['Boolean']['output'];
  /** Whether the coach works on Saturday. */
  saturday: Scalars['Boolean']['output'];
  /** Whether the coach works on Sunday. */
  sunday: Scalars['Boolean']['output'];
  /** Whether the coach works on Thursday. */
  thursday: Scalars['Boolean']['output'];
  /** Whether the coach works on Tuesday. */
  tuesday: Scalars['Boolean']['output'];
  /** Whether the coach works on Wednesday. */
  wednesday: Scalars['Boolean']['output'];
  /** Total weekly working hours. */
  weeklyHours: Scalars['Int']['output'];
  /** Per-weekday working hours for the schedule. */
  workingHours?: Maybe<WorkingHours>;
};

export type CduScheduledWorkHoursList = {
  __typename?: 'CduScheduledWorkHoursList';
  /** Schedule records for the CDU. */
  scheduledWorkHours: Array<CduScheduledWorkHours>;
};

/** Input for changing the status of a relation request. */
export type ChangeRelationRequestStatusInput = {
  /** The desired new status (e.g. ACCEPTED, DECLINED). */
  newStatus: RelationRequestStatus;
  /** The stable identifier of the relation request. */
  relationRequestId: Scalars['ID']['input'];
};

/** Response returned after changing a relation request status. Always includes the relation request entity. */
export type ChangeRelationRequestStatusResponse = {
  __typename?: 'ChangeRelationRequestStatusResponse';
  /** The relation request after the operation. */
  relationRequest?: Maybe<RelationRequest>;
  /** State of the operation (e.g. STATUS_CHANGED, ALREADY_IN_STATUS). */
  state: RelationRequestOperationState;
};

/** Represents a redeemable charitable donation reward */
export type CharitableDonationProductListing = {
  __typename?: 'CharitableDonationProductListing';
  /** Display image for the reward */
  image: RewardImage;
  /** Minimal amount required to make a donation */
  minimalAmount: RewardsMoney;
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
  /** WebView URL for redeeming the charitable donation reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Display subtitle for the reward */
  subtitle: Scalars['String']['output'];
  /** Display title for the reward */
  title: Scalars['String']['output'];
};

/**
 * A chat channel is a grouping structure for messages and provides an interaction
 * point for users and Noom humans (coaches, care, etc)
 */
export type ChatChannel = {
  __typename?: 'ChatChannel';
  /** Returns a list of surveys for the given user. */
  csatSurveys?: Maybe<Array<CsatSurvey>>;
  /** The id for the channel */
  id: Scalars['String']['output'];
};


/**
 * A chat channel is a grouping structure for messages and provides an interaction
 * point for users and Noom humans (coaches, care, etc)
 */
export type ChatChannelCsatSurveysArgs = {
  accessCode: Scalars['String']['input'];
};

/** Member inbox response: ordered sections of chat channels. */
export type ChatMemberInbox = {
  __typename?: 'ChatMemberInbox';
  /** Channel URLs the client must exclude from the member inbox display. */
  hiddenChannelUrls: Array<Scalars['String']['output']>;
  /** Ordered list of sections (e.g. 'Your coaches', 'Get help'). Composition varies by program. */
  sections: Array<ChatMemberInboxSection>;
};

/**
 * A channel in the member inbox.
 *
 * When channelUrl is present, the client uses the chat SDK as the primary data
 * source, and the rest of the fields serve as optional overrides.
 *
 * When channelUrl is absent, the rest of the fields are used to display this channel.
 */
export type ChatMemberInboxChannel = {
  __typename?: 'ChatMemberInboxChannel';
  /**
   * Chat channel identifier (e.g. a channel URL or ID) used by the
   * client's chat SDK to look up channel data for SDK-backed channels.
   * Absent for non-SDK channels.
   */
  channelUrl?: Maybe<Scalars['String']['output']>;
  /**
   * When present, tapping navigates to this deep link instead of the default behavior.
   * The default behavior for SDK channels is navigating to the channel with url `channelUrl`.
   */
  deepLinkUrl?: Maybe<Scalars['String']['output']>;
  /** Role or description line shown below the channel `name`. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Channel display name. Expected to be present when `channelUrl` is absent.
   * Overrides SDK channel's name when present.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Preview or status text shown as the third (gray) line in the inbox row.
   * For SDK channels, client should instead show the most recent unread message when available.
   */
  previewText?: Maybe<Scalars['String']['output']>;
  /**
   * Profile picture URL.
   * Overrides SDK channel's avatar when present.
   */
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
};

/** A labeled group of channels within the member inbox. */
export type ChatMemberInboxSection = {
  __typename?: 'ChatMemberInboxSection';
  /** Channels in this section. */
  channels: Array<ChatMemberInboxChannel>;
  /** Stable identifier for this section (e.g. 'your_coaches', 'get_help'). */
  id: Scalars['String']['output'];
  /** Localized display title (e.g. 'Your coaches', 'Get help'). */
  title: Scalars['String']['output'];
};

export type ClientHints = {
  __typename?: 'ClientHints';
  enableClientPostCore?: Maybe<Scalars['Boolean']['output']>;
  usedDayOffsetStrategy?: Maybe<Scalars['Boolean']['output']>;
};

/** Header that is rendered by the client for specific progress features */
export type ClientProgressHeader = {
  __typename?: 'ClientProgressHeader';
  /** The type of client header to render */
  kind: ClientProgressHeaderType;
};

/** Client-rendered progress header types */
export enum ClientProgressHeaderType {
  /** Noomcoin header, rendered by the client for progress features related to Noomcoin. */
  Noomcoin = 'NOOMCOIN',
  /** Treat Day header, rendered by the client for progress features related to treatment days. */
  TreatDay = 'TREAT_DAY',
  /** Unknown or unspecified client-rendered progress header type. */
  Unknown = 'UNKNOWN'
}

/** Display details for the prescribing clinician shown on the treatment card. */
export type ClinicianDetail = {
  __typename?: 'ClinicianDetail';
  /** Clinician display name (e.g. 'Dr. Jones'). */
  name: Scalars['String']['output'];
  /** URL of the clinician's profile photo. Null when no photo is available. */
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type CoachAnnouncement = {
  __typename?: 'CoachAnnouncement';
  /** The number of visibility days for the announcement */
  activeDurationDays?: Maybe<Scalars['Int']['output']>;
  /** The first date when the announcement will be visible */
  activeStartTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  announcementId?: Maybe<Scalars['String']['output']>;
  /** If an announcements is ephemeral, it won't be shown to the users once it's been acknowledged */
  isEphemeral?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedByCduAccessCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Whether or not the coach should acknowledge that they've seen the announcement */
  requiresAcknowledgement?: Maybe<Scalars['Boolean']['output']>;
  /** Types of coaches that can see the announcement */
  ufcTypeConstraints?: Maybe<Array<Maybe<UfcType>>>;
};

export type CoachAnnouncementInfo = {
  __typename?: 'CoachAnnouncementInfo';
  /** The number of coaches that acknowledged the announcement */
  acknowledgedByCount?: Maybe<Scalars['Int']['output']>;
  coachAnnouncement?: Maybe<CoachAnnouncement>;
  /** The number of coaches that should see the announcement */
  targetedCoachesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of coaches that viewed the announcement */
  viewedByCount?: Maybe<Scalars['Int']['output']>;
};

export type CoachAnnouncementInput = {
  activeDurationInDays: Scalars['Int']['input'];
  activeStartTime: Scalars['OffsetDateTime']['input'];
  isEphemeral?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  requiresAcknowledgement: Scalars['Boolean']['input'];
  ufcTypeConstraints: Array<UfcType>;
};

export type CoachAnnouncementUserInteraction = {
  __typename?: 'CoachAnnouncementUserInteraction';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  coachAnnouncement: CoachAnnouncement;
  viewed: Scalars['Boolean']['output'];
};

export type CoachAnnouncementUserInteractions = {
  __typename?: 'CoachAnnouncementUserInteractions';
  items: Array<CoachAnnouncementUserInteraction>;
};

export type CoachAnnouncementUserInteractionsPaged = {
  __typename?: 'CoachAnnouncementUserInteractionsPaged';
  items: Array<CoachAnnouncementUserInteraction>;
  pageInfo?: Maybe<CursorPageInfo>;
};

export type CoachAnnouncementsConfig = {
  __typename?: 'CoachAnnouncementsConfig';
  isCoachAnnouncementsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CoachAnnouncementsResult = {
  __typename?: 'CoachAnnouncementsResult';
  items: Array<CoachAnnouncementInfo>;
  pageInfo?: Maybe<CursorPageInfo>;
};

export type CoachAnnouncementsUserInteractionInfo = {
  __typename?: 'CoachAnnouncementsUserInteractionInfo';
  numberOfNewAcknowledgeAnnouncements?: Maybe<Scalars['Int']['output']>;
  numberOfUnseenAnnouncements?: Maybe<Scalars['Int']['output']>;
};

export type CoachingConfig = {
  __typename?: 'CoachingConfig';
  coachAnnouncementsConfig?: Maybe<CoachAnnouncementsConfig>;
  dashboardAiacConfig?: Maybe<DashboardAiacConfig>;
};

export type CoachingConfigForUser = {
  __typename?: 'CoachingConfigForUser';
  /** If AI assisted coaching should be shown to a user */
  aiacConfig?: Maybe<AiacConfigForUser>;
};

/**
 * Metrics to display in the goal achieved screen.
 * This will be displayed as a string, depending on the goal type. For example: "120/100 calories".
 */
export type ComparisonMetrics = {
  __typename?: 'ComparisonMetrics';
  /** Current value of the goal that user has achieved. */
  currentValue: Scalars['Int']['output'];
  /** Goal target value. */
  targetValue: Scalars['Int']['output'];
};

/** Context for requesting recommendations after a challenge is completed */
export type CompletionInterstitialContextInput = {
  /** ID of the user micro challenge that was just completed */
  completedUserMicroChallengeId: Scalars['UUID']['input'];
  /** Number of recommended challenges to return (defaults to 3) */
  recommendationLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Response for the completion interstitial recommendation surface */
export type CompletionInterstitialResponse = {
  __typename?: 'CompletionInterstitialResponse';
  /** The challenge that was just completed */
  completedChallenge: MicroChallenge;
  /** Recommended next challenges (each item's recommendationContext is pre-filled) */
  recommendedChallenges: Array<MicroChallenge>;
};

export type CompositeMealItem = {
  __typename?: 'CompositeMealItem';
  loggedUuid: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  originUuid?: Maybe<Scalars['UUID']['output']>;
  portion?: Maybe<Portion>;
  simpleMealItems: Array<SimpleMealItem>;
};

export type CompositeMealItemInput = {
  /** Client-generated UUID to track this logged item */
  loggedUuid: Scalars['UUID']['input'];
  /** Display name */
  name: Scalars['String']['input'];
  /** UUID linking to the recipe/food database */
  originUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Portion information */
  portion?: InputMaybe<PortionInput>;
  /** Sub-items in this composite item */
  simpleMealItems: Array<SimpleMealItemInput>;
};

/**
 * A single resolved consent record for a `(userAccessCode, consentType,
 * qualifier)` natural key. Domain-agnostic — mirrors the backing
 * protobuf `ConsentProto` (see
 * `noom_contracts/identity/consent/consent_service.proto`).
 */
export type Consent = {
  __typename?: 'Consent';
  /**
   * Consent type identifier (e.g. `CONTACT_BOOK_UPLOADING`). The set
   * of valid values is defined per-domain — see the corresponding
   * domain enum (e.g. `RelationsConsentType`) for the canonical list.
   */
  consentType: Scalars['String']['output'];
  /**
   * Version of the consent definition the user consented to (or
   * denied). Absent when the status is `NOT_SPECIFIED`.
   */
  consentVersion?: Maybe<Scalars['Int']['output']>;
  /**
   * Default behavior for this consent type when no explicit decision
   * exists. Tells the caller whether `NOT_SPECIFIED` means
   * "operation allowed" (`GRANTED`) or "operation blocked"
   * (`DENIED`). Only `GRANTED` or `DENIED` are valid values.
   */
  defaultBehavior: ConsentStatus;
  /**
   * Per-`consentType` scope value. Absent when the consent type is
   * unscoped; otherwise carries the qualifier set on the consent.
   */
  qualifier?: Maybe<Scalars['String']['output']>;
  /**
   * The recorded decision; always `GRANTED` or `DENIED`. Consents
   * that have never been set are not represented as a `Consent` at
   * all (they are simply absent from any read / list response).
   */
  status: ConsentStatus;
  /**
   * Server-side timestamp of the most recent state transition. Absent
   * when the status is `NOT_SPECIFIED`.
   */
  updateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** User access code the consent belongs to. */
  userAccessCode: Scalars['String']['output'];
};

/** Promo shown when the user needs to grant consent for phone number processing. */
export type ConsentPromo = {
  __typename?: 'ConsentPromo';
  /** The user's latest phone number. */
  phoneNumber: Scalars['String']['output'];
};

/**
 * The user's consent decision on the API surface. Mirrors the backing
 * protobuf `ConsentStatusProto.Value` (see
 * `noom_contracts/identity/consent/shared.proto`). Persisted rows are
 * always `GRANTED` or `DENIED`; `NOT_SPECIFIED` is exposed so clients
 * can explicitly model the not-yet-decided state, but `set*Consent`
 * mutations reject it with `INVALID_ARGUMENT` (HTTP 400) — represent
 * the not-specified state by *not sending* a set-consent call for the
 * natural key (or by deleting the row when delete-consent ships).
 */
export enum ConsentStatus {
  /** User explicitly denied / opted out of the consent. */
  Denied = 'DENIED',
  /** User explicitly granted the consent. */
  Granted = 'GRANTED',
  /**
   * No decision has been recorded for this `(userAccessCode,
   * consentType, qualifier)`. Accepted by the schema so clients can
   * model the value, but `set*Consent` mutations reject it with HTTP
   * 400 — only `GRANTED` / `DENIED` actually persist.
   */
  NotSpecified = 'NOT_SPECIFIED'
}

/** Optional, computed add-ons for a contact match. Omitted if not requested or unavailable. */
export type ContactMatchExtraData = {
  __typename?: 'ContactMatchExtraData';
  /** Profile data for the matched Noom user. */
  profile?: Maybe<NoomUserPreviewProfile>;
};

export type ContactPreviewInput = {
  /** Client-side stable ID — SHA-256(userAccessCode|phone_e164). Echoed back in the response. */
  clientContactId: Scalars['String']['input'];
  /** E.164-normalised phone number. */
  phone: Scalars['String']['input'];
};

/** A device contact that matched a discoverable Noom user. */
export type ContactPreviewMatch = {
  __typename?: 'ContactPreviewMatch';
  /** Access code of the matched Noom user — used by the client to send friend requests. */
  accessCode: Scalars['String']['output'];
  /**
   * Complete set of actions for this match (e.g. ADD_FRIEND). Never empty.
   * Lookup by action, not by index. Model guide: social/USER_ACTION_MODEL.md in noom-contracts.
   *
   * For findFriendsByPhoneNumbers, matches with FRIENDS_ESTABLISHED are filtered
   * server-side (client contact id in excluded); clients will not receive that status here.
   */
  actions: Array<UserActionState>;
  /** Echoed back so the client can map the result to its local contact. */
  clientContactId: Scalars['String']['output'];
  /** Optional extra data. May be null if not selected or not available. */
  extraData?: Maybe<ContactMatchExtraData>;
};

/** Payload returned on a successful requestContactsUploadUrl mutation. */
export type ContactsUploadUrlPayload = {
  __typename?: 'ContactsUploadUrlPayload';
  /**
   * Seconds until the pre-signed URL expires. Derived by the resolver from the
   * SOA expires_at absolute timestamp. Clients MUST not use uploadUrl after
   * this many seconds from the time the response was received.
   */
  expiresInSeconds: Scalars['Int']['output'];
  /**
   * Opaque sync-session identifier created by the Relations SOA for this
   * upload. Used in subsequent status-tracking calls.
   */
  syncId: Scalars['String']['output'];
  /**
   * HTTP headers the client MUST send verbatim on the PUT request to uploadUrl
   * (e.g. Content-Type, x-amz-server-side-encryption). Empty when no extra
   * headers are required.
   */
  uploadHeaders: Array<HttpHeader>;
  /**
   * Pre-signed S3 URL; the client HTTP PUTs the JSON Lines contacts file
   * directly to this URL without routing through the backend.
   * Obtained from the Relations SOA createContactsUploadUrl RPC.
   */
  uploadUrl: Scalars['String']['output'];
};

/** Content item for content section assignment. */
export type ContentItem = {
  __typename?: 'ContentItem';
  /** Content data */
  content?: Maybe<ContentItemData>;
  /** Content url of the content task assignment */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Description string|markdown for UI, e.g. 'Earn 250 Seeds' */
  description?: Maybe<ContentItemDescription>;
  /** Whether this content task activity has been completed */
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
};

/** A union for a different content types */
export type ContentItemData = ArtBreaksContent;

/** A union for description wrappers to allow markdown */
export type ContentItemDescription = MarkdownString | SeedsString;

/** Content section assignment for creative mindfulness tasks. */
export type ContentSectionAssignment = {
  __typename?: 'ContentSectionAssignment';
  /** List of the content activities */
  items?: Maybe<Array<ContentItem>>;
  /** Subtitle of the assignment, e.g. 'Elevate your mood with 2 minutes of art' */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the assignment, e.g. 'Take your weekly Art Break' */
  title?: Maybe<Scalars['String']['output']>;
};

/** Enum for scheduled content status lifecycle */
export enum ContentStatus {
  /** Unspecified status (default) */
  ContentStatusUnspecified = 'CONTENT_STATUS_UNSPECIFIED',
  /** Content has been published and is live */
  Published = 'PUBLISHED',
  /** Content is ready for review before publishing */
  ReadyToReview = 'READY_TO_REVIEW'
}

/** Course Map tab presentation */
export type CourseMapTab = {
  __typename?: 'CourseMapTab';
  /** Placeholder field; reserved for future Course Map tab presentation properties */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Course pack data.
 * Matches CoursePackDataProto from noom_contracts/backend/curriculum/service/module_library.proto
 */
export type CoursePack = {
  __typename?: 'CoursePack';
  /** Description of the course pack */
  description?: Maybe<Scalars['String']['output']>;
  /** URL of the course pack image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user has purchased this course pack */
  isPurchased?: Maybe<Scalars['Boolean']['output']>;
  /** Unique course pack designation */
  slug: CoursePackSlug;
  /** Display title of the course pack */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Course pack slug identifiers.
 * Matches CoursePackProto.CoursePackSlug.Value from noom_contracts/backend/program/model/course_pack.proto
 */
export enum CoursePackSlug {
  /** Aging and Metabolism, a set of additional articles which explore how A&M impacts the user's weight loss journey */
  AgingAndMetabolism = 'AGING_AND_METABOLISM',
  /** Body scan course pack. For free users who have access to body scan features */
  BodyScan = 'BODY_SCAN',
  /** Diabetes support course pack for users eligible for Type 2 Diabetes (T2D) support */
  DiabetesSupport = 'DIABETES_SUPPORT',
  /** Eat & move well coursepack, part of SDOH */
  EatAndMove = 'EAT_AND_MOVE',
  /** Food logging v2 course pack. For users who have access to the food logging v2 feature */
  FoodLoggingV2 = 'FOOD_LOGGING_V2',
  /** GLP1 course pack which covers how certain medications affect weight loss and health */
  Glp1 = 'GLP1',
  /** Metabolic supplements course pack for OTC users who purchased metabolic supplement products */
  MetabolicSupplements = 'METABOLIC_SUPPLEMENTS',
  /** Movement course pack, which covers the fundamentals of movement and helps users build a movement habit */
  Movement = 'MOVEMENT',
  /** Balancing nutrition and culture coursepack, part of SDOH */
  NutritionAndCulture = 'NUTRITION_AND_CULTURE',
  /** Nutrition basics coursepack, part of SDOH */
  NutritionBasics = 'NUTRITION_BASICS',
  /** Noom Weight Plus, a set of 16 Noom Mood articles sprinkled on top of Noom Weight curriculum */
  NwPlus = 'NW_PLUS',
  /** Sleep course pack, which covers how sleep impacts weight loss and tools for consistently better sleep */
  Sleep = 'SLEEP',
  /** Summit Nutrition, special coaching and content providing nutritional guidance on top of Noom Weight */
  SummitNutrition = 'SUMMIT_NUTRITION',
  /** Unknown or unspecified course pack */
  Unknown = 'UNKNOWN'
}

/** Input type for creating a new art gallery. */
export type CreateArtGalleryInput = {
  /** URL to background music for the gallery experience */
  backgroundMusicUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the cover photo for the gallery */
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Reflection question associated with the gallery */
  reflectionQuestion?: InputMaybe<Scalars['String']['input']>;
  /** URL to the thumbnail image for the gallery */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the art gallery (required) */
  title: Scalars['String']['input'];
};

/** Input type for creating a new art piece. */
export type CreateArtPieceInput = {
  /** Names of the artists who created this piece */
  artistNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of the art piece */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display time period for the art piece (e.g. "early 17th century") */
  displayTimePeriod?: InputMaybe<Scalars['String']['input']>;
  /** Location hosting the art */
  hostedAt?: InputMaybe<Scalars['String']['input']>;
  /** URL to the image of the art piece (required) */
  imageUrl: Scalars['String']['input'];
  /** Medium/type of the artwork */
  medium?: InputMaybe<ArtPieceMedium>;
  /** Title of the art piece (required) */
  title: Scalars['String']['input'];
  /** Year the art piece was created */
  yearCreated?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating an asset registry entry. */
export type CreateAssetRegistryEntryInput = {
  /** The size of the asset in bytes. */
  byteSize?: InputMaybe<Scalars['Int']['input']>;
  /** Who created the asset. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The description of the asset. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The filename of the asset. */
  filename: Scalars['String']['input'];
  /** A JSON string representing the metadata of the asset. */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** The MIME type of the asset. */
  mimeType: Scalars['String']['input'];
  /** The storage path of the asset. */
  path: Scalars['String']['input'];
  /** The public URL for accessing the asset. */
  publicUrl: Scalars['String']['input'];
  /** The status of the asset (defaults to WAITING_FOR_APPROVAL if not set). */
  status?: InputMaybe<AssetRegistryStatus>;
  /** The storage bucket (empty means default bucket). */
  storageBucket?: InputMaybe<Scalars['String']['input']>;
  /** The type of the asset (e.g. image vs agent artifact for UI filtering). */
  type?: InputMaybe<AssetRegistryType>;
};

/** Represents the customer support ticket that was created. */
export type CreateCustomerSupportTicketResponse = {
  __typename?: 'CreateCustomerSupportTicketResponse';
  /** Identifier of the customer support ticket that was created */
  ticketId: Scalars['String']['output'];
};

/** Input for creating an audit trail. */
export type CreateNoomFlowAuditTrailInput = {
  /** The identifier of the associated entity (flow, persona, experiment, etc.). */
  associatedIdentifier: Scalars['String']['input'];
  /**
   * The version of the associated entity.
   * This is used to identify the version of the associated entity that was changed.
   * If the associated entity is a flow, this will be the version of the flow.
   */
  associatedVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The type of audit trail event. */
  auditTrailType: NoomFlowAuditTrailType;
  /** Description of the change that was made. */
  changeDescription: Scalars['String']['input'];
  /** A JSON string representing the diff of the change that was made. */
  diffAsJsonString: Scalars['String']['input'];
};

/** Input for computing a flow diff overlay against a resolved baseline. */
export type CreateNoomFlowDiffInput = {
  /** Inline baseline configuration as JSON text. */
  baselineFlowAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Baseline from this persisted flow instance. Omit when supplying inline baseline JSON. */
  baselineFlowUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Full alternate flow definition as JSON to compare against the baseline. */
  flowToDiffAgainstBaselineAsJsonString: Scalars['String']['input'];
};

/**
 * Writable experiment fields for create. Omits server-generated fields such as uuid,
 * creator, audit timestamps, and lifecycle timestamps assigned by the service.
 */
export type CreateNoomFlowExperimentInput = {
  /** Baseline flow for the experiment. */
  baselineFlowIdentifier: Scalars['String']['input'];
  /** Other experiments that must not overlap in assignment. */
  conflictingExperimentIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Required when status is beyond initial `IN_PROGRESS`; may be omitted for draft-only creates. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Links to design docs, PRDs, or tickets. */
  designDocumentationLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional Meristem or other experiment-engine key. */
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  /** Mixpanel funnel id for reporting links. */
  funnelId?: InputMaybe<Scalars['String']['input']>;
  /** Immutable human-readable id (required); alphanumeric, hyphens, underscores. */
  identifier: Scalars['String']['input'];
  /** When true, greedy allocation applies; only when allowed by Noom Flow validation. */
  isGreedyTargeting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Human-readable display name for the experiment (distinct from `identifier`). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner identity (email or service principal); required on save per Noom Flow validation. */
  owner: Scalars['String']['input'];
  /** Owning team label for reporting and Slack context. */
  owningTeam?: InputMaybe<Scalars['String']['input']>;
  /** Optional pinned baseline flow instance uuid. */
  pinnedBaselineFlowUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional psychology or technique label for categorization. */
  psychTechnique?: InputMaybe<Scalars['String']['input']>;
  /** Target sample size per arm for power / Mixpanel checks. */
  sampleSizePerArm?: InputMaybe<Scalars['Int']['input']>;
  /** Planned end of the experiment window. */
  scheduledEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Planned start of the experiment window. */
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Funnel start events for analytics. */
  startEvents?: InputMaybe<Array<NoomFlowExperimentQueriedReferenceInput>>;
  /** Initial lifecycle state; often `IN_PROGRESS` for drafts. */
  status?: InputMaybe<NoomFlowExperimentStatus>;
  /** Conversion / target events for analytics. */
  targetEvents?: InputMaybe<Array<NoomFlowExperimentQueriedReferenceInput>>;
  /** Targeting rows (e.g. `context_type`, `language_code`). */
  targeting?: InputMaybe<Array<NoomFlowExperimentTargetingCriteriaInput>>;
  /** Traffic share for this experiment, 0–100 style (default 0 on save if omitted). */
  trafficPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Variation arms: weight_percentage per arm, flow diff, config, and identifiers when required. */
  variations?: InputMaybe<Array<NoomFlowExperimentVariationInput>>;
  /** Whole number percent for experiment-level allocation (e.g. 30 means 30%). Server may default when omitted. */
  weightPercentage?: InputMaybe<Scalars['Int']['input']>;
};

/** Writable fields for creating a flow (server assigns uuid and audit fields). */
export type CreateNoomFlowInput = {
  /** Agent artifacts used to create the flow as a JSON object string (e.g. screenshots, PRDs). */
  agentArtifactsAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Preferred structured configuration as a JSON object string. */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** Legacy configuration as JSON text. Prefer `configuration` when available. */
  configurationAsJsonString: Scalars['String']['input'];
  /** Who created the flow configuration. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The description of the flow. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The group name of flow configurations that may be chosen based on criteria when requested. */
  flowGroupName?: InputMaybe<Scalars['String']['input']>;
  /** The identifier for the flow. */
  flowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The associated github pull request URLs for the flow. */
  githubPullRequestUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The associated jira ticket URLs for the flow. */
  jiraTicketUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Flow metadata as a JSON object string (e.g. annotations, todos). */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** The name of the flow. */
  name: Scalars['String']['input'];
  /**
   * The version of the flow configuration. If this is not provided,
   * it will be set to the next incremented version.
   */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Create a named list. */
export type CreateNoomFlowListInput = {
  /** Optional user identity stored on the new row. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Required; must satisfy server uniqueness rules. */
  name: Scalars['String']['input'];
  /** Declared type of item `value` for this list; omit for server default. */
  valueDataType?: InputMaybe<NoomFlowListValueDataType>;
};

/** Create a list item. Set exactly one of `listUuid` or `listName`. */
export type CreateNoomFlowListItemInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  listName?: InputMaybe<Scalars['String']['input']>;
  listUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional JSON metadata for the item. */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

/** Writable fields for creating a page (server assigns uuid and audit fields). */
export type CreateNoomFlowPageInput = {
  /** Agent artifacts as a JSON object string (`NoomFlowPage.agentArtifactsAsJsonString`). */
  agentArtifactsAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Structured page configuration as a JSON object string. */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** Audit: creating principal or user id. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Optional description in admin. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Page metadata as a JSON object string (`NoomFlowPage.metadataAsJsonString`). */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Display name in admin. */
  name: Scalars['String']['input'];
  /** Logical page id for the new configuration. */
  pageIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Initial configuration version if the client supplies it. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a noom flow persona. */
export type CreateNoomFlowPersonaInput = {
  /** The flowIdentifiers this persona is associated with. */
  associatedFlowIdentifiers: Array<Scalars['String']['input']>;
  /** Who created the persona. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The description of the persona. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the persona. */
  name: Scalars['String']['input'];
  /** A JSON string representing the persona configuration. */
  personaAsJsonString: Scalars['String']['input'];
  /** The type of the persona. */
  type: NoomFlowPersonaType;
};

/** Create a Noom Flow rule. Server assigns uuid and audit timestamps. */
export type CreateNoomFlowRuleInput = {
  /** Structured JSON for the ordered list of conditions. */
  conditionalsAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Optional user identity stored on the new row. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Optional description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the rule. */
  name: Scalars['String']['input'];
};

/** Input for creating a noom flow text translation. */
export type CreateNoomFlowTextTranslationInput = {
  /** Who created the text translation. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** German (Germany) translation. */
  deDe?: InputMaybe<Scalars['String']['input']>;
  /** German (international) translation. */
  deInternational?: InputMaybe<Scalars['String']['input']>;
  /** English (Australia) translation. */
  enAu?: InputMaybe<Scalars['String']['input']>;
  /** English (Canada) translation. */
  enCa?: InputMaybe<Scalars['String']['input']>;
  /** English (Great Britain) translation. */
  enGb?: InputMaybe<Scalars['String']['input']>;
  /** English (Ireland) translation. */
  enIe?: InputMaybe<Scalars['String']['input']>;
  /** English (international) translation. */
  enInternational?: InputMaybe<Scalars['String']['input']>;
  /** English (Mexico) translation. */
  enMx?: InputMaybe<Scalars['String']['input']>;
  /** English (New Zealand) translation. */
  enNz?: InputMaybe<Scalars['String']['input']>;
  /** English (Pakistan) translation. */
  enPk?: InputMaybe<Scalars['String']['input']>;
  /** English (Singapore) translation. */
  enSg?: InputMaybe<Scalars['String']['input']>;
  /**
   * English (United States) translation.
   * NOTE: This is required!
   */
  enUs: Scalars['String']['input'];
  /** Spanish (international) translation. */
  esInternational?: InputMaybe<Scalars['String']['input']>;
  /** Spanish (Mexico) translation. */
  esMx?: InputMaybe<Scalars['String']['input']>;
  /**
   * The key that is the unique identifier for the text translation in flows.
   * NOTE: Once this is created, it cannot be changed!
   */
  key: Scalars['String']['input'];
  /** Whether the translation is shared across flows. */
  shared: Scalars['Boolean']['input'];
  /** The state of the translation. */
  translationState: NoomFlowTextTranslationStateType;
};

/** Input for creating a noom flow text translation key. */
export type CreateNoomFlowTextTranslationKeyInput = {
  /** The text to create the key for. */
  text: Scalars['String']['input'];
  /**
   * To manually specify the text translation key to create.
   * Note: If not provided, the key will be generated from the text.
   * Note: This will fail if the key is already taken.
   */
  textTranslationKey?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new relation request by invite code. */
export type CreateOrGetRelationByInviteCodeInput = {
  /** Client date and time when the request is made. Used to check available rewards for relation creation. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** The type of invitation code.  */
  codeType: InvitationCodeType;
  /** The target (relation) user's invite code, which will be converted to an access code. */
  codeValue: Scalars['String']['input'];
};

/** Enumeration of response statuses for relation creation operations. */
export enum CreateOrGetRelationByInviteCodeResponseStatus {
  /** Feature is disabled for the user. */
  FeatureIsDisabled = 'FEATURE_IS_DISABLED',
  /** Feature requires a subscription upgrade. */
  FeatureRequiresSubscriptionUpgrade = 'FEATURE_REQUIRES_SUBSCRIPTION_UPGRADE',
  /** Friendship is forbidden for B2B users. */
  FriendshipB2BForbidden = 'FRIENDSHIP_B2B_FORBIDDEN',
  /** Friendship is forbidden for users without DPP entitlement. */
  FriendshipDppForbidden = 'FRIENDSHIP_DPP_FORBIDDEN',
  /** Friendship is forbidden due to specific entitlement. */
  FriendshipForSpecificEntitlementForbidden = 'FRIENDSHIP_FOR_SPECIFIC_ENTITLEMENT_FORBIDDEN',
  /** Initiator already has too many friends. */
  InitiatorTooManyFriends = 'INITIATOR_TOO_MANY_FRIENDS',
  /** Paid to freemium invite flow is disabled. */
  PaidToFreemiumInviteFlowDisabled = 'PAID_TO_FREEMIUM_INVITE_FLOW_DISABLED',
  /** Operation completed successfully. */
  Success = 'SUCCESS',
  /** Target user profile has been deleted. */
  TargetUserProfileDeleted = 'TARGET_USER_PROFILE_DELETED',
  /** Unknown or unmapped error. */
  UnknownError = 'UNKNOWN_ERROR',
  /** Unsupported business type for this operation. */
  UnsupportedBusinessTypeForOperation = 'UNSUPPORTED_BUSINESS_TYPE_FOR_OPERATION',
  /** B2C user needs to upgrade to freemium. */
  UpgradeB2CToFreemiumRequired = 'UPGRADE_B2C_TO_FREEMIUM_REQUIRED'
}

/** Union type containing either the success payload or the error response. */
export type CreateOrGetRelationByInviteCodeResponseUnion = CreateOrGetRelationError | CreateOrGetRelationPayload;

/** Response wrapper for the v2 relation creation mutation that returns errors as part of the response instead of throwing exceptions. */
export type CreateOrGetRelationByInviteCodeResponseV2 = {
  __typename?: 'CreateOrGetRelationByInviteCodeResponseV2';
  /** Union type containing either the success payload or the error response. */
  response: CreateOrGetRelationByInviteCodeResponseUnion;
  /** Status indicating the result of the operation. */
  responseDetails: CreateOrGetRelationByInviteCodeResponseStatus;
};

/** Generic error response for relation creation failures. */
export type CreateOrGetRelationError = {
  __typename?: 'CreateOrGetRelationError';
  /** Error code(e.g., "UNKNOWN", "TARGET_USER_PROFILE_DELETED"). */
  errorCode: Scalars['String']['output'];
  /** Human-readable or not error message. */
  errorMessage: Scalars['String']['output'];
  /** Target user profile. Only present for certain error types that require user data (e.g., UPGRADE_B2C_TO_FREEMIUM_REQUIRED). */
  targetUser?: Maybe<NoomUserPreviewProfile>;
};

/** Payload returned after attempting to create a relation connection. */
export type CreateOrGetRelationPayload = {
  __typename?: 'CreateOrGetRelationPayload';
  /** Available rewards earned through this relation creation. */
  availableRewards: Array<Maybe<RelationAvailableReward>>;
  /** True if a new request was created; false if an existing record was returned. */
  created: Scalars['Boolean']['output'];
  /** The resulting relation (newly created or existing). */
  relation: Relation;
};

/** Input for creating a relation request. */
export type CreateRelationRequestInput = {
  /** Client date and time when the request is made. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Type of relation (e.g., friendship). */
  relationType: RelationType;
  /** The target user's access code. */
  targetUserAccessCode: Scalars['String']['input'];
};

/** Response returned after creating a relation request. Includes operation state and the request entity when created or idempotent (similar to create-or-get relation by invite). */
export type CreateRelationRequestResponse = {
  __typename?: 'CreateRelationRequestResponse';
  /** The relation request when created or when idempotent (existing request); null if the operation failed (e.g. limit reached). */
  relationRequest?: Maybe<RelationRequest>;
  /** State of the operation (e.g. CREATED, REQUEST_ALREADY_EXISTS, SOURCE_USER_RELATION_LIMIT_REACHED). */
  state: RelationRequestOperationState;
};

/** Input type for creating a new scheduled content. */
export type CreateScheduledContentInput = {
  /** ID of the content to be scheduled (e.g., art gallery ID) (required) */
  contentId: Scalars['ID']['input'];
  /** Type of content being scheduled (optional) */
  contentType?: InputMaybe<ScheduledContentType>;
  /** End date and time of the scheduled content (required) */
  endDateTime: Scalars['LocalDateTime']['input'];
  /** Start date and time of the scheduled content (required) */
  startDateTime: Scalars['LocalDateTime']['input'];
  /** Initial status of the scheduled content (optional) */
  status?: InputMaybe<ContentStatus>;
};

/** Input for creating a short URL */
export type CreateShortUrlInput = {
  /** The destination URL to redirect to */
  destinationUrl: Scalars['String']['input'];
  /** Optional custom slug. If not provided, one will be auto-generated. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for creating a new mapping. All fields required by EF. */
export type CreateSkuRegistryEntryInput = {
  internalSku: Scalars['String']['input'];
  productType: SkuProductType;
  vendor: SkuVendor;
  vendorSku: Scalars['String']['input'];
};

export type CreatorsToExclude = {
  creators?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Content for a cross-sell pitch ad. */
export type CrossSellPitchContent = {
  __typename?: 'CrossSellPitchContent';
  /** The text of the badge displayed alongside the title. */
  badgeText: Scalars['String']['output'];
  /** A bullet list of benefits to display in the pitch. */
  benefits: Array<Scalars['String']['output']>;
  /** URL of the header image shown at the top of the pitch. */
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Primary CTA button. */
  primaryButton?: Maybe<Button>;
  /** Secondary CTA button. */
  secondaryButton?: Maybe<Button>;
  /** The title shown at the top of the pitch. */
  title: Scalars['String']['output'];
  /**
   * Based on the upsell ad location type we might have to show a different
   * entry page for the upsell ad. This field will represent that.
   */
  upsellAdUrl?: Maybe<Scalars['String']['output']>;
};

/** A customer satisfaction survey that can be presented to the user to get feedback */
export type CsatSurvey = {
  __typename?: 'CsatSurvey';
  id: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  status: CsatSurveyStatus;
  textFeedback?: Maybe<Scalars['String']['output']>;
  type: CsatSurveyType;
};

/** The status of a given customer satisfaction survey */
export enum CsatSurveyStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED'
}

/** The type of a given customer satisfaction survey */
export enum CsatSurveyType {
  Deprecated = 'DEPRECATED',
  LongTermCoachInteraction = 'LONG_TERM_COACH_INTERACTION',
  ShortTermCoachInteraction = 'SHORT_TERM_COACH_INTERACTION'
}

/** Available currencies for rewards */
export enum CurrencyCode {
  /** Currency awarded for gamification action */
  Seeds = 'SEEDS'
}

/** Rewards celebration shown when user earns currency. It has two variants: modal and toast */
export type CurrencyEarnedCelebration = {
  __typename?: 'CurrencyEarnedCelebration';
  /** Currency amount earned in currency units. */
  amountEarned: Scalars['Int']['output'];
  /** Type of in-app flow. */
  flowType: CurrencyEarnedCelebrationFlowType;
  /** New rewards balance in currency units. */
  newBalance: Scalars['Int']['output'];
  /** Data on rewards sharing */
  rewardSharingData?: Maybe<RewardSharingData>;
};

/**
 * Type of currency earned flow shown to the user.
 * In older versions of the app that do not recognize the flow type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedCelebrationFlowType = CurrencyEarnedCelebrationModal | CurrencyEarnedCelebrationToast;

/** Currency earned modal flow */
export type CurrencyEarnedCelebrationModal = {
  __typename?: 'CurrencyEarnedCelebrationModal';
  /** Reason for modal celebration. Drives the subtitle text shown in the modal. */
  earningReason?: Maybe<CurrencyEarnedReason>;
  /** Animation to display in the modal. Default is SEED_DROP_LARGE. */
  seedsAnimation?: Maybe<CurrencyEarnedModalSeedsAnimation>;
};

/** Currency earned toast flow */
export type CurrencyEarnedCelebrationToast = {
  __typename?: 'CurrencyEarnedCelebrationToast';
  /** Reason for toast notification. Used to drive text displayed in the toast. */
  earningReason?: Maybe<CurrencyEarnedReason>;
};

/**
 * DEPRECATED: use CurrencyEarnedCelebration instead.
 * We're simplifying the flow by removing the progress bar, reward unlocking, and first time earning experience.
 */
export type CurrencyEarnedEvent = {
  __typename?: 'CurrencyEarnedEvent';
  /** Currency amount earned in currency units. */
  amountEarned: Scalars['Int']['output'];
  /** New rewards balance in currency units. */
  newBalance: Scalars['Int']['output'];
  /** Type of in-app notification. */
  notification: CurrencyEarnedNotificationType;
};

/** DEPRECATED */
export type CurrencyEarnedModal = {
  __typename?: 'CurrencyEarnedModal';
  /**
   * Screens to show before the main currency earned modal flow is shown.
   * @deprecated Additional screens will be provided as part of the synchronous mutation result in the celebration field in GamificationActionResult
   */
  leadingScreens?: Maybe<Array<CurrencyEarnedModalScreen>>;
  /** Flow for modal notification. Used to drive specific screens used for the notification. */
  modalFlow: CurrencyEarnedModalFlow;
  /** Reason for modal notification. Drives the subtitle text shown in the modal. */
  modalReason: CurrencyEarnedModalReason;
  /** Animation to use in the first screen that shows the amount earned. Default is SEED_DROP_LARGE. */
  seedsAnimation?: Maybe<CurrencyEarnedModalSeedsAnimation>;
  /** Whether to show the progress bar. Default is true. */
  showProgressBar?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * DEPRECATED
 * Flow for the currency earned modal notification.
 * In older versions of the app that do not recognize the flow type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedModalFlow = CurrencyEarnedModalIntro | CurrencyEarnedModalProgress | CurrencyEarnedModalRewardUnlocked;

/** DEPRECATED */
export type CurrencyEarnedModalIntro = {
  __typename?: 'CurrencyEarnedModalIntro';
  /**
   * Next reward that can be unlocked.
   * This will typically be non-null but the field is optional to keep consistency with other CurrencyEarnedModalFlow subtypes.
   * This is due to a GraphQL limitation where fields with the same name across different child types of a union need to have the same type.
   */
  nextReward?: Maybe<CurrencyEarnedReward>;
  /** Title that is shown in intro flow. */
  title?: Maybe<CurrencyEarnedModalIntroTitle>;
};

/**
 * DEPRECATED
 * Intro title for the currency earned modal notification.
 * This drives title text shown in the modal.
 * In older versions of the app that do not recognize the modal reason, EARN_SEEDS_FOR_NOOMCOIN will be used.
 */
export enum CurrencyEarnedModalIntroTitle {
  /** Title will be similar to 'You get Seeds every time you earn your daily Noomcoin!' */
  EarnSeedsForNoomcoin = 'EARN_SEEDS_FOR_NOOMCOIN',
  /** Title will be similar to 'You get Seeds every time you earn your daily Noomcoin or weigh in for the first time in a week!' */
  EarnSeedsForNoomcoinAndFirstWeeklyWeighIn = 'EARN_SEEDS_FOR_NOOMCOIN_AND_FIRST_WEEKLY_WEIGH_IN'
}

/** DEPRECATED */
export type CurrencyEarnedModalProgress = {
  __typename?: 'CurrencyEarnedModalProgress';
  /** Next reward that can be unlocked. Null if no further reward can be unlocked. */
  nextReward?: Maybe<CurrencyEarnedReward>;
};

/**
 * DEPRECATED
 * Reason for the currency earned modal notification.
 * This drives subtitle text shown in the modal.
 * In older versions of the app that do not recognize the modal reason, the text will not be shown.
 */
export enum CurrencyEarnedModalReason {
  /** User completed first weigh-in in the current week. */
  FirstWeeklyWeighIn = 'FIRST_WEEKLY_WEIGH_IN',
  /** Reason for earning the currency will not be displayed. */
  None = 'NONE',
  /** User earned a Noomcoin. */
  Noomcoin = 'NOOMCOIN'
}

/** DEPRECATED */
export type CurrencyEarnedModalRewardUnlocked = {
  __typename?: 'CurrencyEarnedModalRewardUnlocked';
  /** Next reward that can be unlocked. Null if no further reward can be unlocked. */
  nextReward?: Maybe<CurrencyEarnedReward>;
  /** Reward that was unlocked. */
  unlockedReward: CurrencyEarnedReward;
};

/**
 * DEPRECATED
 * Union representing other screens that can be shown during the currency earned modal flow.
 * In older versions of the app that do not recognize the screen type, the screen will be ignored and not displayed.
 */
export type CurrencyEarnedModalScreen = GoalAchievedScreen;

/**
 * Animation to use in the first screen of the modal.
 * In older versions of the app that do not recognize the animation type:
 * - SEED_DROP_LARGE will be used for amounts >= 500
 * - SEED_DROP_MEDIUM will be used for amounts < 500
 */
export enum CurrencyEarnedModalSeedsAnimation {
  /** Large seed drop animation, used for larger earning amounts. */
  SeedDropLarge = 'SEED_DROP_LARGE',
  /** Medium seed drop animation, used for smaller earning amounts. */
  SeedDropMedium = 'SEED_DROP_MEDIUM'
}

/**
 * DEPRECATED
 * Type of currency earned notification shown to the user.
 * In older versions of the app that do not recognize the notification type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedNotificationType = CurrencyEarnedModal | CurrencyEarnedToast;

/**
 * Reason for the currency earned modal celebration.
 * This drives the copy shown on the modal and toast.
 * In older versions of the app that do not recognize the reason, in case of modal flow the text will not be shown, and in case of toast flow,
 * a generic earning message will be displayed.
 */
export enum CurrencyEarnedReason {
  /** User completed an art break. */
  ArtBreak = 'ART_BREAK',
  /** User performed a body scan. */
  BodyScan = 'BODY_SCAN',
  /** User has consumed a curriculum content item. */
  CurriculumContent = 'CURRICULUM_CONTENT',
  /** User performed a facial blood scan. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** User logged food/meal data. */
  FoodLogging = 'FOOD_LOGGING',
  /** User created a friendship */
  FriendshipCreated = 'FRIENDSHIP_CREATED',
  /** Reward shared by friend earning a reward */
  FriendRewardShared = 'FRIEND_REWARD_SHARED',
  /** User logged green calories. */
  GreenCaloriesLogging = 'GREEN_CALORIES_LOGGING',
  /** User achieved their green calorie goal. */
  GreenCalorieGoal = 'GREEN_CALORIE_GOAL',
  /** User logged med data. */
  MedLogging = 'MED_LOGGING',
  /** User completed micro challenge */
  MicroChallengeCompleted = 'MICRO_CHALLENGE_COMPLETED',
  /** User recorded micro challenge progress */
  MicroChallengeProgressed = 'MICRO_CHALLENGE_PROGRESSED',
  /** User logged mood. */
  MoodLogging = 'MOOD_LOGGING',
  /** User logged movement. */
  MoveLogging = 'MOVE_LOGGING',
  /** User earned a Noomcoin. */
  Noomcoin = 'NOOMCOIN',
  /** User achieved their protein goal. */
  ProteinGoal = 'PROTEIN_GOAL',
  /** User logged protein. */
  ProteinLogging = 'PROTEIN_LOGGING',
  /** User has consumed a standalone content item (initially article, but type may expand). */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User has banked currency for steps. */
  StepsBanked = 'STEPS_BANKED',
  /** Steps goal achieved. */
  StepsGoalAchieved = 'STEPS_GOAL_ACHIEVED',
  /** User reached a milestone streak length. */
  StreakMilestone = 'STREAK_MILESTONE',
  /** User logged stress data. */
  StressLogging = 'STRESS_LOGGING',
  /** User logged water drinking. */
  WaterLogging = 'WATER_LOGGING',
  /** User completed weigh in task. */
  WeighIn = 'WEIGH_IN'
}

/** DEPRECATED */
export type CurrencyEarnedReward = {
  __typename?: 'CurrencyEarnedReward';
  /** Amount required to redeem reward in currency units. */
  amount: Scalars['Int']['output'];
  /** Image for the reward */
  image: RewardImage;
  /** Type of reward */
  type: CurrencyEarnedRewardType;
};

/** DEPRECATED */
export type CurrencyEarnedRewardCharity = {
  __typename?: 'CurrencyEarnedRewardCharity';
  /** Dummy field. Needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** DEPRECATED */
export type CurrencyEarnedRewardGiftCard = {
  __typename?: 'CurrencyEarnedRewardGiftCard';
  /** Monetary amount of gift card */
  value: Money;
};

/** DEPRECATED */
export type CurrencyEarnedRewardType = CurrencyEarnedRewardCharity | CurrencyEarnedRewardGiftCard;

/** DEPRECATED */
export type CurrencyEarnedToast = {
  __typename?: 'CurrencyEarnedToast';
  /** Reason for toast notification. Used to drive text and image assets used for the notification. */
  toastReason: CurrencyEarnedToastReason;
};

/**
 * DEPRECATED
 * Reason for the currency earned toast notification.
 * This drives text shown in the toast.
 * In older versions of the app that do not recognize the toast reason, the toast will not be shown.
 */
export enum CurrencyEarnedToastReason {
  /** User weighs in for the first time in a calendar week and receives bonus currency. */
  WeighInBonus = 'WEIGH_IN_BONUS'
}

/** Payload for ART_BREAK content items. */
export type CurriculumArtBreakContent = {
  __typename?: 'CurriculumArtBreakContent';
  /** Title of the gallery for the art break */
  galleryTitle?: Maybe<Scalars['String']['output']>;
  /** Primary image URL for the art break content */
  primaryImageUrl?: Maybe<Scalars['String']['output']>;
  /** Secondary image URL for the art break content */
  secondaryImageUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Consumption state response wrapper for curriculum tasks.
 * This wrapper exists (instead of a top-level list) to allow future extensibility such as pagination.
 */
export type CurriculumContentConsumptionState = {
  __typename?: 'CurriculumContentConsumptionState';
  /** The list of tasks returned by curriculum-api for the requested content type and timestamps */
  curriculumTasks: Array<CurriculumTask>;
};

/** An individual content item within a curriculum task section. */
export type CurriculumContentItem = {
  __typename?: 'CurriculumContentItem';
  /** Content-type specific payload for this item */
  content: CurriculumContentPayload;
  /** URL for the content item (e.g., deep link or web URL) */
  contentUrl: Scalars['String']['output'];
  /** Optional description seed data used by clients to generate display text */
  descriptionSeeds?: Maybe<CurriculumDescriptionSeeds>;
  /** Whether the user has completed this content item */
  isCompleted: Scalars['Boolean']['output'];
};

/**
 * Content payload for a curriculum content item.
 * This union allows adding new content types without breaking existing clients.
 */
export type CurriculumContentPayload = CurriculumArtBreakContent;

/** Metadata for how a task is displayed/organized into a section, including the ordered items in that section. */
export type CurriculumContentTaskSectionAssignment = {
  __typename?: 'CurriculumContentTaskSectionAssignment';
  /** Ordered content items for this section */
  items: Array<CurriculumContentItem>;
  /** Section subtitle */
  subtitle: Scalars['String']['output'];
  /** Section title */
  title: Scalars['String']['output'];
};

/**
 * Content types supported by curriculum-api for content consumption tasks.
 * Start small (ART_BREAK) and extend as backend adds new types.
 */
export enum CurriculumContentType {
  /** Art break content tasks */
  ArtBreak = 'ART_BREAK'
}

/** Seed data used to construct human-readable descriptions for content items. */
export type CurriculumDescriptionSeeds = {
  __typename?: 'CurriculumDescriptionSeeds';
  /** A seed value used by clients to generate the description */
  value: Scalars['String']['output'];
};

/**
 *  These values should be aligned with:
 *  - noom_contracts/backend/curriculum/model/shared.proto (CurriculumEditorActionTypeProto.Value)
 */
export enum CurriculumEditorAction {
  Delete = 'DELETE',
  Publish = 'PUBLISH',
  SaveDraft = 'SAVE_DRAFT',
  SendToQa = 'SEND_TO_QA',
  Unknown = 'UNKNOWN'
}

/**  Details about an editor action. It shows when was an editor action last taken (if at all). */
export type CurriculumEditorActionDetails = {
  __typename?: 'CurriculumEditorActionDetails';
  /**
   *  The action last taken datetime can be null if we need to report about
   *  an action that has never been taken.
   */
  actionLastTakenAt?: Maybe<Scalars['LocalDateTime']['output']>;
  actionType: CurriculumEditorAction;
};

/**  Composes all details about actions editors can take or have taken */
export type CurriculumEditorActionsDetails = {
  __typename?: 'CurriculumEditorActionsDetails';
  editorActionDetails: Array<CurriculumEditorActionDetails>;
  nextEditorActions: Array<CurriculumEditorAction>;
};

/** A tool representing a curriculum feature */
export type CurriculumFeatureTool = {
  __typename?: 'CurriculumFeatureTool';
  /** The curriculum feature type */
  feature: ProgramProgressCurriculumFeature;
};

/** Represents a module within a curriculum program */
export type CurriculumModule = {
  __typename?: 'CurriculumModule';
  /** Optional description of the module */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the module */
  moduleId: Scalars['UUID']['output'];
  /** Name of the module */
  name: Scalars['String']['output'];
};

export type CurriculumModules = {
  __typename?: 'CurriculumModules';
  curriculumModules: Array<CurriculumModule>;
};

/** Clients may specify filtering options to control which modules they need */
export type CurriculumModulesFilters = {
  /** If specified, filters the list of modules by this list of module IDs, in the same order */
  moduleIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If specified, filters the list of modules by module name */
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** If specified, returned modules must be referenced by the specified program */
  programConfigId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Basic definition of a program within a curriculum */
export type CurriculumProgram = {
  __typename?: 'CurriculumProgram';
  /** Program description. It's present for all programs, but it's optional in CurE, so it's optional here. */
  description?: Maybe<Scalars['String']['output']>;
  /** Program name */
  name: Scalars['String']['output'];
  /** Program Config ID coming from CurE. The same as in Curriculum API. */
  programConfigId: Scalars['UUID']['output'];
};

export type CurriculumPrograms = {
  __typename?: 'CurriculumPrograms';
  programs: Array<CurriculumProgram>;
};

/** A single task within the curriculum content consumption response. */
export type CurriculumTask = {
  __typename?: 'CurriculumTask';
  /** Section assignment information for this task */
  contentTaskSectionAssignment: CurriculumContentTaskSectionAssignment;
  /** The content type of this task */
  taskType: CurriculumContentType;
};

export type CurriculumWorkflowActionInput = {
  actionId: Scalars['ID']['input'];
  actionType: CurriculumEditorAction;
  objectId: Scalars['ID']['input'];
  objectType: CurriculumWorkflowObjectType;
};

/**
 *  These values should be aligned with:
 *  - noom_contracts/backend/curriculum/model/shared.proto (CurriculumWorkflowActionObjectTypeProto)
 */
export enum CurriculumWorkflowObjectType {
  Foundation = 'FOUNDATION',
  Unknown = 'UNKNOWN'
}

/** Metadata for a single page from a paginated set of results */
export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  /** Opaque token which represents the cursor for the current page */
  currentPageCursor: Scalars['String']['output'];
  /** Opaque token the client may use to fetch the next page, or null if none exists */
  nextPageCursor?: Maybe<Scalars['String']['output']>;
};

/** Provides the client the ability to paginate through a list of results */
export type CursorPagination = {
  /** Opaque token that specifies the page of results to retrieve. If unset, will default to the first page */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of results to include in the response. Note the backend may impose a stricter limit than
   * the client requests.
   */
  first: Scalars['Int']['input'];
  /** Dictates the order in which the results are returned. At least one Sort predicate must be defined */
  sort: Array<Sort>;
};

export type DailyStepsPayload = {
  __typename?: 'DailyStepsPayload';
  target: Scalars['Int']['output'];
};

export type DashboardAiacConfig = {
  __typename?: 'DashboardAiacConfig';
  isDashboardAiacEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a day of the week */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DecagonSignatureToken = {
  __typename?: 'DecagonSignatureToken';
  /** Specifies the user business type - B2B or B2C */
  businessType?: Maybe<BusinessType>;
  /** List of user entitlements */
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp when the signature expires, represented as Unix epoch time */
  expiryEpochInSeconds: Scalars['Int']['output'];
  /** The external user id corresponding to the user access code for whom the signature is generated */
  externalUserId: Scalars['String']['output'];
  /** Any additional metadata serialized as JSON string */
  metadataJson?: Maybe<Scalars['String']['output']>;
  /** ID of the user's associated B2B Partner */
  partnerId?: Maybe<Scalars['Int']['output']>;
  /** Name of the user's associated B2B Partner */
  partnerName?: Maybe<Scalars['String']['output']>;
  /** HMAC-SHA256 signature used for validating the authenticity of the user with Decagon */
  signature: Scalars['String']['output'];
  /** User subscription tier */
  subscriptionTier?: Maybe<SubscriptionTier>;
};

/** Input to delete a PTO record for a CDU. */
export type DeleteCduPersonalTimeOffInput = {
  /** CDU access code for the coach. */
  cduAccessCode: Scalars['String']['input'];
  /** PTO record identifier to delete. */
  id: Scalars['Int']['input'];
};

/** Result of a CDU PTO deletion. */
export type DeleteCduPersonalTimeOffResponse = {
  __typename?: 'DeleteCduPersonalTimeOffResponse';
  /** Indicates if PTO was deleted or not. */
  deleted: Scalars['Boolean']['output'];
};

/** Input for deleting a relations request. */
export type DeleteRelationInput = {
  /** The type of relations.  */
  relationType: RelationType;
  /** The target user's access code. */
  targetUserAccessCode: Scalars['String']['input'];
};

/** Payload returned after attempting to delete a relations. */
export type DeleteRelationPayload = {
  __typename?: 'DeleteRelationPayload';
  /** True if a relations was deleted; false if a relations can't be deleted for some reason. */
  success: Scalars['Boolean']['output'];
};

/** Response from successfully deleting scheduled content */
export type DeleteScheduledContentResponse = {
  __typename?: 'DeleteScheduledContentResponse';
  /** The scheduled content that was deleted */
  scheduledContent: ScheduledContent;
};

/**
 * Payload returned when disabling external health records connection
 * for a user.
 */
export type DisableHealthRecordsConnectionPayload = {
  __typename?: 'DisableHealthRecordsConnectionPayload';
  /**
   * User-facing error message when the connection could not be disabled.
   * Present only when success is false and the client should display this message.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Returns true if the disconnection was successful, otherwise false. */
  success: Scalars['Boolean']['output'];
};

/** Union of discoverability promo variants. Exactly one variant is returned depending on the user's current state. */
export type DiscoverabilityPromo = AddPhoneNumberPromo | ConsentPromo;

/** The data necessary to render the Discoverability Promo card. */
export type DiscoverabilityPromoCard = {
  __typename?: 'DiscoverabilityPromoCard';
  /** The specific promo variant to display. */
  promo: DiscoverabilityPromo;
};

/** Input for dismissing a customer satisfaction survey */
export type DismissCsatSurveyInput = {
  dismissedBy: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};

export type Document = {
  __typename?: 'Document';
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  lastAcceptedTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  type: DocumentType;
};

/** Enum representing the different types of documents that can be accepted */
export enum DocumentType {
  /** Business Associate Agreement (BAA) */
  Baa = 'BAA',
  CoachLicenseAgreement = 'COACH_LICENSE_AGREEMENT',
  /** Data Processing Agreement (DPA) */
  Dpa = 'DPA',
  PrivacyPolicy = 'PRIVACY_POLICY'
}

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum DoseUnits {
  DoseInG = 'DOSE_IN_G',
  DoseInMcg = 'DOSE_IN_MCG',
  DoseInMg = 'DOSE_IN_MG',
  DoseInMl = 'DOSE_IN_ML',
  DoseInPercent = 'DOSE_IN_PERCENT',
  Each = 'EACH',
  Unknown = 'UNKNOWN'
}

/** Encapsulates the data needed to render the calorie goal settings screen */
export type DynamicCalorieGoalSettingsState = {
  __typename?: 'DynamicCalorieGoalSettingsState';
  /** The activity level for the user */
  activityLevel: ActivityLevel;
  /** Whether the user has enabled external BMR source */
  externalBmrEnabled: Scalars['Boolean']['output'];
  /** Optional external BMR value, used to replace the BMR calculated from weight, height and gender */
  externalBmrValue?: Maybe<Scalars['Int']['output']>;
  /** Number of calories to manually add (if positive number) or subtract (if negative) from the calculated BMR. */
  manualCalorieAdjustment?: Maybe<Scalars['Int']['output']>;
};

/** DEPRECATED: Represents the different ways user can earn rewards currency */
export type EarnCurrencyMethod = {
  __typename?: 'EarnCurrencyMethod';
  /** The type of method used to earn rewards currency */
  type: EarnCurrencyMethodType;
  /** Currency units (seeds) awarded when requirements are met. */
  value: Scalars['Int']['output'];
};

/** DEPRECATED: The different types of earn currency methods */
export enum EarnCurrencyMethodType {
  /** Earn currency by earning 1 noomcoin */
  Noomcoin = 'NOOMCOIN',
  /** Earn currency by weighing in */
  WeighIn = 'WEIGH_IN'
}

export enum EatingReason {
  Bored = 'BORED',
  DontKnow = 'DONT_KNOW',
  Hungry = 'HUNGRY',
  ItWasTime = 'IT_WAS_TIME',
  Social = 'SOCIAL',
  Stressed = 'STRESSED',
  Tired = 'TIRED'
}

/**
 * Full shipping address for an order.
 * Maps to billing.address.AddressProto in noom_contracts/billing/address/address.proto.
 */
export type EfAddressInput = {
  /** Address line 1. */
  addressLine1: Scalars['String']['input'];
  /** Address line 2. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City. */
  city: Scalars['String']['input'];
  /** ISO country code. */
  countryCode: Scalars['String']['input'];
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Postal/ZIP code. */
  postalCode: Scalars['String']['input'];
  /** Recipient name. */
  recipient: Scalars['String']['input'];
  /** State/province/zone code. */
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for creating a new fulfillment order.
 * Maps to CreateOrderRequestProto.Body in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
 */
export type EfCreateOrderInput = {
  /**
   * Optional user access code. When omitted, gql-java resolves the caller's access code
   * from the auth token (`accessCode` claim or `sub`). Callers creating orders for another
   * user (e.g. Supportland) must supply the target user's access code.
   */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Full shipping address. */
  address: EfAddressInput;
  /** Typed caller metadata, stored immutably and passed to vendor at submission. May include PHI. */
  domainContext?: InputMaybe<EfDomainContextInput>;
  /**
   * Caller-provided operation key (stable across retries).
   * - The key must represent one logical create-order intent and remain stable across retries for that intent.
   * - Reuse the same key after timeouts/retries; do not generate a new random key per retry attempt.
   * - Use a different key for a new intent (e.g., replacement order).
   * - Prefer stable business identifiers (e.g., lab_order_id, enrollment_id) over transport-level request IDs.
   */
  idempotencyKey: Scalars['String']['input'];
  /** UUID of the order this replaces (informational). */
  replacedOrderId?: InputMaybe<Scalars['ID']['input']>;
  /** Reason this order replaces another (optional, informational). */
  replacementReason?: InputMaybe<EfOrderReplacementReason>;
  /** List of SKUs to fulfill. */
  skus: Array<EfSkuLineItemInput>;
  /** What initiated order creation (optional in GraphQL; maps to UNKNOWN when omitted). */
  trigger?: InputMaybe<EfOrderTrigger>;
};

/**
 * Response for a created fulfillment order.
 * Maps to CreateOrderResponseProto in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
 */
export type EfCreateOrderResponse = {
  __typename?: 'EfCreateOrderResponse';
  /** UUID of the created order. */
  orderId: Scalars['ID']['output'];
};

/**
 * Domain-specific context for an order. Use exactly one context type.
 * Maps to DomainContextProto in noom_contracts/external_fulfillment/shared.proto.
 */
export type EfDomainContextInput = {
  /** Context for lab orders. */
  labOrderContext?: InputMaybe<EfLabOrderContextInput>;
  /** Context for OTC supplement orders. */
  otcSupplementDomainContext?: InputMaybe<EfOtcSupplementDomainContextInput>;
};

/**
 * Context for lab orders.
 * Maps to LabOrderContextProto in noom_contracts/external_fulfillment/shared.proto.
 */
export type EfLabOrderContextInput = {
  /** Internal tracking ID for the lab order. */
  internalTrackingId: Scalars['String']['input'];
};

/**
 * Reason for replacing an order.
 * Maps to OrderReplacementReasonEnumProto.Value in noom_contracts/external_fulfillment/shared.proto.
 * Keep in sync with the proto.
 */
export enum EfOrderReplacementReason {
  /** Agent-selected: fulfillment or vendor error (e.g. wrong items shipped). */
  FulfillmentError = 'FULFILLMENT_ERROR',
  /** Agent-selected: member provided incorrect information or requested the wrong product. */
  MemberError = 'MEMBER_ERROR',
  PharmacyHubOrderHeld = 'PHARMACY_HUB_ORDER_HELD',
  /** User reported the product arrived damaged. */
  ProductDamaged = 'PRODUCT_DAMAGED',
  /** User reported the product arrived incomplete (missing items). */
  ProductIncomplete = 'PRODUCT_INCOMPLETE',
  /** User reported the product never arrived. */
  ProductNotReceived = 'PRODUCT_NOT_RECEIVED',
  Unknown = 'UNKNOWN'
}

/**
 * What initiated order creation.
 * Maps to OrderTriggerEnumProto.Value in noom_contracts/external_fulfillment/shared.proto.
 * Keep in sync with the proto.
 */
export enum EfOrderTrigger {
  /** Admin or ops manual order. */
  Manual = 'MANUAL',
  /** Standalone one-time OTC purchase. */
  OneTimePurchase = 'ONE_TIME_PURCHASE',
  /** Subscription fulfillment (initial or renewal). */
  Subscription = 'SUBSCRIPTION',
  /** CX tooling (e.g. Supportland). */
  Supportland = 'SUPPORTLAND',
  Unknown = 'UNKNOWN'
}

/**
 * Context for OTC supplement orders.
 * Maps to OtcSupplementDomainContextProto in noom_contracts/external_fulfillment/shared.proto.
 */
export type EfOtcSupplementDomainContextInput = {
  /** User email address. */
  email: Scalars['String']['input'];
};

/**
 * Input for reordering a fulfillment order.
 * Maps to CreateOrderRequestProto.Body in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
 */
export type EfReorderInput = {
  /**
   * Optional user access code. When omitted, gql-java resolves the caller's access code
   * from the auth token (`accessCode` claim or `sub`). Callers creating orders for another
   * user (e.g. Supportland) must supply the target user's access code.
   */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Full shipping address. */
  address: EfAddressInput;
  /** Typed caller metadata, stored immutably and passed to vendor at submission. May include PHI. */
  domainContext?: InputMaybe<EfDomainContextInput>;
  /**
   * Caller-provided operation key (stable across retries).
   * - The key must represent one logical create-order intent and remain stable across retries for that intent.
   * - Reuse the same key after timeouts/retries; do not generate a new random key per retry attempt.
   * - Use a different key for a new intent (e.g., replacement order).
   * - Prefer stable business identifiers (e.g., lab_order_id, enrollment_id) over transport-level request IDs.
   */
  idempotencyKey: Scalars['String']['input'];
  /** UUID of the order this replaces. */
  replacedOrderId: Scalars['ID']['input'];
  /** Reason this order replaces another (informational). */
  replacementReason?: InputMaybe<EfOrderReplacementReason>;
  /** List of SKUs to fulfill. */
  skus: Array<EfSkuLineItemInput>;
  /** What initiated order creation (optional in GraphQL; maps to UNKNOWN when omitted). */
  trigger?: InputMaybe<EfOrderTrigger>;
};

/**
 * Response for a reordered fulfillment order.
 * Maps to CreateOrderResponseProto in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
 */
export type EfReorderResponse = {
  __typename?: 'EfReorderResponse';
  /** UUID of the created order. */
  orderId: Scalars['ID']['output'];
};

/**
 * SKU line item for an order.
 * Maps to SkuLineItemProto in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
 */
export type EfSkuLineItemInput = {
  /** Quantity to fulfill. */
  quantity: Scalars['Int']['input'];
  /** Noom-internal SKU code (validated against sku_registry at runtime). */
  sku: Scalars['String']['input'];
};

/** Represents a Streak Freeze product */
export type EngagementStreakFreezeProductListing = {
  __typename?: 'EngagementStreakFreezeProductListing';
  /** Required amount to redeem a streak freeze */
  amount: RewardsMoney;
  /** Whether the user meets the product specific eligibility criteria */
  isRedemptionEligible: Scalars['Boolean']['output'];
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
};

/** Represents a Streak Repair product */
export type EngagementStreakRepairProductListing = {
  __typename?: 'EngagementStreakRepairProductListing';
  /** Required amount to redeem a streak repair */
  amount: RewardsMoney;
  /** Whether if the user meets the product specific eligibility criteria */
  isRedemptionEligible: Scalars['Boolean']['output'];
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
  /** Length of the broken streak to be repaired */
  streakLength: Scalars['Int']['output'];
};

/** Status of user that is enrolled in rewards program. */
export type EnrolledRewardsState = {
  __typename?: 'EnrolledRewardsState';
  /** Rewards balance in currency units (seeds). */
  balance: Scalars['Int']['output'];
};

export type ExampleArticle = ExampleInterfaceContent & {
  __typename?: 'ExampleArticle';
  /**  Text body of the article */
  body: Scalars['String']['output'];
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

/**  If the items in your union don't need any fields of their own, consider using an enum instead */
export enum ExampleEnumStatus {
  Failure = 'FAILURE',
  /**  States in the enum don't have their own fields, but represent distinct, non-overlapping cases like unions do. */
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/**
 *  If fields are shared between types, an interface allows for easier querying by specifying those fields once at the top
 *  level instead of repeating those fields for each type. The shared fields still have to be defined on each implementing
 *  type. Interfaces aren't allowed to end with the word interface!
 */
export type ExampleInterfaceContent = {
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

export type ExampleMultipleChoiceQuiz = ExampleInterfaceContent & {
  __typename?: 'ExampleMultipleChoiceQuiz';
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  List of multiple choice options to choose from */
  options: Array<Scalars['String']['output']>;
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

export type ExampleNullableItem = {
  __typename?: 'ExampleNullableItem';
  /**  Fields with ! are required */
  id: Scalars['ID']['output'];
  /**  Fields without ! can be omitted */
  optionalField?: Maybe<Scalars['String']['output']>;
};

/**
 *  Different list nullability states. Use the non-null list, non-null items by default. Nullable list items pose a risk.
 *  Only use nullableListNonNullItems if you need to model empty lists and null lists as separate states.
 */
export type ExampleNullableList = {
  __typename?: 'ExampleNullableList';
  /**  RECOMMENDED DEFAULT: list can't be null, items within the list can't be null */
  nonNullListNonNullItems: Array<ExampleNullableItem>;
  /**  AVOID: list can't be null, items within the list can be null */
  nonNullListNullableItems: Array<Maybe<ExampleNullableItem>>;
  /**  USE SPARINGLY: list can be null, items within the list can't be null */
  nullableListNonNullItems?: Maybe<Array<ExampleNullableItem>>;
  /**  AVOID: list can be null, items within the list can be null */
  nullableListNullableItems?: Maybe<Array<Maybe<ExampleNullableItem>>>;
};

export type ExampleStatusFailure = {
  __typename?: 'ExampleStatusFailure';
  /**  Error message to display to the user */
  errorMessage: Scalars['String']['output'];
};

/**
 *  In Protobuf, we achieve polymorphism using one-ofs, which specify an exclusive list of types that could be included.
 *  GraphQL doesn't have that construct, but does offer both interfaces and unions as mechanisms to model polymorphism.
 *  Both interfaces and unions have to be defined ahead of time. If it's unclear whether we'll need to support
 *  polymorphism, it's much better not to use a union or an interface since it may lead to restrictive or unintuitive type
 *  modeling down the line! In these cases, using a semantic comment above fields is a reasonable compromise.
 *  Unions are useful for describing types which have distinct possible states that don't have overlapping fields. They
 *  can be used to model scenarios which are more complicated than enums since each type within the union can have fields
 *  that are specific to that type. However, if there are shared fields between the types, an interface may be a better
 *  fit.
 */
export type ExampleStatusPending = {
  __typename?: 'ExampleStatusPending';
  /**  When the operation began */
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ExampleStatusSuccess = {
  __typename?: 'ExampleStatusSuccess';
  /**  Time the operation took to complete */
  timeElapsedMs: Scalars['Int']['output'];
};

export type ExampleStepData = {
  __typename?: 'ExampleStepData';
  /**  Step data is keyed by date (e.g. 2024-07-19) */
  date: Scalars['LocalDate']['output'];
  /**  Cumulative step count for the day */
  stepCount: Scalars['Int']['output'];
  /**  Target step count for the day */
  stepGoal: Scalars['Int']['output'];
};

export type ExampleStepsData = {
  __typename?: 'ExampleStepsData';
  /**
   *  In protobuf, we would likely model this as a map from date to step data, but here we model it as a list and use
   *  with the date field representing the key
   */
  stepData: Array<ExampleStepData>;
};

export type ExampleUnionStatus = ExampleStatusFailure | ExampleStatusPending | ExampleStatusSuccess;

export type ExtendMicroChallengeResponse = {
  __typename?: 'ExtendMicroChallengeResponse';
  error?: Maybe<Scalars['String']['output']>;
  newExpiresAt?: Maybe<Scalars['LocalDateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalCoachingTermsAndConditionsInfo = {
  __typename?: 'ExternalCoachingTermsAndConditionsInfo';
  documents: Array<Document>;
};

export type ExternalCoachingTermsAndConditionsInput = {
  documents: Array<DocumentType>;
};

export type FaceScanError = {
  __typename?: 'FaceScanError';
  /** Type of the error message */
  faceScanErrorType: FaceScanErrorType;
  /** Body of the error message */
  messageBody?: Maybe<Scalars['String']['output']>;
  /** Title of the error message */
  messageTitle?: Maybe<Scalars['String']['output']>;
};

export enum FaceScanErrorType {
  Disabled = 'DISABLED',
  FatalError = 'FATAL_ERROR',
  NonFatalError = 'NON_FATAL_ERROR',
  ProcessingError = 'PROCESSING_ERROR',
  ProviderDown = 'PROVIDER_DOWN',
  Unknown = 'UNKNOWN'
}

export type FaceScanImageAndBackground = {
  __typename?: 'FaceScanImageAndBackground';
  imageBackgroundDownloadUrl: Scalars['String']['output'];
  imageDownloadUrl: Scalars['String']['output'];
};

export type FaceScanImageProcessingState = FaceScanError | FaceScanNotStarted | FaceScanProcessing | FaceScanResults;

export type FaceScanImageUploadHeader = {
  __typename?: 'FaceScanImageUploadHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FaceScanInitializationInfo = {
  __typename?: 'FaceScanInitializationInfo';
  errorMessageBody?: Maybe<Scalars['String']['output']>;
  errorMessageTitle?: Maybe<Scalars['String']['output']>;
  processingScreenData: FaceScanProcessing;
  state: FaceScanInitializationState;
  uploadContentType: Scalars['String']['output'];
  uploadHeaders: Array<FaceScanImageUploadHeader>;
  uploadMethod: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum FaceScanInitializationState {
  Disabled = 'DISABLED',
  Error = 'ERROR',
  FatalError = 'FATAL_ERROR',
  NonFatalError = 'NON_FATAL_ERROR',
  Ok = 'OK',
  Unknown = 'UNKNOWN'
}

export type FaceScanLoadingScreenTips = {
  __typename?: 'FaceScanLoadingScreenTips';
  otherLines: Scalars['String']['output'];
  sourceLine: Scalars['String']['output'];
  topLine: Scalars['String']['output'];
};

export type FaceScanNotStarted = {
  __typename?: 'FaceScanNotStarted';
  /** Message in case we need to notify anything */
  message?: Maybe<Scalars['String']['output']>;
};

export type FaceScanProcessing = {
  __typename?: 'FaceScanProcessing';
  /** The image to show while the face scan gets processed */
  image: Scalars['String']['output'];
  /** Messages to show with the loading bar/icon to the user while the images get processed */
  loadingScreenAnalysisMessages: Array<Scalars['String']['output']>;
  /** Messages to show in the LOADING screen to the user while the images get processed */
  loadingScreenTips: Array<FaceScanLoadingScreenTips>;
};

export type FaceScanResults = {
  __typename?: 'FaceScanResults';
  badHabitsImageAndBackground: FaceScanImageAndBackground;
  /** @deprecated Use badHabitsImageAndBackground instead */
  badHabitsImageDownloadUrl: Scalars['String']['output'];
  badHabitsItems: Array<Scalars['String']['output']>;
  /** @deprecated Use badHabitsMarkdownHeader and badHabitsItems instead */
  badHabitsMarkdown: Scalars['String']['output'];
  badHabitsMarkdownHeader: Scalars['String']['output'];
  badHabitsSwitchButton: Scalars['String']['output'];
  choiceButton: Scalars['String']['output'];
  clientDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  goodHabitsImageAndBackground: FaceScanImageAndBackground;
  /** @deprecated Use goodHabitsImageAndBackground instead */
  goodHabitsImageDownloadUrl: Scalars['String']['output'];
  goodHabitsItems: Array<Scalars['String']['output']>;
  /** @deprecated Use goodHabitsMarkdownHeader and goodHabitsItems instead */
  goodHabitsMarkdown: Scalars['String']['output'];
  goodHabitsMarkdownHeader: Scalars['String']['output'];
  goodHabitsSwitchButton: Scalars['String']['output'];
  shareables: Array<Maybe<ShareableMedia>>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** State of face scan task */
export type FaceScanTask = {
  __typename?: 'FaceScanTask';
  state: FaceScanTaskState;
};

/** Represents the 'Completed' state of a face scan Task where processing has been completed */
export type FaceScanTaskCompleted = {
  __typename?: 'FaceScanTaskCompleted';
  /** The URL where the generated face scan image can be accessed */
  imageUrl: Scalars['String']['output'];
  /** The unique identifier of the completed scan */
  scanId: Scalars['UUID']['output'];
  /** How many years in future is scan */
  yearsInFuture: Scalars['Int']['output'];
};

/** Represents the 'Hidden' state of a face scan Task where no processing has been initiated */
export type FaceScanTaskHidden = {
  __typename?: 'FaceScanTaskHidden';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the 'InProgress' state of a face scan Task where processing is currently ongoing */
export type FaceScanTaskInProgress = {
  __typename?: 'FaceScanTaskInProgress';
  /** The unique identifier of the scan in progress */
  scanId: Scalars['UUID']['output'];
};

/** Represents the 'Ready' state of a face scan Task face scan is ready to be initiated */
export type FaceScanTaskReady = {
  __typename?: 'FaceScanTaskReady';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Union type representing the different states of a face scan Task */
export type FaceScanTaskState = FaceScanTaskCompleted | FaceScanTaskHidden | FaceScanTaskInProgress | FaceScanTaskReady;

export type FacialBloodScanAttributionDataInput = {
  /** Facial blood scan report identifier. */
  reportId: Scalars['String']['input'];
};

export type FacialBloodScanAttributionDataMatchInput = {
  /** Facial blood scan report identifier. */
  reportId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Metadata needed for the facial blood scan introduction flow.
 * Contains information about the user's data collection status to help
 * determine which pages to show during the introduction flow.
 */
export type FacialBloodScanIntroMetadata = {
  __typename?: 'FacialBloodScanIntroMetadata';
  /**
   * Total number of completed facial blood scans for this user.
   * Used to show different introduction content for first-time users (0)
   * versus returning users (>0).
   */
  facialBloodScanCount: Scalars['Int']['output'];
  /** Whether user already answered the facial blood scan questionnaire */
  hasCompletedQuestionnaire?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether date of birth has been collected from any source (user profile,
   * questionnaire, etc.).
   */
  hasDateOfBirth: Scalars['Boolean']['output'];
};

/** Enumerates the facial blood scan 3rd party providers */
export enum FacialBloodScanProvider {
  Anura = 'ANURA'
}

export type FacialBloodScanQuestionnaire = {
  /** Server time of when the questionnaire has been saved */
  serverTimeCreated: Scalars['LocalDateTime']['output'];
};

/** Statistics about a user's facial blood scans. */
export type FacialBloodScanStats = {
  __typename?: 'FacialBloodScanStats';
  /**
   * Date and time of the last scan performed by the user.
   * Returns null if the user has no scans.
   */
  lastScanDate?: Maybe<Scalars['LocalDateTime']['output']>;
  /**
   * Total number of scans completed by the user.
   * Returns 0 if the user has no scans.
   */
  totalScans: Scalars['Int']['output'];
};

/**
 * The status of the current scan, indicating where the user is in that scans
 * flow, and how to proceed.
 */
export enum FacialBloodScanStatus {
  /** There has been in error while generating the scan or processing the results */
  Error = 'ERROR',
  /** The report is ready. Any processing of the scan is complete */
  ReportReady = 'REPORT_READY',
  /** The report has been viewed by the user. */
  ReportViewed = 'REPORT_VIEWED',
  /** Indicates the user is due for another facial blood scan */
  ScanDue = 'SCAN_DUE'
}

export type FacialBloodScanToken = {
  __typename?: 'FacialBloodScanToken';
  /** Authentication token used for API authorization */
  authToken: Scalars['String']['output'];
  /** One time token used to obtain a new auth token when it expires */
  refreshToken: Scalars['String']['output'];
  /** Time in seconds until the refresh token expires */
  refreshTokenExpirationSeconds: Scalars['Int']['output'];
  /** Time in seconds until the auth token expires */
  tokenExpirationSeconds: Scalars['Int']['output'];
};

export type FacialBloodScanTokenInput = {
  anuraTokenInput?: InputMaybe<AnuraTokenInput>;
};

/** Payload added to Facial Blood Scan Tracker Assignments */
export type FacialBloodScanTrackerPayload = {
  __typename?: 'FacialBloodScanTrackerPayload';
  /** Optional ISO-8601 timestamp string from the original task list request */
  clientTimestamp?: Maybe<Scalars['String']['output']>;
  /**
   * Details about the latest scan. If the user has no scan, this field
   * will not be included.
   */
  state?: Maybe<FacialBloodScanTrackerPayloadState>;
  /** The total number of scans the user has */
  totalCount: Scalars['Int']['output'];
};

/** Representation of the latest scan status */
export type FacialBloodScanTrackerPayloadState = {
  __typename?: 'FacialBloodScanTrackerPayloadState';
  /** UUID of the most recent scan */
  scanUuid: Scalars['UUID']['output'];
  /** The status of the recent scan */
  status?: Maybe<FacialBloodScanStatus>;
};

/**
 * Union of feature-specific detail types.
 * Each feature set returns its own detail type with fields relevant to that feature.
 */
export type FeatureOptInDetails = WeightRevampOptInDetails;

/** Opt-in state for a feature set. */
export type FeatureOptInState = {
  __typename?: 'FeatureOptInState';
  /** Feature-specific details */
  details?: Maybe<FeatureOptInDetails>;
  /** The user's current opt-in status */
  status: FeatureOptInStatus;
};

/**
 * The user's current status with respect to opting in/out of a feature set.
 * Exactly one status is active at a time.
 */
export enum FeatureOptInStatus {
  /** User is eligible to opt in and has not yet opted in */
  EligibleForOptIn = 'ELIGIBLE_FOR_OPT_IN',
  /** User has opted in and is eligible to opt out */
  EligibleForOptOut = 'ELIGIBLE_FOR_OPT_OUT',
  /** User is not eligible for opt-in or opt-out (e.g. not in a qualifying program/locale) */
  NotEligible = 'NOT_ELIGIBLE'
}

/**
 * Polymorphic input that identifies a feature set and carries its specific parameters.
 * Exactly one field must be provided.
 */
export type FeatureSetInput = {
  weightRevamp?: InputMaybe<WeightRevampInput>;
};

/**
 * Preflight config for findFriendsByPhoneNumbers. Tells the client whether to send
 * phone numbers and, when required, the server-side contact cap.
 */
export type FindFriendsByPhoneNumbersCallConfig = {
  __typename?: 'FindFriendsByPhoneNumbersCallConfig';
  /**
   * Present only when shouldSendContacts is true. Maximum number of contacts the
   * client may submit in findFriendsByPhoneNumbers.
   */
  contactsLimit?: Maybe<Scalars['Int']['output']>;
  /**
   * When false, the client MUST NOT send phone numbers to findFriendsByPhoneNumbers.
   * When true, the client MUST cap the submitted contact list at contactsLimit.
   */
  shouldSendContacts: Scalars['Boolean']['output'];
};

/** Response for findFriendsByPhoneNumbers. */
export type FindFriendsByPhoneNumbersResponse = {
  __typename?: 'FindFriendsByPhoneNumbersResponse';
  /** Client-side contact IDs excluded from the results. */
  excluded: Array<Scalars['String']['output']>;
  /** Subset of the supplied contacts that matched a discoverable Noom user. */
  matches: Array<ContactPreviewMatch>;
};

/** Sort mode for findFriendsByPhoneNumbers. */
export enum FindFriendsSort {
  /** Sort by most recent activity. */
  LastActive = 'LAST_ACTIVE',
  /** Sort by display name. */
  Name = 'NAME'
}

/** Fixed content (e.g. static articles) served by url */
export type FixedContent = {
  __typename?: 'FixedContent';
  /** Url for audio version of FixedContent */
  audioSourceUrl?: Maybe<Scalars['String']['output']>;
  /** Describes to user how long to expect reading takes */
  averageReadingDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  /** Id for content analytics */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Indicates how to display FixedContent */
  contentType: FixedContentType;
  /** Url for fixed content */
  contentUrl: Scalars['String']['output'];
  /** ImageUrl for FixedContent */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title: Scalars['String']['output'];
};

/** Groups fixed content into titled sections */
export type FixedContentSection = {
  __typename?: 'FixedContentSection';
  /** List of FixedContent for section of fixed content */
  fixedContentList: Array<FixedContent>;
  /** Section Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Differentiates between articles and future types */
export enum FixedContentType {
  /** Article - contentUrl driven fixed content */
  Article = 'ARTICLE',
  /** Unknown type required by proto */
  FixedContentTypeUnknown = 'FIXED_CONTENT_TYPE_UNKNOWN'
}

export type FloatRange = {
  __typename?: 'FloatRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type FoodCalorieBar = {
  __typename?: 'FoodCalorieBar';
  foodColor?: Maybe<FoodColor>;
  goalInCals: Scalars['Float']['output'];
  valueInCals: Scalars['Float']['output'];
};

/**
 *  These values should be aligned with:
 *  - food_colors.proto (FoodColorProto)
 */
export enum FoodColor {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Yellow = 'YELLOW'
}

/** Response containing the presigned URL for uploading a food image */
export type FoodImageUploadUrlResponse = {
  __typename?: 'FoodImageUploadUrlResponse';
  /** The S3 key identifying this image, used in subsequent meal logging calls */
  s3Key: Scalars['String']['output'];
  /** The presigned URL for uploading the image via HTTP PUT */
  uploadUrl: Scalars['String']['output'];
};

/** Glucose forecast data associated with a specific food item */
export type FoodItemForecast = {
  __typename?: 'FoodItemForecast';
  /** Glucose spike classification assigned to this food item */
  spikeClassification: SpikeClassification;
  /** Time series data containing glucose values projected over time */
  timeSeriesData: Array<GlucoseTimeSeriesPoint>;
};

/**
 * Information about an individual food item that was logged.
 *
 * Note: we have calories, greenCalories, yellowCalories and orangeCalories as nullable because
 * some food items are expected to have only calories and color while others are expected to not have
 * the calories field populated, but the green, yellow or orangle calories fields populated.
 *
 * masterFoodUuid, customFoodUuid and name attributes will not be used by the backend at initial feature launch.
 */
export type FoodItemInput = {
  /** Calories in the food */
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** Food color */
  color: FoodColor;
  /** Custom food UUID (either this will be present or masterFoodUuid) */
  customFoodUuid?: InputMaybe<Scalars['String']['input']>;
  /** Green calories of the food entry (if applicable) */
  greenCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Master food UUID (either this will be present or customFoodUuid) */
  masterFoodUuid?: InputMaybe<Scalars['String']['input']>;
  /** The name of the food */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Orange calories of the food entry (if applicable) */
  orangeCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Yellow calories of the food entry (if applicable) */
  yellowCalories?: InputMaybe<Scalars['Float']['input']>;
};

/**  Represents the state data of all food logging related features */
export type FoodLoggingFeaturesStates = {
  __typename?: 'FoodLoggingFeaturesStates';
  /**  Feature state containing configuration for the glucose forecasting feature */
  glucoseForecastingState: GlucoseForecastingFeatureState;
  /**  Feature state containing the configuration for meal logging method selector UI */
  loggingMethodSelectorState: MealLoggingMethodSelectorFeatureState;
};

/** Association between a food item identifier and its corresponding forecast data */
export type ForecastByFoodItem = {
  __typename?: 'ForecastByFoodItem';
  /** Glucose forecast data for the associated food item */
  foodItemForecast: FoodItemForecast;
  /** Unique identifier for the food item */
  foodItemId: Scalars['String']['output'];
};

/** Enumeration of specific reasons why glucose forecast generation may fail */
export enum ForecastErrorReason {
  MissingAge = 'MISSING_AGE',
  Unknown = 'UNKNOWN'
}

/** Enumeration of specific reasons why the forecast could not be generated */
export enum ForecastUnavailableReason {
  /** User's age could not be found */
  MissingAge = 'MISSING_AGE',
  /** User's height could not be found */
  MissingHeight = 'MISSING_HEIGHT',
  /** User's sex could not be found */
  MissingSex = 'MISSING_SEX',
  /** User's weight could not be found */
  MissingWeight = 'MISSING_WEIGHT',
  /** Reason could not be determined */
  Unknown = 'UNKNOWN'
}

/** Calendar period used to aggregate friend sharing summaries. */
export enum FriendSharingPeriod {
  Week = 'WEEK'
}

/** Bidirectional summary of currency shared between the caller and a friend through friend sharing for the requested period. */
export type FriendSharingSummary = {
  __typename?: 'FriendSharingSummary';
  /** Effective date range the summary was aggregated over. */
  dateRange: LocalDateRange;
  /** Total amount the caller earned from this friend through friend sharing during the requested period. */
  earnedByFriend?: Maybe<RewardsMoney>;
  /** Total amount the caller earned for this friend through friend sharing during the requested period. */
  earnedForFriend?: Maybe<RewardsMoney>;
  /** Calendar period the summary was aggregated over. */
  period: FriendSharingPeriod;
};

/** Data input for art break gamification action */
export type GamificationActionArtBreakDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
};

/** Data input for body scan gamification action - triggered when user performs a body scan */
export type GamificationActionBodyScanDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
};

/** Data input for curriculum content consumed gamification action */
export type GamificationActionCurriculumContentDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/**
 * Data input type that contains features-specific data sent from the client. This is used to map Gamification action type to Domain SOA.
 * The team who's integrating a feature with rewards is responsible for creating an input type for their feature.
 * It's up to the team to decide what data to send to the backend - the context needed to process the action can be provided either by the client, or the backend.
 */
export type GamificationActionDataInput = {
  /** Art break data input */
  artBreak?: InputMaybe<GamificationActionArtBreakDataInput>;
  /** Body scan data input */
  bodyScan?: InputMaybe<GamificationActionBodyScanDataInput>;
  /** Reading curriculum content data input */
  curriculumContent?: InputMaybe<GamificationActionCurriculumContentDataInput>;
  /** Face scan data input */
  faceScan?: InputMaybe<GamificationActionFaceScanDataInput>;
  /** Facial blood scan data input */
  facialBloodScan?: InputMaybe<GamificationActionFacialBloodScanDataInput>;
  /** Food logging data input */
  foodLogging?: InputMaybe<GamificationActionFoodLoggingDataInput>;
  /** Med logging data input */
  medLogging?: InputMaybe<GamificationActionMedLoggingDataInput>;
  /** Micro challenge progress data input */
  microChallenge?: InputMaybe<GamificationActionMicroChallengeDataInput>;
  /** Mood logging data input */
  moodLogging?: InputMaybe<GamificationActionMoodLoggingDataInput>;
  /** Movement logging data input */
  moveLogging?: InputMaybe<GamificationActionMoveLoggingDataInput>;
  /** Reading standalone content data input */
  standaloneContent?: InputMaybe<GamificationActionStandaloneContentDataInput>;
  /** Step banking data input */
  stepBanking?: InputMaybe<GamificationActionStepBankingDataInput>;
  /** Stress logging data input */
  stressLogging?: InputMaybe<GamificationActionStressLoggingDataInput>;
  /** Water logging data input */
  waterLogging?: InputMaybe<GamificationActionWaterLoggingDataInput>;
  /** Weight logging data input */
  weightLogging?: InputMaybe<GamificationActionWeightLoggingDataInput>;
};

/** Data input for face scan gamification action - triggered when user performs a face scan */
export type GamificationActionFaceScanDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
};

/** Data input for facial blood scan gamification action - triggered when user performs a facial blood scan */
export type GamificationActionFacialBloodScanDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** 3rd party facial blood scan provider */
  provider: FacialBloodScanProvider;
};

/** Data input for food logging gamification action - triggered when user logs or updates a meal */
export type GamificationActionFoodLoggingDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Total green calories across all meals for the current day */
  greenCaloriesCurrent: Scalars['Float']['input'];
  /** Green calories goal for the user */
  greenCaloriesTarget: Scalars['Int']['input'];
  /** True indicates a new meal has been recorded, false means an existing meal has been updated */
  isNewMeal: Scalars['Boolean']['input'];
  /** Total protein in grams across all meals for the current day */
  proteinCurrent?: InputMaybe<Scalars['Float']['input']>;
  /** Protein goal in grams for the user */
  proteinTarget?: InputMaybe<Scalars['Int']['input']>;
};

/** Data input for med logging gamification action - triggered when user logs medicine ingestion */
export type GamificationActionMedLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for micro challenge gamification action - triggered when user progresses or completes micro challenge */
export type GamificationActionMicroChallengeDataInput = {
  /** Date when micro challenge was progressed/completed */
  clientDate: Scalars['LocalDate']['input'];
  /** Id of progressed/completed micro challenge */
  userMicroChallengeUuid: Scalars['UUID']['input'];
};

/** Data input for mood logging gamification action - triggered when user logs a mood */
export type GamificationActionMoodLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for move logging gamification action - triggered when user logs movement */
export type GamificationActionMoveLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Result of processing a gamification action - returns celebrations and processing results */
export type GamificationActionResult = {
  __typename?: 'GamificationActionResult';
  /**
   * List of celebrations triggered by the gamification action (one action can trigger multiple celebrations)
   * E.g. when a user achieves daily goal with an action, celebrations list would contain GoalAchieved, and CurrencyEarnedEvent(modal) celebrations
   */
  celebrations?: Maybe<Array<GamificationCelebration>>;
  /** Status of the rewards processing step. When different than SUCCESSFUL, rewards results may be missing due to a processing failure. */
  rewardsProcessingStatus?: Maybe<RewardsProcessingStatus>;
  /** Processing result related to rewards */
  rewardsResult?: Maybe<GamificationActionRewardsResult>;
  /** Status of the streaks processing step. When different than SUCCESSFUL, streak results may be missing or incomplete due to a processing failure. */
  streaksProcessingStatus?: Maybe<StreaksProcessingStatus>;
  /** Processing results related to streaks */
  streaksResults?: Maybe<Array<Maybe<GamificationActionStreaksResult>>>;
};

/**
 * Processing a rewards-specific gamification action didn't trigger a balance update.
 * In the future this can be expanded with an explanation on why the balance was not updated.
 */
export type GamificationActionRewardsBalanceUnchanged = {
  __typename?: 'GamificationActionRewardsBalanceUnchanged';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a balance update for a specific reward within a gamification action */
export type GamificationActionRewardsBalanceUpdate = {
  __typename?: 'GamificationActionRewardsBalanceUpdate';
  /** The amount of currency earned for this specific reward */
  amountEarned: Scalars['Int']['output'];
  /** The reason why currency was earned, e.g. completing a Noomcoin */
  reason: GamificationActionRewardsBalanceUpdateReason;
};

/**
 * Reason for the currency balance update.
 * Used on clients for cases when we want to break down the total amount earned - e.g. for analytics
 */
export enum GamificationActionRewardsBalanceUpdateReason {
  /** User completed an art break. */
  ArtBreak = 'ART_BREAK',
  /** User performed a body scan. */
  BodyScan = 'BODY_SCAN',
  /** User has consumed a curriculum content item. */
  CurriculumContent = 'CURRICULUM_CONTENT',
  /** User performed a facial blood scan. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** User logged food/meal data. */
  FoodLogging = 'FOOD_LOGGING',
  /** Reward shared by friend earning a reward */
  FriendRewardShared = 'FRIEND_REWARD_SHARED',
  /** User logged green calories. */
  GreenCaloriesLogging = 'GREEN_CALORIES_LOGGING',
  /** User achieved their green calorie goal. */
  GreenCalorieGoal = 'GREEN_CALORIE_GOAL',
  /** User logged med data. */
  MedLogging = 'MED_LOGGING',
  /** User completed micro challenge */
  MicroChallengeCompleted = 'MICRO_CHALLENGE_COMPLETED',
  /** User progressed on micro challenge */
  MicroChallengeProgressed = 'MICRO_CHALLENGE_PROGRESSED',
  /** User logged mood. */
  MoodLogging = 'MOOD_LOGGING',
  /** User logged movement. */
  MoveLogging = 'MOVE_LOGGING',
  /** User earned a Noomcoin */
  Noomcoin = 'NOOMCOIN',
  /** User achieved their protein goal. */
  ProteinGoal = 'PROTEIN_GOAL',
  /** User logged protein. */
  ProteinLogging = 'PROTEIN_LOGGING',
  /** User completed standalone content item */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User banked steps */
  StepBanking = 'STEP_BANKING',
  /** User banked step goal */
  StepGoalBanking = 'STEP_GOAL_BANKING',
  /** User banked steps onboarding reward */
  StepOnboardingRewardBanking = 'STEP_ONBOARDING_REWARD_BANKING',
  /** User reached a milestone streak length */
  StreakMilestone = 'STREAK_MILESTONE',
  /** User logged stress data. */
  StressLogging = 'STRESS_LOGGING',
  /** User logged water drinking. */
  WaterLogging = 'WATER_LOGGING',
  /** User completed weigh-in task. */
  WeighIn = 'WEIGH_IN'
}

/** Processing a rewards-specific gamification action triggered a balance update */
export type GamificationActionRewardsBalanceUpdated = {
  __typename?: 'GamificationActionRewardsBalanceUpdated';
  /** Total amount of currency earned from the action */
  amountEarned: Scalars['Int']['output'];
  /** Breakdown of balance updates by individual reward type - sum equals amountEarned */
  balanceUpdatesPerReward?: Maybe<Array<GamificationActionRewardsBalanceUpdate>>;
};

/**
 * Processing a rewards-specific gamification action failed.
 * In the future this can be expanded with a field that indicates the cause of failure.
 */
export type GamificationActionRewardsFailure = {
  __typename?: 'GamificationActionRewardsFailure';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Union of rewards specific processing results */
export type GamificationActionRewardsResult = GamificationActionRewardsBalanceUnchanged | GamificationActionRewardsBalanceUpdated | GamificationActionRewardsFailure;

/** Data input for standalone content consumed gamification action */
export type GamificationActionStandaloneContentDataInput = {
  /** User's local date */
  clientDate: Scalars['LocalDate']['input'];
};

/** Data input for step banking gamification action - data for generating granting context is provided by the domain SOA */
export type GamificationActionStepBankingDataInput = {
  /** The user's selected date, for determining the range of steps measurements to use */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Determines whether the user performed the action with the help of an intro guide, e.g. an onboarding tooltip */
  introAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag, used to determine if required to include onboarding steps reward to the list of gamification actions */
  onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's current selected program ID, used for determining the user's current steps goal */
  programId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Processing a streaks-specific gamification action failed.
 * In the future this can be expanded with a field that indicates the cause of failure.
 */
export type GamificationActionStreakFailure = {
  __typename?: 'GamificationActionStreakFailure';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Processing a streak update succeeded.
 * In the future this can be expanded with fields expanding on the result of update.
 */
export type GamificationActionStreakUpdated = {
  __typename?: 'GamificationActionStreakUpdated';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** The wrapper for a processing result for a specific streak type. */
export type GamificationActionStreaksResult = {
  __typename?: 'GamificationActionStreaksResult';
  /** Processing result for this specific streak type */
  result?: Maybe<StreakProcessingResult>;
  /** Type of the streak the result is referring to */
  streakType?: Maybe<StreakType>;
};

/** Data input for stress logging gamification action - triggered when user logs a stress status */
export type GamificationActionStressLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for water logging gamification action - triggered when user logs water ingestion */
export type GamificationActionWaterLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for weight logging gamification action - triggered when user logs their weight */
export type GamificationActionWeightLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/**
 * Union type representing different types of celebrations that can be triggered by gamification actions.
 * In older versions of the app that do not recognize the celebration type, the celebration will be ignored.
 */
export type GamificationCelebration = CurrencyEarnedCelebration | GoalAchievedCelebration | StreakIncreasedCelebration | StreakMilestoneCelebration;

/**
 * Represents application-level errors that occur during forecast generation.
 * This does not replace HTTP 4xx or 5xx status codes, but provides structured
 * error information when the forecast cannot be completed due to known business
 * logic constraints that require client awareness.
 */
export type GenerateGlucoseForecastErrorResponse = {
  __typename?: 'GenerateGlucoseForecastErrorResponse';
  /** Specific error code indicating why the glucose forecast could not be generated */
  reason: ForecastErrorReason;
};

/** Union type representing either a successful forecast response or an error response */
export type GenerateGlucoseForecastResponse = GenerateGlucoseForecastErrorResponse | GenerateGlucoseForecastSuccessResponse;

/** Union type representing either a successful forecast response or a response for when the forecast is unavailable */
export type GenerateGlucoseForecastResponseV2 = GenerateGlucoseForecastSuccessResponse | GenerateGlucoseForecastUnavailableResponse;

/** Successful response containing the generated glucose forecast data */
export type GenerateGlucoseForecastSuccessResponse = {
  __typename?: 'GenerateGlucoseForecastSuccessResponse';
  /** Collection of food items mapped to their respective forecast data */
  forecastByFoodItem: Array<ForecastByFoodItem>;
};

/**
 * Response for when the forecast is unavailable.
 * This does not replace HTTP 4xx or 5xx status codes, but provides structured
 * way to inform clients that the forecast could not be generated because of
 * expected constraints (e.g. missing user data).
 */
export type GenerateGlucoseForecastUnavailableResponse = {
  __typename?: 'GenerateGlucoseForecastUnavailableResponse';
  /** Specific reason indicating why the glucose forecast could not be generated */
  reason: ForecastUnavailableReason;
};

/** An order record for non-lab-kit product types (RX, OTC, Scale, Supply). */
export type GenericOrder = ShipmentOrder & {
  __typename?: 'GenericOrder';
  /** Date and time the order was placed. */
  orderDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Order identifier. */
  orderId: Scalars['ID']['output'];
  /** Integration type of the pharmacy for this Rx order (e.g. DIRECT, DOSESPOT). Null for non-Rx product types. */
  pharmacyIntegrationType?: Maybe<PharmacyIntegrationType>;
  /** Product categories. */
  productCategories: Array<ShipmentProductCategory>;
  /** Original order id if this is a replacement. */
  replacedOrderId?: Maybe<Scalars['ID']['output']>;
  /** Shipments associated with this order. */
  shipments: Array<Shipment>;
  /** Shipping address for this order. Populated for Scale and OTC orders; null for all other product types. */
  shippingAddress?: Maybe<Address>;
  /** Current status of this order. */
  status: ShipmentOrderStatus;
  /** Fulfillment partner, pharmacy, or vendor name (e.g. 'Wells Dallas', 'Ash Labs'). */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** A shipment record with only fields common across all product types. */
export type GenericShipment = Shipment & {
  __typename?: 'GenericShipment';
  /** Shipping carrier name (e.g. 'UPS', 'USPS', 'FedEx'). */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Current status of this shipment. */
  status: ShipmentStatus;
  /** Carrier tracking number.  */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Full carrier tracking URL. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Input for getting an API key. */
export type GetApiKeyInput = {
  /**
   * The unique application ID for the application to get the API key for.
   * Note: This will be validated in the future and the appropriate
   * key will be returned based on the accessCode. For now, we'll
   * be ignoring it.
   */
  applicationId: Scalars['String']['input'];
  /** The key to get the API key for. */
  keyType: ApiKeyType;
};

/**
 * Select multiple flows identifiers for experiments associated with those
 * baselines (`GetExperimentsAssociatedWithNoomFlowsRequestProto.body`).
 */
export type GetExperimentsAssociatedWithNoomFlowsInput = {
  /** Cursor pagination when the merged association set is large. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Flows identifiers to filter experiments by. */
  flowIdentifiers: Array<Scalars['String']['input']>;
};

/**
 * Lookup a single experiment. At least one of `uuid` or `identifier` should be set;
 * if both are set, precedence is server-defined.
 */
export type GetNoomFlowExperimentInput = {
  /** Immutable experiment identifier assigned at create. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Primary key returned on create and used in URLs for updates/deletes. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Lookup one list by uuid and/or name. At least one field should be set. */
export type GetNoomFlowListInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Load one list item by uuid. */
export type GetNoomFlowListItemInput = {
  uuid: Scalars['UUID']['input'];
};

/**
 * List items with optional partial or exact value filters.
 * Set exactly one of `listUuid` or `listName` for the owning list.
 */
export type GetNoomFlowListItemsInput = {
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Exact match on item `value` (for example after picking an autocomplete option). */
  exactItemValue?: InputMaybe<Scalars['String']['input']>;
  listName?: InputMaybe<Scalars['String']['input']>;
  listUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Partial match against item `value` (typeahead); use with `valueMatch`. */
  partialItemValue?: InputMaybe<Scalars['String']['input']>;
  /** How `partialItemValue` is applied; ignored if `partialItemValue` is unset. */
  valueMatch?: InputMaybe<NoomFlowListItemValueMatch>;
};

/**
 * Input for requesting a presigned S3 upload URL.
 * If no object_key is provided, a random one will be generated.
 * If no bucket_name is provided, the default bucket will be used.
 */
export type GetPresignedS3UploadUrlInput = {
  /** The content type of the file (e.g. image/png, application/json) */
  contentType: Scalars['String']['input'];
  /** The name of the file to upload */
  fileName: Scalars['String']['input'];
  /** The size of the file to upload in bytes */
  fileSize: Scalars['Int']['input'];
};

/**
 * Response containing the presigned URL for uploading a file to S3.
 * Used by the noom flow admin for asset management.
 */
export type GetPresignedS3UploadUrlResponse = {
  __typename?: 'GetPresignedS3UploadUrlResponse';
  /** The bucket name where the file will be stored (for reference) */
  bucketName?: Maybe<Scalars['String']['output']>;
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime']['output'];
  /** The object key where the file will be stored (for reference) */
  objectKey?: Maybe<Scalars['String']['output']>;
  /** The presigned URL to upload the file directly to object storage */
  presignedUrl: Scalars['String']['output'];
};

/**
 * Filter entry for `getRelationConsents` — selects a consent record by
 * its `(consentType, qualifier)` natural key (within the calling user's
 * access code).
 */
export type GetRelationConsentsQueryInput = {
  /** Consent type identifier (e.g. `CONTACT_BOOK_UPLOADING`). */
  consentType: RelationsConsentType;
  /**
   * Qualifier scoping the consent within its type. The `consentType`
   * defines *what* the consent is for; the qualifier defines *for
   * whom/which*. Required when the consent type is scoped; MUST be
   * unset for unscoped types. Must not contain PII (e.g. no email
   * addresses, phone numbers, or access codes).
   */
  qualifier?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a redeemable gift card reward */
export type GiftCardProductListing = {
  __typename?: 'GiftCardProductListing';
  /** Required amount to redeem the gift card */
  amount: RewardsMoney;
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
  /** WebView URL for redeeming the gift card reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary value of the gift card */
  value: Money;
};

/** A GLP-1 medication available for selection in the GLP-1 Companion feature. */
export type Glp1CompanionMedication = {
  __typename?: 'Glp1CompanionMedication';
  /** Available dose options for this medication. */
  doseOptions: Array<MedicationDoseOption>;
  /**
   * External medication identifier required by MedicationDataInput when
   * logging a dose. Null for medications that cannot be tracked (only
   * surfaced in the ONBOARDING context).
   */
  medicationExternalId?: Maybe<Scalars['String']['output']>;
  /** Medication group identifier. Stable across dose variants. */
  medicationGroup: Glp1CompanionMedicationGroup;
  /** Human-readable medication name. */
  medicationName: Scalars['String']['output'];
  /** Potential side effects, used to populate the side-effect selection UI. */
  potentialSideEffects: Array<MedicationSideEffect>;
};

/** Context in which the GLP-1 medication list is being requested. */
export enum Glp1CompanionMedicationContext {
  /** Medications available for selection in the GLP-1 Companion med tracker. */
  MedTracker = 'MED_TRACKER',
  /** Medications available for selection during the GLP-1 Companion onboarding flow. */
  Onboarding = 'ONBOARDING'
}

/** Identifier for a GLP-1 medication group. */
export enum Glp1CompanionMedicationGroup {
  CompoundedSemaglutide = 'COMPOUNDED_SEMAGLUTIDE',
  CompoundedTirzepatide = 'COMPOUNDED_TIRZEPATIDE',
  Liraglutide = 'LIRAGLUTIDE',
  Mounjaro = 'MOUNJARO',
  Ozempic = 'OZEMPIC',
  Saxenda = 'SAXENDA',
  WegovyInjection = 'WEGOVY_INJECTION',
  WegovyOral = 'WEGOVY_ORAL',
  ZepboundKwikpen = 'ZEPBOUND_KWIKPEN',
  ZepboundPen = 'ZEPBOUND_PEN',
  ZepboundVial = 'ZEPBOUND_VIAL'
}

/** List of GLP-1 companion medications. */
export type Glp1CompanionMedicationList = {
  __typename?: 'Glp1CompanionMedicationList';
  /** GLP-1 companion medications. */
  medications: Array<Glp1CompanionMedication>;
};

/** Result payload for `updateGlp1CompanionMedication`, echoing the persisted GLP-1 Companion medication state. */
export type Glp1CompanionMedicationResponse = {
  __typename?: 'Glp1CompanionMedicationResponse';
  /** Date the user reports having started GLP-1 medications. Null when the user has not provided one. */
  glp1MedicationStartedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** External id of the medication the user is currently tracking via the GLP-1 Companion. */
  trackedMedicationExternalId: Scalars['String']['output'];
};

/** GLP-1 Companion state for a specific user. */
export type Glp1CompanionState = {
  __typename?: 'Glp1CompanionState';
  /** Whether the GLP-1 Companion feature is enabled for the user. */
  isGlp1CompanionEnabled: Scalars['Boolean']['output'];
};

/** Input parameters containing nutritional information for a food item used in glucose forecasting */
export type GlucoseForecastFoodItemInput = {
  /** Total carbohydrate content measured in milligrams */
  carbsMilligrams: Scalars['Float']['input'];
  /** Total fat content measured in milligrams */
  fatMilligrams: Scalars['Float']['input'];
  /** Unique identifier for the food item */
  id: Scalars['String']['input'];
  /** Total protein content measured in milligrams */
  proteinMilligrams: Scalars['Float']['input'];
};

/**  Represents the state of the glucose forecasting feature for a user */
export type GlucoseForecastingFeatureState = {
  __typename?: 'GlucoseForecastingFeatureState';
  /**  Indicates whether the glucose forecasting feature is enabled */
  isEnabled: Scalars['Boolean']['output'];
};

/** Individual data point within a glucose time series */
export type GlucoseTimeSeriesPoint = {
  __typename?: 'GlucoseTimeSeriesPoint';
  /** Predicted glucose level in milligrams per deciliter (mg/dL) */
  glucoseLevelMgDl: Scalars['Int']['output'];
  /** Time offset in minutes relative to the forecast start time */
  minute: Scalars['Int']['output'];
  /**
   * More precise version of the predicted glucose level in milligrams per deciliter (mg/dL)
   * that includes decimal points.
   */
  preciseGlucoseLevelMgDl: Scalars['Float']['output'];
};

/** Celebration shown when user achieves a goal. */
export type GoalAchievedCelebration = {
  __typename?: 'GoalAchievedCelebration';
  /** Metrics to display in the goal achieved celebration. If null, metrics will not be displayed. */
  metrics?: Maybe<GoalAchievedMetrics>;
  /** Type of goal achieved (required). */
  type?: Maybe<GoalAchievedType>;
};

/**
 * Union type for the metrics to display in the goal achieved screen.
 * In older versions of the app that do not recognize the metrics type, metrics will not be displayed.
 */
export type GoalAchievedMetrics = ComparisonMetrics;

/** DEPRECATED: use GoalAchievedCelebration instead */
export type GoalAchievedScreen = {
  __typename?: 'GoalAchievedScreen';
  /** Metrics to display in the goal achieved screen. If null, metrics will not be displayed. */
  metrics?: Maybe<GoalAchievedMetrics>;
  /** Type of goal achieved (required). */
  type?: Maybe<GoalAchievedType>;
};

/**
 * Type of goal achieved.
 * This drives UI assets used in the goal achieved screen - highlight color, goal text, and header animation.
 * In older versions of the app that do not recognize the goal achieved type, the goal achieved screen will be ignored and not displayed.
 */
export enum GoalAchievedType {
  /** Green calorie goal. */
  GreenCalorie = 'GREEN_CALORIE',
  /** Protein goal */
  Protein = 'PROTEIN',
  /** Steps goal */
  Steps = 'STEPS'
}

/**
 *  These values should be aligned with:
 *  - goal_id_enum.proto (GoalIdEnumProto.Value.Id)
 */
export enum GoalId {
  DailyStepsAtLeastCount = 'DAILY_STEPS_AT_LEAST_COUNT',
  DrinkAtLeastWaterUnits = 'DRINK_AT_LEAST_WATER_UNITS',
  IngestBelowCalorieUnits = 'INGEST_BELOW_CALORIE_UNITS',
  LogBloodGlucoseReadingAtLeastCount = 'LOG_BLOOD_GLUCOSE_READING_AT_LEAST_COUNT',
  LogGreenCaloriesAtLeastCount = 'LOG_GREEN_CALORIES_AT_LEAST_COUNT',
  LogHighBloodGlucoseReading = 'LOG_HIGH_BLOOD_GLUCOSE_READING',
  LogLowBloodGlucoseReading = 'LOG_LOW_BLOOD_GLUCOSE_READING',
  LogMealsAtLeastCount = 'LOG_MEALS_AT_LEAST_COUNT',
  LogMealsCalciumAtLeastCount = 'LOG_MEALS_CALCIUM_AT_LEAST_COUNT',
  LogMealsFiberAtLeastCount = 'LOG_MEALS_FIBER_AT_LEAST_COUNT',
  LogMealsMacroCarbohydrateAtLeastCount = 'LOG_MEALS_MACRO_CARBOHYDRATE_AT_LEAST_COUNT',
  LogMealsMacroFatAtLeastCount = 'LOG_MEALS_MACRO_FAT_AT_LEAST_COUNT',
  LogMealsMacroProteinAtLeastCount = 'LOG_MEALS_MACRO_PROTEIN_AT_LEAST_COUNT',
  LogMealsPotassiumAtLeastCount = 'LOG_MEALS_POTASSIUM_AT_LEAST_COUNT',
  LogMealsProteinAtLeastCount = 'LOG_MEALS_PROTEIN_AT_LEAST_COUNT',
  LogMealsSaturatedFatsBelowCount = 'LOG_MEALS_SATURATED_FATS_BELOW_COUNT',
  LogMealsSodiumBelowCount = 'LOG_MEALS_SODIUM_BELOW_COUNT',
  LogMealsSugarBelowCount = 'LOG_MEALS_SUGAR_BELOW_COUNT',
  LogMedicationDoseAtLeastCount = 'LOG_MEDICATION_DOSE_AT_LEAST_COUNT',
  LogMedicationMetforminDoseAtLeastCount = 'LOG_MEDICATION_METFORMIN_DOSE_AT_LEAST_COUNT',
  LogVeryHighBloodGlucoseReading = 'LOG_VERY_HIGH_BLOOD_GLUCOSE_READING',
  LogVeryLowBloodGlucoseReading = 'LOG_VERY_LOW_BLOOD_GLUCOSE_READING',
  StepProtocolDailyEngagement = 'STEP_PROTOCOL_DAILY_ENGAGEMENT',
  TakeAtLeastMedicationDoseCount = 'TAKE_AT_LEAST_MEDICATION_DOSE_COUNT',
  Unknown = 'UNKNOWN'
}

export type GoalMetadata = GreenCaloriesGoalMetadata | MedicationGoalMetadata | NutrientGoalMetadata | ProteinGoalMetadata | StepGoalMetadata | WaterGoalMetadata;

export type GoalTarget = {
  greenCaloriesTarget?: InputMaybe<GreenCaloriesTarget>;
  nutrientTarget?: InputMaybe<NutrientTargetInput>;
  proteinTarget?: InputMaybe<ProteinTarget>;
  stepTarget?: InputMaybe<StepTarget>;
  waterTarget?: InputMaybe<WaterTarget>;
};

export type GoogleFitAttributionDataInput = {
  /** Package name of the app inserting data. */
  packageName: Scalars['String']['input'];
  /** Name of the app inserting data in Google Fit. */
  sourceName: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

/**
 * Variant of GoogleFitAttributionDataInput with all fields optional for matching.
 * Keep in sync with GoogleFitAttributionDataInput.
 */
export type GoogleFitAttributionDataMatchInput = {
  /** Package name of the app inserting data. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the app inserting data in Google Fit. */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
};

/** Immutable grant definition stored in the Rewards system. */
export type GrantDefinition = {
  __typename?: 'GrantDefinition';
  /** Whether the grant can be awarded via external override. */
  allowExternalOverriding?: Maybe<Scalars['Boolean']['output']>;
  /** Number of times a grant can be awarded per period. */
  frequencyLimitCount?: Maybe<Scalars['Int']['output']>;
  /** Calendar period used for frequency limits and metric caps. */
  frequencyLimitPeriod: GrantFrequencyLimitPeriod;
  /** Identifier of the grant. */
  grantSlug: Scalars['String']['output'];
  /** Configuration for how the rewarded amount is calculated. */
  rewardCalculationConfig: RewardCalculationConfig;
  /** User-facing reason shown for why a grant is awarded. */
  userFacingReason: UserFacingReason;
};

/** Calendar period for grant frequency limits. */
export enum GrantFrequencyLimitPeriod {
  /** Frequency period is a calendar day; the count defines how many times per day. */
  Day = 'DAY',
  /** A grant can be awarded based on a global counter. */
  Forever = 'FOREVER',
  /** Frequency period is a calendar month; the count defines how many times per month. */
  Month = 'MONTH',
  /** No frequency restrictions apply. */
  None = 'NONE',
  /** Not expected to be returned, used as a fallback to maintain backwards compatibility if a part of the system is not yet updated. */
  Unknown = 'UNKNOWN',
  /** Frequency period is a calendar week; the count defines how many times per week. */
  Week = 'WEEK'
}

export type Grants = {
  __typename?: 'Grants';
  /** Reference grant slug for fetching the next page; null if end reached. */
  cursorSlug?: Maybe<Scalars['String']['output']>;
  /** List of grant definitions available to rewards. */
  grants: Array<GrantDefinition>;
  /** Limit of grants which can be returned in the page. */
  limit: Scalars['Int']['output'];
};

/** A graph widget on the Trends surface */
export type GraphWidget = {
  __typename?: 'GraphWidget';
  /** Content of the graph widget (union of supported graph types) */
  content: GraphWidgetContent;
};

/** Union of supported graph widget types */
export type GraphWidgetContent = ToolGraph;

export type GreenCaloriesGoalMetadata = {
  __typename?: 'GreenCaloriesGoalMetadata';
  minGreenCalories?: Maybe<Scalars['Int']['output']>;
};

export type GreenCaloriesTarget = {
  minGreenCalories?: InputMaybe<Scalars['Int']['input']>;
};

/** A curated stack of micro challenges grouped under a single theme. */
export type HabitStack = {
  __typename?: 'HabitStack';
  /**
   * Aggregate stack-level CTA (not per-challenge `userContext.availableActions`).
   * `start` is enabled if ANY child challenge can be started.
   */
  availableActions?: Maybe<MicroChallengeActions>;
  /** Categories this stack belongs to; used for filtering in the library. */
  categories?: Maybe<Array<MicroChallengeCategory>>;
  /**
   * Ordered list of challenges in the stack, each enriched with
   * available actions, completion rewards, and recipe.
   */
  challenges: Array<MicroChallenge>;
  /** Unique identifier (slug) for the stack */
  id: Scalars['String']['output'];
  /** Display name of the stack */
  name: Scalars['String']['output'];
};

export enum HeaderAnimation {
  Apple = 'APPLE',
  BarGraph = 'BAR_GRAPH',
  Camera = 'CAMERA',
  One = 'ONE',
  Plant = 'PLANT',
  Rocket = 'ROCKET',
  Target = 'TARGET'
}

/** A header widget on the Trends surface */
export type HeaderWidget = {
  __typename?: 'HeaderWidget';
  /** Content of the header widget (union of supported header types) */
  content: HeaderWidgetContent;
};

/** Union of supported header widget types */
export type HeaderWidgetContent = ClientProgressHeader | ToolHeader;

export type HealthConnectAttributionDataInput = {
  /** List of package names of the apps inserting data. Steps data could have multiple data providers. Other types of data will have one provider. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Variant of HealthConnectAttributionDataInput with all fields optional for matching.
 * Keep in sync with HealthConnectAttributionDataInput.
 */
export type HealthConnectAttributionDataMatchInput = {
  /** List of package names of the apps inserting data. Steps data could have multiple data providers. Other types of data will have one provider. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Supported health-data providers. */
export enum HealthDataProvider {
  /** Validic provider. */
  Validic = 'VALIDIC'
}

/**
 * Represents the external user identity for a Noom user within a given health-data
 * provider.
 */
export type HealthDataProviderUser = {
  __typename?: 'HealthDataProviderUser';
  /** User's access code in the Noom system. */
  accessCode: Scalars['String']['output'];
  /** Partner user account details for this user. */
  partnerUserAccountDetails?: Maybe<PartnerUserAccountDetails>;
  /** Which provider this user is associated with. */
  provider: HealthDataProvider;
  /** The unique identifier for the user in the provider system. */
  providerUserId: Scalars['String']['output'];
};

/** Health insights data, providing an overview of available scan data and actionable items for users. */
export type HealthInsights = {
  __typename?: 'HealthInsights';
  /**
   * Actionable items encouraging users to take specific health assessments
   * or follow up on existing scan results.
   */
  actions: Array<HealthScanItem>;
  /**
   * Tiles displaying available scan types and their current status.
   * Shows users what health assessments they can take or have taken.
   */
  tiles: Array<HealthScanItem>;
};

/** Health Insights tab presentation */
export type HealthInsightsTab = {
  __typename?: 'HealthInsightsTab';
  /** Placeholder field; reserved for future Health Insights tab presentation properties */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthKitAttributionDataInput = {
  /** The bundle identifier of the app inserting the data. */
  bundleIdentifier: Scalars['String']['input'];
  /** Name of the app inserting data in HealthKit. */
  sourceName: Scalars['String']['input'];
};

/**
 * Variant of HealthKitAttributionDataInput with all fields optional for matching.
 * Keep in sync with HealthKitAttributionDataInput.
 */
export type HealthKitAttributionDataMatchInput = {
  /** The bundle identifier of the app inserting the data. */
  bundleIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Name of the app inserting data in HealthKit. */
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

/** Reference range for a specific health status level. */
export type HealthLabelRange = {
  __typename?: 'HealthLabelRange';
  /** Maximum value for this range (inclusive). */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum value for this range (inclusive). */
  min?: Maybe<Scalars['Float']['output']>;
  /** Health status classification for values in this range. */
  status: HealthStatus;
  /** Unit of measurement for this range (e.g., "%", "mg/dL"). */
  unit?: Maybe<HealthMetricUnit>;
};

/** Individual health metric with current value and detailed information. */
export type HealthMetric = {
  __typename?: 'HealthMetric';
  /** Detailed information about this metric including reference ranges. */
  detail: HealthMetricDetail;
  /** Most recent measurement value for this metric. */
  latestMetricValue: HealthMetricValue;
  /** Name of this health metric. */
  name: HealthMetricName;
  /** Whether this metric supports trend data (historical comparisons), derived from per-assessment-type feature config. */
  supportsTrends?: Maybe<Scalars['Boolean']['output']>;
};

/** A single historical data point for a health metric. */
export type HealthMetricDataPoint = {
  __typename?: 'HealthMetricDataPoint';
  /** Health label classification at this value */
  healthLabel?: Maybe<HealthStatus>;
  /** Report metadata for report-backed measurements */
  report?: Maybe<HealthMetricReportMetadata>;
  /** When the measurement was taken */
  timestamp: Scalars['LocalDateTime']['output'];
  /** Trend comparison with the first recorded measurement */
  trendFromFirst?: Maybe<Trend>;
  /** Trend comparison with the previous data point in the series */
  trendFromPrevious?: Maybe<Trend>;
  /** Unit of measurement */
  unit?: Maybe<HealthMetricUnit>;
  /** Numerical value of the measurement */
  value: Scalars['Float']['output'];
};

/** Detailed information about a health metric including reference ranges and source. */
export type HealthMetricDetail = {
  __typename?: 'HealthMetricDetail';
  /** Reference ranges for different health status levels. */
  healthLabels: Array<HealthLabelRange>;
  /** Source of this metric data for presentation purposes. */
  source?: Maybe<HealthMetricSource>;
  /** The weight of the metric. Metrics with higher weight are shown first. */
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Individual health metric names. */
export enum HealthMetricName {
  /** Alanine aminotransferase enzyme levels. */
  AlanineAminotransferase = 'ALANINE_AMINOTRANSFERASE',
  /** Apolipoprotein B levels. */
  ApolipoproteinB = 'APOLIPOPROTEIN_B',
  /** Basal Metabolic Rate - calories burned at rest. */
  BasalMetabolicRate = 'BASAL_METABOLIC_RATE',
  /** Body fat percentage. */
  BodyFatPercentage = 'BODY_FAT_PERCENTAGE',
  /** Respiratory rate measurement. */
  BreathingRate = 'BREATHING_RATE',
  /** Cardiac workload assessment. */
  CardiacWorkload = 'CARDIAC_WORKLOAD',
  /** Total cholesterol levels. */
  Cholesterol = 'CHOLESTEROL',
  /** CHOLESTEROL_HDL_RATIO levels for Labs. */
  CholesterolHdlRatio = 'CHOLESTEROL_HDL_RATIO',
  /** Dehydroepiandrosterone sulfate levels. */
  DehydroepiandrosteroneSulfate = 'DEHYDROEPIANDROSTERONE_SULFATE',
  /** Estradiol hormone levels. */
  Estradiol = 'ESTRADIOL',
  /** Total fat mass in the body. */
  FatMass = 'FAT_MASS',
  /** Heart rate measurement. */
  HeartRate = 'HEART_RATE',
  /** Heart rate variability analysis. */
  HeartRateVariability = 'HEART_RATE_VARIABILITY',
  /** Hemoglobin A1C levels for diabetes monitoring. */
  HemoglobinA1C = 'HEMOGLOBIN_A1C',
  /** High-density lipoprotein cholesterol. */
  HighDensityLipoproteinCholesterol = 'HIGH_DENSITY_LIPOPROTEIN_CHOLESTEROL',
  /** High-sensitivity C-reactive protein levels. */
  HighSensitivityCReactiveProtein = 'HIGH_SENSITIVITY_C_REACTIVE_PROTEIN',
  /** Detection of irregular heartbeat patterns. */
  IrregularHeartbeats = 'IRREGULAR_HEARTBEATS',
  /** LDL_APOB_RATIO levels for Labs. */
  LdlApobRatio = 'LDL_APOB_RATIO',
  /** Total lean mass in the body. */
  LeanMass = 'LEAN_MASS',
  /** Likelihood of avoiding heart attack (inverted from risk). */
  LikelihoodOfAvoidingHeartAttack = 'LIKELIHOOD_OF_AVOIDING_HEART_ATTACK',
  /** Likelihood of avoiding stroke (inverted from risk). */
  LikelihoodOfAvoidingStroke = 'LIKELIHOOD_OF_AVOIDING_STROKE',
  /**
   * Likelihood of avoiding Type 2 diabetes (inverted from risk).
   * @deprecated Use RISK_OF_TYPE_2_DIABETES instead.
   */
  LikelihoodOfAvoidingType_2Diabetes = 'LIKELIHOOD_OF_AVOIDING_TYPE_2_DIABETES',
  /** Lipoprotein(a) levels. */
  LipoproteinA = 'LIPOPROTEIN_A',
  /**
   * Long-term risk assessment for heart attack.
   * @deprecated Use LIKELIHOOD_OF_AVOIDING_HEART_ATTACK instead for positive framing.
   */
  LongTermRiskOfHeartAttack = 'LONG_TERM_RISK_OF_HEART_ATTACK',
  /**
   * Long-term risk assessment for stroke.
   * @deprecated Use LIKELIHOOD_OF_AVOIDING_STROKE instead for positive framing.
   */
  LongTermRiskOfStroke = 'LONG_TERM_RISK_OF_STROKE',
  /** Low-density lipoprotein cholesterol. */
  LowDensityLipoproteinCholesterol = 'LOW_DENSITY_LIPOPROTEIN_CHOLESTEROL',
  /** Luteinizing hormone levels for Labs. */
  LuteinizingHormone = 'LUTEINIZING_HORMONE',
  /** General body measurements. */
  Measurements = 'MEASUREMENTS',
  /** Mental stress level assessment. */
  MentalStressLevel = 'MENTAL_STRESS_LEVEL',
  /** Risk assessment for developing fatty liver disease. */
  RiskOfFattyLiverDisease = 'RISK_OF_FATTY_LIVER_DISEASE',
  /** Risk assessment for developing high blood pressure. */
  RiskOfHighBloodPressure = 'RISK_OF_HIGH_BLOOD_PRESSURE',
  /** Risk assessment for developing high cholesterol. */
  RiskOfHighCholesterol = 'RISK_OF_HIGH_CHOLESTEROL',
  /** Risk assessment for developing high triglycerides. */
  RiskOfHighTriglycerides = 'RISK_OF_HIGH_TRIGLYCERIDES',
  /** Risk assessment for developing prediabetes. */
  RiskOfPrediabetes = 'RISK_OF_PREDIABETES',
  /** Risk assessment for developing Type 2 diabetes. */
  RiskOfType_2Diabetes = 'RISK_OF_TYPE_2_DIABETES',
  /** Total testosterone hormone levels. */
  TotalTestosterone = 'TOTAL_TESTOSTERONE',
  /** Triglyceride levels. */
  Triglycerides = 'TRIGLYCERIDES',
  /** TRIGLYCERIDES_HDL_RATIO levels for Labs. */
  TriglyceridesHdlRatio = 'TRIGLYCERIDES_HDL_RATIO',
  /** Blood vessel elasticity and flexibility. */
  VascularElasticity = 'VASCULAR_ELASTICITY',
  /** Vitamin B12 levels. */
  VitaminB12 = 'VITAMIN_B12',
  /** Vitamin D levels. */
  VitaminD = 'VITAMIN_D',
  /** Waist to height ratio measurement. */
  WaistToHeightRatio = 'WAIST_TO_HEIGHT_RATIO'
}

/** Content for health metric overview. */
export type HealthMetricOverviewContent = {
  __typename?: 'HealthMetricOverviewContent';
  /** Reference to the image that will be shown depending on the framing. */
  arrowImageUrl: Scalars['String']['output'];
  /**
   * Represents how we will frame the claims of the program for that metric.
   * Eg: "Lose upto 11lbs in 30 days"
   * Eg: "Reduce your risk of heart attack"
   */
  metricClaimFraming: Scalars['String']['output'];
};

/** Report metadata for a report-backed data point. */
export type HealthMetricReportMetadata = {
  __typename?: 'HealthMetricReportMetadata';
  /** Report identifier from the source system */
  id: Scalars['String']['output'];
  /** Timestamp when the report was released */
  releasedAt: Scalars['LocalDateTime']['output'];
};

/**
 * Source of health metric data used for frontend presentation grouping.
 * This helps the frontend group metrics with appropriate subtitles like
 * "Last update from your Blood Test on 6/2/2025".
 */
export enum HealthMetricSource {
  /** Data sourced from body scan analysis. */
  BodyScan = 'BODY_SCAN',
  /** Data sourced from facial blood scan technology. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** Data sourced from Future Me analysis. */
  FutureMe = 'FUTURE_ME',
  /** Data sourced from laboratory blood tests. */
  Labs = 'LABS'
}

/**
 * Trend data for a specific health metric, including the trend summary
 * and initial line graph data points.
 */
export type HealthMetricTrends = {
  __typename?: 'HealthMetricTrends';
  /** Most recent data points in chronological order for the initial line graph */
  dataPoints: Array<HealthMetricDataPoint>;
  /** Token for fetching additional history */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Units of measurement for health metrics. */
export enum HealthMetricUnit {
  /** Beats per minute - heart rate measurement. */
  BeatsPerMinute = 'BEATS_PER_MINUTE',
  /** Breaths per minute - respiratory rate. */
  BreathsPerMinute = 'BREATHS_PER_MINUTE',
  /** Calories - unit of energy measurement. */
  Calories = 'CALORIES',
  /** Decibels (dB) - sound intensity measurement. */
  Db = 'DB',
  /** Inches (in) - length measurement. */
  In = 'IN',
  /** Inches per inch (in/in) - ratio measurement. */
  InPerIn = 'IN_PER_IN',
  /** Pounds (lbs) - weight measurement. */
  Lbs = 'LBS',
  /** Milligrams per deciliter (mg/dL) - concentration measurement. */
  MgDl = 'MG_DL',
  /** Milligrams per liter (mg/L) - concentration measurement. */
  MgL = 'MG_L',
  /** Milliseconds (ms) - time measurement. */
  Milliseconds = 'MILLISECONDS',
  /** Milli-international units per milliliter (mIU/mL) */
  MiuMl = 'MIU_ML',
  /** Nanograms per deciliter (ng/dL) - concentration measurement. */
  NgDl = 'NG_DL',
  /** Nanograms per milliliter (ng/mL) - concentration measurement. */
  NgMl = 'NG_ML',
  /** Percentage (%). */
  Percent = 'PERCENT',
  /** Picograms per milliliter (pg/mL) - concentration measurement. */
  PgMl = 'PG_ML',
  /** Seconds - time measurement. */
  Seconds = 'SECONDS',
  /** Micrograms per deciliter (ug/dL) - concentration measurement. */
  UgDl = 'UG_DL',
  /** Dimensionless count or index */
  Unitless = 'UNITLESS',
  /** Units per liter (U/L) - enzyme activity measurement. */
  UL = 'U_L'
}

/** User's biological age information. */
export type HealthMetricUpsellBiologicalAge = {
  __typename?: 'HealthMetricUpsellBiologicalAge';
  /** The user's current age. */
  currentAge: Scalars['Float']['output'];
  /** User's face scan age. */
  faceScanAge?: Maybe<Scalars['Float']['output']>;
  /** Biological age at healthy BMI. */
  healthyBmiAge: Scalars['Float']['output'];
};

/** Content for health metric upsell learn more section. */
export type HealthMetricUpsellLearnMoreContent = {
  __typename?: 'HealthMetricUpsellLearnMoreContent';
  /**
   * Footnotes that contain supporting information for the claim.
   * NOTE: This will be a html component that encodes all of the footnotes.
   */
  footnotes: Scalars['String']['output'];
  /** The label for the metric that determines the status of the metric (e.g. NEEDS_ATTENTION, FAIR). */
  label: HealthStatus;
  /** Description of the health label enum that determines what to show for the user. Eg: "Needs Attention" */
  labelDescription: Scalars['String']['output'];
  /**
   * Additional information corresponding to the metric.
   * Eg: "Losing 5-10% of body weight has been shown to... lowering heart attack risk"
   */
  metricDescription: Scalars['String']['output'];
  /**
   * The string representation of the metric type enum.
   * Eg: "Likelihood of avoiding heart attack"
   */
  metricTitle: Scalars['String']['output'];
  /** The health metric type. */
  metricType: HealthMetricName;
};

/** Group of health metric upsell content shown in the learn more page. */
export type HealthMetricUpsellLearnMoreContentGroup = {
  __typename?: 'HealthMetricUpsellLearnMoreContentGroup';
  /** The health metrics that belong to this group. */
  metrics: Array<HealthMetricUpsellLearnMoreContent>;
  /**
   * The subtitle text to display for this group of health metrics.
   * Eg: "Noom weight is designed to improve the following..."
   * Eg: "Noom weight is designed to further improve these healthy metrics..."
   */
  subtitle: Scalars['String']['output'];
};

/** Current or historical measurement value for a health metric. */
export type HealthMetricValue = {
  __typename?: 'HealthMetricValue';
  /** Health status classification for this value. */
  status?: Maybe<HealthStatus>;
  /** Date and time when this measurement was taken. */
  timestamp: Scalars['LocalDateTime']['output'];
  /** Trend comparison with the first recorded measurement. */
  trendFromFirst?: Maybe<Trend>;
  /** Trend comparison with the previous measurement. */
  trendFromPrevious?: Maybe<Trend>;
  /** Unit of measurement for the value. */
  unit?: Maybe<HealthMetricUnit>;
  /** Numerical value of the measurement. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Available health pillar names. */
export enum HealthPillarName {
  /** Cardiovascular health and heart-related metrics. */
  HeartHealth = 'HEART_HEALTH',
  /** Hormone levels and endocrine system health. */
  HormoneBalance = 'HORMONE_BALANCE',
  /** Inflammation markers and immune system health. */
  Inflammation = 'INFLAMMATION',
  /** Blood sugar, cholesterol, and metabolism-related metrics. */
  MetabolicHealth = 'METABOLIC_HEALTH'
}

/** Health assessment for a specific pillar (e.g., heart health, metabolic health). */
export type HealthPillarReport = {
  __typename?: 'HealthPillarReport';
  /** Name of this health pillar. */
  name: HealthPillarName;
  /** Detailed sections within this pillar (e.g., blood vessel risk, cholesterol levels). */
  sections: Array<HealthPillarSection>;
  /** Overall health status for this pillar based on all subsection assessments. */
  status?: Maybe<HealthStatus>;
};

/** Detailed section within a health pillar containing related health metrics. */
export type HealthPillarSection = {
  __typename?: 'HealthPillarSection';
  /** Individual health metrics within this subsection. */
  metrics: Array<HealthMetric>;
  /** Name of this subsection. */
  name: HealthPillarSectionName;
  /** Health status for this specific subsection. */
  status?: Maybe<HealthStatus>;
  /** Trend comparison with the previous assessment. */
  trendFromPrevious?: Maybe<Trend>;
};

/** Section names within health pillars. */
export enum HealthPillarSectionName {
  /** Adrenal function and stress response markers. */
  AdrenalHealth = 'ADRENAL_HEALTH',
  /** Risk assessment for heart attack and cardiovascular events. */
  HeartAndBloodVesselRisk = 'HEART_AND_BLOOD_VESSEL_RISK',
  /** Heart function and cardiac performance metrics. */
  HeartFunction = 'HEART_FUNCTION',
  /** Lipid levels and liver function markers. */
  LipidsAndLiver = 'LIPIDS_AND_LIVER',
  /** Metabolic risk factors and blood sugar control. */
  MetabolicRisk = 'METABOLIC_RISK',
  /** Sex hormone levels and reproductive health markers. */
  SexHormones = 'SEX_HORMONES',
  /** Systemic inflammation markers and immune response. */
  SystemicInflammation = 'SYSTEMIC_INFLAMMATION',
  /** Vitamin levels and nutritional balance. */
  VitaminBalance = 'VITAMIN_BALANCE'
}

/**
 * Top-level health report containing comprehensive health assessment data
 * based on the latest facial blood scan, body scan and lab results.
 */
export type HealthReport = {
  __typename?: 'HealthReport';
  /** Assessments that were included in this health report */
  assessments?: Maybe<Array<Assessment>>;
  /** Body age analysis based on body scan data. */
  bodyAgeReport?: Maybe<BodyAgeReport>;
  /** Date and time of the most recent health assessment used to generate this report. */
  dateOfLastAssessment: Scalars['LocalDateTime']['output'];
  /** Heart health assessment pillar including cardiovascular risk metrics. */
  heartHealth?: Maybe<HealthPillarReport>;
  /** Hormone balance assessment pillar including hormone levels and endocrine system health. */
  hormoneBalance?: Maybe<HealthPillarReport>;
  /** Inflammation assessment pillar including inflammatory markers and immune system health. */
  inflammation?: Maybe<HealthPillarReport>;
  /** Metabolic health assessment pillar including blood sugar, cholesterol, and metabolism metrics. */
  metabolicHealth?: Maybe<HealthPillarReport>;
  /**
   * Controls the Action Plan section in the health report.
   * Nullable so older producers that omit this field do not break clients.
   */
  showActionPlan?: Maybe<HealthReportActionPlan>;
  /**
   * Controls the ads/upsells in the health report.
   * Nullable so older producers that omit this field do not break clients.
   */
  showAds?: Maybe<HealthReportAds>;
};

/**
 * Controls the Action Plan section in the health report.
 * Modeled as an object (not a bare Boolean) so additional fields (variant, reason, copy) can be
 * added without a breaking schema change.
 */
export type HealthReportActionPlan = {
  __typename?: 'HealthReportActionPlan';
  /** Whether the Action Plan section should be shown. */
  enabled: Scalars['Boolean']['output'];
};

/**
 * Controls the ads/upsells in the health report. Object-typed for the same forward-compat
 * reason as HealthReportActionPlan.
 */
export type HealthReportAds = {
  __typename?: 'HealthReportAds';
  /** Whether ads/upsells should be shown. */
  enabled: Scalars['Boolean']['output'];
};

/** Content for health report upsell. */
export type HealthReportUpsellContent = {
  __typename?: 'HealthReportUpsellContent';
  /** Appendix, if applicable. */
  appendixText?: Maybe<Scalars['String']['output']>;
  /** The user's biological age info. */
  biologicalAgeInfo?: Maybe<HealthMetricUpsellBiologicalAge>;
  /** Disclaimer text, if applicable. */
  disclaimers: Array<Scalars['String']['output']>;
  /** The url of the image to show at the top of the page. */
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Health metrics upsell related content shown in the learn more page.
   * Each group contains a subtitle and the metrics that belong to that group.
   */
  healthMetricUpsellContentGroups: Array<HealthMetricUpsellLearnMoreContentGroup>;
  /** List of health metrics overview content, which will be shown in the main page. */
  healthMetricsOverview: Array<HealthMetricOverviewContent>;
  /**
   * Subtitle for the title page.
   * Eg: "Recommended for ..."
   */
  healthReportUpsellPageSubtitle?: Maybe<Scalars['String']['output']>;
  /**
   * Text to be shown as the title of the upsell page.
   * Eg: "Designed to improve your health metrics and biological age"
   */
  healthReportUpsellPageTitle?: Maybe<Scalars['String']['output']>;
  /**
   * The string representing the title of the page that will be shown from the learn more section.
   * Eg: "How Noom's Program can support your overall health"
   */
  learnMorePageTitle: Scalars['String']['output'];
  /** The primary button. */
  primaryButton?: Maybe<Button>;
  /** The name of the upsell product. */
  productName: Scalars['String']['output'];
  /** The secondary button. */
  secondaryButton?: Maybe<Button>;
  /** The starts at price pill. */
  startsAtPriceText: Scalars['String']['output'];
  /**
   * Based on the upsell ad location type we might have to show a different
   * entry page for the upsell ad. This field will represent that.
   */
  upsellAdUrl?: Maybe<Scalars['String']['output']>;
  /** The value proposition bullets. */
  valueProps: Array<ValueProps>;
};

/**
 * View type for the health report. Used when requesting a health report to determine
 * which view's metrics should be prioritized.
 */
export enum HealthReportViewType {
  /** View focused on facial blood scan results. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** View focused biomarker test results. */
  Labs = 'LABS',
  /** Summary view */
  Summary = 'SUMMARY',
  /** Unknown or unspecified view type. */
  Unknown = 'UNKNOWN'
}

/** Individual health scan item representing a specific type of health assessment. */
export type HealthScanItem = {
  __typename?: 'HealthScanItem';
  /**
   * Date and time of the most recent scan of this type.
   * Null if the user has never completed this type of scan.
   */
  lastScanAt?: Maybe<Scalars['LocalDateTime']['output']>;
  /**
   * Unique identifier of the most recent scan of this type.
   * Null if the user has never completed this type of scan.
   */
  lastScanId?: Maybe<Scalars['String']['output']>;
  /** Total number of scans of this type that the user has completed. */
  numberOfScans: Scalars['Int']['output'];
  /** Type of health scan or assessment this item represents. */
  scanType: HealthMetricSource;
};

/** Overall health status classification levels. */
export enum HealthStatus {
  /** Health metric is acceptable but could be improved. */
  Fair = 'FAIR',
  /** Health metric is in a good range. */
  Good = 'GOOD',
  /** Health metric requires attention or intervention. */
  NeedsAttention = 'NEEDS_ATTENTION',
  /** Health metric is in the optimal range. */
  Optimal = 'OPTIMAL'
}

/** Content for a large home screen ad placement. */
export type HomeLargeContent = {
  __typename?: 'HomeLargeContent';
  /** A bullet list of benefits with markdown encoding. */
  benefitKeysMarkdown: Array<Scalars['String']['output']>;
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** Text for the disclaimer. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
  /** The title of the testimonial section. */
  testimonialTitle?: Maybe<Scalars['String']['output']>;
  /** The title of the content block. */
  title?: Maybe<Scalars['String']['output']>;
  /** A list of testimonials. */
  upsellAdTestimonial?: Maybe<Array<UpsellAdTestimonial>>;
};

/**  Available page types for the home screen carousel (enum preserved for backward compatibility). */
export enum HomeScreenCarouselPage {
  CalorieBudget = 'CALORIE_BUDGET',
  FoodColorBreakdown = 'FOOD_COLOR_BREAKDOWN',
  MacroBudgets = 'MACRO_BUDGETS',
  MacroNutrients = 'MACRO_NUTRIENTS',
  MicroNutrients = 'MICRO_NUTRIENTS',
  ProteinBudget = 'PROTEIN_BUDGET',
  ProteinFocusedMacroBudgets = 'PROTEIN_FOCUSED_MACRO_BUDGETS'
}

/**  A single carousel page with optional goal IDs. Use for MICRO_NUTRIENTS and other pages that specify goals. */
export type HomeScreenCarouselPageContainer = {
  __typename?: 'HomeScreenCarouselPageContainer';
  /** Optional goal IDs (GoalId) for nutrient goals on this page. See noom_contracts.tools.goals.GoalIdEnumProto.Value. */
  goalIds?: Maybe<Array<GoalId>>;
  page: HomeScreenCarouselPage;
};

export type HomeScreenCarouselState = {
  __typename?: 'HomeScreenCarouselState';
  /** Carousel pages with optional goal IDs (e.g. for MICRO_NUTRIENTS). */
  pageContainers: Array<HomeScreenCarouselPageContainer>;
  /**
   * Page types only. Prefer pageContainers when goal IDs are needed.
   * @deprecated Use pageContainers for pages that may include goal IDs
   */
  pages: Array<HomeScreenCarouselPage>;
};

/** Content for a single tile in the home screen carousel ad placement. */
export type HomeScreenCarouselTileContent = {
  __typename?: 'HomeScreenCarouselTileContent';
  /** Call to action button for the carousel tile. */
  button?: Maybe<Button>;
  /** Header for this carousel tile. */
  header?: Maybe<Scalars['String']['output']>;
  /** URL of the image to display in this carousel tile. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Text to display on the carousel tile. */
  text?: Maybe<Scalars['String']['output']>;
  /**
   * Title for the entire carousel section.
   * This value is expected to be the same across all tiles and is typically taken from the first tile.
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The upsell ad type for this carousel tile. Note that each tile can be a different
   * type and the type of the ad UpsellAdData may not be representative of all of the ads.
   */
  upsellAdType?: Maybe<UpsellAdType>;
};

/** Home screen navigation configuration - drives the navigation view shown in toolbar */
export type HomeScreenNavigation = {
  __typename?: 'HomeScreenNavigation';
  /** Type of home screen navigation */
  type: HomeScreenNavigationType;
};

/** Available types of home screen navigation */
export enum HomeScreenNavigationType {
  /** Daily navigation */
  DailyNavigation = 'DAILY_NAVIGATION',
  /** No navigation */
  NoNavigation = 'NO_NAVIGATION',
  /** Weekly navigation - for users with Noomcoin */
  WeeklyNavigation = 'WEEKLY_NAVIGATION'
}

/** DEPRECATED: Display the full list of available methods from RewardsLevels.methods. This type is not currently supported by clients */
export type HowToEarnCurrencyFullList = {
  __typename?: 'HowToEarnCurrencyFullList';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Display the generic message with a link to a FAQ page */
export type HowToEarnCurrencyGeneric = {
  __typename?: 'HowToEarnCurrencyGeneric';
  /** WebView URL for rewards learn more webpage */
  learnMoreWebViewUrl: Scalars['String']['output'];
};

/** Display noomcoin information only */
export type HowToEarnCurrencyNoomcoin = {
  __typename?: 'HowToEarnCurrencyNoomcoin';
  /** Currency units (seeds) awarded when requirements are met. */
  currencyAmountAwarded: Scalars['Int']['output'];
  /** WebView URL for rewards learn more webpage */
  learnMoreWebViewUrl: Scalars['String']['output'];
};

/** Union type representing the type of How to earn currency screen to display */
export type HowToEarnCurrencyType = HowToEarnCurrencyFullList | HowToEarnCurrencyGeneric | HowToEarnCurrencyNoomcoin;

/** A single HTTP header key-value pair. */
export type HttpHeader = {
  __typename?: 'HttpHeader';
  /** Header name (e.g. Content-Type). */
  name: Scalars['String']['output'];
  /** Header value. */
  value: Scalars['String']['output'];
};

/**
 * This type of switch is effective immediately.
 * Because the switch is effective immediately, we have to determine how to
 * handle the unused remainder of the billing cycle. That is controlled by
 * billingCycleBehavior and prorationBehavior fields.
 */
export type ImmediateSwitch = {
  __typename?: 'ImmediateSwitch';
  /** Determines how the switch affects the user's billing date */
  billingCycleBehavior: BillingCycleBehavior;
  /** Determines proration behavior for the remainder of the billing cycle. */
  prorationBehavior: ProrationBehavior;
  /** Determines the trial behavior for an immediate switch operation */
  trialType: SwitchTrialType;
};

/** Initial prescribed dosage. */
export type InitialDose = {
  __typename?: 'InitialDose';
  /** Prescribed dosage quantity and unit. */
  dosage: MedicationQuantity;
};

/** Payload returned after attempting to initialize the core experience for the user. */
export type InitializeCoreExperiencePayload = {
  __typename?: 'InitializeCoreExperiencePayload';
  /**
   * Returns true if the initialization was successful; otherwise, it is false.
   * Note: Currently, it cannot be false, as the service method implementation
   * is expected to either return true or throw an exception.
   */
  success: Scalars['Boolean']['output'];
};

/** CTA for insight (example is quick reply with a deep link, etc.). */
export type InsightCallToAction = {
  __typename?: 'InsightCallToAction';
  /** Indicates do we need to show locker on the CTA. */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Link to take action of CTA. */
  link: Scalars['String']['output'];
  /** Text to show for the CTA. */
  text: Scalars['String']['output'];
};

/** Feedback from the user on the value of the insight */
export type InsightFeedback = {
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
};

/** Options for how the user can rate an insight */
export enum InsightFeedbackRating {
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP'
}

/**
 * A canonical internal SKU entity defining a first-class product identifier.
 * Maps to InternalSkuProto in noom_contracts/external_fulfillment/orders/model/internal_sku.proto.
 */
export type InternalSku = {
  __typename?: 'InternalSku';
  /** Product description. */
  description: Scalars['String']['output'];
  /** Product icon — URL or icon identifier. */
  icon: Scalars['String']['output'];
  /** SKU lifecycle state. Uses SkuLifecycleState defined in skuRegistry.graphqls. */
  lifecycleState: SkuLifecycleState;
  /** Human-readable product name. */
  name: Scalars['String']['output'];
  /** Noom-internal SKU code (lowercase slug, natural key). */
  sku: Scalars['String']['output'];
};

/** Filter inputs for internalSkus. Empty fields are ignored. */
export type InternalSkuFilter = {
  lifecycleState?: InputMaybe<SkuLifecycleState>;
};

/**
 * Wrapper around the internal SKU list response. Wrapping instead of returning a bare list allows
 * pagination fields (cursor, pageInfo) to be added later without a breaking schema change.
 */
export type InternalSkuList = {
  __typename?: 'InternalSkuList';
  /** All internal SKUs matching the filter. */
  skus: Array<InternalSku>;
};

export type InterstitialState = {
  __typename?: 'InterstitialState';
  lastShownDate?: Maybe<Scalars['LocalDate']['output']>;
  shownCount: Scalars['Int']['output'];
};

export type Interstitials = {
  __typename?: 'Interstitials';
  careTabHint: InterstitialState;
  communityHint: InterstitialState;
  communityIntroAnnouncement: InterstitialState;
  communityMoved: InterstitialState;
  successKitIntro: InterstitialState;
};

/** Enumerates the available code types for user invitation codes. */
export enum InvitationCodeType {
  /** Invitation code used for establishing friend connections between users. */
  FriendInvitation = 'FRIEND_INVITATION'
}

/** Response for generating an friend invitation link mutation */
export type InviteFriendLink = {
  __typename?: 'InviteFriendLink';
  /** User's invitation code. Since the code can be copied separately from the link, we return it as a separate field. */
  code: Scalars['String']['output'];
  /** User’s friend invitation link. */
  link: Scalars['String']['output'];
};

/** Represents the contents of a JWT token. */
export type JwtContents = {
  __typename?: 'JwtContents';
  /** The access code associated with the account. */
  accessCode: Scalars['String']['output'];
  /** The email address of the account. */
  accountEmail: Scalars['String']['output'];
  /** The authorities/permissions granted by the JWT token. */
  authorities: Array<Scalars['String']['output']>;
  /** The client ID associated with the JWT token. */
  clientId: Scalars['String']['output'];
  /** The expiration date and time of the JWT token. */
  exp: Scalars['DateTime']['output'];
  /** The username associated with the account. */
  userName: Scalars['String']['output'];
};

/** An order record for Ash Labs biomarker test kit orders. */
export type LabKitOrder = ShipmentOrder & {
  __typename?: 'LabKitOrder';
  /** Lab kit identifier assigned by Ash Labs. */
  kitId?: Maybe<Scalars['String']['output']>;
  /** Date and time the order was placed. */
  orderDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Order identifier. */
  orderId: Scalars['ID']['output'];
  /** Product categories. */
  productCategories: Array<ShipmentProductCategory>;
  /** Shipments associated with this order. */
  shipments: Array<Shipment>;
  /** Shipping address for this order. Null for lab kit orders. */
  shippingAddress?: Maybe<Address>;
  /** Current status of this order. */
  status: ShipmentOrderStatus;
  /** Fulfillment partner, pharmacy, or vendor name (e.g. 'Ash Labs'). */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** A lab kit shipment record. */
export type LabKitShipment = Shipment & {
  __typename?: 'LabKitShipment';
  /** Shipping carrier name (e.g. 'UPS', 'USPS', 'FedEx'). */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Direction of this lab kit shipment. */
  direction: LabKitShipmentDirection;
  /** Current status of this shipment. */
  status: ShipmentStatus;
  /** Carrier tracking number.  */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Full carrier tracking URL. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Direction of a lab kit shipment. */
export enum LabKitShipmentDirection {
  /** The lab is sending the kit to the patient. */
  LabToPatient = 'LAB_TO_PATIENT',
  /** The patient is sending the input back to the lab. */
  PatientToLab = 'PATIENT_TO_LAB',
  /** Unknown lab kit shipment direction. */
  Unknown = 'UNKNOWN'
}

export enum LabLifecycleScenario {
  FullLifecycle = 'FULL_LIFECYCLE'
}

/**
 * The context identifying the specific type and lifecycle stage of a lab order
 * placement. Mirrors `LabOrderContextEnumProto` in the healthcare shared proto.
 */
export enum LabOrderContext {
  /** OTC standalone one-time purchase (single invoice, no subscription). */
  OtcOneTime = 'OTC_ONE_TIME',
  /** OTC subscription — initial order (first kit in a subscription). */
  OtcSubscriptionInitial = 'OTC_SUBSCRIPTION_INITIAL',
  /** OTC subscription — renewal order (repeat kit in an ongoing subscription). */
  OtcSubscriptionRenewal = 'OTC_SUBSCRIPTION_RENEWAL',
  /** Proactive Health — initial order (first lab kit for this patient). */
  PhInitial = 'PH_INITIAL',
  /** Proactive Health — renewal order (repeat kit, existing patient). */
  PhRenewal = 'PH_RENEWAL',
  /** Default unknown value. */
  Unknown = 'UNKNOWN'
}

/** How the lab test input is collected, mirrors `LabOrderInputCollectionMechanismEnumProto.Value`. */
export enum LabOrderInputCollectionMechanism {
  /** The input was collected at home. */
  AtHome = 'AT_HOME',
  /** The input was collected in the lab. */
  InLab = 'IN_LAB',
  /** Default unknown value. */
  Unknown = 'UNKNOWN'
}

/** Structured replacement reason, mirrors `LabOrderReplacementReasonEnumProto.Value`. */
export enum LabOrderReplacementReason {
  /** Automated: results contained insufficient biomarkers. */
  AutomatedInsufficientBiomarkers = 'AUTOMATED_INSUFFICIENT_BIOMARKERS',
  /** Automated: rejected because results were indeterminate. */
  AutomatedRejectedIndeterminate = 'AUTOMATED_REJECTED_INDETERMINATE',
  /** Automated: rejected because the kit was lost in transit. */
  AutomatedRejectedKitLostInTransit = 'AUTOMATED_REJECTED_KIT_LOST_IN_TRANSIT',
  /** Automated: rejected because patient data was missing. */
  AutomatedRejectedMissingPatientData = 'AUTOMATED_REJECTED_MISSING_PATIENT_DATA',
  /** Automated: rejected because the sample quantity was not sufficient. */
  AutomatedRejectedQuantityNotSufficient = 'AUTOMATED_REJECTED_QUANTITY_NOT_SUFFICIENT',
  /** Automated: rejected because patient data could not be confirmed. */
  AutomatedRejectedUnableToConfirmPatientData = 'AUTOMATED_REJECTED_UNABLE_TO_CONFIRM_PATIENT_DATA',
  /** Automated: lab rejected the test. */
  AutomatedTestRejected = 'AUTOMATED_TEST_REJECTED',
  /** Carrier was unable to deliver the kit to the patient. */
  FailedDelivery = 'FAILED_DELIVERY',
  /** Generic fulfillment error not covered by other reasons. */
  FulfillmentError = 'FULFILLMENT_ERROR',
  /** Shipping address was insufficient or invalid. */
  InsufficientOrInvalidAddress = 'INSUFFICIENT_OR_INVALID_ADDRESS',
  /** Kit was past its expiration date. */
  KitExpiration = 'KIT_EXPIRATION',
  /** Lab processing error not attributable to the patient (e.g. lab equipment failure). */
  LabProcessingError = 'LAB_PROCESSING_ERROR',
  /** Kit was missing materials required for collection. */
  MissingMaterials = 'MISSING_MATERIALS',
  /** Patient made a collection error (e.g. insufficient or contaminated sample). */
  PatientCollectionError = 'PATIENT_COLLECTION_ERROR',
  /** Patient information error (mismatched or missing patient data). */
  PatientInfoError = 'PATIENT_INFO_ERROR',
  /** Returned kit had a delivery issue (lost or damaged in transit back to the lab). */
  ReturnedKitDeliveryIssue = 'RETURNED_KIT_DELIVERY_ISSUE',
  /** Default unknown value; fall back to the free-text reason field. */
  Unknown = 'UNKNOWN'
}

/** Direction of a lab shipment, mirrors `LabOrderShipmentDirectionEnumProto.Value`. */
export enum LabOrderShipmentDirection {
  /** The lab is sending the kit to the patient. */
  LabToPatient = 'LAB_TO_PATIENT',
  /** The patient is sending the input back to the lab. */
  PatientToLab = 'PATIENT_TO_LAB',
  /** Default unknown value. */
  Unknown = 'UNKNOWN'
}

/** Lifecycle status of a lab order, mirrors `LabOrderStatusEnumProto.Value`. */
export enum LabOrderStatus {
  /** Order was canceled before completion. */
  Canceled = 'CANCELED',
  /** A system or integration error occurred. */
  Error = 'ERROR',
  /** User has returned or uploaded the input; it is in transit or queued. */
  InputInTransit = 'INPUT_IN_TRANSIT',
  /** Input (sample/data/etc.) has been received by the lab. */
  InputReceived = 'INPUT_RECEIVED',
  /** A recoverable issue was detected that requires manual intervention or retry. */
  IssueReported = 'ISSUE_REPORTED',
  /** Kit delivered to the patient; waiting for required input (sample, photo, survey, data). */
  OrderDelivered = 'ORDER_DELIVERED',
  /** Order confirmed by the vendor; tracking information returned. */
  OrderFulfilled = 'ORDER_FULFILLED',
  /** Order placed with the vendor. */
  OrderPlaced = 'ORDER_PLACED',
  /** A replacement order was created for this order. */
  OrderReplaced = 'ORDER_REPLACED',
  /** Lab has accessioned the input and begun processing or analysis. */
  Processing = 'PROCESSING',
  /** The input was invalid or unusable; lab unable to proceed. */
  Rejected = 'REJECTED',
  /** Results are finalized and available for delivery or review. */
  ResultsReady = 'RESULTS_READY',
  /** Default unknown value. */
  Unknown = 'UNKNOWN'
}

/** Lab service provider, mirrors `LabServiceProviderEnumProto.Value`. */
export enum LabServiceProvider {
  /** Ash Wellness — at-home lab kit fulfillment partner. */
  AshWellness = 'ASH_WELLNESS',
  /** Default unknown value. */
  Unknown = 'UNKNOWN'
}

/** At-home lab kit treatment card (e.g. biomarkers). */
export type LabTreatmentOverview = TreatmentOverview & {
  __typename?: 'LabTreatmentOverview';
  actionLinks: Array<TreatmentActionLink>;
  chatWithDoctorDeeplink?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  isMedicationLogSupported?: Maybe<Scalars['Boolean']['output']>;
  productBackgroundColor?: Maybe<Scalars['String']['output']>;
  productIconUrl?: Maybe<Scalars['String']['output']>;
  productImageUrl: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  /** Date the lab kit was purchased. Null when no purchase date is known. */
  purchaseDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Current status of the lab kit lifecycle. Null when the treatment is in an unrecognized state (no status row). */
  status?: Maybe<LabTreatmentStatus>;
  treatmentCode: Scalars['String']['output'];
  treatmentName: Scalars['String']['output'];
};

/** Status union for at-home lab kit treatments (e.g. biomarkers). Each variant carries the data specific to that state and composes the treatment card UI. */
export type LabTreatmentStatus = TreatmentOverviewStatusCompletedKitReceived | TreatmentOverviewStatusCompletedKitShipped | TreatmentOverviewStatusDelivered | TreatmentOverviewStatusReplacementShipped | TreatmentOverviewStatusResultsAvailable | TreatmentOverviewStatusShipped | TreatmentOverviewStatusShippingSoon;

/**
 * A label -> value pair of strings, formatted in markdown.
 *
 * Can be used to represent a list of labeled items.
 */
export type LabeledValue = {
  __typename?: 'LabeledValue';
  /** The descriptive label for the field name, optionally with markdown */
  labelMarkdown: Scalars['String']['output'];
  /** The value associated with the label, optionally with markdown */
  valueMarkdown: Scalars['String']['output'];
};

/** Latest dose taken: the dosage and the date it was administered. */
export type LatestDoseTaken = {
  __typename?: 'LatestDoseTaken';
  /** Dosage quantity and unit of the dose that was taken. */
  dosage: MedicationQuantity;
  /** Date the dose was taken. */
  takenOn: Scalars['LocalDate']['output'];
  /** Number of units taken in this dose. */
  unitsTaken?: Maybe<Scalars['Int']['output']>;
};

/** Legacy weekly cadence (automatic weekly grant) */
export type LegacyWeeklyCadence = {
  __typename?: 'LegacyWeeklyCadence';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

export type LessonsData = {
  __typename?: 'LessonsData';
  measurementCivilDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  secondsRead: Scalars['Int']['output'];
};

export type LessonsDataInput = {
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  secondsRead: Scalars['Int']['input'];
};

/** A wrapper type for an inclusive date range */
export type LocalDateRange = {
  __typename?: 'LocalDateRange';
  /** The inclusive end day of the date range */
  endDate: Scalars['LocalDate']['output'];
  /** The inclusive starting day of the date range */
  startDate: Scalars['LocalDate']['output'];
};

/** A wrapper input type for an inclusive date range */
export type LocalDateRangeInput = {
  /** The inclusive end day of the date range */
  endDate: Scalars['LocalDate']['input'];
  /** The inclusive starting day of the date range */
  startDate: Scalars['LocalDate']['input'];
};

export type LocalDateTimeRange = {
  __typename?: 'LocalDateTimeRange';
  end: Scalars['LocalDateTime']['output'];
  start: Scalars['LocalDateTime']['output'];
};

export type LogMealResponse = {
  __typename?: 'LogMealResponse';
  /** The user's updated goals after meal logging and evaluation */
  goals: UserGoalList;
  /** The stored meal data returned by measurements-api */
  mealData: MealData;
};

export type LogMealsTrackerPayload = {
  __typename?: 'LogMealsTrackerPayload';
  /** Different configurable pages for a tracker */
  pages: Array<MealLoggingTrackerPage>;
  /** Optional task subtitle override */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Optional task title override */
  title?: Maybe<Scalars['String']['output']>;
  /** What variant of the tracker are we showing. */
  variant: MealLoggingTrackerVariant;
};

/** Logged meal information used to generate an AI insight for the user. */
export type LoggedMealInput = {
  /** Access code of user that meal was logged for. */
  accessCode: Scalars['String']['input'];
  /** The food items that the user logged for the meal. */
  foodItems: Array<FoodItemInput>;
  /** Date of the meal. */
  mealDate: Scalars['LocalDate']['input'];
  /** The slot for the logged meal. */
  mealSlot: MealSlot;
};

/**  Encapsulates the data needed to render the macro monitoring settings screen */
export type MacroMonitoringSettingsState = {
  __typename?: 'MacroMonitoringSettingsState';
  /**  Whether the user has enabled macro monitoring on their account */
  isEnabled: Scalars['Boolean']['output'];
  /**  The macronutrient target percentage values based on the users calorie budget */
  macroTargets: CalorieBudgetMacroTargets;
};

/** Input for marking a content item as completed */
export type MarkContentItemCompletedInput = {
  /** Access code of the user that is completing the content */
  accessCode: Scalars['String']['input'];
  /** The client's date and time when the task was completed */
  completedAt: Scalars['LocalDateTime']['input'];
  /** The id of the task to mark as completed */
  taskId: Scalars['ID']['input'];
};

/** Input for marking standalone content as consumed */
export type MarkStandaloneContentConsumedInput = {
  /** Access code that pseudo-identifies the user (optional, can be obtained from headers) */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Opaque round-trip payload for tracking content consumption state */
  contentConsumedPayload: Scalars['String']['input'];
  /** Represents the client's civil date the content is requested for */
  contentLocalDate: Scalars['LocalDate']['input'];
};

/** Response for marking standalone content as consumed */
export type MarkStandaloneContentConsumedResponse = {
  __typename?: 'MarkStandaloneContentConsumedResponse';
  /** The updated standalone content item */
  content: StandaloneContent;
};

/** A wrapper for the markdown string Content Item description */
export type MarkdownString = {
  __typename?: 'MarkdownString';
  /** Markdown string value */
  value: Scalars['String']['output'];
};

/**
 *  These values should be aligned with:
 *  - blood_glucose_data.proto (BloodGlucoseDataProto)
 */
export enum MealContext {
  AfterAfternoonSnack = 'AFTER_AFTERNOON_SNACK',
  AfterBreakfast = 'AFTER_BREAKFAST',
  AfterDinner = 'AFTER_DINNER',
  AfterEveningSnack = 'AFTER_EVENING_SNACK',
  AfterLunch = 'AFTER_LUNCH',
  AfterMorningSnack = 'AFTER_MORNING_SNACK',
  BeforeAfternoonSnack = 'BEFORE_AFTERNOON_SNACK',
  BeforeBed = 'BEFORE_BED',
  BeforeBreakfast = 'BEFORE_BREAKFAST',
  BeforeDinner = 'BEFORE_DINNER',
  BeforeEveningSnack = 'BEFORE_EVENING_SNACK',
  BeforeLunch = 'BEFORE_LUNCH',
  BeforeMorningSnack = 'BEFORE_MORNING_SNACK',
  Fasting = 'FASTING',
  Unknown = 'UNKNOWN'
}

export type MealData = {
  __typename?: 'MealData';
  mealItems: Array<MealItemOneOf>;
  mealNotes?: Maybe<MealNotes>;
  mealPhotos?: Maybe<MealPhotos>;
  mealSlot?: Maybe<MealSlot>;
  mealTimeSlot?: Maybe<MealTimeSlot>;
  measurementCivilDate: Scalars['LocalDate']['output'];
};

export type MealDataInput = {
  /** The items in the meal */
  mealItems: Array<MealItemInput>;
  /** Optional notes about the meal */
  mealNotes?: InputMaybe<MealNotesInput>;
  /** Optional photos attached to the meal */
  mealPhotos?: InputMaybe<Array<MealPhotoInput>>;
  /** The meal slot (breakfast, lunch, dinner, etc.) */
  mealSlot: MealSlot;
  /** date_time when meal log was submitted */
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
};

/** Content for displaying a meal feedback screen upsell ad. */
export type MealFeedbackScreenContent = {
  __typename?: 'MealFeedbackScreenContent';
  /** Button configuration for the meal feedback screen upsell ad. */
  button?: Maybe<Button>;
  /** URL of the image to display on the meal feedback screen upsell ad. */
  imageUrl: Scalars['String']['output'];
  /** Text to display on the meal feedback screen upsell ad. */
  text: Scalars['String']['output'];
};

export type MealItemInput = {
  /** A composite meal item (recipe or custom dish) */
  compositeMealItem?: InputMaybe<CompositeMealItemInput>;
  /** A single food item */
  simpleMealItem?: InputMaybe<SimpleMealItemInput>;
};

export type MealItemOneOf = {
  __typename?: 'MealItemOneOf';
  compositeMealItem?: Maybe<CompositeMealItem>;
  simpleMealItem?: Maybe<SimpleMealItem>;
};

/** Feature state containing the configuration for meal logging method selector UI */
export type MealLoggingMethodSelectorFeatureState = {
  __typename?: 'MealLoggingMethodSelectorFeatureState';
  /** List of rows containing meal logging option cards */
  rows: Array<MealLoggingSelectorRow>;
};

/**
 * Available meal logging methods
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionType)
 */
export enum MealLoggingOption {
  /** Log meals by scanning product barcodes */
  Barcode = 'BARCODE',
  /** View previously recorded meal history */
  History = 'HISTORY',
  /** Log meals by taking a photo */
  Photo = 'PHOTO',
  /** Log meals by searching a food database */
  Search = 'SEARCH',
  /** Default/unspecified meal logging option type */
  UnknownType = 'UNKNOWN_TYPE',
  /** Log meals using voice recording */
  Voice = 'VOICE'
}

/**
 * Availability states for meal logging options
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionAvailability)
 */
export enum MealLoggingOptionAvailability {
  /** Option is temporarily unavailable */
  Disabled = 'DISABLED',
  /** Option is available and can be used */
  Enabled = 'ENABLED',
  /** Option is locked and requires special access or upgrade */
  Locked = 'LOCKED',
  /** Default/unspecified availability state */
  UnknownAvailability = 'UNKNOWN_AVAILABILITY'
}

/** Individual card representing a meal logging method option */
export type MealLoggingOptionCard = {
  __typename?: 'MealLoggingOptionCard';
  /** Current availability state of this logging option */
  availability: MealLoggingOptionAvailability;
  /** The specific meal logging method this card represents */
  option: MealLoggingOption;
  /** Display size of the card in the UI */
  size: MealLoggingOptionCardSize;
  /** Tags to highlight special features or promotions */
  tags: Array<MealLoggingOptionCardTag>;
};

/**
 * Display sizes for meal logging option cards
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionCardSize)
 */
export enum MealLoggingOptionCardSize {
  /** Large card size for prominent display */
  Large = 'LARGE',
  /** Medium card size for standard display */
  Medium = 'MEDIUM',
  /** Small card size for compact display */
  Small = 'SMALL',
  /** Default/unspecified card size */
  UnknownSize = 'UNKNOWN_SIZE'
}

/**
 * Optional tags for meal logging option cards
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionCardTagProto)
 */
export enum MealLoggingOptionCardTag {
  /** Indicates a feature the user should try */
  TryMe = 'TRY_ME',
  /** Default/unspecified card tag */
  UnknownTag = 'UNKNOWN_TAG'
}

export type MealLoggingProgressBarPage = {
  __typename?: 'MealLoggingProgressBarPage';
  bars: Array<MealLoggingTrackerBar>;
};

/** A row in the meal logging method selector containing option cards */
export type MealLoggingSelectorRow = {
  __typename?: 'MealLoggingSelectorRow';
  /** List of meal logging option cards in this row */
  cards: Array<MealLoggingOptionCard>;
};

export type MealLoggingTrackerBar = FoodCalorieBar | ProteinBar;

export type MealLoggingTrackerPage = MealLoggingProgressBarPage;

export enum MealLoggingTrackerVariant {
  /** Regular configurable food tracking, showing progress bars for food calories or mass. */
  Default = 'DEFAULT',
  /** The state shown for freemium users before they set their green goal. */
  GreenGoalOnboarding = 'GREEN_GOAL_ONBOARDING',
  /** The state shown for freemium users before they set their protein goal. */
  ProteinGoalOnboarding = 'PROTEIN_GOAL_ONBOARDING',
  Unknown = 'UNKNOWN'
}

export type MealNotes = {
  __typename?: 'MealNotes';
  eatingReason?: Maybe<EatingReason>;
  mealOrigin?: Maybe<MealOrigin>;
};

export type MealNotesInput = {
  /** Why the user ate */
  eatingReason?: InputMaybe<EatingReason>;
  /** How the meal was prepared */
  mealOrigin?: InputMaybe<MealOrigin>;
};

export enum MealOrigin {
  DontKnow = 'DONT_KNOW',
  FastFood = 'FAST_FOOD',
  Homemade = 'HOMEMADE',
  Prepackaged = 'PREPACKAGED',
  Raw = 'RAW',
  Restaurant = 'RESTAURANT'
}

export type MealPhoto = {
  __typename?: 'MealPhoto';
  url: Scalars['String']['output'];
};

export type MealPhotoInput = {
  /** URL of the meal photo */
  url: Scalars['String']['input'];
};

export type MealPhotos = {
  __typename?: 'MealPhotos';
  photos?: Maybe<Array<MealPhoto>>;
};

/**
 *  These values should be aligned with:
 *  - meal_slots.proto (MealSlotsProto.MealSlot)
 */
export enum MealSlot {
  AfternoonSnack = 'AFTERNOON_SNACK',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  EveningSnack = 'EVENING_SNACK',
  Lunch = 'LUNCH',
  MorningSnack = 'MORNING_SNACK',
  Unknown = 'UNKNOWN'
}

export type MealTimeSlot = {
  __typename?: 'MealTimeSlot';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
};

/**
 *  These values should be aligned with:
 *  - measurement_data.proto (DatapointAggregationProto.Grouping)
 */
export enum MeasurementAggregationGrouping {
  Day = 'DAY',
  GroupingUnknown = 'GROUPING_UNKNOWN',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type MeasurementData = BloodGlucoseData | LessonsData | MealData | MedicationData | MoodData | StepsData | WaterData | WeightData;

export type MeasurementDataInput = {
  bloodGlucoseData?: InputMaybe<BloodGlucoseDataInput>;
  lessonsData?: InputMaybe<LessonsDataInput>;
  mealData?: InputMaybe<MealDataInput>;
  medicationData?: InputMaybe<MedicationDataInput>;
  moodData?: InputMaybe<MoodDataInput>;
  stepsData?: InputMaybe<StepsDataInput>;
  waterData?: InputMaybe<WaterDataInput>;
  weightData?: InputMaybe<WeightDataInput>;
};

export type MeasurementDataList = {
  __typename?: 'MeasurementDataList';
  measurements: Array<MeasurementDataOneOf>;
};

export type MeasurementDataOneOf = {
  __typename?: 'MeasurementDataOneOf';
  bloodGlucoseData?: Maybe<BloodGlucoseData>;
  lessonsData?: Maybe<LessonsData>;
  mealData?: Maybe<MealData>;
  medicationData?: Maybe<MedicationData>;
  moodData?: Maybe<MoodData>;
  stepsData?: Maybe<StepsData>;
  waterData?: Maybe<WaterData>;
  weightData?: Maybe<WeightData>;
};

export enum MeasurementSnapshotStyle {
  Default = 'DEFAULT',
  Prominent = 'PROMINENT'
}

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum MeasurementType {
  Absi = 'ABSI',
  AfternoonSnack = 'AFTERNOON_SNACK',
  Age = 'AGE',
  ApolipoproteinB = 'APOLIPOPROTEIN_B',
  BloodGlucose = 'BLOOD_GLUCOSE',
  BmiCalc = 'BMI_CALC',
  BpCvd = 'BP_CVD',
  BpDiastolic = 'BP_DIASTOLIC',
  BpHeartAttack = 'BP_HEART_ATTACK',
  BpRpp = 'BP_RPP',
  BpStroke = 'BP_STROKE',
  BpSystolic = 'BP_SYSTOLIC',
  BpTau = 'BP_TAU',
  Breakfast = 'BREAKFAST',
  BrBpm = 'BR_BPM',
  Cholesterol = 'CHOLESTEROL',
  CholesterolHdlRatio = 'CHOLESTEROL_HDL_RATIO',
  DbtRiskProb = 'DBT_RISK_PROB',
  DheaS = 'DHEA_S',
  Dinner = 'DINNER',
  Estradiol = 'ESTRADIOL',
  EveningSnack = 'EVENING_SNACK',
  FacialBodyAge = 'FACIAL_BODY_AGE',
  FacialBodyAgeIdx = 'FACIAL_BODY_AGE_IDX',
  FldRiskProb = 'FLD_RISK_PROB',
  Gender = 'GENDER',
  Hba1CRiskProb = 'HBA1C_RISK_PROB',
  Hdl = 'HDL',
  HdltcRiskProb = 'HDLTC_RISK_PROB',
  HealthScore = 'HEALTH_SCORE',
  Height = 'HEIGHT',
  HemoglobinA1C = 'HEMOGLOBIN_A1C',
  HptRiskProb = 'HPT_RISK_PROB',
  HrvSdnn = 'HRV_SDNN',
  HrBpm = 'HR_BPM',
  HsCrp = 'HS_CRP',
  IhbCount = 'IHB_COUNT',
  Ldl = 'LDL',
  LdlApobRatio = 'LDL_APOB_RATIO',
  Lessons = 'LESSONS',
  LipoproteinA = 'LIPOPROTEIN_A',
  Lunch = 'LUNCH',
  LuteinizingHormone = 'LUTEINIZING_HORMONE',
  Meal = 'MEAL',
  Medication = 'MEDICATION',
  MentalScore = 'MENTAL_SCORE',
  MfbgRiskProb = 'MFBG_RISK_PROB',
  Mood = 'MOOD',
  MorningSnack = 'MORNING_SNACK',
  Msi = 'MSI',
  OverallMetabolicRiskProb = 'OVERALL_METABOLIC_RISK_PROB',
  PhysicalScore = 'PHYSICAL_SCORE',
  PhysioScore = 'PHYSIO_SCORE',
  RisksScore = 'RISKS_SCORE',
  Sgpt = 'SGPT',
  Snr = 'SNR',
  Steps = 'STEPS',
  Testosterone = 'TESTOSTERONE',
  TgRiskProb = 'TG_RISK_PROB',
  Triglycerides = 'TRIGLYCERIDES',
  TriglyceridesHdlRatio = 'TRIGLYCERIDES_HDL_RATIO',
  Unknown = 'UNKNOWN',
  VitalScore = 'VITAL_SCORE',
  VitaminB12 = 'VITAMIN_B12',
  VitaminD_25Hydroxy = 'VITAMIN_D_25_HYDROXY',
  WaistCircum = 'WAIST_CIRCUM',
  WaistToHeight = 'WAIST_TO_HEIGHT',
  Water = 'WATER',
  Weight = 'WEIGHT'
}

export type MeasurementsData = {
  __typename?: 'MeasurementsData';
  measurements: Array<MeasurementData>;
};

export type MeasurementsDataInput = {
  measurements: Array<MeasurementDataInput>;
};

/** A call-to-action button on a med homepage card. */
export type MedHomepageCardCallToAction = {
  __typename?: 'MedHomepageCardCallToAction';
  /** Button text (e.g. "Complete intake", "View prescriptions"). */
  text?: Maybe<Scalars['String']['output']>;
  /** Deep link URL invoked when the user taps the button. */
  url: Scalars['String']['output'];
};

/** Server-driven UI card for med status on the Today tab. */
export type MedHomepageCardPayload = {
  __typename?: 'MedHomepageCardPayload';
  /** Card body / description text. */
  body?: Maybe<Scalars['String']['output']>;
  /** Calls to action displayed on the card. */
  ctas: Array<MedHomepageCardCallToAction>;
  /** Icon URL displayed alongside the card content. */
  iconUrl: Scalars['String']['output'];
  /** Visual treatment controlling prominence and color scheme. */
  style?: Maybe<MedHomepageCardStyle>;
  /** Optional subtitle text (e.g. "Under 10 mins"). */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Card title text. */
  title: Scalars['String']['output'];
};

/** Visual treatment for med homepage cards. */
export enum MedHomepageCardStyle {
  /** Compact card style for secondary information (e.g. prescription status). */
  Minimal = 'MINIMAL',
  /** Compact card with inverted color scheme. */
  MinimalInverted = 'MINIMAL_INVERTED',
  /** High-visibility card style for primary actions (e.g. intake reminders). */
  Prominent = 'PROMINENT'
}

/** Med refill eligibility data with per-window engagement breakdown */
export type MedRefillEligibility = {
  __typename?: 'MedRefillEligibility';
  /** The eligibility windows, most recent first */
  windows: Array<MedRefillEligibilityWindow>;
};

/** A single day's engagement status for med refill eligibility */
export type MedRefillEligibilityDay = {
  __typename?: 'MedRefillEligibilityDay';
  /** Whether the user read at least one article on this day */
  articleRead: Scalars['Boolean']['output'];
  /** The calendar date */
  date: Scalars['LocalDate']['output'];
  /** Whether the day counts as engaged (all three actions completed) */
  engaged: Scalars['Boolean']['output'];
  /** Whether the user logged at least one meal on this day */
  mealLogged: Scalars['Boolean']['output'];
  /** Whether the user logged their weight on this day */
  weightLogged: Scalars['Boolean']['output'];
};

/** A single FAQ entry for med refill eligibility */
export type MedRefillEligibilityFaqEntry = {
  __typename?: 'MedRefillEligibilityFaqEntry';
  /** The FAQ answer */
  answer: Scalars['String']['output'];
  /** The FAQ question */
  question: Scalars['String']['output'];
};

/** Response wrapper for the med refill eligibility FAQ query */
export type MedRefillEligibilityFaqResponse = {
  __typename?: 'MedRefillEligibilityFaqResponse';
  /** The FAQ entries */
  entries: Array<MedRefillEligibilityFaqEntry>;
};

/** State of the med refill eligibility feature for a user */
export type MedRefillEligibilityFeatureState = {
  __typename?: 'MedRefillEligibilityFeatureState';
  /** Whether the feature is enabled for this user */
  isEnabled: Scalars['Boolean']['output'];
  /** Per-partner step protocol thresholds for this user. Null if not applicable for the user. */
  stepProtocolConfig?: Maybe<StepProtocolConfig>;
  /**
   * The user type bucket for refill eligibility (MED, PBM, or NMPBA).
   * Null when the feature is not enabled for the user.
   */
  userType?: Maybe<MedRefillEligibilityUserType>;
};

/** User type bucket for the med refill eligibility feature */
export enum MedRefillEligibilityUserType {
  /** Noom Med (telehealth) member */
  Med = 'MED',
  /** State Farm Noom Med Powered by Accolade member */
  Nmpba = 'NMPBA',
  /** Partner / PBM-integrated member */
  Pbm = 'PBM'
}

/** A rolling window of days for med refill eligibility tracking */
export type MedRefillEligibilityWindow = {
  __typename?: 'MedRefillEligibilityWindow';
  /** All days within the window, most recent first */
  days: Array<MedRefillEligibilityDay>;
  /** The last day of the window (inclusive) */
  endDate: Scalars['LocalDate']['output'];
  /** Number of engaged days in this window */
  engagedDays: Scalars['Int']['output'];
  /** The first day of the window (inclusive) */
  startDate: Scalars['LocalDate']['output'];
};

/**  Medication that is available to the user for logging. */
export type Medication = {
  __typename?: 'Medication';
  /** Medication concentration info, used for deriving syringe units */
  concentrationInfo?: Maybe<MedicationConcentration>;
  /** Medication dose options */
  doseOptions: Array<MedicationDoseOption>;
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
  /** The list of potential side-effects for this medication */
  potentialSideEffects: Array<MedicationSideEffect>;
};

/**  Concentration of an available medication. */
export type MedicationConcentration = {
  __typename?: 'MedicationConcentration';
  /** The units of the medication's concentration ratio numerator */
  activeIngredientUnit: DoseUnits;
  /** The ratio of medication dose to concentration volume */
  concentrationRatio: Scalars['Float']['output'];
  /** The units of the medication's concentration ratio denominator */
  concentrationUnits: DoseUnits;
};

export type MedicationData = {
  __typename?: 'MedicationData';
  dose: Scalars['Float']['output'];
  internalDrugId?: Maybe<Scalars['ID']['output']>;
  measurementCivilDateTime: Scalars['LocalDateTime']['output'];
  medicationExternalId: Scalars['String']['output'];
  sideEffects: Array<Scalars['ID']['output']>;
  unit: DoseUnits;
};

export type MedicationDataInput = {
  dose: Scalars['Float']['input'];
  internalDrugId?: InputMaybe<Scalars['ID']['input']>;
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  medicationExternalId: Scalars['String']['input'];
  sideEffects: Array<Scalars['ID']['input']>;
  smartDose?: InputMaybe<Scalars['Float']['input']>;
  unit: DoseUnits;
};

/**  Dose option - each unit could have multiple strengths. */
export type MedicationDoseOption = {
  __typename?: 'MedicationDoseOption';
  /** Available dose strengths */
  doses: Array<Scalars['Float']['output']>;
  /** Dose option unit */
  unit: DoseUnits;
};

export type MedicationGoalMetadata = {
  __typename?: 'MedicationGoalMetadata';
  externalMedicationId?: Maybe<Scalars['String']['output']>;
  /** Days of the week when the medication identified by externalMedicationId should be taken */
  scheduledDaysOfWeek?: Maybe<Array<DayOfWeek>>;
};

/**  Information about a medication identified by external Id. */
export type MedicationInfo = {
  __typename?: 'MedicationInfo';
  /** Internal ID of the medication */
  internalDrugId?: Maybe<Scalars['ID']['output']>;
  /** Whether the medication represents a GLP-1 agonist classification */
  isGlp1?: Maybe<Scalars['Boolean']['output']>;
  /** Color HEX code (#RRGGBB) for the medication background in the UI */
  medicationBackgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** External id of the medication */
  medicationExternalId: Scalars['String']['output'];
  /** URL of the image representing the medication */
  medicationImageUrl: Scalars['String']['output'];
  /** URL of the large image representing the medication */
  medicationLargeImageUrl?: Maybe<Scalars['String']['output']>;
  /** Human readable medication name */
  medicationName: Scalars['String']['output'];
  /** Extra user-facing medication information (like concentration) */
  medicationSubtitle?: Maybe<Scalars['String']['output']>;
};

/**  List of medications available to the user for logging. */
export type MedicationList = {
  __typename?: 'MedicationList';
  /** List of available medications */
  medications: Array<Medication>;
};

export type MedicationPayload = {
  __typename?: 'MedicationPayload';
  medicationName: Scalars['String']['output'];
};

/** Dosage quantity and unit (e.g. 8 units, 500 mg). */
export type MedicationQuantity = {
  __typename?: 'MedicationQuantity';
  /** Dose amount (e.g. 8.0, 500.0). */
  amount: Scalars['Float']['output'];
  /** Dose unit for the medication quantity. */
  unit: DoseUnits;
};

/** Dosing schedule cadence and frequency (e.g. weekly, 3x a week). */
export type MedicationSchedule = {
  __typename?: 'MedicationSchedule';
  /** Schedule cadence — DAY or WEEK. */
  cadence: ScheduleCadence;
  /** How many times per cadence period (e.g. 1 for 'weekly', 3 for '3x a week'). */
  frequency: Scalars['Int']['output'];
};

/**  A model wrapping a potential side-effect with ID and display name. */
export type MedicationSideEffect = {
  __typename?: 'MedicationSideEffect';
  /** The string to be used in UI-related features when showing this side-effect */
  displayName: Scalars['String']['output'];
  /** The id of the side-effect */
  id: Scalars['ID']['output'];
};

export type MedicationSideEffectInput = {
  /** The user's indication of whether their side effects were manageable, if any. */
  manageableSideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The list of side effects experienced since the user's last dose.
   * Can be empty if `None`, or the list of [MedicationSideEffect.id] that the
   * user selected at check-in.
   */
  medicationSideEffectIds?: Array<Scalars['ID']['input']>;
};

/** Payload added to Medication Tracker Assignments */
export type MedicationTrackerPayload = {
  __typename?: 'MedicationTrackerPayload';
  /** Status that drives UI state of the task card */
  doseStatus: MedicationTrackerStatus;
  /** The date on or after which we can reuse the last logged weight */
  earliestAcceptedWeightDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Whether the user has ever logged this type of medication before */
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this task should be displayed prominently -- such as with a
   * Hero-style card layout, or by moving into a more prominent position.
   * Recommended client-side default: isProminent = isOnboarded == false
   */
  isProminent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use title and subTitle */
  lastScheduledDoseDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated Use title and subTitle */
  lastTakenDoseDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated Use title and subTitle */
  lastTakenDoseStrength?: Maybe<Scalars['Float']['output']>;
  /**
   *  DoseUnits comes from measurements/medication.graphqls
   * @deprecated Use title and subTitle
   */
  lastTakenDoseUnit?: Maybe<DoseUnits>;
  /** Whether to present the SmartDose flow on this medication */
  smartDoseFlowEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Subtitle of the task card */
  subTitle: Scalars['String']['output'];
  /** Title of the task card */
  title: Scalars['String']['output'];
};

export enum MedicationTrackerStatus {
  LastDoseMissed = 'LAST_DOSE_MISSED',
  LastDoseTaken = 'LAST_DOSE_TAKEN',
  /** @deprecated Abandoned */
  NextDoseUpcoming = 'NEXT_DOSE_UPCOMING'
}

/** Payload for a Member Trust & Safety escalation ticket. */
export type MemberTrustAndSafetyEscalationInput = {
  /** Optional attachments such as screenshots */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Case category to help Trust & Safety triage appropriately */
  caseCategory: Scalars['String']['input'];
  /** Coach access code that uniquely identifies the coach */
  coachAccessCode: Scalars['String']['input'];
  /** Name of the coach raising the escalation */
  coachName: Scalars['String']['input'];
  /** Dashboard type that the coach is working in */
  dashboardType: Scalars['String']['input'];
  /** Detailed description supplied by the coach */
  description: Scalars['String']['input'];
  /** Indicates if this is a life threatening situation */
  lifeThreateningStatus: Scalars['String']['input'];
  /** Manager email to keep in the loop */
  managerEmail: Scalars['String']['input'];
  /** Member message that prompted the escalation */
  memberMessage: Scalars['String']['input'];
  /** Optional link to a Manatee or Circles transcript */
  transcriptLink: Scalars['String']['input'];
  /** User access code for the affected member */
  userAccessCode: Scalars['String']['input'];
};

/**
 * Container for the member journey timeline.
 * Events are sorted by occurredAt ascending (oldest first).
 */
export type MembersJourney = {
  __typename?: 'MembersJourney';
  events: Array<MembersJourneyEvent>;
};

/** B2B enrollment into a partner program. */
export type MembersJourneyB2bEnrollmentEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2bEnrollmentEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  partnerName: Scalars['String']['output'];
  programName: Scalars['String']['output'];
  segmentName: Scalars['String']['output'];
};

/** B2B program switch or retriage. */
export type MembersJourneyB2bProgramSwitchEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2bProgramSwitchEvent';
  displayTier: MembersJourneyDisplayTier;
  fromProgramName: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
  partnerName: Scalars['String']['output'];
  segmentName: Scalars['String']['output'];
  toProgramName: Scalars['String']['output'];
};

/** B2B unenrollment from a partner program. */
export type MembersJourneyB2bUnenrollmentEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2bUnenrollmentEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  partnerName: Scalars['String']['output'];
  programName: Scalars['String']['output'];
  segmentName: Scalars['String']['output'];
};

/** B2C plan or product switch. */
export type MembersJourneyB2cPlanSwitchEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cPlanSwitchEvent';
  displayTier: MembersJourneyDisplayTier;
  fromProductName: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
  toProductName: Scalars['String']['output'];
};

/** B2C refund granted. */
export type MembersJourneyB2cRefundGrantedEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cRefundGrantedEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  productName: Scalars['String']['output'];
  refundAmount: Money;
};

/** B2C auto-renew disabled or re-enabled. */
export type MembersJourneyB2cSubscriptionAutoRenewStatusEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cSubscriptionAutoRenewStatusEvent';
  autoRenewEnabled: Scalars['Boolean']['output'];
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  productName: Scalars['String']['output'];
};

/** B2C subscription ended. */
export type MembersJourneyB2cSubscriptionEndEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cSubscriptionEndEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  productName: Scalars['String']['output'];
};

/** A successful B2C subscription renewal. */
export type MembersJourneyB2cSubscriptionRenewalEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cSubscriptionRenewalEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  productName: Scalars['String']['output'];
};

/** B2C subscription started (paid or start of billed period). */
export type MembersJourneyB2cSubscriptionStartEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cSubscriptionStartEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  productName: Scalars['String']['output'];
};

/** B2C trial converted to a paid subscription. */
export type MembersJourneyB2cSubscriptionTrialConversionEvent = MembersJourneyEvent & {
  __typename?: 'MembersJourneyB2cSubscriptionTrialConversionEvent';
  displayTier: MembersJourneyDisplayTier;
  occurredAt: Scalars['DateTime']['output'];
  productName: Scalars['String']['output'];
};

/** Visual emphasis for timeline rendering (green / yellow / red). */
export enum MembersJourneyDisplayTier {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** Shared fields for all journey events. New event types should implement this interface. */
export type MembersJourneyEvent = {
  /** Suggested UI tier for the timeline row. */
  displayTier: MembersJourneyDisplayTier;
  /** When the event occurred. */
  occurredAt: Scalars['DateTime']['output'];
};

/** Experiment information */
export type MeristemExperimentInfo = {
  /** The context for this experiment */
  context?: InputMaybe<Scalars['String']['input']>;
  /** The experiment name */
  experimentName?: InputMaybe<Scalars['String']['input']>;
  /** The SHA the user is accessing for this context */
  sha?: InputMaybe<Scalars['String']['input']>;
  /** The name of the arm the user is in */
  variationName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a micro challenge definition/template.
 * This is the base challenge configuration that users can start instances of.
 */
export type MicroChallenge = {
  __typename?: 'MicroChallenge';
  /**
   * The actions available for the user to take for this challenge.
   * @deprecated Use userContext.availableActions instead
   */
  availableActions?: Maybe<MicroChallengeActions>;
  /**
   * Optional benefit text describing what the user gains from completing this challenge.
   * Null when no benefit is defined for this template.
   */
  benefit?: Maybe<Scalars['String']['output']>;
  /** IDs of the categories for this challenge; used for filtering */
  categories: Array<Scalars['String']['output']>;
  /**
   * Discriminator describing what kind of challenge this is.
   * Clients should switch on this value to render the challenge differently
   * (e.g. ONE_TIME challenges have no daily progress and never expire, so the
   * `targetProgress`/`durationDays` fields are not meaningful).
   *
   * Null is treated as TIME_BOUND for backwards compatibility.
   */
  challengeType?: Maybe<MicroChallengeType>;
  /**
   * The rewards user would receive for finishing this challenge
   * @deprecated Use userContext.completionRewards instead
   */
  completionRewards?: Maybe<RewardsMoney>;
  /** Description of what the challenge entails */
  description: Scalars['String']['output'];
  /**
   * Duration of the challenge in days
   * Derived from completion_condition.duration_days
   */
  durationDays: Scalars['Int']['output'];
  /** URL to the hero image for this challenge (used for high-emphasis display) */
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  /** URL to the challenge image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Long description providing detailed information about the challenge. */
  longDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Ordered metadata sections for the challenge details screen
   * (e.g. "Helpful Tips", "How it Works").
   * Empty when the template has no metadata.
   */
  metadataSections: Array<MicroChallengeMetadataSection>;
  /** Unique identifier for the micro challenge definition */
  microChallengeId: Scalars['String']['output'];
  /** Display name of the micro challenge */
  name: Scalars['String']['output'];
  /**
   * The active recipe for this challenge template, containing the ordered steps.
   * Null when the template has no active recipe.
   */
  recipe?: Maybe<MicroChallengeRecipe>;
  /**
   * Recommendation context pre-filled by the backend for attribution.
   * Null when this challenge has no active recommendation.
   * Client adds positionViewed, eventLocalDatetime, and origin before
   * sending back via startMicroChallenge.
   * @deprecated Use userContext.recommendationContext instead
   */
  recommendationContext?: Maybe<RecommendationContext>;
  /**
   * Target progress needed for completion (e.g., number of required success days)
   * Derived from completion_condition.daily_threshold.required_success_days
   */
  targetProgress: Scalars['Int']['output'];
  /**
   * Per-user fields for this challenge template (actions, rewards, instance state).
   * Always resolved for the requesting user.
   * Read `latestState` for the current state of the challenge (Most recent UserMicroChallenge);
   * it is null when the user has not started this challenge.
   */
  userContext: MicroChallengeUserContext;
};

/** Reasons why an action cannot be performed. */
export enum MicroChallengeActionDisabledReason {
  /** Indicates that the user has reached or exceeded the limit of active challenges */
  MaxChallengesReached = 'MAX_CHALLENGES_REACHED'
}

/** Provides details about the action for a micro challenge. */
export type MicroChallengeActionInfo = {
  __typename?: 'MicroChallengeActionInfo';
  /** The reason why the action is disabled, if applicable */
  disabledReason?: Maybe<MicroChallengeActionDisabledReason>;
  /** Whether the action is currently enabled */
  isEnabled: Scalars['Boolean']['output'];
};

/** Represents the actions a user can take for a micro challenge. */
export type MicroChallengeActions = {
  __typename?: 'MicroChallengeActions';
  /** Show 'End' button to stop the challenge */
  cancel?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Edit' button to modify challenge configuration */
  edit?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Did it' button to track progress */
  record?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Retry' button for recently ended challenge */
  retry?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Start' button */
  start?: Maybe<MicroChallengeActionInfo>;
};

/** Category of a micro challenge. Used to filter challenges in library */
export type MicroChallengeCategory = {
  __typename?: 'MicroChallengeCategory';
  /**
   * Habit stacks in this category (V1). V2 library clients should use `items`
   * instead, which returns stacks and challenges in display order with pagination.
   */
  habitStacks?: Maybe<Array<HabitStack>>;
  /** URL for the category hero image */
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the category */
  id: Scalars['String']['output'];
  /** URL for the category icon */
  imageUrl: Scalars['String']['output'];
  /**
   * First page of challenges and habit stacks for this category. Provided via DataLoader.
   * To load subsequent pages, call `categoryItems(categoryId: <this id>, cursorPagination: { after: pageInfo.nextPageCursor, ... })`.
   */
  items?: Maybe<MicroChallengeCategoryItemPage>;
  /** Display name of the category */
  name: Scalars['String']['output'];
};

/**
 * Exactly one concrete challenge shape per value (intended to align with backend
 * category-item protos). V2 category browsing should use `MicroChallengeCategory.items`.
 */
export type MicroChallengeCategoryItem = HabitStack | MicroChallenge;

/**
 * A paginated list of micro challenge variants (MicroChallenge or HabitStack).
 * Used for scrollable category contents (e.g. `MicroChallengeCategory.items`,
 * `categoryItems`). Recommendations use a non-paginated list instead.
 */
export type MicroChallengeCategoryItemPage = Pageable & {
  __typename?: 'MicroChallengeCategoryItemPage';
  /**
   * The challenge variants on the current page.
   * Each item is either a MicroChallenge or a HabitStack.
   */
  items: Array<MicroChallengeCategoryItem>;
  /**
   * Cursor-based pagination info. Always present; use `pageInfo.nextPageCursor` to
   * detect the last page — it is null when no further pages exist.
   */
  pageInfo?: Maybe<CursorPageInfo>;
  /**
   * Total number of variants across all pages, regardless of the current page size.
   * Null when the total count is not available.
   */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Container for the user's micro challenges library entries */
export type MicroChallengeLibrary = {
  __typename?: 'MicroChallengeLibrary';
  /** List of categories to display */
  categories?: Maybe<Array<Maybe<MicroChallengeCategory>>>;
  /** List of micro challenge definitions available in the library (may include locked items) */
  challenges: Array<MicroChallenge>;
  /**
   * Curated habit stacks available in the library.
   * Resolved independently from the library via the getMicroChallengeStacks endpoint.
   * Each stack contains an ordered list of enriched challenges.
   */
  habitStacks?: Maybe<Array<HabitStack>>;
  /**
   * User challenge instances (V1). V2 clients should use
   * `microChallengeLibraryV2.myChallenges` or the root `myChallenges` query instead,
   * which return `MicroChallenge` templates with `userContext.latestState`.
   */
  myChallenges?: Maybe<Array<Maybe<UserMicroChallenge>>>;
  /**
   * Ordered subset of recommended challenges from recommendation-api.
   * Null when recommendations were not requested or are unavailable.
   * Each item's recommendationContext is pre-filled by the backend.
   */
  recommendedChallenges?: Maybe<Array<MicroChallenge>>;
  /**
   * Usage information for the user's challenges (capacity tracking)
   * @deprecated Use `challenges.map { it.availableActions }`.
   */
  usage: Usage;
};

/** The v2 micro challenge library, providing paginated challenges and habit stacks */
export type MicroChallengeLibraryV2 = {
  __typename?: 'MicroChallengeLibraryV2';
  /** All categories and the first page of challenges/habit stacks mapped to them */
  categories: Array<MicroChallengeCategory>;
  /**
   * First page of challenge templates the user has engaged with (not user instances).
   * Unlike V1 `MicroChallengeLibrary.myChallenges`, items are `MicroChallenge` with
   * `userContext` populated; read `userContext.latestState` for enrollment status.
   *
   * `statuses` includes only templates whose `userContext.latestState.status`
   * matches one of the given values; templates with no `latestState` are excluded
   * when a filter is provided. When omitted, all engaged templates are returned
   * regardless of status.
   *
   * Returns the first page only. For subsequent pages, call the root `myChallenges`
   * query with the same `statuses` and `challengeTypes`. Pass
   * `cursorPagination.after` from `pageInfo.nextPageCursor`; use `sort: []`
   * (backend-default order) and repeat your chosen `first` value — the embedded
   * field does not expose these inputs.
   */
  myChallenges: MicroChallengePage;
};


/** The v2 micro challenge library, providing paginated challenges and habit stacks */
export type MicroChallengeLibraryV2MyChallengesArgs = {
  statuses?: InputMaybe<Array<MicroChallengeStatus>>;
};

/** A titled section of metadata displayed on the micro challenge details screen. */
export type MicroChallengeMetadataSection = {
  __typename?: 'MicroChallengeMetadataSection';
  /** Body text of the section */
  description: Scalars['String']['output'];
  /** Display order of the section relative to other sections */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  /** String readable slug used for identifying a section and for event tracking */
  id?: Maybe<Scalars['String']['output']>;
  /** Display title of the section (e.g. "Helpful Tips") */
  title: Scalars['String']['output'];
};

/**
 * Implementation of GUIDE onboarding step.
 * This step contains a list of screens to show.
 */
export type MicroChallengeOnboardingGuideStepInfo = MicroChallengeOnboardingStepInfo & {
  __typename?: 'MicroChallengeOnboardingGuideStepInfo';
  /** The list of screens associated with this onboarding step. */
  screens: Array<MicroChallengeOnboardingGuideStepScreen>;
  /** The type of the onboarding step (always GUIDE) */
  step: MicroChallengeOnboardingStep;
};

/** Enum representing screens in the Micro Challenges guide onboarding step. */
export enum MicroChallengeOnboardingGuideStepScreen {
  /** Make habits splash screen */
  MakeHabitsScreen = 'MAKE_HABITS_SCREEN',
  /** Recipe splash screen */
  RecipeScreen = 'RECIPE_SCREEN',
  /** Small rewards splash screen */
  SmallRewardsScreen = 'SMALL_REWARDS_SCREEN'
}

/**
 * Implementation of INTRO_SPLASH_SCREEN onboarding step.
 * This is a legacy onboarding flow.
 */
export type MicroChallengeOnboardingIntroStepInfo = MicroChallengeOnboardingStepInfo & {
  __typename?: 'MicroChallengeOnboardingIntroStepInfo';
  /** The type of the onboarding step (always INTRO_SPLASH_SCREEN) */
  step: MicroChallengeOnboardingStep;
};

/** Enum representing steps in the Micro Challenges onboarding process the user can iterate over */
export enum MicroChallengeOnboardingStep {
  /** Onboarding guide step, containing a list of screens to show: MAKE_HABITS_SCREEN, SMALL_REWARDS_SCREEN, RECIPE_SCREEN. */
  Guide = 'GUIDE',
  /** Initial legacy splash screen for onboarding. */
  IntroSplashScreen = 'INTRO_SPLASH_SCREEN'
}

/** Interface representing an onboarding step, containing its type. */
export type MicroChallengeOnboardingStepInfo = {
  /** The type of the onboarding step */
  step: MicroChallengeOnboardingStep;
};

/**
 * A paginated list of MicroChallenge templates (excludes HabitStack variants).
 * Used for user-engaged challenges (`myChallenges`), where each item includes
 * `userContext`. current status is read from `userContext.latestState`.
 */
export type MicroChallengePage = Pageable & {
  __typename?: 'MicroChallengePage';
  /** The micro challenges on the current page. */
  items: Array<MicroChallenge>;
  /**
   * Cursor-based pagination info. Always present; use `pageInfo.nextPageCursor` to
   * detect the last page — it is null when no further pages exist.
   */
  pageInfo?: Maybe<CursorPageInfo>;
  /**
   * Total number of challenges across all pages, regardless of the current page size.
   * Null when the total count is not available.
   */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of challenges across all pages, grouped by status. */
  totalCountByStatus: Array<MicroChallengeStatusCount>;
};

/**
 * The active recipe for a micro challenge template, containing the ordered steps
 * and the available options that can be used to customise it.
 */
export type MicroChallengeRecipe = {
  __typename?: 'MicroChallengeRecipe';
  /**
   * Available recipe options for this template, ordered by display order.
   * These are the pre-defined building blocks a user can choose from when
   * customising their recipe.
   */
  availableOptions: Array<MicroChallengeRecipeOption>;
  /** Ordered steps that define this recipe */
  steps: Array<MicroChallengeRecipeStep>;
};

/** A pre-defined recipe option from the global catalogue, available for a template. */
export type MicroChallengeRecipeOption = {
  __typename?: 'MicroChallengeRecipeOption';
  /**
   * When partType is MICROHABIT: available quantity/duration options for this option.
   * Empty for non-MICROHABIT options or options with no quantity choices.
   */
  availableQuantities: Array<MicroChallengeRecipeQuantity>;
  /** Display ordering for this option within the template */
  displayOrder: Scalars['Int']['output'];
  /** Unique identifier for this recipe option */
  id: Scalars['String']['output'];
  /** The part of the habit loop this option belongs to (e.g. CUE, MICROHABIT, REWARD, TRANSITION) */
  partType: MicroChallengeRecipePartType;
  /** The display text for this option */
  text: Scalars['String']['output'];
};

/** The part of a micro challenge recipe that a step belongs to. */
export enum MicroChallengeRecipePartType {
  Cue = 'CUE',
  Microhabit = 'MICROHABIT',
  Reward = 'REWARD'
}

/** A quantity or duration option for a MICROHABIT recipe step. */
export type MicroChallengeRecipeQuantity = {
  __typename?: 'MicroChallengeRecipeQuantity';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * A quantity or duration option submitted by the client for a MICROHABIT step.
 * Order is not required for a selection.
 */
export type MicroChallengeRecipeQuantityInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

/** A single step within a micro challenge recipe. */
export type MicroChallengeRecipeStep = {
  __typename?: 'MicroChallengeRecipeStep';
  /** Unique identifier for this recipe step */
  id: Scalars['String']['output'];
  /** The type of this recipe step (e.g. CUE, MICROHABIT, REWARD, TRANSITION) */
  partType: MicroChallengeRecipePartType;
  /**
   * Structured payload for this recipe step.
   * Null only when the step has no configuration data.
   */
  payload?: Maybe<MicroChallengeRecipeStepPayload>;
  /** Position of this step in the recipe ordering */
  position: Scalars['Int']['output'];
};

/** A single recipe step submitted when starting a micro challenge. */
export type MicroChallengeRecipeStepInput = {
  /** The type of this recipe step */
  partType: MicroChallengeRecipePartType;
  /** Step configuration data (includes selectedQuantityId for MICROHABIT steps) */
  payload?: InputMaybe<MicroChallengeRecipeStepPayloadInput>;
  /** Position of this step in the recipe ordering */
  position: Scalars['Int']['input'];
};

/** The configuration data for a recipe step, deserialized from the backend JSONB payload. */
export type MicroChallengeRecipeStepPayload = {
  __typename?: 'MicroChallengeRecipeStepPayload';
  /**
   * ID of the recipe option from the global catalogue, if this step was
   * built from a pre-defined option. Null for free-text steps.
   */
  optionId?: Maybe<Scalars['String']['output']>;
  /**
   * When partType is MICROHABIT: the quantity option the user selected.
   * Null on template steps (no selection yet) and on non-MICROHABIT steps.
   */
  selectedQuantity?: Maybe<MicroChallengeRecipeQuantity>;
  /** The display text for this recipe step */
  text: Scalars['String']['output'];
};

/** Structured payload for a recipe step. */
export type MicroChallengeRecipeStepPayloadInput = {
  /** Optional reference to a recipe option */
  optionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * When partType is MICROHABIT: the quantity option the user selected.
   * Null when the step has no quantity choice or the user has not yet selected one.
   */
  selectedQuantity?: InputMaybe<MicroChallengeRecipeQuantityInput>;
  /** Display text for this step */
  text: Scalars['String']['input'];
};

/**
 * Context-based input for requesting micro challenge recommendations.
 * Uses @oneOf to support different recommendation surfaces.
 */
export type MicroChallengeRecommendationContextInput = {
  /** Context for the completion interstitial recommendation surface */
  completionInterstitial?: InputMaybe<CompletionInterstitialContextInput>;
};

/**
 * A recommendation surface item — either an individual challenge or a habit stack.
 * Kept separate from MicroChallengeCategoryItem so recommendation-specific variants
 * can be added independently.
 */
export type MicroChallengeRecommendationItem = HabitStack | MicroChallenge;

/**
 * Union of context-specific recommendation responses.
 * Extensible for future recommendation surfaces.
 */
export type MicroChallengeRecommendationResponseUnion = CompletionInterstitialResponse;

/** Response wrapper for V2 micro challenge recommendations. */
export type MicroChallengeRecommendationV2Response = {
  __typename?: 'MicroChallengeRecommendationV2Response';
  /** The recommended challenges (individual challenges or habit stacks). */
  response: Array<MicroChallengeRecommendationItem>;
};

/** Response for micro challenge recommendations */
export type MicroChallengeRecommendationsResponse = {
  __typename?: 'MicroChallengeRecommendationsResponse';
  /** Context-specific response containing the recommended challenges */
  response: MicroChallengeRecommendationResponseUnion;
};

/** The user's reflection rating for a completed micro challenge. */
export enum MicroChallengeReflectionRating {
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP'
}

/** Status of a user's micro challenge enrollment */
export enum MicroChallengeStatus {
  /** Challenge is active and user can make progress */
  Active = 'ACTIVE',
  /** Challenge was cancelled by the user */
  Cancelled = 'CANCELLED',
  /** Challenge was successfully completed */
  Completed = 'COMPLETED',
  /** Challenge failed (expired or insufficient progress) */
  Failed = 'FAILED'
}

/** The number of micro challenges matching a specific status. */
export type MicroChallengeStatusCount = {
  __typename?: 'MicroChallengeStatusCount';
  /** The status these challenges share. */
  status: MicroChallengeStatus;
  /** The number of challenges with this status. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Describes what kind of micro challenge this is. Used by clients to render the
 * challenge differently (e.g. multi-day progress UI vs. one-shot action UI).
 */
export enum MicroChallengeType {
  /**
   * A challenge that is completed by a single explicit user action. There is
   * no daily progress tracking and no fixed end date — the challenge stays
   * active until the user completes or cancels it. Seeds are awarded on
   * completion.
   */
  OneTime = 'ONE_TIME',
  /**
   * A time-bounded challenge that runs for a fixed number of days and is
   * completed by hitting a per-day metric threshold on a required number of
   * those days. Uses `targetProgress` and `durationDays`, and the user records
   * progress over time.
   */
  TimeBound = 'TIME_BOUND'
}

/**
 * Represents the user's current state for the micro challenge, including available actions,
 * rewards that can be earned, and the current status.
 */
export type MicroChallengeUserContext = {
  __typename?: 'MicroChallengeUserContext';
  /** The actions available for the user to take for this challenge. */
  availableActions?: Maybe<MicroChallengeActions>;
  /** The rewards user would receive for finishing this challenge */
  completionRewards?: Maybe<RewardsMoney>;
  /**
   * Latest state for the users micro challenge. Null if the user
   * has not interacted with the micro challenge.
   */
  latestState?: Maybe<UserMicroChallenge>;
  /**
   * Recommendation context pre-filled by the backend for attribution.
   * Null when this challenge has no active recommendation.
   * Client adds positionViewed, eventLocalDatetime, and origin before
   * sending back via startMicroChallenge.
   */
  recommendationContext?: Maybe<RecommendationContext>;
};

/** Placeholder for Micro Challenges tracker payload details. */
export type MicroChallengesTrackerPayload = {
  __typename?: 'MicroChallengesTrackerPayload';
  /** Placeholder field to satisfy GraphQL type requirements. Will be replaced with actual fields. */
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents the state of a user's micro challenges for the tracker card.
 * This determines what UI the client should show (HIDDEN, INTRO, INACTIVE, or ACTIVE).
 */
export type MicroChallengesTrackerState = {
  __typename?: 'MicroChallengesTrackerState';
  /** The card variant that clients may use to modify the UI */
  cardVariant?: Maybe<CardVariant>;
  /**
   * List of the user's micro challenge instances.
   * Empty if state is INTRO or INACTIVE.
   */
  challenges: Array<UserMicroChallenge>;
  /**
   * Whether the user has seen the intro splash screen
   * Null if state is NOT INTRO.
   * @deprecated Use `shouldOnboard`.
   */
  hasSeenIntroSplashScreen?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The maximum number of challenges to show in the home screen card
   * If count > this number there will be a "show more" button added
   * Null should be treated as no maximum count. Never show "show more"
   */
  maxHomeScreenCollapsedChallengeCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Ongoing list of required onboarding steps that the client should show and record.
   * If this list is not empty, the client should show onboarding.
   */
  onboardingSteps?: Maybe<Array<MicroChallengeOnboardingStepInfo>>;
  /**
   * Whether the user should onboard
   * Null if state is NOT INTRO.
   * @deprecated Use `onboardingSteps`.
   */
  shouldOnboard?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The current status of the micro challenges tracker card.
   * HIDDEN - Don't show the card
   * INTRO - Show introduction/onboarding
   * INACTIVE - Show empty state with library entry point
   * ACTIVE - Show active challenges
   */
  state: MicroChallengesTrackerStatus;
  /**
   * Usage information for the user's challenges (capacity tracking)
   * @deprecated Use `challenges.map { it.availableActions }`.
   */
  usage: Usage;
};

/** Status of the micro challenges tracker card, determining what UI to show. */
export enum MicroChallengesTrackerStatus {
  Active = 'ACTIVE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Intro = 'INTRO'
}

/** Per-user module details for the Module Details screen. */
export type ModuleDetails = {
  __typename?: 'ModuleDetails';
  /** http(s) URL of the banner image */
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  /** True if module was left paused and can be resumed */
  canResume?: Maybe<Scalars['Boolean']['output']>;
  /** Categories this module belongs to (replaces the deprecated `category` enum) */
  categories: Array<ModuleDetailsCategory>;
  /** Course pack the module belongs to, if any */
  coursePack?: Maybe<CoursePack>;
  /** Long-form description of the module */
  description?: Maybe<Scalars['String']['output']>;
  /** Expected maximum days to complete */
  expectedMaxDaysToComplete?: Maybe<Scalars['Int']['output']>;
  /** Expected minimum days to complete */
  expectedMinDaysToComplete?: Maybe<Scalars['Int']['output']>;
  /** http(s) URL of the icon */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** True if this is the user's queued up-next module */
  isUpNext?: Maybe<Scalars['Boolean']['output']>;
  /** Completion ratio (0.0 to 1.0). Null when not enrolled. */
  moduleCompletion?: Maybe<Scalars['Float']['output']>;
  /** Date module was completed in the user's timezone. Null if not completed. */
  moduleCompletionDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Optional server-driven label for modules tied to a purchase (e.g. an OTC
   * course pack). Resolved server-side per user from Blueprint
   * course_pack_assignments (wording authored in Calico; curriculum-api does not
   * localize). Clients should render verbatim. Absent when not applicable.
   */
  purchaseLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Optional purchase label key for modules tied to a purchase. Resolved
   * server-side alongside purchaseLabel from the winning blueprint
   * entitlement_assignment. Clients forward this to CourseLibraryCourseTapped
   * when the user taps the module. Absent when not applicable.
   */
  purchaseLabelKey?: Maybe<Scalars['String']['output']>;
  /** True if swap-out should be confirmed first */
  requireSwapConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** True if the user can retake this module */
  showRetakeModuleButton?: Maybe<Scalars['Boolean']['output']>;
  /** True if the user can start this module */
  showStartModuleButton?: Maybe<Scalars['Boolean']['output']>;
  /** True if this is the active module and user can swap out of it */
  showSwapModuleButton?: Maybe<Scalars['Boolean']['output']>;
  /** Display title of the module */
  title?: Maybe<Scalars['String']['output']>;
  /** Curriculum features and trackers surfaced for this module */
  tools: Array<ProgramProgressTool>;
};

/** Matches `ModuleDetailsResponseProto.ModuleDetailsCategory`. */
export type ModuleDetailsCategory = {
  __typename?: 'ModuleDetailsCategory';
  /** Localized display name in the user's program locale */
  displayName: Scalars['String']['output'];
};

/**
 * Wrapper type for the module library response.
 * Returns user-specific module library data including recommendations,
 * categorized modules, and completion status.
 */
export type ModuleLibrary = {
  __typename?: 'ModuleLibrary';
  /** The currently active module for this user */
  activeModule?: Maybe<ModuleLibraryModule>;
  /**
   * Optional upsell creative for Module Library. Reuses the shared UpsellAdData
   * type so clients get the placement metadata (type, identifier, location)
   * alongside the content payload, matching the Offers upsell ad shape.
   */
  ad?: Maybe<UpsellAdData>;
  /** List of modules grouped by category */
  categories: Array<ModuleLibraryCategory>;
  /** List of course packs available to explore */
  coursePacks: Array<CoursePack>;
  /** The next module recommended for the user */
  recommendedModule?: Maybe<ModuleLibraryModule>;
  /** Flag indicating user should see module retake banner */
  showModuleRetakeBanner: Scalars['Boolean']['output'];
  /** Module queued for next enrollment */
  upNextModule?: Maybe<ModuleLibraryUpNextModule>;
};

/**
 * Module category containing grouped modules.
 * Matches ModuleLibraryResponseProto.ModuleLibraryCategory.
 */
export type ModuleLibraryCategory = {
  __typename?: 'ModuleLibraryCategory';
  /**
   * Category identifier for the modules. The exact shape depends on which
   * query produced this value:
   * - `moduleLibrary` (v1) returns the legacy `ModuleCategory` enum name,
   *   e.g. `NUTRITION_HEALTHY_EATING`.
   * - `moduleLibraryV3` returns the stable string slug sourced from the
   *   program blueprint, e.g. `nutrition_healthy_eating`.
   * In both cases the value is safe to use as a client-side key.
   */
  category: Scalars['String']['output'];
  /** List of completed modules in this category */
  completedModules: Array<ModuleLibraryModule>;
  /**
   * Localized display name for the category in the user's program locale.
   * Always populated — sourced server-side from the program blueprint for
   * `moduleLibraryV3`, and derived server-side from the legacy
   * `ModuleCategory` enum for `moduleLibrary`. Clients render verbatim.
   */
  displayName: Scalars['String']['output'];
  /** List of incomplete modules in this category */
  modules: Array<ModuleLibraryModule>;
};

/** Deep link to the module library */
export type ModuleLibraryDeepLink = {
  __typename?: 'ModuleLibraryDeepLink';
  /** Placeholder field to satisfy GraphQL type requirements - always returns true when this deep link type is used */
  isModuleLibrary: Scalars['Boolean']['output'];
};

/**
 * A module within the module library.
 * Matches ModuleLibraryResponseProto.ModuleLibraryModule.
 */
export type ModuleLibraryModule = {
  __typename?: 'ModuleLibraryModule';
  /** Number of articles in this module */
  articleCount?: Maybe<Scalars['Int']['output']>;
  /** Course pack associated with this module */
  coursePack?: Maybe<CoursePack>;
  /** Expected maximum days to complete this module */
  expectedMaxDaysToComplete: Scalars['Int']['output'];
  /** Expected minimum days to complete this module */
  expectedMinDaysToComplete: Scalars['Int']['output'];
  /** URL of the icon representing this module */
  iconUrl: Scalars['String']['output'];
  /** Module completion percentage (0.0 to 1.0) */
  moduleCompletion?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the module */
  moduleId: Scalars['ID']['output'];
  /**
   * Optional server-driven label for modules tied to a purchase (e.g. an OTC
   * course pack). Resolved server-side per user from Blueprint
   * course_pack_assignments (wording authored in Calico; curriculum-api does not
   * localize). Clients should render verbatim. Absent when not applicable.
   */
  purchaseLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Optional purchase label key for modules tied to a purchase. Resolved
   * server-side alongside purchaseLabel from the winning blueprint
   * entitlement_assignment. Clients forward this to CourseLibraryCourseTapped
   * when the user taps the module. Absent when not applicable.
   */
  purchaseLabelKey?: Maybe<Scalars['String']['output']>;
  /** Display title of the module */
  title: Scalars['String']['output'];
  /**
   * When present, the client should present this module in a locked state;
   * use this URL for the upsell/buyflow entry (e.g. aligns with ad CTA).
   */
  upsellUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Actor types that can set the up-next module.
 * Matches UpNextModuleProto.Actor.
 */
export enum ModuleLibraryUpNextActor {
  Coach = 'COACH',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

/**
 * Module queued for next enrollment.
 * Matches ModuleLibraryResponseProto.UpNextModule.
 */
export type ModuleLibraryUpNextModule = {
  __typename?: 'ModuleLibraryUpNextModule';
  /** Actor that set this module as next */
  actor?: Maybe<ModuleLibraryUpNextActor>;
  /** The module queued for next enrollment */
  module?: Maybe<ModuleLibraryModule>;
};

/**
 * Module Library upsell: title, image, and CTA from Offers Service when the
 * buyflow URL comes from the Module Library entry point.
 */
export type ModuleLibraryUpsellContent = {
  __typename?: 'ModuleLibraryUpsellContent';
  /** CTA button for the ad. */
  button: Button;
  /** URL of the image for the ad. */
  imageUrl: Scalars['String']['output'];
  /** URL opened when an upsell module is tapped. */
  moduleUpsellUrl?: Maybe<Scalars['String']['output']>;
  /** Title placed on the top of the ad. */
  title: Scalars['String']['output'];
  /** Program identifier for this upsell. */
  upsellProgramId: Scalars['String']['output'];
};

/**
 * Represents an amount of money with its currency type.
 * Modeled after MoneyProto in money.proto.
 */
export type Money = {
  __typename?: 'Money';
  /** The three-letter currency code defined in ISO 4217. */
  currencyCode: Scalars['String']['output'];
  /**
   * Number of nano (10^-9) units of the amount.
   * Defaults to 0 if null.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example:
   *   - $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   *   - $99.99 is represented as `units`=99 and `nanos`=990,000,000.
   *   - $5.00  is represented as `units`=5  and `nanos`=0.
   */
  nanos?: Maybe<Scalars['Int']['output']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units: Scalars['Int']['output'];
};

export type MoodData = {
  __typename?: 'MoodData';
  measurementCivilDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  moodLevel: Scalars['Int']['output'];
};

export type MoodDataInput = {
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  moodLevel: Scalars['Int']['input'];
};

export type MultiDayAssignment = {
  __typename?: 'MultiDayAssignment';
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptExternalCoachingTermsAndConditions: ExternalCoachingTermsAndConditionsInfo;
  acknowledgeCoachUserAnnouncement: CoachAnnouncementUserInteraction;
  /**
   * Add a simulated assessment report for a user. For LABS, publishes Ash
   * webhook events through the EDA event proxy. Currently supports
   * assessmentType = LABS only.
   */
  addAssessmentReport: AddAssessmentReportResponse;
  /** AI-powered meal identification from text or image, returning matched foods and portions */
  aiMealIdentification: AiMealIdentificationResponse;
  /**
   * Apply a flow diff overlay on a baseline (persisted flow uuid and/or inline baseline JSON).
   * Returns the merged full flow configuration, not the overlay alone.
   */
  applyNoomFlowDiff: NoomFlowWithDiffApplied;
  /**
   * Apply a workflow action to a curriculum object.
   * - `actionInput`: Input containing the action type, object ID and object type
   * Returns the updated editor actions details after applying the workflow action
   */
  applyWorkflowAction: CurriculumEditorActionsDetails;
  /** Archive a Noom Flow experiment by primary key (`uuid`). Server sets archival timestamps and validates transitions. */
  archiveNoomFlowExperiment: NoomFlowExperiment;
  /** Processes measurements by proxying the request to the measurement-api. */
  batchMeasurements: BatchMeasurementsData;
  /**
   * Updates a user's SmartDose table as needed, returns current SmartDose.
   * May be null if the user hasn't logged medications before.
   * In case of errors, clients should check if `errors[].extensions.code`
   * is one of the known [SmartDoseMutationErrorCodes], and handle accordingly.
   */
  calculateSmartDose?: Maybe<SmartDose>;
  /**
   * Request cancellation for a lab order through healthcare.
   * Returns true when healthcare accepts the cancellation request.
   */
  cancelLabOrder: Scalars['Boolean']['output'];
  /** Cancel an active micro challenge instance for the user */
  cancelMicroChallenge: CancelMicroChallengeResponse;
  /** Changes the status of a relation request (e.g. ACCEPTED or DECLINED). The caller must be the target user of the request. */
  changeRelationRequestStatus: ChangeRelationRequestStatusResponse;
  /**
   * Creates a new art gallery.
   * - `input`: Data for the new gallery
   */
  createArtGallery?: Maybe<ArtGallery>;
  /**
   * Creates a new art piece.
   * - `input`: Data for the new art piece
   */
  createArtPiece?: Maybe<ArtPiece>;
  /** Create a new asset registry entry. */
  createAssetRegistryEntry: AssetRegistryEntry;
  createCoachAnnouncement: CoachAnnouncement;
  /** Retrieves the Decagon signature token for a user identified by their access code */
  createDecagonSignatureToken: DecagonSignatureToken;
  /**
   * Creates a new fulfillment order in the external fulfillment service.
   * Maps to OrderV2ServiceProto.CreateOrder in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
   *
   * Errors:
   * - BAD_USER_INPUT: Unknown/inactive SKU, missing required fields, invalid address, or missing access code when not available from token.
   * - INTERNAL_ERROR: DB or EDA publish failure (order not created).
   *
   * Duplicate idempotency key: EF returns HTTP 409 with an EfCreateOrderResponse body (existing orderId).
   * gql-java treats this as success and returns EfCreateOrderResponse.
   */
  createEfOrder: EfCreateOrderResponse;
  /** Creates a Member Trust & Safety escalation ticket */
  createMemberTrustAndSafetyEscalation: CreateCustomerSupportTicketResponse;
  /** Create a new noom flow. */
  createNoomFlow: NoomFlow;
  /** Create a new audit trail entry. */
  createNoomFlowAuditTrail: NoomFlowAuditTrail;
  /**
   * Compute a patch-style flow diff by comparing a full alternate flow definition to a baseline
   * (persisted flow uuid and/or inline baseline JSON). Returns the overlay JSON suitable for experiment arms or rebaselining flows.
   */
  createNoomFlowDiff: NoomFlowDiff;
  /** Create a new Noom Flow experiment. Server assigns uuid and audit timestamps. */
  createNoomFlowExperiment: NoomFlowExperiment;
  /** Create a named Noom Flow list. Server assigns uuid and audit timestamps. */
  createNoomFlowList: NoomFlowList;
  /** Add an item to a Noom Flow list. */
  createNoomFlowListItem: NoomFlowListItem;
  /** Create a new Noom Flow page configuration. Server assigns uuid and audit timestamps. */
  createNoomFlowPage: NoomFlowPage;
  /** Create a new noom flow persona. */
  createNoomFlowPersona: NoomFlowPersona;
  /** Create a new Noom Flow rule. Server assigns uuid and audit timestamps. */
  createNoomFlowRule: NoomFlowRule;
  /** Create a new noom flow text translation. */
  createNoomFlowTextTranslation: NoomFlowTextTranslation;
  /** Create a new noom flow text translation key. */
  createNoomFlowTextTranslationKey: NoomFlowTextTranslationKey;
  /** Create a relation request, or return the existing relation. This mutation throws exceptions for errors. */
  createOrGetRelationByInviteCode: CreateOrGetRelationPayload;
  /** Creates a partner mapping for the user if one doesn't exist and returns the (existing|new) mapping. */
  createPartnerMappingIfNotExists: PartnerMapping;
  /**
   * Create a program foundation.
   * - `programConfigId`: Required id of the program this foundation is being added to
   * - `foundation`: the input required to create the foundation
   * Returns the newly created foundation
   */
  createProgramFoundation: ProgramFoundation;
  /** Creates a relation request from the source user to the target user. Returns operation state and the request entity when created or idempotent. */
  createRelationRequest: CreateRelationRequestResponse;
  /**
   * Creates a new scheduled content.
   * - `input`: Data for the new scheduled content
   */
  createScheduledContent?: Maybe<ScheduledContent>;
  /**
   * Creates a short URL that redirects to the specified destination.
   *
   * The destination URL must be on an approved domain (e.g., *.noom.com).
   * The generated short URL can be shared and will redirect users to the destination.
   */
  createShortUrl: ShortUrl;
  /**
   * Create a new SKU registry mapping. Errors:
   * - CONFLICT: (internalSku, vendor) pair already exists
   * - BAD_USER_INPUT: missing required fields or unsupported enum values
   */
  createSkuRegistryEntry: SkuRegistryEntry;
  /** Creates a customer support request ticket */
  createSupportRequest: CreateCustomerSupportTicketResponse;
  /** Delete an asset registry entry. */
  deleteAssetRegistryEntry: AssetRegistryEntry;
  /** Deletes the specified body scan for a user */
  deleteBodyScan: BodyScanDeletionResponse;
  /** Delete a PTO record for a CDU. */
  deleteCduPto: DeleteCduPersonalTimeOffResponse;
  deleteCoachAnnouncement: Scalars['Boolean']['output'];
  /** Delete a noom flow. */
  deleteNoomFlow: NoomFlow;
  /** Delete a Noom Flow experiment (or soft-delete per server policy). */
  deleteNoomFlowExperiment: NoomFlowExperiment;
  /** Delete a Noom Flow list (hard or soft-delete per server policy). */
  deleteNoomFlowList: NoomFlowList;
  /** Delete a Noom Flow list item. */
  deleteNoomFlowListItem: NoomFlowListItem;
  /** Delete a Noom Flow page configuration (hard or soft-delete per server policy). */
  deleteNoomFlowPage: NoomFlowPage;
  /** Delete a noom flow persona. */
  deleteNoomFlowPersona: NoomFlowPersona;
  /** Delete a Noom Flow rule (hard or soft-delete per server policy). */
  deleteNoomFlowRule: NoomFlowRule;
  /** Delete a noom flow text translation. */
  deleteNoomFlowTextTranslation: NoomFlowTextTranslation;
  /**
   * Delete a program foundation.
   * - `programConfigId`: the UUID of the program this foundation is in
   * - `foundationId`: the UUID of the foundation to delete
   * Returns `true` if the deletion was successful (status code `204`)
   */
  deleteProgramFoundation: Scalars['Boolean']['output'];
  /** Delete a relations request */
  deleteRelation: DeleteRelationPayload;
  /** Cascade delete a scheduled content item */
  deleteScheduledContent: DeleteScheduledContentResponse;
  /**
   * Soft-deletes a short URL.
   * Returns the deleted short URL, or null if it doesn't exist.
   */
  deleteShortUrl?: Maybe<ShortUrl>;
  /**
   * Disables a user's connection to b.well. Removes the saved configuration from
   * the user model, as if they never connected their health records in the first place,
   * and revokes the consent for b.well to automatically connect medical records.
   */
  disableHealthRecordsConnection: DisableHealthRecordsConnectionPayload;
  /** Dismisses customer satisfaction survey of the given type on behalf of the user */
  dismissCsatSurvey?: Maybe<CsatSurvey>;
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /**
   * Idempotently ensure that a provider-side user identity exists for the given
   * Noom accessCode and provider. If one already exists, return it; otherwise,
   * create it.
   */
  ensureHealthDataProviderUser: HealthDataProviderUser;
  expireCoachAnnouncement: CoachAnnouncement;
  /**
   * Extend the duration of an active micro challenge instance for the user
   * (extension parameters TBD; seeds redemption flow likely to supply menu item instead of duration)
   */
  extendMicroChallenge: ExtendMicroChallengeResponse;
  /** Generates a pair of auth/refresh tokens used to access facial blood scan partner API */
  generateApiToken: FacialBloodScanToken;
  /**
   * Generate a presigned S3 URL to upload an image for a specific art piece.
   * Clients should upload the image bytes directly to S3 via HTTP PUT using the returned `uploadUrl`.
   * - `artPieceId`: Unique identifier of the art piece
   * - `contentType`: MIME type of the file to be uploaded (e.g. "image/jpeg")
   */
  generateArtPieceImageUploadUrl: ArtPieceImageUploadUrlResponse;
  /** Generates a presigned S3 URL for uploading a food image */
  generateFoodImageUploadUrl: FoodImageUploadUrlResponse;
  /** Generate or get invite friend link */
  generateInviteFriendLink: InviteFriendLink;
  /**
   * Get a presigned S3 upload URL for uploading assets.
   * Used by the noom flow admin for asset management.
   */
  getPresignedS3UploadUrl: GetPresignedS3UploadUrlResponse;
  /** Initializes a new body scan for the user, and returns the URL which the client should use to upload the body scan data */
  initializeBodyScan: BodyScanUploadMetadata;
  /**
   * Initialize the core experience for the user.
   * Returns InitializeCoreExperiencePayload with success status.
   */
  initializeCoreExperience: InitializeCoreExperiencePayload;
  /**
   * Logs a meal and returns the user's updated goals evaluated against
   * the newly recorded nutrient intake.
   */
  logMeal: LogMealResponse;
  markCoachAnnouncementsView: CoachAnnouncementUserInteractions;
  /** Mark a content item as completed */
  markContentItemCompleted: Scalars['Boolean']['output'];
  /** Mark standalone content as consumed */
  markStandaloneContentConsumed: MarkStandaloneContentConsumedResponse;
  /**
   * Called whenever the user opens the mealbot channel. This calls a CS endpoint that triggers actions such as
   * sending a welcome message in the chat.
   * Using a boolean as a response, since GQL doesn't support void responses.
   */
  mealbotChatChannelOpened?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Opts the user in to the specified feature set.
   * Grants the associated entitlements and feature flags.
   */
  optInToFeatureSet: OptInToFeatureSetResult;
  /**
   * Opts the user out of the specified feature set.
   * Revokes the associated entitlements and feature flags.
   */
  optOutOfFeatureSet: OptOutOfFeatureSetResult;
  /**
   * Processes a gamification action with the provided data
   * This can update the system state for various gamification elements like rewards or streaks, and return gamification celebrations to be displayed on the client.
   */
  processGamificationAction: GamificationActionResult;
  /**
   * Record progress to an active micro challenge instance for the user identified from the access code.
   * Returns the updated UserMicroChallenge with the recorded progress.
   */
  recordMicroChallengeProgress: RecordMicroChallengeProgressResponse;
  /** Record a user's reflection response after completing a micro challenge. */
  recordMicroChallengeReflectionResponse: RecordMicroChallengeReflectionResponse;
  /** Record interaction to a specific onboarding step for micro challenges onboarding. */
  recordMicroChallengeUserOnboardingStep: RecordMicroChallengeUserOnboardingStepResponse;
  /** Processes the redemption of a list of products. */
  redeemProducts: ProductRedemptionResult;
  /**
   * Reorders a fulfillment order in the external fulfillment service.
   * Maps to OrderV2ServiceProto.ReorderOrder in noom_contracts/external_fulfillment/orders/service/order_service_v2.proto.
   *
   * Errors:
   * - BAD_USER_INPUT: Unknown/inactive SKU, missing required fields, invalid address, or missing access code when not available from token.
   * - INTERNAL_ERROR: DB or EDA publish failure (order not created).
   *
   * Duplicate idempotency key: EF returns HTTP 409 with an EfCreateOrderResponse body (existing orderId).
   * gql-java treats this as success and returns EfCreateOrderResponse.
   */
  reorderEfOrder: EfReorderResponse;
  /**
   * Requests a pre-signed S3 URL for uploading the user's full contacts book.
   * All preconditions (consent, feature flag, resync delay) are validated by
   * the Relations SOA (ContactsServiceProto.createContactsUploadUrl).
   *
   * Declared as a Mutation because this call has side effects: it creates a
   * syncId, issues a single-use pre-signed URL, and evaluates the resync
   * throttle. Using a Mutation also prevents Apollo/DGS clients from caching
   * a response that contains an already-expired or already-used URL.
   *
   * On success, status is SUCCESS and payload is populated. On failure, status
   * carries the reason (CONTACTS_UPLOAD_CONSENT_REQUIRED, FEATURE_DISABLED,
   * SYNC_TOO_FREQUENT, or UNKNOWN_ERROR) and payload is null.
   */
  requestContactsUploadUrl: RequestContactsUploadUrlResponse;
  /** Store facial blood scan measurements */
  saveFacialBloodScanResults?: Maybe<Scalars['Boolean']['output']>;
  /** Stores the questionnaire data on the backend */
  saveQuestionnaire: Scalars['Boolean']['output'];
  /** Updates user body scan settings with provided mode to be used */
  setBodyScanModeSetting: SetBodyScanModeSettingResponse;
  /** Sets the shared adjustment mode (and custom split when CUSTOM) for all 3 macro goals together. customValues is required if adjustmentMode is CUSTOM. */
  setMacroGoalsAdjustmentMode: UserGoalList;
  /**
   * Enables or disables out-of-range blood glucose alerts for a user.
   * Returns the new state (true if enabled, false if disabled).
   */
  setOutOfRangeBloodGlucoseAlerts: Scalars['Boolean']['output'];
  /**
   * Records an explicit consent decision (`GRANTED` or `DENIED`) for the
   * `(userAccessCode, consentType, qualifier)` natural key.
   *
   * True upsert: creates the row if it does not yet exist; overwrites the
   * existing active row in place otherwise. Setting the same `status`
   * that already exists is a no-op.
   *
   * Backed by `relations-api` `ConsentServiceProto.setConsent`.
   */
  setRelationConsent: Consent;
  /** Updates user show avatar settings with provided boolean value */
  setShowAvatarSetting: SetShowAvatarSettingResponse;
  /**
   * This method is no longer supported and should be removed, but we can't until we allow for exceptions to schema checks
   * @deprecated Use toolsState to patch the state of a tool
   */
  setToolPinState: ToolId;
  /**
   * Start a new micro challenge for the user. Optional userMicroChallengeId allows clients to supply
   * a deterministic identifier so they can optimistically wait for subscription updates.
   */
  startMicroChallenge: StartMicroChallengeResponse;
  /**
   * Start all challenges in a micro challenge stack for the user.
   * Already-active challenges are skipped and returned in the skipped list.
   */
  startMicroChallengeStack: StartMicroChallengeStackResponse;
  /** Start a Noom Flow experiment by primary key (`uuid`). Server validates status transitions and lifecycle timestamps. */
  startNoomFlowExperiment: NoomFlowExperiment;
  /** Stop a Noom Flow experiment by primary key (`uuid`). Server validates status transitions and lifecycle timestamps. */
  stopNoomFlowExperiment: NoomFlowExperiment;
  submitConsent?: Maybe<Scalars['Boolean']['output']>;
  /** Submits a completed customer satisfaction survey on behalf of the user */
  submitCsatSurvey?: Maybe<CsatSurvey>;
  /** Records the user's response to the specified policy */
  submitPolicyOption: UserPolicyOption;
  /** Enables or disables all 3 macro goals (protein, carbohydrate, fat) or all 6 micro goals together (fiber, calcium, potassium, sugar, sodium, saturated fats). */
  toggleNutrientGoals: UserGoalList;
  /** Patches the new state for one or more tools, and returns the full state, updated, of all the tools of the user and program */
  toolsState: ToolList;
  /**
   * Notify the backend that the image has been uploaded and it can start processing.
   * GQL doesn’t support void responses, so returning an object in case we want to
   * extend it in the future
   */
  triggerFaceScanProcessing?: Maybe<TriggerFaceScanResponse>;
  /**
   * Updates an existing art gallery with partial data (PATCH operation).
   * Only provided fields will be updated, null or omitted fields will remain unchanged.
   * - `galleryId`: Unique identifier of the gallery to update
   * - `input`: Partial data to update the gallery
   */
  updateArtGallery?: Maybe<ArtGallery>;
  /**
   * Updates an existing art piece with partial data (PATCH operation).
   * Only provided fields will be updated, null or omitted fields will remain unchanged.
   * - `artPieceId`: Unique identifier of the art piece to update
   * - `input`: Partial data to update the art piece
   */
  updateArtPiece?: Maybe<ArtPiece>;
  /** Update an existing asset registry entry. */
  updateAssetRegistryEntry: AssetRegistryEntry;
  updateCoachAnnouncement: CoachAnnouncement;
  updateCommunityHintInterstitialState: InterstitialState;
  /** Updates dynamic calorie goal settings for a user. */
  updateDynamicCalorieGoalSettingsState: DynamicCalorieGoalSettingsState;
  /**
   * Updates the user's GLP-1 Companion medication state. Used by the
   * Med Tracker home card to record which medication the user is
   * actively tracking and, optionally, when they started GLP-1
   * treatment.
   *
   * `trackedMedicationExternalId` is required and is persisted to
   * `baselined.features.medicationCompanion.assessment.medications[*]
   * .trackedMedicationExternalId` on the user model.
   * `glp1MedicationStartedDate` is optional; when provided it updates
   * the user's GLP-1 start date alongside the tracked medication.
   * `clientDateTime` is optional; when provided it is forwarded to
   * goals-api so that the activated GLP-1 Companion medication goal's
   * `enable_on` is set in the user's local calendar day. When omitted
   * the server falls back to its own clock.
   */
  updateGlp1CompanionMedication: Glp1CompanionMedicationResponse;
  /** Updates the glucose forecasting feature state for a user identified by an access code */
  updateGlucoseForecastingFeatureState: GlucoseForecastingFeatureState;
  /** Updates a user's goal in GoalsAPI for a user and program. */
  updateGoal: UserGoal;
  updateInterstitial: InterstitialState;
  updateMacroMonitoringSettingsState: MacroMonitoringSettingsState;
  /** Update an existing noom flow. */
  updateNoomFlow: NoomFlow;
  /**
   * Update an existing Noom Flow experiment (`UpdateNoomFlowExperimentRequestProto`).
   * Immutable `identifier` is not on the patch body—use mutation `uuid` for routing only.
   * Set fields you want to change; omitted fields are left unchanged per server-defined merge rules.
   */
  updateNoomFlowExperiment: NoomFlowExperiment;
  /** Update Noom Flow list metadata (partial merge). */
  updateNoomFlowList: NoomFlowList;
  /** Update a Noom Flow list item (partial merge). */
  updateNoomFlowListItem: NoomFlowListItem;
  /** Update an existing Noom Flow page (partial merge). */
  updateNoomFlowPage: NoomFlowPage;
  /** Transition page lifecycle status (for example enable/disable). */
  updateNoomFlowPageStatus: NoomFlowPage;
  /** Update an existing noom flow persona. */
  updateNoomFlowPersona: NoomFlowPersona;
  /** Update an existing Noom Flow rule (partial merge). */
  updateNoomFlowRule: NoomFlowRule;
  /** Update the status of a noom flow. */
  updateNoomFlowStatus: NoomFlow;
  /** Update an existing noom flow text translation. */
  updateNoomFlowTextTranslation: NoomFlowTextTranslation;
  /**
   * Update the scheduled date for a prescription refill.
   * This proxies the request to the healthcare API to update the fill date
   * for a specific scheduled prescription refill.
   */
  updatePrescriptionRefillDate: PrescriptionRefill;
  /**
   * Update the foundation.
   * - `programConfidId`: Required id of this foundation's parent program
   * - `foundationId`: Required id of the foundation to update
   * - `foundation`: The input required to update the foundation
   * Returns the updated foundation
   */
  updateProgramFoundation: ProgramFoundation;
  /**
   * Update the ordering of Foundations within a Program. The order of the foundation IDs in the provided list
   * determines the order of the Foundations within the Program.
   * - `programConfigId`: the id of the program the foundations belong to
   * - `foundationIds`: an *ordered* list of foundation ids;
   * Returns true if the update succeeded.
   */
  updateProgramFoundationOrder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Updates the user's rewards settings.
   * Only available to users with the CORE entitlement.
   * Returns the full updated RewardsSettings.
   */
  updateRewardsSettings?: Maybe<RewardsSettings>;
  /**
   * Updates an existing scheduled content.
   * - `scheduledContentId`: The unique identifier of the scheduled content to update
   * - `input`: Updated data for the scheduled content
   */
  updateScheduledContent?: Maybe<ScheduledContent>;
  /**
   * Updates an existing short URL's destination.
   * Returns null if the short URL doesn't exist or has been deleted.
   */
  updateShortUrl?: Maybe<ShortUrl>;
  /**
   * Update a SKU registry mapping. Errors:
   * - NOT_FOUND: id does not exist
   * - BAD_USER_INPUT: invalid UUID or empty patch
   */
  updateSkuRegistryEntry: SkuRegistryEntry;
  updateSuccessKitIntroInterstitialState: InterstitialState;
  /** Updates user birth date and returns it back on success. */
  updateUserDateOfBirth: Scalars['LocalDate']['output'];
  /**
   * Updates a user's preferred shipping address, routing to the appropriate
   * downstream service based on their active treatment program.
   *
   * On success, result.error is null and result.nextFillLocked is null.
   *
   * Soft block — next fill locked: result.nextFillLocked is true and no update
   * was applied. Prompt the user to confirm, then retry with
   * excludeUpcomingShipment: true to apply the change to future fills only.
   *
   * Hard block — update fully blocked: result.error is populated with a reason
   * and message. The update was not applied and cannot be retried as-is.
   */
  updateUserShippingAddress: UpdateUserShippingAddressResult;
  /**
   * Uploads an image for a specific art piece.
   * - `artPieceId`: Unique identifier of the art piece to upload image for
   * - `input`: Image upload data containing the image URL
   */
  uploadArtPieceImage: UploadArtPieceImageResponse;
  /** Create or update a PTO record for a CDU. */
  upsertCduPto: CduPersonalTimeOff;
  /** Create or update the active schedule for a CDU. */
  upsertCduSchedule: CduScheduledWorkHours;
  /** Stores a measurement by proxying the request to the measurement-api. */
  upsertMeasurement: MeasurementData;
  /** DEPRECATED: Stores a measurements by proxying the request to the measurement-api. */
  upsertMeasurements: MeasurementsData;
  /**  Create or update settings for a specific reminder */
  upsertReminderSettings: ReminderSettings;
};


export type MutationAcceptExternalCoachingTermsAndConditionsArgs = {
  accessCode: Scalars['String']['input'];
  externalCoachingTermsAndConditionsInput: ExternalCoachingTermsAndConditionsInput;
};


export type MutationAcknowledgeCoachUserAnnouncementArgs = {
  coachUserAnnouncementId: Scalars['String']['input'];
};


export type MutationAddAssessmentReportArgs = {
  accessCode: Scalars['String']['input'];
  assessmentType: HealthMetricSource;
  input: AddAssessmentReportInput;
};


export type MutationAiMealIdentificationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: AiMealIdentificationInput;
};


export type MutationApplyNoomFlowDiffArgs = {
  input: ApplyNoomFlowDiffInput;
};


export type MutationApplyWorkflowActionArgs = {
  actionInput: CurriculumWorkflowActionInput;
};


export type MutationArchiveNoomFlowExperimentArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationBatchMeasurementsArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: BatchMeasurementsDataInput;
};


export type MutationCalculateSmartDoseArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  calculationInputs?: InputMaybe<CalculateSmartDoseInput>;
  clientDateTime: Scalars['LocalDateTime']['input'];
};


export type MutationCancelLabOrderArgs = {
  accessCode: Scalars['String']['input'];
  labOrderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelMicroChallengeArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationChangeRelationRequestStatusArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: ChangeRelationRequestStatusInput;
};


export type MutationCreateArtGalleryArgs = {
  input: CreateArtGalleryInput;
};


export type MutationCreateArtPieceArgs = {
  input: CreateArtPieceInput;
};


export type MutationCreateAssetRegistryEntryArgs = {
  input: CreateAssetRegistryEntryInput;
};


export type MutationCreateCoachAnnouncementArgs = {
  coachAnnouncementInput: CoachAnnouncementInput;
};


export type MutationCreateDecagonSignatureTokenArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationCreateEfOrderArgs = {
  input: EfCreateOrderInput;
};


export type MutationCreateMemberTrustAndSafetyEscalationArgs = {
  input: MemberTrustAndSafetyEscalationInput;
};


export type MutationCreateNoomFlowArgs = {
  input: CreateNoomFlowInput;
};


export type MutationCreateNoomFlowAuditTrailArgs = {
  input: CreateNoomFlowAuditTrailInput;
};


export type MutationCreateNoomFlowDiffArgs = {
  input: CreateNoomFlowDiffInput;
};


export type MutationCreateNoomFlowExperimentArgs = {
  input: CreateNoomFlowExperimentInput;
};


export type MutationCreateNoomFlowListArgs = {
  input: CreateNoomFlowListInput;
};


export type MutationCreateNoomFlowListItemArgs = {
  input: CreateNoomFlowListItemInput;
};


export type MutationCreateNoomFlowPageArgs = {
  input: CreateNoomFlowPageInput;
};


export type MutationCreateNoomFlowPersonaArgs = {
  input: CreateNoomFlowPersonaInput;
};


export type MutationCreateNoomFlowRuleArgs = {
  input: CreateNoomFlowRuleInput;
};


export type MutationCreateNoomFlowTextTranslationArgs = {
  input: CreateNoomFlowTextTranslationInput;
};


export type MutationCreateNoomFlowTextTranslationKeyArgs = {
  input: CreateNoomFlowTextTranslationKeyInput;
};


export type MutationCreateOrGetRelationByInviteCodeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: CreateOrGetRelationByInviteCodeInput;
};


export type MutationCreatePartnerMappingIfNotExistsArgs = {
  accessCode: Scalars['String']['input'];
  partnerSlug: PartnerSlug;
};


export type MutationCreateProgramFoundationArgs = {
  foundation: ProgramFoundationInput;
  programConfigId: Scalars['UUID']['input'];
};


export type MutationCreateRelationRequestArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: CreateRelationRequestInput;
};


export type MutationCreateScheduledContentArgs = {
  input: CreateScheduledContentInput;
};


export type MutationCreateShortUrlArgs = {
  input: CreateShortUrlInput;
};


export type MutationCreateSkuRegistryEntryArgs = {
  input: CreateSkuRegistryEntryInput;
};


export type MutationCreateSupportRequestArgs = {
  input: SupportRequestInput;
};


export type MutationDeleteAssetRegistryEntryArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteBodyScanArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  scanUuid: Scalars['UUID']['input'];
};


export type MutationDeleteCduPtoArgs = {
  input: DeleteCduPersonalTimeOffInput;
};


export type MutationDeleteCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationDeleteNoomFlowArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowExperimentArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowListArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowListItemArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowPageArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowPersonaArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowRuleArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteNoomFlowTextTranslationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteProgramFoundationArgs = {
  foundationId: Scalars['UUID']['input'];
  programConfigId: Scalars['UUID']['input'];
};


export type MutationDeleteRelationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: DeleteRelationInput;
};


export type MutationDeleteScheduledContentArgs = {
  scheduledContentId: Scalars['UUID']['input'];
};


export type MutationDeleteShortUrlArgs = {
  slug: Scalars['ID']['input'];
};


export type MutationDisableHealthRecordsConnectionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDismissCsatSurveyArgs = {
  surveyInput: DismissCsatSurveyInput;
};


export type MutationEnsureHealthDataProviderUserArgs = {
  accessCode: Scalars['String']['input'];
  provider: HealthDataProvider;
};


export type MutationExpireCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationExtendMicroChallengeArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationGenerateApiTokenArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  tokenInput: FacialBloodScanTokenInput;
};


export type MutationGenerateArtPieceImageUploadUrlArgs = {
  artPieceId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
};


export type MutationGenerateFoodImageUploadUrlArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationGenerateInviteFriendLinkArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationGetPresignedS3UploadUrlArgs = {
  input: GetPresignedS3UploadUrlInput;
};


export type MutationInitializeBodyScanArgs = {
  accessCode: Scalars['String']['input'];
  clientCivilDatetime: Scalars['LocalDateTime']['input'];
  mode?: InputMaybe<BodyScanMode>;
  scanDevice: TargetPlatform;
  sex?: InputMaybe<Sex>;
  weightInKg: Scalars['Float']['input'];
};


export type MutationInitializeCoreExperienceArgs = {
  accessCode: Scalars['String']['input'];
  programUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationLogMealArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  input: MealDataInput;
  programUuid: Scalars['String']['input'];
};


export type MutationMarkCoachAnnouncementsViewArgs = {
  coachUserAnnouncementIds: Array<Scalars['String']['input']>;
};


export type MutationMarkContentItemCompletedArgs = {
  input: MarkContentItemCompletedInput;
};


export type MutationMarkStandaloneContentConsumedArgs = {
  input: MarkStandaloneContentConsumedInput;
};


export type MutationMealbotChatChannelOpenedArgs = {
  channelURL: Scalars['String']['input'];
  userAccessCode: Scalars['String']['input'];
};


export type MutationOptInToFeatureSetArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  featureSet: FeatureSetInput;
};


export type MutationOptOutOfFeatureSetArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  featureSet: FeatureSetInput;
};


export type MutationProcessGamificationActionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  data: GamificationActionDataInput;
};


export type MutationRecordMicroChallengeProgressArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationRecordMicroChallengeReflectionResponseArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: MicroChallengeReflectionRating;
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationRecordMicroChallengeUserOnboardingStepArgs = {
  accessCode: Scalars['String']['input'];
  onboardingStep: MicroChallengeOnboardingStep;
};


export type MutationRedeemProductsArgs = {
  accessCode: Scalars['String']['input'];
  productOrders: Array<ProductOrder>;
  targetDate: Scalars['LocalDate']['input'];
};


export type MutationReorderEfOrderArgs = {
  input: EfReorderInput;
};


export type MutationRequestContactsUploadUrlArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  minutesSinceLastSync?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveFacialBloodScanResultsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  input: SaveFacialBloodScanInput;
};


export type MutationSaveQuestionnaireArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: SaveFacialBloodScanQuestionnaireInput;
};


export type MutationSetBodyScanModeSettingArgs = {
  accessCode: Scalars['String']['input'];
  mode: BodyScanMode;
};


export type MutationSetMacroGoalsAdjustmentModeArgs = {
  accessCode: Scalars['String']['input'];
  adjustmentMode: AdjustmentMode;
  clientDateTime: Scalars['LocalDateTime']['input'];
  customValues?: InputMaybe<CalorieBudgetMacroTargetsInput>;
  programUuid: Scalars['String']['input'];
};


export type MutationSetOutOfRangeBloodGlucoseAlertsArgs = {
  accessCode: Scalars['String']['input'];
  alertsEnabled: Scalars['Boolean']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type MutationSetRelationConsentArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: SetRelationConsentInput;
};


export type MutationSetShowAvatarSettingArgs = {
  accessCode: Scalars['String']['input'];
  showAvatar: Scalars['Boolean']['input'];
};


export type MutationSetToolPinStateArgs = {
  accessCode: Scalars['String']['input'];
  pinStateInput: SetToolPinStateInput;
  programUuid: Scalars['UUID']['input'];
};


export type MutationStartMicroChallengeArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  microChallengeId: Scalars['String']['input'];
  recipeSteps?: InputMaybe<Array<MicroChallengeRecipeStepInput>>;
  recommendationContext?: InputMaybe<RecommendationContextInput>;
  userMicroChallengeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationStartMicroChallengeStackArgs = {
  accessCode: Scalars['String']['input'];
  challenges: Array<StartMicroChallengeStackChallengeInput>;
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  recommendationContext?: InputMaybe<RecommendationContextInput>;
  stackId: Scalars['String']['input'];
};


export type MutationStartNoomFlowExperimentArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationStopNoomFlowExperimentArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationSubmitConsentArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreedToPolicies: Array<Policy>;
};


export type MutationSubmitCsatSurveyArgs = {
  surveyInput: SubmitCsatSurveyInput;
};


export type MutationSubmitPolicyOptionArgs = {
  accessCode: Scalars['String']['input'];
  consentStatus: PolicyOptionStatus;
  policy: Policy;
  signature?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleNutrientGoalsArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  enabled: Scalars['Boolean']['input'];
  nutrientGoalsGroup: NutrientGoalsGroup;
  programUuid: Scalars['String']['input'];
};


export type MutationToolsStateArgs = {
  accessCode: Scalars['String']['input'];
  newToolsState: PatchToolsState;
  programUuid: Scalars['UUID']['input'];
};


export type MutationTriggerFaceScanProcessingArgs = {
  scanId: Scalars['UUID']['input'];
};


export type MutationUpdateArtGalleryArgs = {
  galleryId: Scalars['ID']['input'];
  input: UpdateArtGalleryInput;
};


export type MutationUpdateArtPieceArgs = {
  artPieceId: Scalars['ID']['input'];
  input: UpdateArtPieceInput;
};


export type MutationUpdateAssetRegistryEntryArgs = {
  input: UpdateAssetRegistryEntryInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
  coachAnnouncementInput: CoachAnnouncementInput;
};


export type MutationUpdateCommunityHintInterstitialStateArgs = {
  accessCode: Scalars['String']['input'];
  displayDate: Scalars['LocalDate']['input'];
};


export type MutationUpdateDynamicCalorieGoalSettingsStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  activityLevelName?: InputMaybe<ActivityLevelName>;
  externalBmrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualCalorieAdjustment?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateGlp1CompanionMedicationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  glp1MedicationStartedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  trackedMedicationExternalId: Scalars['String']['input'];
};


export type MutationUpdateGlucoseForecastingFeatureStateArgs = {
  accessCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateGoalArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  goalPatch: UserGoalPatch;
  programUuid: Scalars['String']['input'];
  userGoalId: Scalars['String']['input'];
};


export type MutationUpdateInterstitialArgs = {
  accessCode: Scalars['String']['input'];
  interstitials: UpdateInterstitialInput;
};


export type MutationUpdateMacroMonitoringSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  macroTargets?: InputMaybe<CalorieBudgetMacroTargetsInput>;
};


export type MutationUpdateNoomFlowArgs = {
  input: UpdateNoomFlowInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowExperimentArgs = {
  input: UpdateNoomFlowExperimentInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowListArgs = {
  input: UpdateNoomFlowListInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowListItemArgs = {
  input: UpdateNoomFlowListItemInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowPageArgs = {
  input: UpdateNoomFlowPageInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowPageStatusArgs = {
  input: UpdateNoomFlowPageStatusInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowPersonaArgs = {
  input: UpdateNoomFlowPersonaInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowRuleArgs = {
  input: UpdateNoomFlowRuleInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowStatusArgs = {
  input: UpdateNoomFlowStatusInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateNoomFlowTextTranslationArgs = {
  input: UpdateNoomFlowTextTranslationInput;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdatePrescriptionRefillDateArgs = {
  accessCode: Scalars['String']['input'];
  fillDate: Scalars['LocalDate']['input'];
  prescriptionRefillId: Scalars['Int']['input'];
};


export type MutationUpdateProgramFoundationArgs = {
  foundation: ProgramFoundationInput;
  foundationId: Scalars['UUID']['input'];
  programConfigId: Scalars['UUID']['input'];
};


export type MutationUpdateProgramFoundationOrderArgs = {
  foundationIds: Array<Scalars['UUID']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type MutationUpdateRewardsSettingsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: UpdateRewardsSettingsInput;
};


export type MutationUpdateScheduledContentArgs = {
  input: UpdateScheduledContentInput;
  scheduledContentId: Scalars['UUID']['input'];
};


export type MutationUpdateShortUrlArgs = {
  input: UpdateShortUrlInput;
  slug: Scalars['ID']['input'];
};


export type MutationUpdateSkuRegistryEntryArgs = {
  id: Scalars['ID']['input'];
  patch: UpdateSkuRegistryEntryInput;
};


export type MutationUpdateSuccessKitIntroInterstitialStateArgs = {
  accessCode: Scalars['String']['input'];
  displayDate: Scalars['LocalDate']['input'];
};


export type MutationUpdateUserDateOfBirthArgs = {
  accessCode: Scalars['String']['input'];
  birthDate: Scalars['LocalDate']['input'];
  clientCivilDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationUpdateUserShippingAddressArgs = {
  input: UpdateUserShippingAddressInput;
};


export type MutationUploadArtPieceImageArgs = {
  artPieceId: Scalars['ID']['input'];
  input: UploadArtPieceImageInput;
};


export type MutationUpsertCduPtoArgs = {
  input: UpsertCduPersonalTimeOffInput;
};


export type MutationUpsertCduScheduleArgs = {
  input: UpsertActiveCduScheduledWorkHoursInput;
};


export type MutationUpsertMeasurementArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: MeasurementDataInput;
};


export type MutationUpsertMeasurementsArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: MeasurementsDataInput;
};


export type MutationUpsertReminderSettingsArgs = {
  accessCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  reminderSubtype: Scalars['String']['input'];
  reminderTime: Scalars['LocalTime']['input'];
  reminderType: ReminderType;
  reminderUuid: Scalars['UUID']['input'];
};

/** Content for a button in the top nav. */
export type NavigationButtonContent = {
  __typename?: 'NavigationButtonContent';
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
};

/**
 * This type of switch is effective from the start of the next billing cycle.
 * This switch type doesn't affect the current billing cycle, so all of the
 * options for an immediate switch are not applicable.
 */
export type NextBillingCycleSwitch = {
  __typename?: 'NextBillingCycleSwitch';
  /** Whether this payment schedule update can be reverted with revertPaymentScheduleUpdate */
  revertBehavior: SwitchRevertBehavior;
};

export type NoomAppAttributionDataInput = {
  /** App version on which the data was created. */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Platform of the device. */
  os?: InputMaybe<TargetPlatform>;
  /** Identifier of the source of attribution, usually app package/bundle name. */
  sourceIdentifier: Scalars['String']['input'];
};

/**
 * Variant of NoomAppAttributionDataInput with all fields optional for matching.
 * Keep in sync with NoomAppAttributionDataInput.
 */
export type NoomAppAttributionDataMatchInput = {
  /** App version on which the data was created. */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Platform of the device. */
  os?: InputMaybe<TargetPlatform>;
  /** Identifier of the source of attribution, usually app package/bundle name. */
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Persisted flow configuration for the Noom Flow admin (not the client Buy Flow payload). */
export type NoomFlow = {
  __typename?: 'NoomFlow';
  /** Agent artifacts used to create the flow as a JSON object string (e.g. screenshots, PRDs). */
  agentArtifactsAsJsonString?: Maybe<Scalars['String']['output']>;
  /** When the flow configuration was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Preferred structured flow configuration as a JSON object string. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Legacy flow configuration as JSON text. Prefer `configuration` when available; this field may be removed later. */
  configurationAsJsonString: Scalars['String']['output'];
  /** When the flow configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the flow configuration (optional for now). */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The description of the flow. */
  description?: Maybe<Scalars['String']['output']>;
  /** When the flow configuration was disabled. */
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the flow configuration was enabled. */
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The group name of flow configurations that may be chosen based on criteria when requested. */
  flowGroupName?: Maybe<Scalars['String']['output']>;
  /** Logical flow id used in routing and admin. */
  flowIdentifier: Scalars['String']['output'];
  /** The associated github pull request URLs for the flow. */
  githubPullRequestUrls: Array<Scalars['String']['output']>;
  /** The associated jira ticket URLs for the flow. */
  jiraTicketUrls: Array<Scalars['String']['output']>;
  /** Flow metadata as a JSON object string (e.g. annotations, todos). */
  metadataAsJsonString?: Maybe<Scalars['String']['output']>;
  /** Display name in admin. */
  name: Scalars['String']['output'];
  /** The status of the flow configuration. */
  status: NoomFlowStatus;
  /** When the flow configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Instance primary key. */
  uuid: Scalars['UUID']['output'];
  /** The version of the flow configuration. */
  version: Scalars['Int']['output'];
};

/** Represents a noom flow audit trail entry. */
export type NoomFlowAuditTrail = {
  __typename?: 'NoomFlowAuditTrail';
  /** The identifier of the associated entity (flow, persona, experiment, etc.). */
  associatedIdentifier: Scalars['String']['output'];
  /** The version of the associated entity. */
  associatedVersion?: Maybe<Scalars['Int']['output']>;
  /** The type of audit trail event. */
  auditTrailType: NoomFlowAuditTrailType;
  /** Description of the change that was made. */
  changeDescription: Scalars['String']['output'];
  /** Who made the change. */
  changedBy: Scalars['String']['output'];
  /** A JSON string representing the diff of the change that was made. */
  diffAsJsonString?: Maybe<Scalars['String']['output']>;
  /** When the change occurred. */
  timestamp: Scalars['DateTime']['output'];
  /** The uuid for the audit trail entry. */
  uuid: Scalars['UUID']['output'];
};

/** Enum representing the different types of audit trail events. */
export enum NoomFlowAuditTrailType {
  /** An asset registry entry was created. */
  AssetRegistryEntryCreated = 'ASSET_REGISTRY_ENTRY_CREATED',
  /** An asset registry entry was deleted. */
  AssetRegistryEntryDeleted = 'ASSET_REGISTRY_ENTRY_DELETED',
  /** An asset registry entry was updated. */
  AssetRegistryEntryUpdated = 'ASSET_REGISTRY_ENTRY_UPDATED',
  /** An experiment was created. */
  ExperimentCreated = 'EXPERIMENT_CREATED',
  /** An experiment was deleted. */
  ExperimentDeleted = 'EXPERIMENT_DELETED',
  /** An experiment was updated. */
  ExperimentUpdated = 'EXPERIMENT_UPDATED',
  /** A flow was created. */
  FlowCreated = 'FLOW_CREATED',
  /** A flow was deleted. */
  FlowDeleted = 'FLOW_DELETED',
  /** A flow was updated. */
  FlowUpdated = 'FLOW_UPDATED',
  /** A page was created. */
  PageCreated = 'PAGE_CREATED',
  /** A page was deleted. */
  PageDeleted = 'PAGE_DELETED',
  /** A page was updated. */
  PageUpdated = 'PAGE_UPDATED',
  /** A persona was created. */
  PersonaCreated = 'PERSONA_CREATED',
  /** A persona was deleted. */
  PersonaDeleted = 'PERSONA_DELETED',
  /** A persona was updated. */
  PersonaUpdated = 'PERSONA_UPDATED',
  /** A rule was created. */
  RuleCreated = 'RULE_CREATED',
  /** A rule was deleted. */
  RuleDeleted = 'RULE_DELETED',
  /** A rule was updated. */
  RuleUpdated = 'RULE_UPDATED',
  /** A text translation was created. */
  TextTranslationCreated = 'TEXT_TRANSLATION_CREATED',
  /** A text translation was deleted. */
  TextTranslationDeleted = 'TEXT_TRANSLATION_DELETED',
  /** A text translation was modified. */
  TextTranslationModified = 'TEXT_TRANSLATION_MODIFIED',
  /**
   * Unknown or unspecified audit trail type.
   * Note: This is the default value for the filter.
   */
  Unknown = 'UNKNOWN'
}

/** Represents an array of noom flow audit trails with pagination. */
export type NoomFlowAuditTrails = Pageable & {
  __typename?: 'NoomFlowAuditTrails';
  /** An array of noom flow audit trails. */
  auditTrails: Array<NoomFlowAuditTrail>;
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Input for filtering audit trails. */
export type NoomFlowAuditTrailsFilterInput = {
  /** The associated identifier of the entity (flow, persona, experiment, etc.). */
  associatedIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * The version of the associated entity.
   * This is used to identify the version of the associated entity that was changed.
   * If the associated entity is a flow, this will be the version of the flow.
   */
  associatedVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The type of audit trail event. */
  auditTrailType?: InputMaybe<NoomFlowAuditTrailType>;
  /** Who made the change. (partial search) */
  changedBy?: InputMaybe<Scalars['String']['input']>;
  /** The configuration for paginating the filtered results. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** The description of the change that was made (partial search) */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * A search string to filter results that looks at changed by, description,
   * and associated identifier.
   */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** The uuid of the audit trail to retrieve. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Targeting and routing inputs for resolving a flow from criteria (Buy Flow v2 and later). */
export type NoomFlowCriteriaInput = {
  /** Experiment arms applied when resolving the flow (preferred over legacy uuid/id lists). */
  associatedExperimentArms?: InputMaybe<Array<NoomFlowExperimentArmInput>>;
  /** Marketing campaign key (attribution / targeting). */
  campaign?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Flow file basename on the service (not a full path); mainly for MVP paths. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Logical flow id when resolving by product identifier. */
  flowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** ISO 639-1 language code (e.g. `en`). */
  languageCode?: InputMaybe<Scalars['String']['input']>;
  /** Marketing medium key (attribution / targeting). */
  medium?: InputMaybe<Scalars['String']['input']>;
  /** Client route / screen id used by the router. */
  routeIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Marketing source key (attribution / targeting). */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Optional instance uuid when resolving a specific configuration row. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Configuration version when multiple revisions exist. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Patch-style flow diff overlay from the create-flow-diff mutation. Same JSON shape as
 * the variation flow diff stored on experiment arms.
 */
export type NoomFlowDiff = {
  __typename?: 'NoomFlowDiff';
  /** JSON object text for the overlay diff. */
  flowDiffAsJsonString?: Maybe<Scalars['String']['output']>;
};

/** Full persisted experiment record for growth / buyflow configuration. */
export type NoomFlowExperiment = {
  __typename?: 'NoomFlowExperiment';
  /** When the experiment was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Baseline flow identifier. If `pinnedBaselineFlowUuid` is unset, the latest published
   * version of this flow is used as the baseline.
   */
  baselineFlowIdentifier: Scalars['String']['output'];
  /** Other experiments that must not run against this one. */
  conflictingExperimentIdentifiers: Array<Scalars['String']['output']>;
  /** When the experiment row was first persisted. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the experiment row. */
  createdBy: Scalars['String']['output'];
  /** Human-readable description; required when the experiment is beyond initial `IN_PROGRESS` (draft-like) configuration per server validation. */
  description?: Maybe<Scalars['String']['output']>;
  /** Links to design docs, PRDs, or related documentation. */
  designDocumentationLinks: Array<Scalars['String']['output']>;
  /** Unique foreign key for the experiment in the experiment engine (e.g. Meristem); assists lookups. */
  foreignKey?: Maybe<Scalars['String']['output']>;
  /** Mixpanel funnel identifier for reporting links. */
  funnelId?: Maybe<Scalars['String']['output']>;
  /** Immutable human-readable id (alphanumeric, hyphens, underscores). */
  identifier: Scalars['String']['output'];
  /** When true, Noom Flow uses greedy allocation semantics; only valid when allowed by Noom Flow validation. */
  isGreedyTargeting: Scalars['Boolean']['output'];
  /** Human-readable display name for the experiment (distinct from immutable `identifier`). */
  name?: Maybe<Scalars['String']['output']>;
  /** Owner email or identity; required on save in Noom Flow. */
  owner: Scalars['String']['output'];
  /** Owning team label for reporting and Slack context. */
  owningTeam?: Maybe<Scalars['String']['output']>;
  /** Optional pinned baseline flow instance uuid (fixed flow version as baseline). */
  pinnedBaselineFlowUuid?: Maybe<Scalars['String']['output']>;
  /** Optional psychology or technique label for categorization. */
  psychTechnique?: Maybe<Scalars['String']['output']>;
  /** Target sample size per arm; used with traffic estimation and Mixpanel checks when completing from `STARTED`. */
  sampleSizePerArm: Scalars['Int']['output'];
  /** Optional planned end of the experiment window. */
  scheduledEndAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional planned start of the experiment window (Noom Flow scheduling). */
  scheduledStartAt?: Maybe<Scalars['DateTime']['output']>;
  /** Events marking experiment start in funnel analytics. */
  startEvents: Array<NoomFlowExperimentQueriedReference>;
  /** When the experiment began running (e.g. entered `STARTED`); semantics defined by the server. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle state; transitions validated server-side. */
  status: NoomFlowExperimentStatus;
  /** When the experiment finished running (e.g. completed or stopped). */
  stoppedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Events marking conversion or target outcomes. */
  targetEvents: Array<NoomFlowExperimentQueriedReference>;
  /**
   * Targeting criteria rows (e.g. context, language). Greedy targeting is only valid when
   * permitted by Noom Flow validation for this experiment.
   */
  targeting: Array<NoomFlowExperimentTargetingCriteria>;
  /** Fraction of traffic allocated to this experiment (0–100 style; default 0 on save if omitted). */
  trafficPercentage: Scalars['Int']['output'];
  /** When the experiment row was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Primary key assigned by Noom Flow (also used in URLs and state). */
  uuid: Scalars['UUID']['output'];
  /** Variation arms: weight_percentage per arm, flow diffs, config and metadata payloads, and identifiers. */
  variations: Array<NoomFlowExperimentVariation>;
  /**
   * Whole number representing experiment-level allocation as a percentage (int32;
   * e.g. 30 means 30%).
   */
  weightPercentage: Scalars['Int']['output'];
};

/** One experiment arm (identifiers and optional configuration) echoed on a rendered flow or sent with criteria. */
export type NoomFlowExperimentArm = {
  __typename?: 'NoomFlowExperimentArm';
  /** Arm configuration as JSON object text (structured config). */
  armConfigurationAsJsonString?: Maybe<Scalars['String']['output']>;
  /** Experiment arm identifier. */
  experimentArmIdentifier: Scalars['String']['output'];
  /** Experiment identifier. */
  experimentIdentifier: Scalars['String']['output'];
};

/** One experiment arm (identifier and optional configuration) supplied with flow resolution criteria. */
export type NoomFlowExperimentArmInput = {
  /** Arm configuration as JSON object text (structured config). */
  armConfigurationAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Experiment arm identifier. */
  experimentArmIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Experiment identifier. */
  experimentIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Arm role for an experiment variation: control (baseline) vs treatment variation. */
export enum NoomFlowExperimentArmType {
  /** Control / baseline arm. */
  Control = 'CONTROL',
  /** Variation arm. */
  Variation = 'VARIATION'
}

/** Analytics event reference with optional filters (for funnel start and target events). */
export type NoomFlowExperimentQueriedReference = {
  __typename?: 'NoomFlowExperimentQueriedReference';
  /** Additional filters on the event; same criterion shape as experiment targeting rows. */
  filters: Array<NoomFlowExperimentTargetingCriteria>;
  /** Event name as used in Mixpanel or similar queries. */
  name: Scalars['String']['output'];
};

/** Input for funnel / conversion event references when creating or updating an experiment. */
export type NoomFlowExperimentQueriedReferenceInput = {
  /** Filters applied to the event (same shape as targeting criteria). */
  filters: Array<NoomFlowExperimentTargetingCriteriaInput>;
  /** Event name for analytics. */
  name: Scalars['String']['input'];
};

/**
 * Lifecycle status for a Noom Flow experiment. Unset filter input matches any status.
 * Transitions are enforced server-side.
 */
export enum NoomFlowExperimentStatus {
  /** Experiment passed QA. */
  ApprovedByQa = 'APPROVED_BY_QA',
  /** Experiment passed review and is approved to be deployed (not yet live). */
  ApprovedForDeployment = 'APPROVED_FOR_DEPLOYMENT',
  /** Experiment was archived: retained for history but excluded from normal active experiment lists per server policy. */
  Archived = 'ARCHIVED',
  /** Experiment did not pass final deployment review. */
  FailedDeploymentReview = 'FAILED_DEPLOYMENT_REVIEW',
  /** Experiment failed QA. */
  FailedQa = 'FAILED_QA',
  /** Experiment is being configured or in internal workflow before it is ready for deployment. */
  InProgress = 'IN_PROGRESS',
  /** Experiment is ready for QA verification. */
  ReadyForQa = 'READY_FOR_QA',
  /** Experiment is live: receiving traffic per allocation rules in the target environment. */
  Started = 'STARTED',
  /** Experiment was stopped: no longer receiving experiment traffic (e.g. manual stop); distinct from archived. */
  Stopped = 'STOPPED'
}

/**
 * One targeting row on an experiment. Non-draft experiments typically require rows for
 * context and language dimensions.
 */
export type NoomFlowExperimentTargetingCriteria = {
  __typename?: 'NoomFlowExperimentTargetingCriteria';
  /** Targeting dimension (e.g. `context_type`, `language_code`, `route_id`). */
  key: Scalars['String']['output'];
  /** Comparison operator for `key`. */
  operator: NoomFlowExperimentTargetingOperator;
  /** JSON text for the comparison value (scalar, array, or object). */
  value: Scalars['String']['output'];
  /** Optional hint for parsing `value` (e.g. string vs boolean). */
  valueType?: Maybe<NoomFlowExperimentTargetingValueType>;
};

/** Input for a targeting row when creating or updating an experiment. */
export type NoomFlowExperimentTargetingCriteriaInput = {
  /** Targeting dimension (e.g. `context_type`, `language_code`). */
  key: Scalars['String']['input'];
  /** Comparison operator for `key`. */
  operator: NoomFlowExperimentTargetingOperator;
  /** JSON text for the comparison value. */
  value: Scalars['String']['input'];
  /** Optional hint for parsing `value`. */
  valueType?: InputMaybe<NoomFlowExperimentTargetingValueType>;
};

/** Targeting comparison operator. Serialized as strings such as `EQUALS`, `IN`. */
export enum NoomFlowExperimentTargetingOperator {
  /** Substring or containment. */
  Contains = 'CONTAINS',
  /** Exact match. */
  Equals = 'EQUALS',
  /** Value is in a set (list). */
  In = 'IN',
  /** Predicate that the attribute is present; `value` may be omitted in some filters. */
  IsSet = 'IS_SET',
  /** Negated containment. */
  NotContains = 'NOT_CONTAINS',
  /** Inequality. */
  NotEquals = 'NOT_EQUALS',
  /** Value is not in a set. */
  NotIn = 'NOT_IN'
}

/** How targeting values are interpreted (string, boolean, number, and so on). */
export enum NoomFlowExperimentTargetingValueType {
  /** Boolean coercion for `value`. */
  Boolean = 'BOOLEAN',
  /** Number or list of numbers. */
  Number = 'NUMBER',
  /** String or list of strings (e.g. `context_type` with `IN`). */
  String = 'STRING'
}

/**
 * A single variation arm on an experiment. A stable identifier is often required
 * when moving beyond draft configuration, per server validation.
 */
export type NoomFlowExperimentVariation = {
  __typename?: 'NoomFlowExperimentVariation';
  /** Whether this arm is the control (baseline) or a treatment variation. */
  armType: NoomFlowExperimentArmType;
  /** Optional variation-level configuration as JSON object text. */
  configAsJsonString?: Maybe<Scalars['String']['output']>;
  /** Optional longer human-readable detail for the variation (beyond display `name`). */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Stable variation identifier when required by Noom Flow validation (alphanumeric,
   * hyphens, underscores).
   */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Optional variation-level metadata as JSON object text. */
  metadataAsJsonString?: Maybe<Scalars['String']['output']>;
  /** Display name of the variation. */
  name: Scalars['String']['output'];
  /**
   * On read, the baseline flow configuration with the variation flow diff applied,
   * computed by Noom Flow from the current baseline and stored diff.
   */
  renderedVariationAsJsonString?: Maybe<Scalars['String']['output']>;
  /**
   * Persisted variation flow diff overlaid on the baseline when the client sends an
   * experiment id with a flow-config request. On read, this is the diff stored in Noom
   * Flow (derived on create/update from `renderedVariationAsJsonString` when that was supplied).
   */
  variationFlowDiffAsJsonString?: Maybe<Scalars['String']['output']>;
  /**
   * Whole number representing this variation's traffic share as a percentage (int32;
   * e.g. 30 means 30%).
   */
  weightPercentage: Scalars['Int']['output'];
};

/** Input for a variation when creating or updating an experiment. */
export type NoomFlowExperimentVariationInput = {
  /** Whether this arm is the control (baseline) or a treatment variation. */
  armType?: InputMaybe<NoomFlowExperimentArmType>;
  /** Optional variation-level configuration as JSON object text. */
  configAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Optional longer human-readable detail for the variation (beyond display `name`). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Stable variation identifier when required by Noom Flow validation. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Optional variation-level metadata as JSON object text. */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the variation. */
  name: Scalars['String']['input'];
  /**
   * On create/update, optional JSON for the complete flow configuration that represents
   * this variation; Noom Flow derives and stores `variation_flow_diff` from this when set.
   */
  renderedVariationAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional variation flow diff as JSON. On create/update this is ignored and does not
   * need to be set; Noom Flow persists the diff computed from `renderedVariationAsJsonString`
   * when provided.
   */
  variationFlowDiffAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whole number representing this variation's traffic share as a percentage (int32;
   * e.g. 30 means 30%).
   */
  weightPercentage: Scalars['Int']['input'];
};

/** Paginated list of experiments for admin and tooling. */
export type NoomFlowExperiments = Pageable & {
  __typename?: 'NoomFlowExperiments';
  /** Experiments matching the filter, in server-defined order unless a sort is applied. */
  experiments: Array<NoomFlowExperiment>;
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Total number of results matching the filter (when the server provides a count). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for listing experiments. */
export type NoomFlowExperimentsFilterInput = {
  /** Filter by baseline flow identifier. */
  baselineFlowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based page size and continuation token. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Filter by experiment-engine or external integration foreign key. */
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  /** Match by immutable human-readable id (exact or prefix—server-defined). */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by owner email or id (exact match; format is server-defined). */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Filter by owning team label. */
  owningTeam?: InputMaybe<Scalars['String']['input']>;
  /** Filter by pinned baseline flow uuid. */
  pinnedBaselineFlowUuid?: InputMaybe<Scalars['String']['input']>;
  /** Lower bound on `scheduledStartAt` (inclusive; server-defined). */
  scheduledStartOnOrAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Upper bound on `scheduledStartAt` (inclusive; server-defined). */
  scheduledStartOnOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Case-insensitive search across identifier, name, description, owner, and related fields (server-defined). */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Filter by lifecycle status; unset means all statuses unless constrained by policy. */
  status?: InputMaybe<NoomFlowExperimentStatus>;
  /** Return at most the single experiment with this primary key, if set. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Lookup a single flow by uuid, identifier, and/or version. */
export type NoomFlowGetFlowByIdentifierInput = {
  /** Filter by logical flow identifier. */
  flowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by instance uuid. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by named version. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** A named list of values (for example for admin-curated option sets). */
export type NoomFlowList = {
  __typename?: 'NoomFlowList';
  /** When the list was first persisted. */
  createdAt: Scalars['DateTime']['output'];
  /** User that created the list (for example email or service principal). */
  createdBy: Scalars['String']['output'];
  /** When the list was soft-deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional free-text description for admin or tooling. */
  description?: Maybe<Scalars['String']['output']>;
  /** Stable human-readable name; used when addressing the list by name instead of uuid. */
  name: Scalars['String']['output'];
  /** When the list was last modified. */
  updatedAt: Scalars['DateTime']['output'];
  /** Primary key returned on create and used in URLs for updates/deletes. */
  uuid: Scalars['UUID']['output'];
  /** How each item `value` in this list should be interpreted (string, number, object, or boolean). */
  valueDataType: NoomFlowListValueDataType;
};

/** One row in a Noom Flow list. */
export type NoomFlowListItem = {
  __typename?: 'NoomFlowListItem';
  /** When the item was first persisted. */
  createdAt: Scalars['DateTime']['output'];
  /** User that created the item, if recorded. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** When the item was soft-deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Owning list name; echoed when the list was addressed by name. */
  listName: Scalars['String']['output'];
  /** Owning list primary key. */
  listUuid: Scalars['UUID']['output'];
  /** Optional JSON metadata for the item. */
  metadataAsJsonString?: Maybe<Scalars['String']['output']>;
  /** Optional sort order within the list when the server applies it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** When the item was last modified. */
  updatedAt: Scalars['DateTime']['output'];
  /** Primary key returned on create and used in URLs for updates/deletes. */
  uuid: Scalars['UUID']['output'];
  /** Stored string value (display, search, and autocomplete). */
  value: Scalars['String']['output'];
};

/**
 * How `partialItemValue` matches `NoomFlowListItem.value`.
 * Omit the filter field to use server defaults.
 */
export enum NoomFlowListItemValueMatch {
  /** Value must contain the partial string anywhere. */
  Contains = 'CONTAINS',
  /** Value must start with the partial string (typical autocomplete). */
  Prefix = 'PREFIX'
}

/** Paginated list items. */
export type NoomFlowListItems = Pageable & {
  __typename?: 'NoomFlowListItems';
  /** Items matching the request for this page. */
  items: Array<NoomFlowListItem>;
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Total matches for the filter, if the server provides it. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Declared JSON-like type of each list item's `value` (validation and UI semantics). */
export enum NoomFlowListValueDataType {
  /** Boolean (for example "true" / "false" in `value`). */
  Boolean = 'BOOLEAN',
  /** Numeric value (may still be stored or transmitted as a string in some APIs). */
  Number = 'NUMBER',
  /** JSON object (for example stringified JSON in `value`). */
  Object = 'OBJECT',
  /** Plain string. */
  String = 'STRING',
  /** Not set; server or legacy default (for example treated as string). */
  Unspecified = 'UNSPECIFIED'
}

/** Paginated named lists. */
export type NoomFlowLists = Pageable & {
  __typename?: 'NoomFlowLists';
  /** Lists matching the filter for this page. */
  lists: Array<NoomFlowList>;
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Total matches for the filter, if the server provides it. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for listing Noom Flow lists. */
export type NoomFlowListsFilterInput = {
  /** Only lists created by this user identifier. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Cursor pagination for the result set. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Exact match on list name (semantics server-defined, typically case-sensitive). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive partial match on list name. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Return at most the list with this primary key, if set. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Persisted page configuration for the Noom Flow admin. */
export type NoomFlowPage = {
  __typename?: 'NoomFlowPage';
  /** Agent artifacts used to create the page as a JSON object string (for example screenshots, PRDs). */
  agentArtifactsAsJsonString?: Maybe<Scalars['String']['output']>;
  /** When the page configuration was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Structured page configuration as a JSON object string. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** When the page configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the page configuration. */
  createdBy: Scalars['String']['output'];
  /** Free-form description in admin. */
  description?: Maybe<Scalars['String']['output']>;
  /** When the page configuration was disabled. */
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the page configuration was enabled. */
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Page metadata as a JSON object string (for example annotations, todos). */
  metadataAsJsonString?: Maybe<Scalars['String']['output']>;
  /** Display name in admin. */
  name: Scalars['String']['output'];
  /** Logical page id used in routing and admin. */
  pageIdentifier: Scalars['String']['output'];
  /** Lifecycle status for this page configuration. */
  status: NoomFlowStatus;
  /** When the page configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Instance primary key. */
  uuid: Scalars['UUID']['output'];
  /** Monotonic or content version for this configuration row. */
  version: Scalars['Int']['output'];
};

/** Paginated list of Noom Flow pages. */
export type NoomFlowPages = Pageable & {
  __typename?: 'NoomFlowPages';
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Page rows for the current page. */
  pages: Array<NoomFlowPage>;
  /** Total matches for the filter, if the server provides it. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for listing Noom Flow pages in the admin. */
export type NoomFlowPagesFilterInput = {
  /** Cursor pagination for the result set. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Filter by logical page identifier. */
  pageIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Matches name, identifier, and description (server-defined matching rules). */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Filter by lifecycle status; unset means all statuses unless policy constrains. */
  status?: InputMaybe<NoomFlowStatus>;
  /** Filter by instance uuid. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by configuration version. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a noom flow persona. */
export type NoomFlowPersona = {
  __typename?: 'NoomFlowPersona';
  /** When the persona was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The flowIdentifiers this persona is associated with. */
  associatedFlowIdentifiers: Array<Scalars['String']['output']>;
  /** When the persona was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the persona. */
  createdBy: Scalars['String']['output'];
  /** The description of the persona. */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the persona. */
  name: Scalars['String']['output'];
  /** A JSON string representing the persona configuration. */
  personaAsJsonString: Scalars['String']['output'];
  /** The type of the persona. */
  type: NoomFlowPersonaType;
  /** When the persona was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uuid for the persona. */
  uuid: Scalars['UUID']['output'];
};

/** Enum representing the different types of a noom flow persona. */
export enum NoomFlowPersonaType {
  /** Persona type is a composed of multiple personas. */
  Composed = 'COMPOSED',
  /** Persona type is device attributes (i.e. device, location, etc.). */
  DeviceAttributes = 'DEVICE_ATTRIBUTES',
  /** Persona type is survey answers. */
  SurveyAnswers = 'SURVEY_ANSWERS',
  /** Any or unspecified persona type. */
  Unknown = 'UNKNOWN',
  /** Persona type is URL parameters (i.e. feature, route). */
  UrlParameters = 'URL_PARAMETERS',
  /** Persona type is user attributes. */
  UserModelAttributes = 'USER_MODEL_ATTRIBUTES'
}

/** Represents an array of noom flow personas with pagination. */
export type NoomFlowPersonas = Pageable & {
  __typename?: 'NoomFlowPersonas';
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** An array of noom flow personas. */
  personas: Array<NoomFlowPersona>;
  /** The total number of results that match the filtering criteria for the returned list. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for getting noom flow personas. */
export type NoomFlowPersonasFilterInput = {
  /** The associated flowIdentifiers of the persona. */
  associatedFlowIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The creator of the persona. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The configuration for paginating the filtered results. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** The name for the persona. */
  personaName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A search string to filter results that looks at the name, identifier,
   * changed by, and associated flow identifiers.
   */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** The type of the persona. */
  type?: InputMaybe<NoomFlowPersonaType>;
  /** The uuid of the persona to retrieve. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Resolved client flow: configuration plus translation lookup for rendering. */
export type NoomFlowRenderedFlow = {
  __typename?: 'NoomFlowRenderedFlow';
  /** Experiment arms considered when resolving this payload (preferred over legacy UUID list). */
  associatedExperimentArms: Array<NoomFlowExperimentArm>;
  /**
   * Experiment UUIDs that were considered when resolving this payload.
   * @deprecated Use associatedExperimentArms instead.
   */
  associatedExperimentUuids: Array<Scalars['UUID']['output']>;
  /** Preferred rendered configuration as a JSON object string. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Legacy rendered configuration as JSON text. Prefer `configuration` when available; this field may be removed later. */
  configurationAsJsonString: Scalars['String']['output'];
  /** Logical flow identifier for this resolution. */
  flowIdentifier: Scalars['String']['output'];
  /** Translation key → localized string lookup for this render. */
  textTranslationLookupTable: NoomFlowTextTranslationLookupTable;
  /** Instance uuid of the flow configuration used for this resolution. */
  uuid: Scalars['UUID']['output'];
  /** Resolved configuration version. */
  version: Scalars['Int']['output'];
};

/**
 * A reusable Noom Flow rule: a named set of conditionals evaluated when applying
 * flow logic (for example routing, visibility, or targeting).
 */
export type NoomFlowRule = {
  __typename?: 'NoomFlowRule';
  /** When the rule was archived, if applicable. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Structured JSON for the ordered list of conditions that define when the rule
   * applies.
   */
  conditionalsAsJsonString?: Maybe<Scalars['String']['output']>;
  /** When the rule was first persisted. */
  createdAt: Scalars['DateTime']['output'];
  /** User that created the rule (for example email or service principal). */
  createdBy: Scalars['String']['output'];
  /** Optional free-text description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable name for the rule. */
  name: Scalars['String']['output'];
  /** When the rule was last modified. */
  updatedAt: Scalars['DateTime']['output'];
  /** Primary key returned on create and used in URLs for updates/deletes. */
  uuid: Scalars['UUID']['output'];
};

/** Paginated list of Noom Flow rules. */
export type NoomFlowRules = Pageable & {
  __typename?: 'NoomFlowRules';
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Rules matching the filter for this page. */
  rules: Array<NoomFlowRule>;
  /** Total matches for the filter, if the server provides it. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for listing Noom Flow rules. */
export type NoomFlowRulesFilterInput = {
  /** Only rules created by this user identifier. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Cursor pagination for the result set. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /**
   * When true, include archived rules; when false or unset, server-defined
   * default (typically exclude archived).
   */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match on rule name (semantics server-defined). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Matches name and description (server-defined matching rules). */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Return at most the rule with this primary key, if set. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Enum representing the different statuses of a noom flow. */
export enum NoomFlowStatus {
  /** The noom flow is in the approved by QA state. */
  ApprovedByQa = 'APPROVED_BY_QA',
  /** The noom flow is approved for deployment. */
  ApprovedForDeployment = 'APPROVED_FOR_DEPLOYMENT',
  /**
   * The noom flow is in the archived state.
   * Note: This is the state after a flow has been updated and deployed.
   */
  Archived = 'ARCHIVED',
  /**
   * The noom flow is in the deployed state.
   * Note: This is the state where a flow is deployed to the environment.
   */
  Deployed = 'DEPLOYED',
  /**
   * The noom flow is in the disabled state.
   * Note: This is the state where a flow is manually disabled by a user.
   */
  Disabled = 'DISABLED',
  /** The noom flow failed final deployment review. */
  FailedDeploymentReview = 'FAILED_DEPLOYMENT_REVIEW',
  /** The noom flow failed QA. */
  FailedQa = 'FAILED_QA',
  /** The noom flow is in the progress state. */
  InProgress = 'IN_PROGRESS',
  /** The noom flow is in the ready for QA state. */
  ReadyForQa = 'READY_FOR_QA'
}

/** Represents a noom flow text translation. */
export type NoomFlowTextTranslation = {
  __typename?: 'NoomFlowTextTranslation';
  /** When the text translation was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the text translation. */
  createdBy: Scalars['String']['output'];
  /** German (Germany) translation. */
  deDe?: Maybe<Scalars['String']['output']>;
  /** German (international) translation. */
  deInternational?: Maybe<Scalars['String']['output']>;
  /** When the text translation was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** English (Australia) translation. */
  enAu?: Maybe<Scalars['String']['output']>;
  /** English (Canada) translation. */
  enCa?: Maybe<Scalars['String']['output']>;
  /** English (Great Britain) translation. */
  enGb?: Maybe<Scalars['String']['output']>;
  /** English (Ireland) translation. */
  enIe?: Maybe<Scalars['String']['output']>;
  /** English (international) translation. */
  enInternational?: Maybe<Scalars['String']['output']>;
  /** English (Mexico) translation. */
  enMx?: Maybe<Scalars['String']['output']>;
  /** English (New Zealand) translation. */
  enNz?: Maybe<Scalars['String']['output']>;
  /** English (Pakistan) translation. */
  enPk?: Maybe<Scalars['String']['output']>;
  /** English (Singapore) translation. */
  enSg?: Maybe<Scalars['String']['output']>;
  /** English (United States) translation. */
  enUs: Scalars['String']['output'];
  /** Spanish (international) translation. */
  esInternational?: Maybe<Scalars['String']['output']>;
  /** Spanish (Mexico) translation. */
  esMx?: Maybe<Scalars['String']['output']>;
  /** The key that is the unique identifier for the text translation in flows. */
  key: Scalars['String']['output'];
  /** Whether the translation is shared across flows. */
  shared: Scalars['Boolean']['output'];
  /** The state of the translation. */
  translationState: NoomFlowTextTranslationStateType;
  /** When the text translation was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uuid for the text translation. */
  uuid: Scalars['UUID']['output'];
};

/**
 * Represents a noom flow text translation key.
 * Note: the new key will be stored.
 */
export type NoomFlowTextTranslationKey = {
  __typename?: 'NoomFlowTextTranslationKey';
  /**
   * The key that is the unique identifier for the text translation in flows.
   * Note: If we generated the key, we'll return the generated key.
   * Note: If we provided the key, and it was not taken we'll return the provided key.
   * Note: If we provided the key, and it was taken we'll return a replacement key.
   */
  key: Scalars['String']['output'];
  /**
   * Whether the key is already taken by another text translation.
   * Note: If we generated the key, this will always be false.
   * We'll return a replacement key in key if this is true.
   */
  keyTaken: Scalars['Boolean']['output'];
};

/** Represents a lookup table mapping translation keys to their lookup table entries. */
export type NoomFlowTextTranslationLookupTable = {
  __typename?: 'NoomFlowTextTranslationLookupTable';
  /** The country of the lookup table. */
  country: Scalars['String']['output'];
  /** Array of translation keys to their lookup table entries. */
  entries: Array<NoomFlowTextTranslationLookupTableEntry>;
  /** The language of the lookup table. */
  language: Scalars['String']['output'];
};

/** Represents a lookup table entry for translated text. */
export type NoomFlowTextTranslationLookupTableEntry = {
  __typename?: 'NoomFlowTextTranslationLookupTableEntry';
  /** The translation key for the lookup table entry. */
  key: Scalars['String']['output'];
  /** The translated text for the given translation key. */
  text: Scalars['String']['output'];
};

/** Enum representing the different states of a text translation. */
export enum NoomFlowTextTranslationStateType {
  /** The translation is currently being processed. */
  BeingTranslated = 'BEING_TRANSLATED',
  /** The translation failed. */
  FailedTranslation = 'FAILED_TRANSLATION',
  /** The translation is needed. */
  NeedsTranslation = 'NEEDS_TRANSLATION',
  /** The translation has been completed. */
  Translated = 'TRANSLATED',
  /** Unknown or unspecified translation state type. */
  Unknown = 'UNKNOWN'
}

/** Represents an array of noom flow text translations with pagination. */
export type NoomFlowTextTranslations = Pageable & {
  __typename?: 'NoomFlowTextTranslations';
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** An array of noom flow text translations. */
  textTranslations: Array<NoomFlowTextTranslation>;
  /** The total number of results that match the filtering criteria for the returned list. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for getting noom flow text translations. */
export type NoomFlowTextTranslationsFilterInput = {
  /** The creator of the text translation. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The configuration for paginating the filtered results. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Whether to only retrieve text translations for the English (United States) translation. */
  enUsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A search string to filter results that looks at the key and created_by. */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Whether the translation is shared across flows. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Text Translation Keys that are the unique identifiers for the text translations in flows. */
  textTranslationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The state of the translation. */
  translationState?: InputMaybe<NoomFlowTextTranslationStateType>;
  /** The uuid of the text translation to retrieve. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Full flow configuration after applying a diff overlay (for example after the apply-flow-diff mutation). */
export type NoomFlowWithDiffApplied = {
  __typename?: 'NoomFlowWithDiffApplied';
  /** JSON object text for the merged flow. */
  flowWithDiffAppliedAsJsonString?: Maybe<Scalars['String']['output']>;
};

/** Paginated list of flows. */
export type NoomFlows = Pageable & {
  __typename?: 'NoomFlows';
  /** Flow rows for the current page. */
  flows: Array<NoomFlow>;
  /** Metadata for fetching the next page of results, if applicable. */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Filter for listing flows in the admin. */
export type NoomFlowsFilterInput = {
  /** Cursor pagination for the result set. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** Filter by flow group name. */
  flowGroupName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by logical flow identifier. */
  flowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Matches name, identifier, and description (server-defined rules). */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Filter by lifecycle status; unset means all statuses unless policy constrains. */
  status?: InputMaybe<NoomFlowStatus>;
  /** Filter by instance uuid. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter by configuration version. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter for getting noom flows with text translation key in noom flow admin. */
export type NoomFlowsTextTranslationKeyFilterInput = {
  /** The configuration for paginating the filtered results. */
  cursorPagination?: InputMaybe<CursorPagination>;
  /** The text translation key to filter by. */
  key?: InputMaybe<Scalars['String']['input']>;
};

/** A user's preview Noom profile */
export type NoomUserPreviewProfile = {
  __typename?: 'NoomUserPreviewProfile';
  /** User's access code */
  accessCode: Scalars['String']['output'];
  /** User's display name */
  name: Scalars['String']['output'];
  /** URL to user's profile picture */
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
};

/** Earn a treat day for every N Noomcoins accumulated */
export type NoomcoinBasedEarning = {
  __typename?: 'NoomcoinBasedEarning';
  /** Number of Noomcoins required to earn one treat day */
  noomcoinsRequiredToEarnTreatDay: Scalars['Int']['output'];
};

/** A Noomcoin-gated capability, unlocked on reaching a level */
export enum NoomcoinCapability {
  NoomcoinRequirementEditing = 'NOOMCOIN_REQUIREMENT_EDITING',
  ToolPinning = 'TOOL_PINNING',
  TreatDay = 'TREAT_DAY'
}

/** Configuration for the Noomcoin feature */
export type NoomcoinConfig = {
  __typename?: 'NoomcoinConfig';
  /** Noomcoin levels, one entry per level */
  levels?: Maybe<Array<NoomcoinLevelConfig>>;
};

/** A Noomcoin level */
export enum NoomcoinLevel {
  Apprentice = 'APPRENTICE',
  Expert = 'EXPERT',
  Guru = 'GURU',
  Novice = 'NOVICE',
  Scholar = 'SCHOLAR',
  Wizard = 'WIZARD'
}

/** Definition of a single Noomcoin level */
export type NoomcoinLevelConfig = {
  __typename?: 'NoomcoinLevelConfig';
  /** The Noomcoin level */
  level: NoomcoinLevel;
  /** Minimum cumulative Noomcoin balance to reach this level */
  threshold: Scalars['Int']['output'];
  /** Capabilities unlocked on reaching this level */
  unlockedCapabilities: Array<NoomcoinCapability>;
};

export type NutrientGoalMetadata = {
  __typename?: 'NutrientGoalMetadata';
  /** Currently selected adjustment mode for this nutrient */
  adjustmentMode: AdjustmentMode;
  /** Amount of this nutrient recorded so far */
  lastRecorded?: Maybe<Scalars['Float']['output']>;
  /** Display order in the UI; lower values appear first */
  order?: Maybe<Scalars['Int']['output']>;
  /** Predefined target options available for this nutrient */
  targetOptions: Array<NutrientTargetOption>;
};

/**  Nutrient goals groups */
export enum NutrientGoalsGroup {
  Advanced = 'ADVANCED',
  Macro = 'MACRO',
  MacroAndAdvanced = 'MACRO_AND_ADVANCED',
  Unknown = 'UNKNOWN'
}

export type NutrientTargetInput = {
  /** Adjustment mode to set for this nutrient goal */
  adjustmentMode: AdjustmentMode;
  /** Macro monitoring only: full P/C/F calorie split (sum to 1.0) */
  macroTargetsPercentage?: InputMaybe<CalorieBudgetMacroTargetsInput>;
  /** Maximum nutrient intake bound */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum nutrient intake bound */
  min?: InputMaybe<Scalars['Float']['input']>;
  /** Display order in the UI; lower values appear first */
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type NutrientTargetOption = {
  __typename?: 'NutrientTargetOption';
  /** Adjustment mode this option represents */
  adjustmentMode: AdjustmentMode;
  /** Macro monitoring only: full P/C/F calorie split (sum to 1.0) */
  macroTargetsPercentage?: Maybe<CalorieBudgetMacroTargets>;
  /** Maximum nutrient intake bound */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum nutrient intake bound */
  min?: Maybe<Scalars['Float']['output']>;
};

/**
 *  These values should be aligned with:
 *  - macros.proto (NutritionBreakdownProto)
 */
export type NutritionBreakdown = {
  __typename?: 'NutritionBreakdown';
  calciumMg?: Maybe<Scalars['Float']['output']>;
  carbohydrateMg?: Maybe<Scalars['Float']['output']>;
  dietaryFiberMg?: Maybe<Scalars['Float']['output']>;
  potassiumMg?: Maybe<Scalars['Float']['output']>;
  proteinMg?: Maybe<Scalars['Float']['output']>;
  saturatedFatsMg?: Maybe<Scalars['Float']['output']>;
  sodiumMg?: Maybe<Scalars['Float']['output']>;
  sugarMg?: Maybe<Scalars['Float']['output']>;
  totalFatMg?: Maybe<Scalars['Float']['output']>;
};

/**
 *  These values should be aligned with:
 *  - macros.proto (NutritionBreakdownProto)
 */
export type NutritionBreakdownInput = {
  calciumMg?: InputMaybe<Scalars['Float']['input']>;
  carbohydrateMg?: InputMaybe<Scalars['Float']['input']>;
  dietaryFiberMg?: InputMaybe<Scalars['Float']['input']>;
  potassiumMg?: InputMaybe<Scalars['Float']['input']>;
  proteinMg?: InputMaybe<Scalars['Float']['input']>;
  saturatedFatsMg?: InputMaybe<Scalars['Float']['input']>;
  sodiumMg?: InputMaybe<Scalars['Float']['input']>;
  sugarMg?: InputMaybe<Scalars['Float']['input']>;
  totalFatMg?: InputMaybe<Scalars['Float']['input']>;
};

/** Over-the-counter treatment card. */
export type OtcTreatmentOverview = TreatmentOverview & {
  __typename?: 'OTCTreatmentOverview';
  actionLinks: Array<TreatmentActionLink>;
  chatWithDoctorDeeplink?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  isMedicationLogSupported?: Maybe<Scalars['Boolean']['output']>;
  productBackgroundColor?: Maybe<Scalars['String']['output']>;
  productIconUrl?: Maybe<Scalars['String']['output']>;
  productImageUrl: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  /** Date the OTC product was purchased. */
  purchaseDate: Scalars['LocalDate']['output'];
  /** Current status of the OTC order. Null when the treatment is in an unrecognized state. */
  status?: Maybe<OtcTreatmentStatus>;
  treatmentCode: Scalars['String']['output'];
  treatmentName: Scalars['String']['output'];
};

/** Status union for OTC treatments. Each variant carries the data specific to that state and composes the treatment card UI. */
export type OtcTreatmentStatus = TreatmentOverviewStatusDelivered | TreatmentOverviewStatusReplacementShipped | TreatmentOverviewStatusShipped | TreatmentOverviewStatusShippingSoon;

/** The type of offer flow */
export enum OfferFlowType {
  /** Med product switch - user switching from one med subscription to another */
  MedProductSwitch = 'MED_PRODUCT_SWITCH',
  /** Post-checkout upsell flow */
  PostCheckoutUpsell = 'POST_CHECKOUT_UPSELL',
  Unknown = 'UNKNOWN'
}

/**
 * The kind of offer backing an ad.
 * Maps to OfferTypeEnumProto.Value in noom_contracts/offers/ads/shared.proto.
 */
export enum OfferType {
  /** The ad is backed by a billing product group. */
  ProductGroupOffer = 'PRODUCT_GROUP_OFFER',
  /** The ad is backed by a billing product. */
  ProductOffer = 'PRODUCT_OFFER',
  Unknown = 'UNKNOWN'
}

/** Result of opting in to a feature set. */
export type OptInToFeatureSetResult = {
  __typename?: 'OptInToFeatureSetResult';
  /** Whether the opt-in was successfully processed */
  success: Scalars['Boolean']['output'];
};

/** Result of opting out of a feature set. */
export type OptOutOfFeatureSetResult = {
  __typename?: 'OptOutOfFeatureSetResult';
  /** Whether the opt-out was successfully processed */
  success: Scalars['Boolean']['output'];
};

/** A single discount entry in the discounts list. */
export type OrderDiscountEntry = {
  __typename?: 'OrderDiscountEntry';
  /** ID of the B2B consumer discount. Populated if the discount source is B2B. */
  b2bConsumerDiscountId?: Maybe<Scalars['Int']['output']>;
  /** The discount effect (fixed amount or percentage). For fixed discounts, percentageDiscountConvertedToFixed is available on OrderFixedDiscount. */
  discountEffect: OrderDiscountType;
  /** The promo code used for the discount. Populated if the discount source is a promo code. */
  promoCode?: Maybe<Scalars['String']['output']>;
};

export type OrderDiscountSummary = {
  __typename?: 'OrderDiscountSummary';
  /**
   * ID of the B2B consumer discount that resulted in this discount, if applicable
   * @deprecated Use discounts field instead
   */
  b2bConsumerDiscountId?: Maybe<Scalars['Int']['output']>;
  /**
   * The type of the discount that will be applied
   * @deprecated Use discounts field instead
   */
  discount?: Maybe<OrderDiscountType>;
  /** Ordered list of discounts. Use instead of the deprecated top-level fields. */
  discounts: Array<OrderDiscountEntry>;
  /**
   * The promo code used for the discount. If not populated, then b2bConsumerDiscountId must be populated.
   * @deprecated Use discounts field instead
   */
  promoCode?: Maybe<Scalars['String']['output']>;
};

/** The type of the discount that will be applied */
export type OrderDiscountType = OrderFixedDiscount | OrderPercentageDiscount;

export type OrderFixedDiscount = {
  __typename?: 'OrderFixedDiscount';
  /** The fixed discount amount */
  amount: Money;
  /** If true, this discount was originally a percentage discount, but converted to a fixed amount from a switch order */
  percentageDiscountConvertedToFixed: Scalars['Boolean']['output'];
};

/** Union type for different order operations (purchase, switch, etc.) */
export type OrderOperation = PurchaseOperation | SwitchOperation;

export type OrderPercentageDiscount = {
  __typename?: 'OrderPercentageDiscount';
  /** The discount percentage */
  percentage: Scalars['String']['output'];
};

export type Pageable = {
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** B2B partner information. */
export type PartnerInfo = {
  __typename?: 'PartnerInfo';
  /** Partner display name. */
  displayName: Scalars['String']['output'];
  /** Internal partner identifier. */
  partnerId: Scalars['Int']['output'];
};

/**  Encapsulates a partner + partner user id mapping for a user. */
export type PartnerMapping = {
  __typename?: 'PartnerMapping';
  partnerSlug: PartnerSlug;
  partnerUserId: Scalars['String']['output'];
};

/**
 *  Supported partners that we store external user ids for.
 *  Keep in sync with user_partner_mapping.proto
 */
export enum PartnerSlug {
  MdIntegrations = 'MD_INTEGRATIONS',
  Sendbird = 'SENDBIRD',
  Singular = 'SINGULAR',
  SteadyMd = 'STEADY_MD',
  Zumba = 'ZUMBA'
}

/** Partner user account details provided for providers stored in PartnerUserAccount. */
export type PartnerUserAccountDetails = {
  __typename?: 'PartnerUserAccountDetails';
  /** Unique identifier used to connect users to the partner mobile solution. */
  mobileToken?: Maybe<Scalars['String']['output']>;
  /** Noom's Organization ID in the partner system associated with the user. */
  orgId?: Maybe<Scalars['String']['output']>;
};

export type PastMedicationDose = {
  __typename?: 'PastMedicationDose';
  /** Dose strength */
  dose: Scalars['Float']['output'];
  /** Server-calculated integer syringe injection units */
  doseSyringeUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether the logged dose matches the calculated SmartDose at
   * the time that the medication was logged
   */
  isSmartDose?: Maybe<Scalars['Boolean']['output']>;
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
  /** Side-effects */
  sideEffects: Array<MedicationSideEffect>;
  /** When the medication was taken */
  takenOn: Scalars['LocalDateTime']['output'];
  /** Dose units */
  unit: DoseUnits;
};

/**  Past medication doses that user has taken */
export type PastMedicationDoseList = {
  __typename?: 'PastMedicationDoseList';
  /** Message to display on the past medications page if not null.  Supports markdown. */
  footerText?: Maybe<Scalars['String']['output']>;
  /** Metadata for fetching the next page of past medication doses, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** List of past medication doses */
  pastDoses: Array<PastMedicationDose>;
};

export type PatchToolsState = {
  toolsStatesPatch: Array<ToolStatePatch>;
};

export type PatientDiagnosticReportList = {
  __typename?: 'PatientDiagnosticReportList';
  /** List of user's diagnostic reports, in reverse order of time collected */
  patientDiagnosticReports: Array<PatientDiagnosticReportMetadata>;
};

/** Encapsulates the data for a single diagnostic report */
export type PatientDiagnosticReportMetadata = {
  __typename?: 'PatientDiagnosticReportMetadata';
  /** AI summary of the diagnostic report result, only for the latest result */
  aiSummary?: Maybe<Scalars['String']['output']>;
  /** URL of the diagnostic report */
  diagnosticReportUrl: Scalars['String']['output'];
  /** Unique identifier of the diagnostic report */
  id: Scalars['String']['output'];
  /** Lab order ID; use with presignedLabReportUrl to get a download URL (presigned URLs expire). Null when the diagnostic report has no associated lab order. */
  labOrderId?: Maybe<Scalars['String']['output']>;
  /** Time at which the diagnostic was performed on the user */
  timeCollected: Scalars['LocalDateTime']['output'];
};

/**
 * A single lab order placed for a patient. Mirrors the healthcare `LabOrderProto`
 * returned by `GET /lab/v1/patient/{accessCode}/orders`.
 */
export type PatientLabOrder = {
  __typename?: 'PatientLabOrder';
  /** Patient access code that owns this lab order. */
  accessCode: Scalars['String']['output'];
  /** Additional structured information (errors, replacement / cancellation metadata, context). */
  additionalInfo?: Maybe<PatientLabOrderAdditionalInfo>;
  /** Clinician vendor encounter identifier (when the order was tied to an encounter). */
  externalEncounterId?: Maybe<Scalars['String']['output']>;
  /** Internal lab order identifier (use with `cancelLabOrder` / `presignedLabReportUrl`). */
  id: Scalars['String']['output'];
  /** How the lab test input is collected (at-home kit vs in-lab draw). */
  inputCollectionMechanism: LabOrderInputCollectionMechanism;
  /** Internal drug ID from the prescription catalog. */
  internalDrugId: Scalars['String']['output'];
  /** Vendor kit identifier. */
  kitId: Scalars['String']['output'];
  /** Lab service provider that fulfills the order. */
  labServiceProvider: LabServiceProvider;
  /** When this is a replacement, the ID of the original (replaced) lab order. */
  originalLabOrderId?: Maybe<Scalars['String']['output']>;
  /** Provider SKU for the lab test (e.g. initial vs refill); null when the SKU is unknown. */
  providerSku?: Maybe<BloodTestSku>;
  /** Associated shipments. Only populated when `includeShipments` is true on the query. */
  shipments?: Maybe<Array<PatientLabShipment>>;
  /** Current lifecycle status of the lab order. */
  status: LabOrderStatus;
  /** Time the lab order was created. */
  timeCreated: Scalars['LocalDateTime']['output'];
  /** Time the lab order was last updated. */
  timeUpdated: Scalars['LocalDateTime']['output'];
};

/** Structured supplementary information attached to a lab order. */
export type PatientLabOrderAdditionalInfo = {
  __typename?: 'PatientLabOrderAdditionalInfo';
  /** Cancellation metadata when this order is being / has been cancelled. Mutually exclusive with `replacementInfo`. */
  cancellationInfo?: Maybe<PatientLabOrderOperationInfo>;
  /** Lifecycle context of this lab order (e.g. PH_INITIAL, OTC_ONE_TIME). Null when unknown. */
  context?: Maybe<LabOrderContext>;
  /** Most recent error from a vendor webhook or failed API call. Null when none. */
  errorInfo?: Maybe<PatientLabOrderErrorInfo>;
  /** Replacement metadata when this order has been replaced. Mutually exclusive with `cancellationInfo`. */
  replacementInfo?: Maybe<PatientLabOrderOperationInfo>;
};

/** Error metadata recorded on a lab order from a vendor webhook or failed API call. */
export type PatientLabOrderErrorInfo = {
  __typename?: 'PatientLabOrderErrorInfo';
  /** Human-readable error reason or message. */
  reason: Scalars['String']['output'];
  /** Whether the error is recoverable (e.g. retryable). Null when unspecified. */
  recoverable?: Maybe<Scalars['Boolean']['output']>;
  /** Source identifier for the error (e.g. `webhook:kit-issue`, `api:placement`). */
  source: Scalars['String']['output'];
  /** When the error was received or occurred. */
  timeOccurred?: Maybe<Scalars['LocalDateTime']['output']>;
};

/** List of lab orders for a patient, in reverse chronological order of creation. */
export type PatientLabOrderList = {
  __typename?: 'PatientLabOrderList';
  /** Lab orders, ordered by `timeCreated` descending (most recent first). */
  labOrders: Array<PatientLabOrder>;
};

/** Replacement or cancellation operation metadata recorded on a lab order. */
export type PatientLabOrderOperationInfo = {
  __typename?: 'PatientLabOrderOperationInfo';
  /** Human-readable reason for the operation. */
  reason: Scalars['String']['output'];
  /** Structured replacement reason (replacement only); null for cancellations or when unspecified. */
  replacementReason?: Maybe<LabOrderReplacementReason>;
  /** When the operation was requested. */
  timeRequested: Scalars['LocalDateTime']['output'];
};

/** Information about a single shipment associated with a lab order. */
export type PatientLabShipment = {
  __typename?: 'PatientLabShipment';
  /** Direction of the shipment (kit out to patient, sample back to lab). */
  direction: LabOrderShipmentDirection;
  /** Vendor's external order ID for this shipment. */
  externalOrderId?: Maybe<Scalars['String']['output']>;
  /** Current shipment status. */
  status: PrescriptionOrderStatus;
  /** Time the shipment record was created. */
  timeCreated: Scalars['LocalDateTime']['output'];
  /** Time the shipment record was last updated. */
  timeUpdated: Scalars['LocalDateTime']['output'];
  /** Tracking carrier (e.g. USPS, UPS, FedEx). Null when not yet available. */
  trackingCarrier?: Maybe<Scalars['String']['output']>;
  /** Tracking number for the shipment. Null when not yet available. */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Tracking URL for the shipment. Null when not yet available. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Integration type for the pharmacy handling an Rx order (e.g. Direct vs. DoseSpot). */
export enum PharmacyIntegrationType {
  /** The pharmacy is integrated directly. */
  Direct = 'DIRECT',
  /** The pharmacy is integrated via DoseSpot. */
  Dosespot = 'DOSESPOT',
  /** Unknown integration type. */
  Unknown = 'UNKNOWN'
}

/**
 * A single placement's ranked ads plus placement-level content.
 * Maps to PlacementAdsProto in noom_contracts/offers/ads/api/ad_service.proto.
 */
export type PlacementAds = {
  __typename?: 'PlacementAds';
  /** Ranked ads for this placement. Empty when no ads are returned. */
  ads: Array<Ad>;
  /** Placement-level content (e.g. carousel section metadata). Null when not set. */
  placementContent?: Maybe<PlacementAdsContent>;
  /** Stable placement identifier (e.g. home_carousel). */
  placementName: Scalars['String']['output'];
};

/**
 * Union of placement-level content types.
 * Maps to PlacementAdsProto.placement_content oneof in noom_contracts/offers/ads/api/ad_service.proto.
 */
export type PlacementAdsContent = CarouselSectionContent;

/**
 * Response for a single-placement ads query.
 * Maps to ListPlacementAdsResponseProto in noom_contracts/offers/ads/api/ad_service.proto.
 */
export type PlacementAdsResponse = {
  __typename?: 'PlacementAdsResponse';
  /** Ads bucket for the requested placement. Null when not set by the server. */
  placement?: Maybe<PlacementAds>;
};

/**
 * Response for a placement-group ads query.
 * Maps to ListPlacementGroupAdsResponseProto in noom_contracts/offers/ads/api/ad_service.proto.
 */
export type PlacementGroupAdsResponse = {
  __typename?: 'PlacementGroupAdsResponse';
  /** One bucket per constituent placement, in group-defined render order. */
  placements: Array<PlacementAds>;
};

/** A resource in the plateau resources screen. */
export type PlateauResource = {
  __typename?: 'PlateauResource';
  /** Button associated with this resource. */
  button: Button;
  /** URL of the image for this resource. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Title of this plateau resource. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 *  Naming convention is the state/province (if applicable) underscore the
 *  recognized acronym for the act. Since the acronym can often be confusing,
 *  prefixing with the state makes it clearer where the policy is applicable.
 */
export enum Policy {
  /**  Ash at-home test consent */
  AshAtHomeTest = 'ASH_AT_HOME_TEST',
  CaCcpa = 'CA_CCPA',
  CoCpa = 'CO_CPA',
  /**
   *  Value representing the CTDPA before it was amended by S.B. 3 (below). The
   *  old value will still be returned by reads, but shouldn't be used in new
   *  policy option writes.
   */
  CtCtdpa = 'CT_CTDPA',
  /**
   *  Connecticut S.B. 3 amended the CTDPA, increasing its breadth and causing
   *  it to apply to an account rather than just an email address.
   */
  CtSb3 = 'CT_SB3',
  /**
   *  This handles users who have opted out, but for whatever reason we are not
   *  sure from where. Largely this will contain users from before we started
   *  keeping track.
   */
  General = 'GENERAL',
  /**  GINA / ADA authorization */
  GinaAda = 'GINA_ADA',
  NoomB2BPp = 'NOOM_B2B_PP',
  NoomB2CPp = 'NOOM_B2C_PP',
  NoomHipaaNotice = 'NOOM_HIPAA_NOTICE',
  NoomLiabilityWaiver = 'NOOM_LIABILITY_WAIVER',
  /**  Noom internal policies */
  NoomTos = 'NOOM_TOS',
  NvSb370 = 'NV_SB370',
  /**  SMS engagement message consent */
  SmsConsent = 'SMS_CONSENT',
  /**
   *  Patient Restriction on Medicare Claim Submition Terms. Allow us to keep
   *  track when patient is presented this terms to indicate he can't bill
   *  medicare (US Only)
   */
  UsPrmcst = 'US_PRMCST',
  UtUcpa = 'UT_UCPA',
  VaVcdpa = 'VA_VCDPA',
  WaMhmd = 'WA_MHMD'
}

/**  Please keep in-sync with StatusEnumProto */
export enum PolicyOptionStatus {
  Agree = 'AGREE',
  DidNotAgree = 'DID_NOT_AGREE',
  NotNeeded = 'NOT_NEEDED',
  OptInMayShare = 'OPT_IN_MAY_SHARE',
  OptOutDoNotShare = 'OPT_OUT_DO_NOT_SHARE'
}

/**
 *  These values should be aligned with:
 *  - food.proto (PortionProto)
 */
export type Portion = {
  __typename?: 'Portion';
  quantity: Scalars['Float']['output'];
  totalCalories?: Maybe<Scalars['Float']['output']>;
  unitName: Scalars['String']['output'];
  unitType: PortionUnitType;
};

export type PortionInput = {
  /** Quantity */
  quantity: Scalars['Float']['input'];
  /** Total calories for this portion */
  totalCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Unit name */
  unitName: Scalars['String']['input'];
  /** Unit type (easy or precise) */
  unitType: PortionUnitType;
};

export enum PortionUnitType {
  Easy = 'EASY',
  Precise = 'PRECISE',
  Unknown = 'UNKNOWN'
}

export enum PreferredWeightUnit {
  Kg = 'KG',
  Lb = 'LB',
  Stone = 'STONE'
}

/** Status of a lab/prescription shipment, mirrors `PrescriptionOrderStatusEnumProto.Status`. */
export enum PrescriptionOrderStatus {
  /** Order has been delivered to the patient. */
  Delivered = 'DELIVERED',
  /** Order entered an error state during fulfillment. */
  Error = 'ERROR',
  /** Order is being prepared for shipment by the fulfillment partner. */
  Preparing = 'PREPARING',
  /** Prescription/order has been recorded but not yet prepared. */
  Prescribed = 'PRESCRIBED',
  /** Order was reshipped (e.g. after a delivery failure). */
  Reshipped = 'RESHIPPED',
  /** Order has been shipped; tracking information available. */
  Shipped = 'SHIPPED',
  /** Default unknown value. */
  Unknown = 'UNKNOWN',
  /** Order was voided / canceled. */
  Voided = 'VOIDED'
}

/** Represents a prescription refill record */
export type PrescriptionRefill = {
  __typename?: 'PrescriptionRefill';
  /** The patient the refill belongs to */
  accessCode: Scalars['String']['output'];
  /** Unique identifier for the scheduled refill */
  id: Scalars['Int']['output'];
  /** Date on which the refill should be processed */
  refillDate: Scalars['LocalDate']['output'];
};

export type PrismBodyScanAttributionDataInput = {
  /** Prism body scan identifier. */
  bodyScanUuid: Scalars['String']['input'];
};

/**
 * Variant of PrismBodyScanAttributionDataInput with all fields optional for matching.
 * Keep in sync with PrismBodyScanAttributionDataInput.
 */
export type PrismBodyScanAttributionDataMatchInput = {
  /** Prism body scan identifier. */
  bodyScanUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the collection of product listings available to the user */
export type ProductListingCatalog = {
  __typename?: 'ProductListingCatalog';
  /** A list of available charitable donations */
  charitableDonations?: Maybe<Array<CharitableDonationProductListing>>;
  /** In-app action for purchasing a streak freeze */
  engagementStreakFreeze?: Maybe<EngagementStreakFreezeProductListing>;
  /** In-app action for repairing an engagement streak */
  engagementStreakRepair?: Maybe<EngagementStreakRepairProductListing>;
  /** A list of available gift cards */
  giftCards?: Maybe<Array<GiftCardProductListing>>;
};

export enum ProductListingValidationErrorReason {
  /** Balance is insufficient to redeem the list of products */
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  /** List of product listings for redemption is empty or invalid */
  InvalidProductListingList = 'INVALID_PRODUCT_LISTING_LIST',
  /** Provided target date is not valid for redemption */
  InvalidTargetDate = 'INVALID_TARGET_DATE',
  /** Requirements for product redemption not met */
  ProductNotEligible = 'PRODUCT_NOT_ELIGIBLE',
  /** Default value, we set this to avoid making assumptions the reason is undefined */
  Unknown = 'UNKNOWN',
  /** Request for product listing is currently not supported by rewards */
  UnsupportedProductListingRequest = 'UNSUPPORTED_PRODUCT_LISTING_REQUEST'
}

/** Represents a single product offer with its order operation and purchase type */
export type ProductOffer = {
  __typename?: 'ProductOffer';
  /** Pre-built order operation for this product. Can be one of PurchaseOperation, SwitchOperation, etc. */
  orderOperation: OrderOperation;
  /** Product name as defined in Product Catalog */
  productName: Scalars['String']['output'];
  /** Purchase type (subscription or one-time purchase) */
  purchaseType: PurchaseType;
};

/** Context describing the origin and intent of the product offer request */
export type ProductOffersContext = {
  /** A list of contexts the user has encountered with experiment arms and SHAs */
  experiments?: InputMaybe<Array<MeristemExperimentInfo>>;
  /** The offer flow type for this request */
  offerFlowType?: InputMaybe<OfferFlowType>;
  /** The route ID from buyflow. Identifies which page/route is requesting offers. */
  routeId?: InputMaybe<Scalars['String']['input']>;
  /** URL tracking parameters (UTM params, referrer, etc.) */
  trackingParams?: InputMaybe<TrackingParams>;
  /** The upsell ad identifier. Used when offers are requested for a specific ad placement. */
  upsellAdIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Input for getting product offers */
export type ProductOffersInput = {
  /** Access code of the user. Optional - when provided, returns user-specific eligible products. */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Context about where/why the request is being made */
  context?: InputMaybe<ProductOffersContext>;
};

/** Response containing product offers */
export type ProductOffersResponse = {
  __typename?: 'ProductOffersResponse';
  /** Array of resolved product offers matching the context criteria */
  offers: Array<ProductOffer>;
};

/** Represents an individual product order */
export type ProductOrder = {
  /** Product identifier for redemption */
  productSlug: Scalars['String']['input'];
  /** Amount of the product for redemption */
  quantity: Scalars['Int']['input'];
};

/** Represents a failed product redemption state */
export type ProductRedemptionFailure = {
  __typename?: 'ProductRedemptionFailure';
  /** Reason why the redemption failed */
  reason: ProductListingValidationErrorReason;
};

/** Represents the union between the possible states when redeeming a product */
export type ProductRedemptionResult = ProductRedemptionFailure | ProductRedemptionSuccessful;

/** Represents a successful product redemption state */
export type ProductRedemptionSuccessful = {
  __typename?: 'ProductRedemptionSuccessful';
  /** List of successful product results */
  productResults?: Maybe<Array<ProductResult>>;
  /** Amount spent for the product redemption transaction */
  totalAmountSpent: RewardsMoney;
};

/** Result of a successful product redemption */
export type ProductResult = StreakFreezeResult | StreakRepairResult;

/** All orders for a single product. */
export type ProductShipmentHistory = {
  __typename?: 'ProductShipmentHistory';
  /** All orders for this product, most recent first. */
  orders: Array<ShipmentOrder>;
  /** User-facing product name (e.g. 'Compounded Semaglutide'). */
  productName: Scalars['String']['output'];
};

/** Product Switch Offer Info */
export type ProductSwitchOffer = {
  __typename?: 'ProductSwitchOffer';
  /** Defines whether product switch is possible in next billing cycle */
  isNextBillingCycleSwitch: Scalars['Boolean']['output'];
  /** Actual price */
  price: Money;
  /** Product name */
  productName: Scalars['String']['output'];
  /** Product saleItemId */
  saleItemId: Scalars['ID']['output'];
  /** The switch operation to execute for switching to this product */
  switchOperation?: Maybe<SwitchOperation>;
  /** Actual trial price if trialSaleItemId present */
  trialPrice?: Maybe<Money>;
  /** Product trial saleItemId if present */
  trialSaleItemId?: Maybe<Scalars['ID']['output']>;
};

/** Product Switch Offers Response */
export type ProductSwitchOffersResponse = {
  __typename?: 'ProductSwitchOffersResponse';
  /** Product switch offers user is eligible for */
  offers: Array<ProductSwitchOffer>;
};

/** Definition of a Foundation within a program */
export type ProgramFoundation = {
  __typename?: 'ProgramFoundation';
  /** An optional description of the foundation */
  description?: Maybe<Scalars['String']['output']>;
  /** Which actions a curriculum editor can take on this object */
  editorActionDetails: CurriculumEditorActionsDetails;
  /** The id of the foundation */
  id: Scalars['UUID']['output'];
  /** Foundation metadata */
  metadata: ProgramFoundationMetadata;
  /** An ordered list of module objects. Only included if explicity requested */
  modules?: Maybe<Array<CurriculumModule>>;
  /** Foundation name */
  name: Scalars['String']['output'];
  /** The ID of the program this foundation belongs to */
  programConfigId: Scalars['UUID']['output'];
  /** The user segment ids that defines who this foundation applies to */
  userSegmentation?: Maybe<ProgramFoundationUserSegmentation>;
};

export type ProgramFoundationInput = {
  /** An optional description to give this foundation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ordered list of module IDs for this foundation */
  moduleIds: Array<Scalars['UUID']['input']>;
  /** The name to give the foundation */
  name: Scalars['String']['input'];
  /** User segmentation ids and operator defining membership to this foundation */
  userSegmentation?: InputMaybe<ProgramFoundationUserSegmentationInput>;
};

export type ProgramFoundationMetadata = {
  __typename?: 'ProgramFoundationMetadata';
  /** User details of the user that created this foundation */
  createdBy: ProgramFoundationUserDetails;
  /** The date and time this foundation was first created */
  createdOn: Scalars['LocalDateTime']['output'];
  /** Whether or not this foundation has unpublished (i.e. draft) changes */
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  /** Whether or not this foundation is in a published state */
  isLive: Scalars['Boolean']['output'];
  /** User details of the user that most recently modified the foundation */
  updatedBy: ProgramFoundationUserDetails;
  /** The date and time this foundation was most recently modified */
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type ProgramFoundationUserDetails = {
  __typename?: 'ProgramFoundationUserDetails';
  /** The first name of the user that created this foundation */
  firstName: Scalars['String']['output'];
  /** The last name of the user that created this foundation */
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The segment IDs and logical operator defining how to evaluate the user against those segments */
export type ProgramFoundationUserSegmentation = {
  __typename?: 'ProgramFoundationUserSegmentation';
  /** The segment ids */
  ids: Array<Scalars['ID']['output']>;
  /** The logical operator defining how the segment ids should be evaluated with eachother */
  operator: ProgramFoundationUserSegmentationOperator;
};

/** Inputs for defining the user segmentation for the foundation */
export type ProgramFoundationUserSegmentationInput = {
  /** The usermodel segment ids */
  ids: Array<Scalars['ID']['input']>;
  /** The operator/condition defining how the segment ids should be evaluated together */
  operator: ProgramFoundationUserSegmentationOperator;
};

/** User segmentation operators defining how segments should be evaluated together */
export enum ProgramFoundationUserSegmentationOperator {
  /** The user must belong to each segment represented in the list */
  And = 'AND',
  /** The user must belong to at least one of the segments in the list */
  Or = 'OR'
}

export type ProgramFoundations = {
  __typename?: 'ProgramFoundations';
  foundations: Array<ProgramFoundation>;
};

/** Program identity information for the Care Tab header. */
export type ProgramInfo = {
  __typename?: 'ProgramInfo';
  /** Stable identifier for the top bar program title. Null when not configured. */
  headerTitleKey?: Maybe<Scalars['String']['output']>;
};

/** Wrapper type for the program progress response */
export type ProgramProgress = {
  __typename?: 'ProgramProgress';
  /** List of modules in the user's program with their progress */
  modules: Array<ProgramProgressModule>;
  /** The current user status in the program */
  userStatus?: Maybe<ProgramProgressUserStatus>;
};

/**
 * Curriculum feature types that can be part of a tool.
 * Matches CurriculumFeatureProto.Value from noom_contracts/content/curriculum/curriculum_feature.proto
 */
export enum ProgramProgressCurriculumFeature {
  /** Exercise-related curriculum feature */
  Exercise = 'EXERCISE',
  /** Reading lessons/articles as a curriculum feature */
  Lessons = 'LESSONS',
  /** Movement-related curriculum feature */
  Move = 'MOVE',
  /** Unknown or unspecified curriculum feature */
  Unknown = 'UNKNOWN'
}

/** Deep link type indicating navigation destination */
export type ProgramProgressDeepLink = ModuleLibraryDeepLink | RecommendationsDeepLink;

/** A module within the user's curriculum program with progress information */
export type ProgramProgressModule = {
  __typename?: 'ProgramProgressModule';
  /** Code of the module, as combination of level and module ordinal, e.g. 101 */
  code?: Maybe<Scalars['String']['output']>;
  /** Color of the level the module belongs to in hex format of form '#RRGGBB' or '#AARRGGBB' */
  color?: Maybe<Scalars['String']['output']>;
  /** Course pack data associated with this module */
  coursePack?: Maybe<CoursePack>;
  /** Description of the module */
  description: Scalars['String']['output'];
  /** Color of the module if it has not yet been completed */
  dimmedColor?: Maybe<Scalars['String']['output']>;
  /** An http(s) URL of the icon that represents this module */
  iconUrl: Scalars['String']['output'];
  /** This flag indicates if the current module is a sentinel, denoting the end of the program */
  isEndSentinelModule: Scalars['Boolean']['output'];
  /** 1-based index of level this module belongs to in the list of levels */
  levelOrdinal?: Maybe<Scalars['Int']['output']>;
  /** Module completion percentage expressed as a number between 0 and 1 */
  moduleCompletion?: Maybe<Scalars['Float']['output']>;
  /** Graduation details shown when the user completes the module */
  moduleGraduation?: Maybe<ProgramProgressModuleGraduation>;
  /** Unique identifier for the module */
  moduleId: Scalars['ID']['output'];
  /** IDs of modules that come after this module in program progress */
  nextModuleIds: Array<Scalars['ID']['output']>;
  /** Display title of the module */
  title: Scalars['String']['output'];
  /** List of tools that the user will engage with during their curriculum progress */
  tools: Array<ProgramProgressTool>;
};

/** Graduation details displayed when a user completes a module */
export type ProgramProgressModuleGraduation = {
  __typename?: 'ProgramProgressModuleGraduation';
  /** An http(s) URL of the animation to show as part of graduation */
  animationUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the graduation confirmation/dismiss button */
  confirmationTitle?: Maybe<Scalars['String']['output']>;
  /** Description of the graduation, broken into paragraphs */
  descriptions: Array<Scalars['String']['output']>;
  /** Title to show as part of graduation */
  title: Scalars['String']['output'];
};

/**
 * A tool represents an entity that a user will engage with during their curriculum progress.
 * A tool can be either a curriculum feature (like lessons) or a tracker (like meal logging).
 * Matches ToolProto from noom_contracts/content/curriculum/tool.proto
 */
export type ProgramProgressTool = CurriculumFeatureTool | TrackerTool;

/** User's current status in the curriculum program */
export type ProgramProgressUserStatus = {
  __typename?: 'ProgramProgressUserStatus';
  /** ID of the module the user is currently enrolled in */
  currentModuleId?: Maybe<Scalars['ID']['output']>;
  /** Deep link indicating where the user should navigate */
  deepLink?: Maybe<ProgramProgressDeepLink>;
  /**
   * Used by mobile clients to show a banner in the module library informing
   * users they have to retake a module because they completed all modules.
   */
  showModuleRetakeBanner: Scalars['Boolean']['output'];
};

/** App bar configuration for the Progress screen. */
export type ProgressAppBar = {
  __typename?: 'ProgressAppBar';
  /** Navigation icon to display on the left side of the app bar. When absent, the client displays no navigation icon. */
  navigationIcon?: Maybe<ProgressAppBarNavigationIcon>;
  /** Title area for the app bar. */
  title: ProgressAppBarTitle;
};

/** Supported navigation icon variants for the Progress screen app bar */
export enum ProgressAppBarNavigationIcon {
  /** Settings ingress icon */
  Settings = 'SETTINGS',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/** Title area variants for the Progress screen app bar */
export enum ProgressAppBarTitle {
  /** Default text title (e.g. the screen name) */
  DefaultText = 'DEFAULT_TEXT',
  /** Standard Noom logo */
  NoomLogo = 'NOOM_LOGO',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/** Represents the Progress screen presentation. */
export type ProgressScreen = {
  __typename?: 'ProgressScreen';
  /** App bar configuration for the Progress screen. When no value is provided, the client uses the default implementation. */
  appBar?: Maybe<ProgressAppBar>;
  /** Tabs are provided in display order. */
  tabs: Array<ProgressTab>;
};

/** A tab which may be displayed on the Progress screen */
export type ProgressTab = {
  __typename?: 'ProgressTab';
  /** Selected tab variant (exclusive union of supported tab types) */
  tab: ProgressTabVariant;
};

/** Union of supported tab variants */
export type ProgressTabVariant = CourseMapTab | HealthInsightsTab | TrendsTab;

/** The prorated refund computed for a subscription's latest charge. */
export type ProratedRefund = {
  __typename?: 'ProratedRefund';
  /** The prorated refund amount */
  refundAmount: Money;
  /** The time that was used to calculate this refund */
  refundTime: Scalars['DateTime']['output'];
};

/**
 * Determines how to handle billing for the remainder of the billing cycle.
 * If the user is getting the new plan for the remainder of their current
 * billing cycle, we must collect a portion of the new plan price proportional
 * to the length. In addition, there will be a refund for the unused portion
 * of the old plan.
 */
export enum ProrationBehavior {
  /**
   * No refunds or charges are made for the remainder of the billing cycle.
   * Note that this doesn't affect the charge if we're immediately starting
   * a new billing cycle.
   */
  None = 'NONE',
  /** Charge and refund for the remainder of the current billing cycle will be collected separately */
  SeparateChargeAndRefund = 'SEPARATE_CHARGE_AND_REFUND',
  UnspecifiedProrationBehavior = 'UNSPECIFIED_PRORATION_BEHAVIOR'
}

export type ProteinBar = {
  __typename?: 'ProteinBar';
  goalInGrams: Scalars['Float']['output'];
  valueInGrams: Scalars['Float']['output'];
};

export type ProteinGoalMetadata = {
  __typename?: 'ProteinGoalMetadata';
  minProtein?: Maybe<Scalars['Int']['output']>;
};

export type ProteinTarget = {
  minProtein?: InputMaybe<Scalars['Int']['input']>;
};

/** This is a superclass for other possible future configurations */
export type ProviderConfiguration = AnuraConfiguration;

/** Purchase operation containing sale item info and optional discount */
export type PurchaseOperation = {
  __typename?: 'PurchaseOperation';
  /** Optional discount to apply to the purchase */
  discountSummary?: Maybe<OrderDiscountSummary>;
  /** The sale item ID to purchase */
  saleItemId: Scalars['ID']['output'];
  /** Optional trial sale item ID if the user is getting a trial */
  trialSaleItemId?: Maybe<Scalars['ID']['output']>;
};

/** Type of purchase */
export enum PurchaseType {
  OneTimePurchase = 'ONE_TIME_PURCHASE',
  Subscription = 'SUBSCRIPTION',
  Unknown = 'UNKNOWN'
}

export type Query = {
  __typename?: 'Query';
  /** Get the currently active schedule for a CDU. */
  activeCduSchedule?: Maybe<CduScheduledWorkHours>;
  /**
   * Gets an AI meal insight for the user with their most recently logged meal as input.
   * @deprecated Use the mealInsight query instead.
   */
  aiMealInsight: AiMealInsight;
  /**
   * Returns the information needed by the client to draw a chart with the specified measurements and annotations.
   * - fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded
   * - Chronological or reverse chronological order is provided by the "from" and "to" dates: if "from" is earlier than "to",
   * then it will be in chronological order; and if "to" is earlier than "from", it will go in reverse chronological order
   * - You can also optionally limit by a maximum number of measurements and/or maximum number of annotations. Whatever
   * is reached earlier will set the limit of the graph, and no further measurements or annotations beyond those
   * will be provided (e.g. if we limit to 10 annotations, and the 10th annotation happens on a certain date, then no
   * annotations or measurements will be provided beyond that date, even if we still had a larger limit of
   * measurements). If not provided, they are each limited to 100. The maximum limit accepted is 500: if a higher
   * limit is provided, it will be ignored and 500 will be used. We still don't provide any mechanism for pagination,
   * so if you need more elements than that, please reach out to the Program Content team!
   */
  annotatedMeasurementTrendChart: AnnotatedMeasurementTrendChart;
  /** Returns the user's prescribed anti-obesity medications */
  antiObesityMedications: AntiObesityMedicationList;
  /**
   * Retrieves a specific art gallery by its unique id.
   * - `galleryId`: Unique identifier of the gallery to fetch
   */
  artGallery?: Maybe<ArtGallery>;
  /** Returns the applicable privacy policy for a health assessment */
  assessmentPrivacyPolicy: Policy;
  /** Returns the detailed health report for a specific assessment report. */
  assessmentReport: HealthReport;
  /** Returns metadata-level assessment reports for admin tooling. */
  assessmentReports: AssessmentReportMetadataList;
  /**
   * Get asset registry entries based on filter criteria.
   * Used by the noom flow admin for asset management.
   */
  assetRegistryEntries: AssetRegistryEntries;
  autocompleteAddress: AutocompleteAddressResponse;
  /** Returns the available target values for a specific user's goal. */
  availableTargets: AvailableTargetsResponse;
  /** Informs the client what all data points (if any) need to be gathered from the user when they enter the body scan feature */
  bodyScanIngress: BodyScanIngressChecks;
  /** Returns the applicable privacy policy for a user using the body scan feature */
  bodyScanPrivacyPolicy: Policy;
  /** Returns body scan settings for a given user */
  bodyScanSettings: BodyScanSettingsResponse;
  /** Returns the state of the user's active body scan at the given instant, or defaults to the current instant if none provided. */
  bodyScanTrackerState: BodyScanTrackerState;
  /** Returns a list of body scans for the user */
  bodyScans: BodyScanList;
  /**
   * Returns the full b.well health records card payload for the user.
   * Mobile clients use this to determine whether and how to render the
   * b.well entry card.
   */
  bwellCard: BwellCard;
  /** Returns the Care Tab notification state for a patient. */
  careTabNotification: CareTabNotification;
  /**
   * Get a paginated list of challenge variants (MicroChallenge or HabitStack) for a
   * category. Intended for load-more flows where the caller already holds a cursor
   * from a previous response (e.g. a category's first-page `pageInfo.nextPageCursor`).
   *
   * Pass the cursor from `MicroChallengeCategory.items.pageInfo.nextPageCursor`
   * together with the same `categoryId` to page through a category's items.
   *
   * `challengeTypes` filters which kinds of challenges are returned. When null or
   * omitted (e.g. by older clients that predate this parameter) the backend
   * returns only `TIME_BOUND` challenges for backwards compatibility. New clients
   * that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  categoryItems: MicroChallengeCategoryItemPage;
  /** List all PTO records for a CDU. */
  cduPtos: CduPersonalTimeOffList;
  /** List all schedules for a CDU. */
  cduSchedules: CduScheduledWorkHoursList;
  /** Queries a chat channel by id */
  chatChannel?: Maybe<ChatChannel>;
  /**
   * Returns the member inbox for the given user, containing ordered sections of
   * chat channels and a list of archived channels.
   */
  chatMemberInbox: ChatMemberInbox;
  /** Get the channel url for the clinician chat. */
  clinicianChannelUrl?: Maybe<Scalars['String']['output']>;
  /** Get one announcement */
  coachAnnouncement?: Maybe<CoachAnnouncement>;
  /** Get a list of announcements. The sorting order is the backend default */
  coachAnnouncements?: Maybe<CoachAnnouncementsResult>;
  coachAnnouncementsUserInteractions: CoachAnnouncementUserInteractionsPaged;
  coachAnnouncementsUserInteractionsInfo: CoachAnnouncementsUserInteractionInfo;
  /** Configs used by the coaching area */
  coachingConfig?: Maybe<CoachingConfig>;
  /** Configs that are user dependent */
  coachingConfigForUser?: Maybe<CoachingConfigForUser>;
  /** Checks if the user needs to (re)accept any agreements */
  consentCheck: UserConsentCheck;
  /** Returns content consumption state for a specific content type */
  contentConsumptionState: CurriculumContentConsumptionState;
  /** Returns modules that can be used to build a curriculum. */
  curriculumModules: CurriculumModules;
  /**
   * Returns all curricular programs with an optional list of modules that belong
   * to programs.
   *
   * Clients can control the results to be more or less granular using the provided filters.
   */
  curriculumPrograms: CurriculumPrograms;
  /**
   * Decodes the JWT for the given encoded JWT.
   * NOTE: This query will deprecated when /userinfo endpoint is available.
   */
  decodeJwt: JwtContents;
  /**
   * Decodes the JWT for the current user.
   * NOTE: This query will deprecated when /userinfo endpoint is available.
   */
  decodeJwtForCurrentUser: JwtContents;
  /** Returns the data necessary to render the Discoverability Promo card. Returns null if the feature is disabled or the user is ineligible. */
  discoverabilityPromoCard?: Maybe<DiscoverabilityPromoCard>;
  /** Returns the dynamic calorie goal settings for a user. */
  dynamicCalorieGoalSettingsState: DynamicCalorieGoalSettingsState;
  /** Returns whether the user is eligible to be displayed the WeightMedsSnapshot, depending on their med logging data */
  eligibleForWeightMedsSnapshot: Scalars['Boolean']['output'];
  /**
   * Returns whether the user is eligible to be displayed the WeightMedsSnapshot, depending on whether they have
   * the goal enabled for the appropriate Meds
   */
  eligibleForWeightMedsSnapshotBasedOnGoals: Scalars['Boolean']['output'];
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /** This endpoint return all mandatory documents that are signed during NMC enrolment */
  externalCoachingTermsAndConditions: ExternalCoachingTermsAndConditionsInfo;
  /**
   * Returns the state of the user's face scan task.
   * Access code is optional to enable easier testing. If no access code is given it will be taken from AuthTokenProvider
   */
  faceScanTask: FaceScanTask;
  /** Gets metadata needed for the facial blood scan introduction flow. */
  facialBloodScanIntroMetadata: FacialBloodScanIntroMetadata;
  /** Retrieves the questionnaire for a specified provider if exists */
  facialBloodScanQuestionnaire: FacialBloodScanQuestionnaire;
  /**
   * Returns statistics about the user's facial blood scans, including
   * total number of scans and the date of the last scan.
   */
  facialBloodScanStats: FacialBloodScanStats;
  /**
   * Returns the opt-in status for a feature set.
   * Called by the client to determine whether to show opt-in/opt-out UI.
   */
  featureOptInState: FeatureOptInState;
  /**
   * Returns which of the supplied phone-number contacts belong to Noom users who have opted
   * in to discoverability. The response echoes back clientContactId so the client can map
   * results to local address-book entries.
   */
  findFriendsByPhoneNumbers: FindFriendsByPhoneNumbersResponse;
  /**
   * Preflight check before findFriendsByPhoneNumbers. Returns whether the client
   * should send phone numbers and, when required, the server-side contact limit.
   */
  findFriendsByPhoneNumbersCallConfig: FindFriendsByPhoneNumbersCallConfig;
  /** Gets sections of fixed content for a user */
  fixedContentSections: Array<FixedContentSection>;
  /**
   * Query used to retrieve state data for all features that are part of the food logging experience
   * (e.g., meal logging method selector, glucose forecasting, etc.).
   *
   * It was decided that food logging–related features should be grouped into a single query,
   * so this should be used instead of mealLoggingMethodSelectorFeatureState.
   */
  foodLoggingFeaturesStates: FoodLoggingFeaturesStates;
  /**
   * DEPRECATED - Use bloodGlucoseForecastingFeatureStateV2 instead.
   *
   * Generates a personalized glucose forecast for a user by analyzing their historical
   * blood glucose patterns and predicting the impact of specified food items on their
   * glucose levels. Returns time series data showing projected glucose values and spike
   * classifications for each food item.
   */
  generateGlucoseForecast: GenerateGlucoseForecastResponse;
  /**
   * Second version of generateGlucoseForecast query. It includes a updated response type
   * that treats forecast unavailability as possible outcome instead of an error.
   *
   * Generates a personalized glucose forecast for a user by analyzing their historical
   * blood glucose patterns and predicting the impact of specified food items on their
   * glucose levels. Returns time series data showing projected glucose values and spike
   * classifications for each food item.
   */
  generateGlucoseForecastV2: GenerateGlucoseForecastResponseV2;
  /** Get an API key based on the input. */
  getApiKey: ApiKey;
  /**
   * Get micro challenge recommendations based on context.
   * Currently supports completion interstitial context, extensible for future surfaces.
   *
   * `challengeTypes` filters which kinds of recommended challenges are returned.
   * When null or omitted (e.g. by older clients that predate this parameter) the
   * backend returns only `TIME_BOUND` challenges for backwards compatibility. New
   * clients that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  getMicroChallengeRecommendations: MicroChallengeRecommendationsResponse;
  /**
   * Get a flat list of recommended challenges without requiring a specific recommendation context.
   * Simplified successor to `getMicroChallengeRecommendations`; V1 remains available for older clients.
   *
   * Unlike V1, this query returns `MicroChallengeRecommendationItem` directly rather than a
   * context-wrapped response union, and `challengeTypes` is required — there is no
   * backwards-compatibility fallback to `TIME_BOUND` only.
   *
   * `recommendationLimit` caps the number of items returned. When omitted, the backend applies
   * a default limit.
   *
   * `challengeTypes` filters which kinds of recommended challenges are returned. New clients
   * must opt in explicitly, e.g. `[TIME_BOUND, ONE_TIME]`.
   */
  getMicroChallengeRecommendationsV2: MicroChallengeRecommendationV2Response;
  /** Query to get the details for a single user relation */
  getRelation: RelationInfo;
  /**
   * Returns the relation-domain consent records matching the requested
   * `(consentType, qualifier)` filters for the given user.
   *
   * Note: the GraphQL layer fetches the full list of relation consents
   * for the user from `relations-api`
   * (`ConsentServiceProto.listConsents`) and filters it in-process by
   * the supplied `queries` parameters — the upstream RPC does not
   * accept per-type / per-qualifier filtering.
   */
  getRelationConsents: RelationConsentsList;
  /** Query to get the details for a single relation request. */
  getRelationRequest: RelationRequestInfo;
  /** Query the list of relation requests for a user. The server resolves extraData lazily; if the client does not select extra fields, no extra computation occurs. */
  getRelationRequests: RelationRequestsList;
  /**
   * Get a short URL by its slug.
   * Returns null if the short URL doesn't exist or has been deleted.
   */
  getShortUrl?: Maybe<ShortUrl>;
  /**
   * Returns GLP-1 medications available in the GLP-1 Companion feature.
   *
   * The medication list is config-driven and user-agnostic.
   */
  glp1CompanionMedicationList: Glp1CompanionMedicationList;
  /**
   * Returns the GLP-1 Companion state for the user identified by the given
   * access code.
   */
  glp1CompanionState: Glp1CompanionState;
  /** Returns the UserGoals for a user and program. */
  goalsForDate: UserGoalList;
  /**
   * Returns available grants using cursor-based pagination.
   * Meant to be used by rewards configuration web app
   */
  grants: Grants;
  /**
   * Checks whether any measurements exist for the user that match inclusion criteria
   * and do not match exclusion criteria, within the specified date range.
   * Returns true if at least one matching measurement exists.
   *
   * The attributionToMatch parameter specifies which attribution source to look for.
   * All specified fields in the attribution input must match (AND semantics).
   * To find any measurement from a source (regardless of field values), provide
   * the attribution type with an empty object (e.g., `{ validic: {} }`).
   *
   * The optional attributionToExclude parameter specifies which attribution source
   * to exclude from results. When both match and exclude are specified, a measurement
   * must match attributionToMatch AND NOT match attributionToExclude.
   */
  hasMeasurementsMatching: Scalars['Boolean']['output'];
  /** Retrieves health insights data, showing available scan types and actionable recommendations for health assessments. */
  healthInsights: HealthInsights;
  /**
   * Returns trend data for a specific health metric including comparison to
   * first and previous measurements, plus an initial set of historical data
   * points for the line graph.
   *
   * Data points are returned in reverse chronological order (most recent first).
   */
  healthMetricTrends: HealthMetricTrends;
  /**
   * Retrieves health report data for a user based on the latest facial blood scan, body scan and lab result.
   *
   * View parameter determines which view's metrics should be prioritized when sorting.
   */
  healthReport: HealthReport;
  homeScreenCarouselState: HomeScreenCarouselState;
  /** Returns home screen navigation configuration */
  homeScreenNavigation: HomeScreenNavigation;
  /** Request a presigned S3 link to upload the face image for further processing */
  initializeFaceScan: FaceScanInitializationInfo;
  /** Fetch a single internal SKU by its SKU code. Returns null if not found. */
  internalSku?: Maybe<InternalSku>;
  /**
   * List internal SKUs, optionally filtered by lifecycle state.
   * Returns a wrapper type so pagination can be added later without a breaking change.
   */
  internalSkus: InternalSkuList;
  interstitials: Interstitials;
  /** Lists all scheduled contents with cursor-based pagination */
  listScheduledContent: ScheduledContentList;
  /**
   * List all short URLs with optional pagination.
   * Requires authentication.
   * Valid sort keys for cursorPagination.sort: CREATED_AT, UPDATED_AT, SLUG.
   */
  listShortUrls: ShortUrlList;
  macroMonitoringSettingsState: MacroMonitoringSettingsState;
  /** Gets an meal insight for the user with their most recently logged meal as input. */
  mealInsight?: Maybe<AiInsight>;
  /** Query for telling the client what meal logging method selector options are available */
  mealLoggingMethodSelectorFeatureState: MealLoggingMethodSelectorFeatureState;
  /**
   * Fetches the latest state of measurements for a given access code and measurement type, replicating what the
   * `measurementDataList` subscription, but as a one-time query.
   *
   * Similar to the subscription, this query returns data points within the given time range
   * (fromCivilDateTime to toCivilDateTime), if provided. If no range is specified, the query will return all
   * available data up to the maximum limit (default max is 1000). The 'limit' parameter restricts the number
   * of returned results and is useful for controlling payload size. Data is returned in ascending or descending
   * order based on the 'ascendingOrder' flag.
   *
   * Note: Pagination is not currently supported. If you require more than 1000 data points in a single request,
   * please reach out to TNG to discuss enabling pagination support.
   */
  measurementDataList: MeasurementDataList;
  /** Fetches med refill eligibility data for the given windows */
  medRefillEligibility: MedRefillEligibility;
  /**
   * Returns FAQ entries for the med refill eligibility feature.
   * Entries are localized and may vary by user segment.
   */
  medRefillEligibilityFaq: MedRefillEligibilityFaqResponse;
  /**
   * Returns the med refill eligibility feature state for a user.
   * Determines whether the med refill eligibility feature should be shown.
   */
  medRefillEligibilityFeatureState: MedRefillEligibilityFeatureState;
  /** List of medications that user needs to take for on the given date. */
  medicationList: MedicationList;
  /**
   * Returns a chronological member journey timeline for support and internal tools.
   * Event kinds may grow over time; use inline fragments on __typename / concrete types.
   */
  membersJourney: MembersJourney;
  /**
   * Get the user's micro challenges library (may include locked or upcoming items).
   *
   * `challengeTypes` filters which kinds of challenges are returned. When null or
   * omitted (e.g. by older clients that predate this parameter) the backend
   * returns only `TIME_BOUND` challenges for backwards compatibility. New clients
   * that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  microChallengeLibrary: MicroChallengeLibrary;
  /**
   * Get the user's micro challenges library (may include locked or upcoming items).
   * Paginated successor to `microChallengeLibrary`; V1 remains available for
   * older clients.
   *
   * `challengeTypes` filters which kinds of challenges are returned. When null or
   * omitted (e.g. by older clients that predate this parameter) the backend
   * returns only `TIME_BOUND` challenges for backwards compatibility. New clients
   * that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  microChallengeLibraryV2: MicroChallengeLibraryV2;
  /**
   * Get the current state of the user's micro challenges.
   * This is the query equivalent of the subscription, useful for initial load.
   *
   * `challengeTypes` filters which kinds of challenges are returned. When null or
   * omitted (e.g. by older clients that predate this parameter) the backend
   * returns only `TIME_BOUND` challenges for backwards compatibility. New clients
   * that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  microChallengesTrackerState: MicroChallengesTrackerState;
  /**
   * Returns per-user details for a single module. The deprecated
   * `category` enum on the REST response is not exposed here; clients
   * use the slug-based `categories` list.
   *
   * Matches `ModulesServiceProto.getModuleDetails` in Curriculum API.
   *
   * If called with a user token, the access code is extracted from the
   * token. If called with a machine token, the access code must be
   * provided.
   */
  moduleDetails: ModuleDetails;
  /**
   * Returns the module library for a user.
   * The module library contains all available modules organized by category,
   * with user-specific progress and recommendations.
   *
   * Matches the module library RPC endpoint in Curriculum API.
   *
   * If called with a user token, the access code is extracted from the token.
   * If called with a machine token, the access code must be provided.
   */
  moduleLibrary: ModuleLibrary;
  /**
   * Returns the v3 module library for a user. Same shape as `moduleLibrary`,
   * but `ModuleLibraryCategory.category` is populated with the localized
   * category display name (sourced server-side from the program blueprint)
   * rather than the legacy `ModuleCategory` enum name. A single module can
   * appear under multiple categories.
   *
   * Matches `ModuleLibraryV3ServiceProto.getModuleLibraryV3` in Curriculum API.
   *
   * If called with a user token, the access code is extracted from the token.
   * If called with a machine token, the access code must be provided.
   */
  moduleLibraryV3: ModuleLibrary;
  /**
   * Paginated list of challenge templates the user has engaged with (not user
   * instances). Each item is a `MicroChallenge` with `userContext` populated;
   * read `userContext.latestState` for enrollment status and progress.
   *
   * Intended for load-more after `microChallengeLibraryV2.myChallenges` (first page).
   * Pass `cursorPagination.after` from the embedded field's `pageInfo.nextPageCursor`,
   * with the same `statuses` and `challengeTypes`. Use `sort: []` (backend-default
   * order) and repeat your chosen `first` value — the embedded field does not
   * expose these inputs.
   *
   * `statuses` includes only templates whose `userContext.latestState.status`
   * matches one of the given values; templates with no `latestState` are excluded
   * when a filter is provided. When omitted, all engaged templates are returned
   * regardless of status.
   *
   * `challengeTypes` filters which kinds of challenges are returned. When null or
   * omitted (e.g. by older clients that predate this parameter) the backend
   * returns only `TIME_BOUND` challenges for backwards compatibility. New clients
   * that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  myChallenges: MicroChallengePage;
  /**
   * Get audit trails based on filter criteria.
   * Used by the noom flow admin.
   */
  noomFlowAuditTrails: NoomFlowAuditTrails;
  /**
   * Get a noom flow based on criteria.
   * Used by a user facing frontend (mobile/web) (i.e. BuyFlow).
   * This will take the criteria and generate a flow on the fly.
   * Note: Includes a lookup table for text translations.
   */
  noomFlowByCriteria: NoomFlowRenderedFlow;
  /**
   * Get a single Noom Flow experiment by uuid and/or identifier.
   * Used by the noom flow admin (Growth Experimentation / buyflow).
   */
  noomFlowExperiment?: Maybe<NoomFlowExperiment>;
  /**
   * List Noom Flow experiments with optional filters and cursor pagination.
   * Used by the noom flow admin.
   */
  noomFlowExperiments: NoomFlowExperiments;
  /**
   * List experiments whose baseline references any of the selected flows (each selected
   * by uuid and/or logical identifier and optional version). Maps to gRPC
   * `getExperimentsAssociatedWithNoomFlows` / REST `POST /api/v1/experiment/associatedWithNoomFlow`.
   */
  noomFlowExperimentsAssociatedWithNoomFlows: NoomFlowExperiments;
  /** Load a single Noom Flow list by uuid and/or name. */
  noomFlowList?: Maybe<NoomFlowList>;
  /** Load one Noom Flow list item by uuid. */
  noomFlowListItem?: Maybe<NoomFlowListItem>;
  /** List items in a Noom Flow list, with optional partial value search for autocomplete. */
  noomFlowListItems: NoomFlowListItems;
  /** List named Noom Flow lists with optional filters and cursor pagination. */
  noomFlowLists: NoomFlowLists;
  /**
   * List Noom Flow pages with optional filters and cursor pagination.
   * Used by the noom flow admin.
   */
  noomFlowPages: NoomFlowPages;
  /**
   * Get personas based on filter criteria.
   * Used by a user facing frontend (mobile/web) (i.e. BuyFlow).
   */
  noomFlowPersonas: NoomFlowPersonas;
  /**
   * List Noom Flow rules with optional filters and cursor pagination.
   * Used by the noom flow admin.
   */
  noomFlowRules: NoomFlowRules;
  /**
   * Get text translations based on filter criteria.
   * Used by the noom flow admin.
   */
  noomFlowTextTranslations: NoomFlowTextTranslations;
  /**
   * Get all noom flows based on the filter.
   * Used by the noom flow admin.
   * Includes pagination.
   */
  noomFlows: NoomFlows;
  /** Get noom flows with a specific text translation key. */
  noomFlowsWithTextTranslationKey: NoomFlows;
  /** Noomcoin feature configuration */
  noomcoinConfig?: Maybe<NoomcoinConfig>;
  /** Returns list of nutrient goals for a user, date and program. */
  nutrientGoalsForDate: UserGoalList;
  /**
   * The current state of the out-of-range blood glucose alerts for a user.
   * True if the alerts are enabled, or false if they are disabled.
   */
  outOfRangeBloodGlucoseAlertsEnabled: Scalars['Boolean']['output'];
  /** Returns B2B partner information for the user. Null if the user is not a B2B user. */
  partnerInfo?: Maybe<PartnerInfo>;
  /** Returns a list of past medication doses. */
  pastMedicationDoseList: PastMedicationDoseList;
  /** Returns the list of user's diagnostic reports, in reverse order of time collected */
  patientDiagnosticReports: PatientDiagnosticReportList;
  /**
   * Returns the list of a patient's lab orders (newest first), as exposed by the healthcare
   * `GET /lab/v1/patient/{accessCode}/orders` endpoint. Intended for admin / QA tooling — pair
   * with `cancelLabOrder` to manage in-flight orders.
   */
  patientLabOrders: PatientLabOrderList;
  /**
   * Ranked ads for a single placement (e.g. home carousel).
   * Maps to AdServiceProto.listPlacementAds in noom_contracts/offers/ads/api/ad_service.proto.
   */
  placementAds: PlacementAdsResponse;
  /**
   * Ranked ads for each placement in a group, in group-defined order (e.g. marketplace).
   * Maps to AdServiceProto.listPlacementGroupAds in noom_contracts/offers/ads/api/ad_service.proto.
   */
  placementGroupAds: PlacementGroupAdsResponse;
  /** Returns the data necessary to render the Discoverability Promo card after a streak completion. Returns null if the feature is disabled or the user is ineligible. */
  postStreakDiscoverabilityPromoCard?: Maybe<DiscoverabilityPromoCard>;
  /** Returns a short-lived presigned URL for the lab report PDF (existing healthcare API). Call when the user opens the viewer; URLs expire. */
  presignedLabReportUrl: Scalars['String']['output'];
  /** Returns available product listings to the user. */
  productListings: ProductListingCatalog;
  /** Get available product offers (authenticated and unauthenticated users) */
  productOffers: ProductOffersResponse;
  /** Get available product switch offers for a user */
  productSwitchOffers: ProductSwitchOffersResponse;
  /**
   * Return a single foundation.
   * - `programConfigId`: Required id of the foundation's parent program
   * - `foundationId`: Required id of the foundation to fetch
   * Returns the foundation
   */
  programFoundation: ProgramFoundation;
  /**
   * Return all program foundations
   * - `programConfigId`: Required id of the program to fetch all foundations for
   * Returns the list of foundations
   */
  programFoundations: ProgramFoundations;
  /**
   * Returns the program progress (course map) for a user.
   * This includes the user's current status and all modules in their curriculum
   * with progress information.
   *
   * Matches the curriculum program progress v2 RPC endpoint.
   *
   * If called with a user token, the access code is extracted from the token.
   * If called with a machine token, the access code must be provided.
   */
  programProgress: ProgramProgress;
  /** Returns the presentation of the Progress screen */
  progressScreen: ProgressScreen;
  /**
   * For a given subscription, get the prorated amount we should refund on the
   * latest charge based on how much time on the subscription is left and the
   * amount of the latest charge.
   */
  proratedRefund: ProratedRefund;
  /** Returns partner specific set of parameters for initiating a facial blood scan */
  providerConfiguration: ProviderConfiguration;
  /** Get a recommended offer for a user going through the buyflow. Initially this will only be used for med plan reveal. */
  recommendedBuyflowOffers: RecommendedBuyflowOffersResponse;
  /**
   * Returns available redeemable rewards.
   * Called by the client when displaying the rewards page.
   */
  redeemableRewards: RedeemableRewards;
  /** Fetches which relation promotion to return based on the user's friends list status. */
  relationPromotion?: Maybe<RelationsPromotions>;
  /** Query the list of relations for a user. The server resolves `extra_data` lazily; if the client does not select extra fields, no extra computation occurs. */
  relationsList: RelationsList;
  /** Returns the data necessary to render the Relations Promo card. Return Null if feature is disabled, user is ineligible, etc. */
  relationsPromoCard?: Maybe<RelationsPromoCard>;
  /**  Return a list of all reminders for a given user and reminder type */
  reminderSettingsState: ReminderSettingsList;
  /**
   * Returns info on the user's rewards, e.g. current state, program configuration, etc.
   * Called by the client on app launch.
   */
  rewards: Rewards;
  /**
   * Returns a list of available rewards levels.
   * Called by the client when the Rewards screen is opened.
   */
  rewardsLevels: RewardsLevels;
  /**
   * Returns the user's rewards settings.
   * Only available to users with the CORE entitlement.
   */
  rewardsSettings?: Maybe<RewardsSettings>;
  /** Retrieves a single scheduled content item by its unique identifier */
  scheduledContent?: Maybe<ScheduledContent>;
  /** Returns shipment history across all product types for a patient. */
  shipmentHistory: ShipmentHistoryList;
  /** Returns Shopify orders associated with a given email */
  shopifyOrders?: Maybe<ShopifyOrdersList>;
  /**
   * List SKU registry entries, optionally filtered. Server-side sort is internalSku ASC, vendor ASC.
   * Returns a wrapper type (per repo convention) even though the underlying REST endpoint does not paginate;
   * pagination metadata can be added to SkuRegistryEntryList later without a breaking change.
   */
  skuRegistryEntries: SkuRegistryEntryList;
  /** Fetch a single SKU registry entry by UUID. Returns null if not found. */
  skuRegistryEntry?: Maybe<SkuRegistryEntry>;
  /**
   * Fetches a user's current SmartDose for the user's prescribed medication.
   * May be null if the user hasn't logged medications before.
   */
  smartDose?: Maybe<SmartDose>;
  /**
   * Fetches medication(s) information for the SmartDose flow, including
   * potential Product & Pharmacy Switching scenarios.
   */
  smartDoseMedications: SmartDoseMedications;
  /** Returns the details of the streak */
  streakDetails?: Maybe<Streak>;
  /** Returns the number of streak freezes available for the user */
  streakFreeze?: Maybe<StreakFreeze>;
  /** Returns streak milestones for the user */
  streakMilestones?: Maybe<StreakMilestones>;
  /** Streaks feature configuration */
  streaksConfig?: Maybe<StreaksConfig>;
  /** Retrieves the support chat unread messages count for a user identified by their access code */
  supportChatUnreadMessages: SupportChatUnreadMessages;
  /**
   * Returns the health metrics supported by the user's resolved lab order profile.
   * Currently supports assessmentType = LABS only; other values return an empty
   * metrics list.
   */
  supportedAssessmentMetrics: SupportedAssessmentMetrics;
  /** Returns successfully if x-noom-config-ref, x-noom-routing-id, and Accept-Language are successfully proxied */
  testHeaderProxying?: Maybe<Scalars['String']['output']>;
  /** Returns the access code parameter if present, otherwise attempts to determine the access code from the token. */
  testOptionalAccessCode: Scalars['String']['output'];
  /** Returns `Looking good!` */
  testSuccess?: Maybe<Scalars['String']['output']>;
  /** Returns an unauthorized API response */
  testUnauthorized?: Maybe<Scalars['String']['output']>;
  /** Get text translations in a noom flow. */
  textTranslationsInNoomFlow: NoomFlowTextTranslations;
  /** Treat Day feature configuration */
  treatDayConfig?: Maybe<TreatDayConfig>;
  /** Returns active treatment overview cards for a patient, ordered by display priority. */
  treatmentOverviews: TreatmentOverviews;
  /** Returns a list of upcoming medication doses. */
  upcomingMedicationDoseList: UpcomingMedicationDoseList;
  /** Returns a list of data required by the client for upsell ad placement */
  upsellAdDataList: UpsellAdDataList;
  /**
   * Search for user model segments using any of the supported search fields.
   *
   * The query exposes pagination via CursorPagination, but the only implemented
   * field is 'first'. You can specify how many search results you want, but
   * you can't sort them or define which page you want to retrieve.
   *
   * All fields except for 'first' are unsupported now, but might be supported in
   * the future. So, if you're using pagination, use sensible values even for
   * unsupported fields to avoid unwanted behavior if and when EC-API rolls
   * out full pagination support.
   */
  userModelSegments?: Maybe<UserModelSegments>;
  /** Get multiple user preview profiles in a single batch request */
  userPreviewProfilesBatch: UserPreviewProfilesBatchResponse;
  /** Returns utility entry points configuration for the given user */
  utilityEntryPointsConfig: UtilityEntryPointsConfig;
  /** Validates a user address and returns the status of the address and the corrected address if applicable */
  validateAddress: ValidateAddressResponse;
  /**
   * Returns a specific version of the AnnotatedMeasurementTrendChart using Weight as measurement and Meds as annotation.
   * The response also includes some information specific to this chart. The limits are determined by the product
   * requirements - we should return all weight measurements occurring within the last three med logs for
   * semaglutide users. For other med users this endpoint should return no data.
   */
  weightMedsSnapshot: WeightMedsSnapshot;
};


export type QueryActiveCduScheduleArgs = {
  cduAccessCode: Scalars['String']['input'];
};


export type QueryAiMealInsightArgs = {
  analyticsConversationId?: InputMaybe<Scalars['String']['input']>;
  loggedMealInput: LoggedMealInput;
};


export type QueryAnnotatedMeasurementTrendChartArgs = {
  accessCode: Scalars['String']['input'];
  annotationType?: InputMaybe<TrendChartAnnotationType>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limitAnnotations?: InputMaybe<Scalars['Int']['input']>;
  limitMeasurements?: InputMaybe<Scalars['Int']['input']>;
  measurementType: TrendChartMeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryAntiObesityMedicationsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryArtGalleryArgs = {
  galleryId: Scalars['ID']['input'];
};


export type QueryAssessmentPrivacyPolicyArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  assessmentType: HealthMetricSource;
};


export type QueryAssessmentReportArgs = {
  accessCode: Scalars['String']['input'];
  assessmentType: HealthMetricSource;
  reportId: Scalars['String']['input'];
};


export type QueryAssessmentReportsArgs = {
  accessCode: Scalars['String']['input'];
  assessmentType?: InputMaybe<HealthMetricSource>;
};


export type QueryAssetRegistryEntriesArgs = {
  filter?: InputMaybe<AssetRegistryEntriesFilterInput>;
};


export type QueryAutocompleteAddressArgs = {
  autocompleteService?: InputMaybe<AutocompleteService>;
  countryCode: Scalars['String']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  queryString: Scalars['String']['input'];
};


export type QueryAvailableTargetsArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  goalId: GoalId;
  programUuid: Scalars['String']['input'];
};


export type QueryBodyScanIngressArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryBodyScanPrivacyPolicyArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBodyScanSettingsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryBodyScanTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type QueryBodyScansArgs = {
  accessCode: Scalars['String']['input'];
  filters?: InputMaybe<BodyScansListFilters>;
  pagination?: InputMaybe<CursorPagination>;
};


export type QueryBwellCardArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  firstShownAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type QueryCareTabNotificationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryItemsArgs = {
  accessCode: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
  cursorPagination: CursorPagination;
};


export type QueryCduPtosArgs = {
  cduAccessCode: Scalars['String']['input'];
  includePastDates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCduSchedulesArgs = {
  cduAccessCode: Scalars['String']['input'];
};


export type QueryChatChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryChatMemberInboxArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryClinicianChannelUrlArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type QueryCoachAnnouncementsArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryCoachAnnouncementsUserInteractionsArgs = {
  cursorPagination: CursorPagination;
};


export type QueryCoachingConfigForUserArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryConsentCheckArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentConsumptionStateArgs = {
  accessCode: Scalars['String']['input'];
  contentType: CurriculumContentType;
  tasksRequestedAtDatetime: Scalars['DateTime']['input'];
  tasksRequestedForDatetime: Scalars['DateTime']['input'];
};


export type QueryCurriculumModulesArgs = {
  filters?: InputMaybe<CurriculumModulesFilters>;
};


export type QueryDecodeJwtArgs = {
  encodedJwt: Scalars['String']['input'];
};


export type QueryDiscoverabilityPromoCardArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<UtilityEntryPointSurface>;
};


export type QueryDynamicCalorieGoalSettingsStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEligibleForWeightMedsSnapshotArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryEligibleForWeightMedsSnapshotBasedOnGoalsArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryExternalCoachingTermsAndConditionsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFaceScanTaskArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type QueryFacialBloodScanIntroMetadataArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacialBloodScanQuestionnaireArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  provider: FacialBloodScanProvider;
};


export type QueryFacialBloodScanStatsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryFeatureOptInStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  featureSet: FeatureSetInput;
};


export type QueryFindFriendsByPhoneNumbersArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  contacts: Array<ContactPreviewInput>;
  sort?: InputMaybe<FindFriendsSort>;
};


export type QueryFindFriendsByPhoneNumbersCallConfigArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFixedContentSectionsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFoodLoggingFeaturesStatesArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateGlucoseForecastArgs = {
  accessCode: Scalars['String']['input'];
  foodItems: Array<GlucoseForecastFoodItemInput>;
};


export type QueryGenerateGlucoseForecastV2Args = {
  accessCode: Scalars['String']['input'];
  foodItems: Array<GlucoseForecastFoodItemInput>;
};


export type QueryGetApiKeyArgs = {
  input: GetApiKeyInput;
};


export type QueryGetMicroChallengeRecommendationsArgs = {
  accessCode: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
  context: MicroChallengeRecommendationContextInput;
};


export type QueryGetMicroChallengeRecommendationsV2Args = {
  accessCode: Scalars['String']['input'];
  challengeTypes: Array<MicroChallengeType>;
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
  recommendationLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRelationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  relationType: RelationType;
  targetAccessCode: Scalars['String']['input'];
};


export type QueryGetRelationConsentsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  queries: Array<GetRelationConsentsQueryInput>;
};


export type QueryGetRelationRequestArgs = {
  relationRequestId: Scalars['ID']['input'];
  userAccessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRelationRequestsArgs = {
  relationType?: InputMaybe<RelationType>;
  status?: InputMaybe<RelationRequestStatus>;
  userAccessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetShortUrlArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryGlp1CompanionMedicationListArgs = {
  context: Glp1CompanionMedicationContext;
};


export type QueryGlp1CompanionStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryGoalsForDateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programUuid: Scalars['String']['input'];
};


export type QueryGrantsArgs = {
  cursorSlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHasMeasurementsMatchingArgs = {
  accessCode: Scalars['String']['input'];
  attributionToExclude?: InputMaybe<AttributionDataMatchInput>;
  attributionToMatch: AttributionDataMatchInput;
  fromCivilDateTime: Scalars['LocalDateTime']['input'];
  measurementType: MeasurementType;
  toCivilDateTime: Scalars['LocalDateTime']['input'];
};


export type QueryHealthInsightsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHealthMetricTrendsArgs = {
  accessCode: Scalars['String']['input'];
  assessmentType?: InputMaybe<HealthMetricSource>;
  initialPageSize?: InputMaybe<Scalars['Int']['input']>;
  metricType: HealthMetricName;
};


export type QueryHealthReportArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<HealthReportViewType>;
};


export type QueryHomeScreenCarouselStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryInitializeFaceScanArgs = {
  age?: InputMaybe<Scalars['Int']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  scanId: Scalars['UUID']['input'];
};


export type QueryInternalSkuArgs = {
  sku: Scalars['String']['input'];
};


export type QueryInternalSkusArgs = {
  filter?: InputMaybe<InternalSkuFilter>;
};


export type QueryInterstitialsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryListScheduledContentArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryListShortUrlsArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryMacroMonitoringSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMealInsightArgs = {
  analyticsConversationId?: InputMaybe<Scalars['String']['input']>;
  loggedMealInput: LoggedMealInput;
};


export type QueryMealLoggingMethodSelectorFeatureStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryMedRefillEligibilityArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  daysPerWindow: Scalars['Int']['input'];
  windowCount: Scalars['Int']['input'];
};


export type QueryMedRefillEligibilityFaqArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMedRefillEligibilityFeatureStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMedicationListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryMembersJourneyArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMicroChallengeLibraryArgs = {
  accessCode: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
  recommendationLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMicroChallengeLibraryV2Args = {
  accessCode: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type QueryMicroChallengesTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type QueryModuleDetailsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['ID']['input'];
};


export type QueryModuleLibraryArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModuleLibraryV3Args = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyChallengesArgs = {
  accessCode: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
  cursorPagination: CursorPagination;
  statuses?: InputMaybe<Array<MicroChallengeStatus>>;
};


export type QueryNoomFlowAuditTrailsArgs = {
  filter?: InputMaybe<NoomFlowAuditTrailsFilterInput>;
};


export type QueryNoomFlowByCriteriaArgs = {
  criteria: NoomFlowCriteriaInput;
};


export type QueryNoomFlowExperimentArgs = {
  filter: GetNoomFlowExperimentInput;
};


export type QueryNoomFlowExperimentsArgs = {
  filter?: InputMaybe<NoomFlowExperimentsFilterInput>;
};


export type QueryNoomFlowExperimentsAssociatedWithNoomFlowsArgs = {
  filter?: InputMaybe<GetExperimentsAssociatedWithNoomFlowsInput>;
};


export type QueryNoomFlowListArgs = {
  filter: GetNoomFlowListInput;
};


export type QueryNoomFlowListItemArgs = {
  filter: GetNoomFlowListItemInput;
};


export type QueryNoomFlowListItemsArgs = {
  filter: GetNoomFlowListItemsInput;
};


export type QueryNoomFlowListsArgs = {
  filter?: InputMaybe<NoomFlowListsFilterInput>;
};


export type QueryNoomFlowPagesArgs = {
  filter?: InputMaybe<NoomFlowPagesFilterInput>;
};


export type QueryNoomFlowPersonasArgs = {
  filter?: InputMaybe<NoomFlowPersonasFilterInput>;
};


export type QueryNoomFlowRulesArgs = {
  filter?: InputMaybe<NoomFlowRulesFilterInput>;
};


export type QueryNoomFlowTextTranslationsArgs = {
  filter?: InputMaybe<NoomFlowTextTranslationsFilterInput>;
};


export type QueryNoomFlowsArgs = {
  filter?: InputMaybe<NoomFlowsFilterInput>;
};


export type QueryNoomFlowsWithTextTranslationKeyArgs = {
  filter?: InputMaybe<NoomFlowsTextTranslationKeyFilterInput>;
};


export type QueryNoomcoinConfigArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNutrientGoalsForDateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programUuid: Scalars['String']['input'];
};


export type QueryOutOfRangeBloodGlucoseAlertsEnabledArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryPartnerInfoArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryPastMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryPatientDiagnosticReportsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryPatientLabOrdersArgs = {
  accessCode: Scalars['String']['input'];
  includeShipments?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlacementAdsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  placementName: Scalars['String']['input'];
};


export type QueryPlacementGroupAdsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  placementGroupName: Scalars['String']['input'];
};


export type QueryPostStreakDiscoverabilityPromoCardArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lastShownDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  surface?: InputMaybe<UtilityEntryPointSurface>;
};


export type QueryPresignedLabReportUrlArgs = {
  accessCode: Scalars['String']['input'];
  labOrderId: Scalars['String']['input'];
};


export type QueryProductListingsArgs = {
  accessCode: Scalars['String']['input'];
  eligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  targetDate: Scalars['LocalDate']['input'];
};


export type QueryProductOffersArgs = {
  input: ProductOffersInput;
};


export type QueryProductSwitchOffersArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProgramFoundationArgs = {
  foundationId: Scalars['UUID']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type QueryProgramFoundationsArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type QueryProgramProgressArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProgressScreenArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProratedRefundArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryProviderConfigurationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  provider: FacialBloodScanProvider;
};


export type QueryRecommendedBuyflowOffersArgs = {
  input: RecommendedBuyflowOffersInput;
};


export type QueryRedeemableRewardsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryRelationPromotionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: RelationsPromotionInput;
};


export type QueryRelationsListArgs = {
  clientDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  cursorPagination?: InputMaybe<CursorPagination>;
  relationType: RelationType;
  userAccessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRelationsPromoCardArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: RelationsPromoCardInput;
};


export type QueryReminderSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
  reminderType: ReminderType;
};


export type QueryRewardsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryRewardsLevelsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryRewardsSettingsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScheduledContentArgs = {
  scheduledContentId: Scalars['UUID']['input'];
};


export type QueryShipmentHistoryArgs = {
  accessCode: Scalars['String']['input'];
  includeOlderRecords?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShopifyOrdersArgs = {
  email: Scalars['String']['input'];
};


export type QuerySkuRegistryEntriesArgs = {
  filter?: InputMaybe<SkuRegistryFilter>;
};


export type QuerySkuRegistryEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmartDoseArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime: Scalars['LocalDateTime']['input'];
};


export type QuerySmartDoseMedicationsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStreakDetailsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  dataDateRange: LocalDateRangeInput;
  type: StreakType;
  userCurrentDate: Scalars['LocalDate']['input'];
};


export type QueryStreakFreezeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStreakMilestonesArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: StreakMilestonesInput;
};


export type QueryStreaksConfigArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupportChatUnreadMessagesArgs = {
  accessCode: Scalars['String']['input'];
};


export type QuerySupportedAssessmentMetricsArgs = {
  accessCode: Scalars['String']['input'];
  assessmentType: HealthMetricSource;
};


export type QueryTestOptionalAccessCodeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTextTranslationsInNoomFlowArgs = {
  filter: NoomFlowGetFlowByIdentifierInput;
};


export type QueryTreatDayConfigArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTreatmentOverviewsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryUpcomingMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
  programUuid: Scalars['String']['input'];
};


export type QueryUpsellAdDataListArgs = {
  accessCode: Scalars['String']['input'];
  adLocation?: InputMaybe<UpsellAdLocation>;
};


export type QueryUserModelSegmentsArgs = {
  createdAfter?: InputMaybe<Scalars['LocalDateTime']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  creatorsToExclude?: InputMaybe<CreatorsToExclude>;
  cursorPagination?: InputMaybe<CursorPagination>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPreviewProfilesBatchArgs = {
  accessCodes: Array<Scalars['String']['input']>;
};


export type QueryUtilityEntryPointsConfigArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<UtilityEntryPointSurface>;
};


export type QueryValidateAddressArgs = {
  address: ValidationAddressInput;
  validationService?: InputMaybe<ValidationService>;
};


export type QueryWeightMedsSnapshotArgs = {
  accessCode: Scalars['String']['input'];
  preferredWeightUnit?: InputMaybe<PreferredWeightUnit>;
};

/** Feedback with just a rating */
export type RatingOnlyInsightFeedback = InsightFeedback & {
  __typename?: 'RatingOnlyInsightFeedback';
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
};

/** Feedback with a rating and further comments */
export type RationaleInsightFeedback = InsightFeedback & {
  __typename?: 'RationaleInsightFeedback';
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
  /** Comments from the user on why they selected the rating they did */
  rationale?: Maybe<Scalars['String']['output']>;
};

/** The reason an address validation failed. */
export enum Reason {
  /**
   * The input address has a missing or unknown secondary address number.
   * It is marked as not required by the validator.
   */
  IncorrectSecondaryAddressNotRequired = 'INCORRECT_SECONDARY_ADDRESS_NOT_REQUIRED',
  /**
   * The input address has a missing or unknown secondary address number.
   * It is marked as required by the validator.
   */
  IncorrectSecondaryAddressRequired = 'INCORRECT_SECONDARY_ADDRESS_REQUIRED',
  /** The input address could not find any matches in our validation service. */
  NoAddressMatch = 'NO_ADDRESS_MATCH',
  /** The input address is a PO Box, which we do not accept. */
  PoBox = 'PO_BOX'
}

/**
 * Recommendation context pre-filled by the backend for attribution.
 * Maps to RecommendationContextProto in noom_contracts/recommender/shared.proto.
 * Backend fills recommendationId, itemId, recommendationSurface.
 * Client adds positionViewed, eventLocalDatetime, and origin before sending back.
 */
export type RecommendationContext = {
  __typename?: 'RecommendationContext';
  /**
   * Client local date-time when the user interacted with the recommendation.
   * Set by the client.
   */
  eventLocalDatetime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** The recommended item identifier */
  itemId: Scalars['String']['output'];
  /**
   * The UI origin where the interaction happened.
   * Set by the client.
   */
  origin?: Maybe<RecommendationInteractionOrigin>;
  /**
   * 0-indexed position of the item in the display order presented to the user.
   * Set by the client.
   */
  positionViewed?: Maybe<Scalars['Int']['output']>;
  /**
   * Recommendation session ID from the recommender service.
   * Null when recommendations come from fallback.
   */
  recommendationId?: Maybe<Scalars['String']['output']>;
  /** The recommendation surface this context belongs to */
  recommendationSurface: RecommendationSurface;
};

/**
 * Input for returning recommendation context back to the server.
 * Client fills in positionViewed, eventLocalDatetime, and origin on top of
 * the backend-provided fields.
 */
export type RecommendationContextInput = {
  /** Client local date-time when the user interacted with the recommendation */
  eventLocalDatetime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** The recommended item identifier */
  itemId: Scalars['String']['input'];
  /** The UI origin where the interaction happened */
  origin?: InputMaybe<RecommendationInteractionOrigin>;
  /** 0-indexed position of the item in the display order presented to the user */
  positionViewed?: InputMaybe<Scalars['Int']['input']>;
  /** Recommendation session ID (from the RecommendationContext returned by the server) */
  recommendationId?: InputMaybe<Scalars['String']['input']>;
  /** The recommendation surface (from the RecommendationContext returned by the server) */
  recommendationSurface: RecommendationSurface;
};

/**
 * The UI view or component where the user interacted with a recommended item.
 * Maps to RecommendationInteractionOriginProto.Value in noom_contracts/recommender/shared.proto.
 */
export enum RecommendationInteractionOrigin {
  HomeScreenMicroChallengeCompletedInterstitial = 'HOME_SCREEN_MICRO_CHALLENGE_COMPLETED_INTERSTITIAL',
  HomeScreenMicroChallengeTracker = 'HOME_SCREEN_MICRO_CHALLENGE_TRACKER',
  MicroChallengeReflection = 'MICRO_CHALLENGE_REFLECTION',
  MicroChallengeViewAllTab = 'MICRO_CHALLENGE_VIEW_ALL_TAB',
  MicroChallengeViewCategoryTab = 'MICRO_CHALLENGE_VIEW_CATEGORY_TAB',
  MicroChallengeViewHabitStacksTab = 'MICRO_CHALLENGE_VIEW_HABIT_STACKS_TAB',
  MicroChallengeViewMyChallengesTab = 'MICRO_CHALLENGE_VIEW_MY_CHALLENGES_TAB',
  MicroChallengeViewOneTimeTab = 'MICRO_CHALLENGE_VIEW_ONE_TIME_TAB',
  MicroChallengeViewRecommendedTab = 'MICRO_CHALLENGE_VIEW_RECOMMENDED_TAB',
  Unknown = 'UNKNOWN'
}

/**
 * Identifies where in the Noom product a recommendation is being served.
 * Maps to RecommendationSurfaceProto.Value in noom_contracts/recommender/shared.proto.
 */
export enum RecommendationSurface {
  MedPlanOffer = 'MED_PLAN_OFFER',
  MicroChallenge = 'MICRO_CHALLENGE',
  StandaloneContent = 'STANDALONE_CONTENT',
  Unknown = 'UNKNOWN'
}

/** Deep link to the recommendations screen */
export type RecommendationsDeepLink = {
  __typename?: 'RecommendationsDeepLink';
  /** Placeholder field to satisfy GraphQL type requirements - always returns true when this deep link type is used */
  isRecommendations: Scalars['Boolean']['output'];
};

/** Input for getting recommended offers */
export type RecommendedBuyflowOffersInput = {
  /**
   * A list of products the user is eligible to be offered.
   * Long term this will be determined by the backend, but initially we
   * send these from the FE.
   */
  eligibleSKUsForRecommendation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of contexts the user has encountered with experiment arms and SHAs */
  experiments?: InputMaybe<Array<MeristemExperimentInfo>>;
  /** The type of recommendation we're doing */
  recommendationType: Scalars['String']['input'];
  /** All of the survey answers the user has stored */
  surveyAnswers?: InputMaybe<Array<BuyflowSurveyAnswer>>;
  /** Tracking parameters the user used (ie from the url) */
  trackingParams?: InputMaybe<TrackingParams>;
  /** userId string - matches buyflow db's userdata_userdata.id */
  userId: Scalars['String']['input'];
};

/** Response containing recommended offers */
export type RecommendedBuyflowOffersResponse = {
  __typename?: 'RecommendedBuyflowOffersResponse';
  /** Ordered list of the offers to display; the first one will be displayed on the plans results page, the whole list will be displayed if the user clicks 'See More' */
  offers: Array<Scalars['String']['output']>;
  /** Correlation id of this request */
  recommendationId: Scalars['String']['output'];
};

/**
 * Response that indicates that the micro challenge progress was successfully recorded.
 * Contains the updated user micro challenge instance with new progress.
 */
export type RecordMicroChallengeProgressResponse = {
  __typename?: 'RecordMicroChallengeProgressResponse';
  /** The updated user micro challenge instance with new progress */
  userMicroChallenge: UserMicroChallenge;
};

/** Response that indicates that the micro challenge reflection response was successfully recorded. */
export type RecordMicroChallengeReflectionResponse = {
  __typename?: 'RecordMicroChallengeReflectionResponse';
  /**
   * Returns true if the record was successful; otherwise, it is false.
   * Note: Currently, it cannot be false, as the service method implementation
   * is expected to either return true or throw an exception.
   */
  success: Scalars['Boolean']['output'];
};

/** Response that indicates that the micro challenge user onboarding step was successfully recorded. */
export type RecordMicroChallengeUserOnboardingStepResponse = {
  __typename?: 'RecordMicroChallengeUserOnboardingStepResponse';
  /**
   * Returns true if the record was successful; otherwise, it is false.
   * Note: Currently, it cannot be false, as the service method implementation
   * is expected to either return true or throw an exception.
   */
  success: Scalars['Boolean']['output'];
};

/** Represents a redeemable charitable donation reward */
export type RedeemableRewardCharitableDonation = {
  __typename?: 'RedeemableRewardCharitableDonation';
  /** Display image for the reward */
  image: RewardImage;
  /** Minimal amount of currency units (seeds) required to make a donation */
  minimalCurrencyAmount: Scalars['Int']['output'];
  /** WebView URL for redeeming the charitable donation reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Display subtitle for the reward */
  subtitle: Scalars['String']['output'];
  /** Display title for the reward */
  title: Scalars['String']['output'];
};

/** Represents a redeemable gift card reward */
export type RedeemableRewardGiftCard = {
  __typename?: 'RedeemableRewardGiftCard';
  /** Required amount of currency units (seeds) to redeem the gift card */
  currencyAmount: Scalars['Int']['output'];
  /** WebView URL for redeeming the gift card reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary value of the gift card */
  value: Money;
};

/** Represents the collection of redeemable rewards available to the user */
export type RedeemableRewards = {
  __typename?: 'RedeemableRewards';
  /** A list of available charitable donations */
  charitableDonations: Array<RedeemableRewardCharitableDonation>;
  /** A list of available gift cards */
  giftCards: Array<RedeemableRewardGiftCard>;
};

/** Represents a directed relation between two users. */
export type Relation = {
  __typename?: 'Relation';
  /** Server time when the relation was created (Unix timestamp in seconds). */
  effectiveDateFrom: Scalars['LocalDateTime']['output'];
  /** The same as effectiveDateFrom but with timezone information */
  effectiveDateTimeFrom: Scalars['OffsetDateTime']['output'];
  /** Stable identifier of the relation record. */
  id: Scalars['ID']['output'];
  /** Type of relation between the users (e.g., friendship). */
  relationType: RelationType;
  /** Source user access code - the main user from whose perspective this relation is materialized. */
  sourceUserAccessCode: Scalars['String']['output'];
  /** Target user access code - the user related to the source in this directed projection. */
  targetUserAccessCode: Scalars['String']['output'];
};

/** Relation activities list delivered via subscription. */
export type RelationActivitiesList = {
  __typename?: 'RelationActivitiesList';
  /** Rewards available if a new relation is created. */
  availableRelationRewards?: Maybe<Array<RelationAvailableReward>>;
  /** Additional configuration for specific relation types */
  relationConfiguration?: Maybe<RelationConfiguration>;
  /** Relations enriched with optional extra data activities (e.g., steps, green calories). */
  relationsInfo: Array<RelationInfo>;
};

/** Input for streaming relation activities for a user. */
export type RelationActivitiesListInput = {
  /** Client date and time when the request is made. Used to check available rewards for relation creation. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Type of relation between the users (e.g., friendship). */
  relationType: RelationType;
  /** Dictates the order in which the results are returned. */
  sort?: InputMaybe<Sort>;
};

/** Details about a specific reward available for creating a relation. */
export type RelationAvailableReward = {
  __typename?: 'RelationAvailableReward';
  /** The amount of currency earned for this specific reward */
  amountEarned: Scalars['Int']['output'];
  /** The reason for earning this currency reward. */
  earningReason?: Maybe<CurrencyEarnedReason>;
};

/** Represents additional configuration that is applied to specific relation type */
export type RelationConfiguration = {
  __typename?: 'RelationConfiguration';
  /** Maximum amount of relations of specific type that user can create */
  maxAllowedRelationsCount?: Maybe<Scalars['Int']['output']>;
  /** Type of relation between the users (e.g., friendship) */
  relationType: RelationType;
};

/**
 * Wrapper payload for `getRelationConsents`. Carries the list of
 * consent records matching the requested filters; wraps the list in an
 * object so the response can grow (e.g. paging metadata, totals, or
 * additional context) without a breaking schema change.
 */
export type RelationConsentsList = {
  __typename?: 'RelationConsentsList';
  /** Consent records matching the requested `(consentType, qualifier)` filters. */
  consents: Array<Consent>;
};

/** Enumeration of specific error reasons for relations API errors. */
export enum RelationErrorReason {
  /** Feature is disabled for the user */
  FeatureIsDisabled = 'FEATURE_IS_DISABLED',
  /** Feature requires a subscription upgrade to be accessed */
  FeatureRequiresSubscriptionUpgrade = 'FEATURE_REQUIRES_SUBSCRIPTION_UPGRADE',
  /** Feature is disabled for B2B users */
  FriendshipB2BForbidden = 'FRIENDSHIP_B2B_FORBIDDEN',
  /** Feature is disabled for users with no DPP entitlement */
  FriendshipDppForbidden = 'FRIENDSHIP_DPP_FORBIDDEN',
  /** Feature is disabled for users due to presence of specific entitlement */
  FriendshipForSpecificEntitlementForbidden = 'FRIENDSHIP_FOR_SPECIFIC_ENTITLEMENT_FORBIDDEN',
  /** Initiator already has too many friends */
  InitiatorTooManyFriends = 'INITIATOR_TOO_MANY_FRIENDS',
  /** Invitation to upgrade subscription to FREEMIUM is disabled (with feature flag) */
  PaidToFreemiumInviteFlowDisabled = 'PAID_TO_FREEMIUM_INVITE_FLOW_DISABLED',
  /** Target user profile has been deleted */
  TargetUserProfileDeleted = 'TARGET_USER_PROFILE_DELETED',
  /** Unknown or unspecified error reason */
  Unknown = 'UNKNOWN',
  /** Unsupported business type for this operation */
  UnsupportedBusinessTypeForOperation = 'UNSUPPORTED_BUSINESS_TYPE_FOR_OPERATION',
  /** Feature requires a subscription upgrade to FREEMIUM for B2C users */
  UpgradeB2CToFreemiumRequired = 'UPGRADE_B2C_TO_FREEMIUM_REQUIRED'
}

/** Optional, computed add-ons for a relation. Omitted (null) if not requested or unavailable. */
export type RelationExtraData = {
  __typename?: 'RelationExtraData';
  /** Aggregated measurements of the related user */
  aggregatedMeasurements?: Maybe<AggregatedRelationMeasurements>;
  /** Aggregated seeds earned by the related user for the requested date. */
  aggregatedSeeds?: Maybe<AggregatedRelationSeeds>;
  /** Bidirectional friend sharing summary between the caller and the related user for the requested period. */
  friendSharing?: Maybe<FriendSharingSummary>;
  /** Profile data for the related user in a relation. */
  profile?: Maybe<NoomUserPreviewProfile>;
  /** Steps data for the related user in a relation. */
  stepsData?: Maybe<RelationStepsExtraData>;
  /** Streak data for the target user in a relation. */
  streak?: Maybe<StreakDay>;
};


/** Optional, computed add-ons for a relation. Omitted (null) if not requested or unavailable. */
export type RelationExtraDataFriendSharingArgs = {
  period: FriendSharingPeriod;
};

/** Wrapper that couples the base relation with optional extra data. */
export type RelationInfo = {
  __typename?: 'RelationInfo';
  /** Optional extra data. May be null if not selected or not available. */
  extraData?: Maybe<RelationExtraData>;
  /** The base relation entity. */
  relation: Relation;
};

/** Represents a relation request between two users. */
export type RelationRequest = {
  __typename?: 'RelationRequest';
  /** Client time when the request was created. */
  civilDateTime: Scalars['OffsetDateTime']['output'];
  /** Stable identifier of the relation request. */
  id: Scalars['ID']['output'];
  /** Type of relation between the users (e.g., friendship). */
  relationType: RelationType;
  /** Source user access code - the user who sent the relation request. */
  sourceUserAccessCode: Scalars['String']['output'];
  /** Current status of the relation request. */
  status: RelationRequestStatus;
  /** Target user access code - the user who received the relation request. */
  targetUserAccessCode: Scalars['String']['output'];
};

/** Optional, computed add-ons for a relation request. Omitted (null) if not requested or unavailable. */
export type RelationRequestExtraData = {
  __typename?: 'RelationRequestExtraData';
  /** Profile data for the source or target user (e.g., the other party in the request). */
  profile?: Maybe<NoomUserPreviewProfile>;
};

/** Wrapper that couples a relation request with optional extra data. */
export type RelationRequestInfo = {
  __typename?: 'RelationRequestInfo';
  /** Optional extra data. May be null if not selected or not available. */
  extraData?: Maybe<RelationRequestExtraData>;
  /** The base relation request entity. */
  relationRequest: RelationRequest;
};

/** Enumerates the outcome of a relation request creation or status change (e.g. CREATED, STATUS_CHANGED, failure reasons). */
export enum RelationRequestOperationState {
  /** Status change: idempotent — relation request was already in the requested status. */
  AlreadyInStatus = 'ALREADY_IN_STATUS',
  /** Create: new relation request was created. */
  Created = 'CREATED',
  /** Feature is disabled for the user. */
  FeatureIsDisabled = 'FEATURE_IS_DISABLED',
  /** Feature is disabled for B2B users. */
  FriendshipB2BForbidden = 'FRIENDSHIP_B2B_FORBIDDEN',
  /** Feature is disabled for users with no DPP entitlement. */
  FriendshipDppForbidden = 'FRIENDSHIP_DPP_FORBIDDEN',
  /** Feature is disabled for users due to presence of specific entitlement. */
  FriendshipForSpecificEntitlementForbidden = 'FRIENDSHIP_FOR_SPECIFIC_ENTITLEMENT_FORBIDDEN',
  /** Status change: the requested new status is not a valid transition target (must be ACCEPTED or DECLINED). */
  InvalidNewStatus = 'INVALID_NEW_STATUS',
  /** A relation already exists between the two users. */
  RelationAlreadyExists = 'RELATION_ALREADY_EXISTS',
  /** Create: relation request already existed (e.g. same source, target, type). */
  RequestAlreadyExists = 'REQUEST_ALREADY_EXISTS',
  /** Attempt to create a self relation request. */
  SelfRelationForbidden = 'SELF_RELATION_FORBIDDEN',
  /** Source user is not active. */
  SourceUserNotActive = 'SOURCE_USER_NOT_ACTIVE',
  /** Source user has reached their relation limit. */
  SourceUserRelationLimitReached = 'SOURCE_USER_RELATION_LIMIT_REACHED',
  /** Status change: status was updated to the requested value (e.g. accepted/declined). */
  StatusChanged = 'STATUS_CHANGED',
  /** Target user is not active. */
  TargetUserNotActive = 'TARGET_USER_NOT_ACTIVE',
  /** Target user has reached their relation limit. */
  TargetUserRelationLimitReached = 'TARGET_USER_RELATION_LIMIT_REACHED',
  /** Unknown or unspecified outcome. */
  Unknown = 'UNKNOWN',
  /** Unsupported business type for this operation. */
  UnsupportedBusinessTypeForOperation = 'UNSUPPORTED_BUSINESS_TYPE_FOR_OPERATION',
  /** Feature requires a subscription upgrade to FREEMIUM for B2C users. */
  UpgradeB2CToFreemiumRequired = 'UPGRADE_B2C_TO_FREEMIUM_REQUIRED'
}

/** Enumerates the status of a relation request. */
export enum RelationRequestStatus {
  /** Target user accepted the relation request. */
  Accepted = 'ACCEPTED',
  /** Target user declined the relation request. */
  Declined = 'DECLINED',
  /** Relation request is awaiting a response from the target user. */
  Pending = 'PENDING',
  /** Unknown or unspecified status. */
  Unknown = 'UNKNOWN'
}

/** Relation requests list. */
export type RelationRequestsList = {
  __typename?: 'RelationRequestsList';
  /** Relation requests enriched with optional extra data. */
  relationRequestsInfo: Array<RelationRequestInfo>;
};

/** Steps data for the related user in a relation. */
export type RelationStepsExtraData = {
  __typename?: 'RelationStepsExtraData';
  /** Steps count for a related user */
  stepCount: Scalars['Int']['output'];
};

/** Enumerates the types of relations between users. */
export enum RelationType {
  /** Friendship relation between two users. */
  Friendship = 'FRIENDSHIP'
}

/**
 * Domain-specific consent type for the Relations domain. Mirrors the
 * backing protobuf `RelationsConsentTypeProto.Value` (see
 * `noom_contracts/relations/shared.proto`). The string name of each
 * value (e.g. `CONTACT_BOOK_UPLOADING`) is the canonical identifier
 * used in the domain-agnostic `ConsentServiceProto` request/response
 * `consent_type` field and in the `user_consents.consent_type` column.
 */
export enum RelationsConsentType {
  /**
   * Consent to upload and process the user's contact book on the
   * backend (E.164 phones tokenized into HMAC-SHA256 join keys).
   * Unscoped — `qualifier` MUST be unset.
   */
  ContactBookUploading = 'CONTACT_BOOK_UPLOADING',
  /**
   * Consent to allow in-app discoverability via any of the user's
   * verified phone numbers. Use-based — once granted, it covers all
   * phone numbers the user has verified. Unscoped — `qualifier`
   * MUST be unset.
   */
  DiscoverabilityByPhoneNumbers = 'DISCOVERABILITY_BY_PHONE_NUMBERS'
}

/** Relation wrapper containing list of relations and paging info. */
export type RelationsList = Pageable & {
  __typename?: 'RelationsList';
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Additional configuration for specific relation types */
  relationConfiguration?: Maybe<RelationConfiguration>;
  /** Relations enriched with optional extra data. */
  relationsInfo: Array<RelationInfo>;
  /** The total number of results that match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** The data necessary to render the Relations Promo card. */
export type RelationsPromoCard = {
  __typename?: 'RelationsPromoCard';
  /** Single available reward to highlight for the user, if any. */
  availableReward?: Maybe<RelationAvailableReward>;
  /** Friends list to show on the home tab. Returns an empty list [] when there are no friends (user has 0 friends). */
  relationsInfo: Array<RelationInfo>;
  /** Number of remaining friend slots available (out of configurable total slots). */
  slotsRemaining: Scalars['Int']['output'];
};

/** Input for the query fetching the Relations Promo card. */
export type RelationsPromoCardInput = {
  /** Client's date and time, with time zone offset. Used to evaluate reward eligibility. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Last time the promo was hidden by the user (client time). */
  lastHiddenAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  /** The type of relation for which to compute friends and rewards. */
  relationType: RelationType;
  /** Last time the rewards screen was shown (client time). */
  rewardsScreenLastViewedAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

/** Input for fetching which promotion to return. */
export type RelationsPromotionInput = {
  /** Civil date and time when the request is made. Optional; if not provided, server time will be used. */
  civilDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  /** The type of relation. */
  relationType: RelationType;
};

/** Enumerates the available promotion types for relations rewards. */
export enum RelationsPromotions {
  /** Promotion for users with an empty friends list. */
  EmptyFriendsListPromotion = 'EMPTY_FRIENDS_LIST_PROMOTION',
  /** Promotion for users with a non-empty friends list. */
  NonEmptyFriendsListPromotion = 'NON_EMPTY_FRIENDS_LIST_PROMOTION'
}

export type ReminderSettings = {
  __typename?: 'ReminderSettings';
  enabled: Scalars['Boolean']['output'];
  reminderSubtype: Scalars['String']['output'];
  reminderTime: Scalars['LocalTime']['output'];
  reminderType: ReminderType;
  reminderUuid: Scalars['UUID']['output'];
};

export type ReminderSettingsList = {
  __typename?: 'ReminderSettingsList';
  reminderSettings: Array<ReminderSettings>;
};

/**
 *  These values must be aligned with:
 *  - reminder_settings.proto (ReminderTypeProto.Value)
 */
export enum ReminderType {
  Medication = 'MEDICATION',
  Unknown = 'UNKNOWN'
}

/**
 * Response wrapper for requestContactsUploadUrl. On success, status is SUCCESS
 * and payload is populated. On failure, status carries the reason and payload
 * is null.
 */
export type RequestContactsUploadUrlResponse = {
  __typename?: 'RequestContactsUploadUrlResponse';
  /** Present when status is SUCCESS; null otherwise. */
  payload?: Maybe<ContactsUploadUrlPayload>;
  /** Status indicating the result of the operation. */
  status: RequestContactsUploadUrlStatus;
};

/**
 * Enumerates the possible outcomes of the requestContactsUploadUrl mutation.
 * The status field on RequestContactsUploadUrlResponse always carries one of
 * these values so callers can branch without inspecting the payload.
 */
export enum RequestContactsUploadUrlStatus {
  /**
   * The user has not granted CONTACT_BOOK_UPLOADING consent
   * (see RelationsConsentType.CONTACT_BOOK_UPLOADING).
   * Callers should surface a consent prompt before retrying.
   */
  ContactsUploadConsentRequired = 'CONTACTS_UPLOAD_CONSENT_REQUIRED',
  /** The contacts-upload feature is disabled for this user via backend feature flag. */
  FeatureDisabled = 'FEATURE_DISABLED',
  /** Pre-signed URL was generated successfully. */
  Success = 'SUCCESS',
  /**
   * The time elapsed since the last completed sync is below the configured
   * minimum resync delay. The client should wait before requesting a new URL.
   */
  SyncTooFrequent = 'SYNC_TOO_FREQUENT',
  /** Unknown or unmapped error. Treat as a transient failure and consider retrying. */
  UnknownError = 'UNKNOWN_ERROR'
}

export type ResultInfoInput = {
  /** Date a patient collected their sample. */
  collectionDate: Scalars['String']['input'];
  /** Date the lab received the sample. */
  dateReceivedAtTheLab: Scalars['String']['input'];
  /** Date results were released. */
  dateReported: Scalars['String']['input'];
  /** Lab name, defaults to "ASH". */
  labName?: InputMaybe<Scalars['String']['input']>;
};

/** Configuration for calculating the rewarded amount. */
export type RewardCalculationConfig = {
  __typename?: 'RewardCalculationConfig';
  /** Maximum metric value used for reward calculation, caps the metric used for calculation, not the final reward amount. */
  metricCap: Scalars['Float']['output'];
  /** Factor used to scale the metric, used for convenience purposes (eg. 0.01 to use steps as a metric, but scale them down so 100 steps = 1 * base reward). */
  metricCoefficient: Scalars['Float']['output'];
  /** Calculation type used to determine reward amount. */
  rewardCalculationType: RewardCalculationType;
};

/** Types of reward calculation. */
export enum RewardCalculationType {
  /** Awards the base reward amount (defined in config) without any scaling. */
  Flat = 'FLAT',
  /** Rewards only the incremental difference of the base reward amount (defined in config) scaled by the metric, within the limit period. */
  IncrementalMultiplicativeMetricBased = 'INCREMENTAL_MULTIPLICATIVE_METRIC_BASED',
  /** Rewards the base reward amount (defined in config) scaled by the metric. */
  MultiplicativeMetricBased = 'MULTIPLICATIVE_METRIC_BASED',
  /** Not expected to be returned, used as a fallback to maintain backwards compatibility if a part of the system is not yet updated. */
  Unknown = 'UNKNOWN'
}

/** Represents an image for a reward */
export type RewardImage = {
  __typename?: 'RewardImage';
  /** Type of image */
  image: RewardImageType;
};

/** Reward image asset - this is a wrapper for enum because union types don't allow enums */
export type RewardImageAsset = {
  __typename?: 'RewardImageAsset';
  /** Type of image asset */
  type: RewardImageAssetType;
};

/**
 * Represents available image assets for rewards.
 * In older versions of the app that do not recognize the image asset type, the image will not be shown.
 */
export enum RewardImageAssetType {
  BlueGemstone = 'BLUE_GEMSTONE',
  GreenGemstone = 'GREEN_GEMSTONE',
  PinkGemstone = 'PINK_GEMSTONE',
  PurpleGemstone = 'PURPLE_GEMSTONE',
  RedGemstone = 'RED_GEMSTONE',
  RedGemstoneHeart = 'RED_GEMSTONE_HEART'
}

/** Represents a reward image with a URL source */
export type RewardImageRemote = {
  __typename?: 'RewardImageRemote';
  /** URL of the image to be displayed for the reward */
  url: Scalars['String']['output'];
};

/**
 * Union of available types of reward images.
 * Currently, we only support local image assets, however, this can be expanded with other types, including URLs for images hosted on the backend.
 * In older versions of the app that do not recognize the image type, depending on where the image is used:
 *     - CurrencyEarnedReward: the reward image will not be shown in the currency earned modal.
 *     - RewardsLevel: the reward level list item will not be shown.
 */
export type RewardImageType = RewardImageAsset | RewardImageRemote;

/** Contains data on rewards shared via the friend reward sharing feature */
export type RewardSharingData = {
  __typename?: 'RewardSharingData';
  /** The amount of currency shared to each friend */
  amountShared: Scalars['Int']['output'];
};

export type Rewards = {
  __typename?: 'Rewards';
  /** Current state of user's rewards. */
  state: RewardsState;
};

/** Represents a single reward level */
export type RewardsLevel = {
  __typename?: 'RewardsLevel';
  /** Image for the reward level */
  image: RewardImage;
  /** Reward level is permanently unlocked once user reached the required amount */
  isUnlocked: Scalars['Boolean']['output'];
  /** Identifies a specific reward level */
  level: Scalars['Int']['output'];
  /** Required amount of currency to unlock the reward */
  requiredCurrencyAmount: Scalars['Int']['output'];
  /** Type of rewards level */
  type: RewardsLevelType;
};

/** Represents a charity reward level */
export type RewardsLevelCharity = {
  __typename?: 'RewardsLevelCharity';
  /** WebView URL for redeeming the reward */
  redeemWebViewUrl: Scalars['String']['output'];
};

/** Represents a gift card reward level */
export type RewardsLevelGiftCard = {
  __typename?: 'RewardsLevelGiftCard';
  /** WebView URL for redeeming the reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary amount of gift card */
  value: Money;
};

/**
 * Union representing the different types of rewards levels.
 * In older versions of the app that do not recognize the reward level type (or the reward image), the reward level will not be shown.
 */
export type RewardsLevelType = RewardsLevelCharity | RewardsLevelGiftCard;

/** Represents the different rewards levels available to users */
export type RewardsLevels = {
  __typename?: 'RewardsLevels';
  /** Contains info for displaying How to earn currency screen */
  howToEarnCurrency: HowToEarnCurrencyType;
  /** A list of available rewards levels */
  levels: Array<RewardsLevel>;
  /**
   * A list of available methods to earn rewards currency
   * @deprecated Methods are not needed any more
   */
  methods: Array<Maybe<EarnCurrencyMethod>>;
};

/**
 * Represents a monetary value used for custom currencies created in the Rewards
 * System
 */
export type RewardsMoney = {
  __typename?: 'RewardsMoney';
  /** Mapped currency types supported on Rewards API. */
  currency: CurrencyCode;
  /**
   * The whole units of the amount.
   * For example if currency is SEEDS, then 10 units represents 10
   * seeds.
   */
  units: Scalars['Int']['output'];
};

/** Status of the rewards processing step within a gamification action */
export enum RewardsProcessingStatus {
  /** An error occurred during rewards processing */
  Error = 'ERROR',
  /** No granting contexts were provided, so rewards processing was skipped */
  Skipped = 'SKIPPED',
  /** Rewards processing completed successfully */
  Successful = 'SUCCESSFUL',
  /** Default value when the status has not been set */
  Unknown = 'UNKNOWN'
}

/** User's rewards experience settings. */
export type RewardsSettings = {
  __typename?: 'RewardsSettings';
  /**
   * Whether reward toast celebrations are disabled for the user. Defaults to false.
   * @deprecated Use rewardToasts instead.
   */
  disableRewardToasts?: Maybe<Scalars['Boolean']['output']>;
  /** Suppress haptics in all gamification features including rewards, streaks, and goals. */
  gamificationHaptics?: Maybe<RewardsToggleSetting>;
  /** Suppress reward modal celebrations for seed earnings. */
  rewardModals?: Maybe<RewardsToggleSetting>;
  /** Suppress reward toast celebrations, including friend shared rewards. */
  rewardToasts?: Maybe<RewardsToggleSetting>;
  /** Suppress streak interstitials including streak celebrations, streak frozen, and streak repair. */
  streakInterstitials?: Maybe<RewardsToggleSetting>;
};

/**
 * Union representing the different types of rewards states.
 * In older versions of the app that do not recognize the reward state type, the state update will be ignored.
 */
export type RewardsState = EnrolledRewardsState | UnenrolledRewardsState;

/** A setting that can be toggled on or off by the user. */
export type RewardsToggleSetting = {
  __typename?: 'RewardsToggleSetting';
  /** Whether the setting is disabled. */
  disabled: Scalars['Boolean']['output'];
  /** Whether the setting is visible to the user. */
  visible: Scalars['Boolean']['output'];
};

/** Prescription treatment card. Contains Rx-specific status, dosing details, and clinician info. */
export type RxTreatmentOverview = TreatmentOverview & {
  __typename?: 'RxTreatmentOverview';
  actionLinks: Array<TreatmentActionLink>;
  chatWithDoctorDeeplink?: Maybe<Scalars['String']['output']>;
  /** Prescribing clinician details. Null when no clinician is associated with the treatment. */
  clinicianDetail?: Maybe<ClinicianDetail>;
  /** Concentration per dose (e.g. 0.2 mg for an 8-unit dose). Null when the dose unit already conveys the amount. */
  concentration?: Maybe<MedicationQuantity>;
  deeplink?: Maybe<Scalars['String']['output']>;
  /**
   * Dosage quantity and unit. Null for lab treatments.
   * @deprecated Use initialDose or latestDoseTaken instead.
   */
  dosage?: Maybe<MedicationQuantity>;
  /** Initial prescribed dosage. Null for lab treatments. */
  initialDose?: Maybe<InitialDose>;
  isMedicationLogSupported?: Maybe<Scalars['Boolean']['output']>;
  /** True when this is a refill checkin; false for a new intake. */
  isRefill?: Maybe<Scalars['Boolean']['output']>;
  /** Latest dose taken, including the dosage and the date it was administered. Null when no dose has been logged. */
  latestDoseTaken?: Maybe<LatestDoseTaken>;
  productBackgroundColor?: Maybe<Scalars['String']['output']>;
  productIconUrl?: Maybe<Scalars['String']['output']>;
  productImageUrl: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  /** Dosing schedule cadence and frequency. Null for lab treatments. */
  schedule?: Maybe<MedicationSchedule>;
  /** Fixed day of the week for dosing. Null when no fixed day applies. */
  scheduledDayOfWeek?: Maybe<DayOfWeek>;
  /** Current status of the prescription. Each variant carries the data relevant to that status. Null when the treatment is in an unrecognized state. */
  status?: Maybe<RxTreatmentStatus>;
  treatmentCode: Scalars['String']['output'];
  treatmentName: Scalars['String']['output'];
};

/** Status union for prescription treatments. Each variant carries the data specific to that state and composes the treatment card UI. */
export type RxTreatmentStatus = TreatmentOverviewStatusDelivered | TreatmentOverviewStatusInReview | TreatmentOverviewStatusIntakeIncomplete | TreatmentOverviewStatusRefills | TreatmentOverviewStatusShipped | TreatmentOverviewStatusShippingSoon | TreatmentOverviewStatusUpdate;

export type SHealthAttributionDataInput = {
  /** Package name of the app inserting data. */
  packageName: Scalars['String']['input'];
  /** Unique identifier for the data point in SHealth. */
  uuid: Scalars['String']['input'];
};

/**
 * Variant of SHealthAttributionDataInput with all fields optional for matching.
 * Keep in sync with SHealthAttributionDataInput.
 */
export type SHealthAttributionDataMatchInput = {
  /** Package name of the app inserting data. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the data point in SHealth. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SaveAnuraScanInput = {
  /** Any signals Anura failed to calculate */
  error?: InputMaybe<AnuraMeasurementError>;
  /** Anura unique identifier of the scan (measurement) */
  faceScanId: Scalars['String']['input'];
  /** Unique identifier (across the organization) of the user in Anura */
  partnerId: Scalars['String']['input'];
  /** Successful point signals */
  results: Array<AnuraMeasurement>;
};

export type SaveFacialBloodScanInput = {
  anuraInput?: InputMaybe<SaveAnuraScanInput>;
};

export type SaveFacialBloodScanQuestionnaireInput = {
  anuraQuestionnaireInput?: InputMaybe<AnuraQuestionnaireInput>;
};

/** Interface for content that can be scheduled */
export type SchedulableContent = {
  /** Unique identifier for the content */
  id: Scalars['ID']['output'];
  /** Title or name of the content */
  title: Scalars['String']['output'];
};

export enum ScheduleCadence {
  Day = 'DAY',
  Unknown = 'UNKNOWN',
  Week = 'WEEK'
}

/** A piece of scheduled content */
export type ScheduledContent = {
  __typename?: 'ScheduledContent';
  /** The content to be displayed in the scheduled slot */
  content: SchedulableContent;
  /** End date and time of the scheduled content */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Start date and time of the scheduled content */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Current status of the scheduled content */
  status?: Maybe<ContentStatus>;
  /** Unique Identifier for scheduled content */
  uuid: Scalars['ID']['output'];
};

/** A list of scheduled contents with pagination support */
export type ScheduledContentList = Pageable & {
  __typename?: 'ScheduledContentList';
  /** The list of scheduled content items */
  items: Array<ScheduledContent>;
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Enum for different types of schedulable content */
export enum ScheduledContentType {
  /** Art break content type */
  ArtBreak = 'ART_BREAK',
  /** Unspecified content type (default) */
  ContentTypeUnspecified = 'CONTENT_TYPE_UNSPECIFIED'
}

/** A wrapper for the seeds string Content Item description */
export type SeedsString = {
  __typename?: 'SeedsString';
  /** Simple string value */
  value: Scalars['String']['output'];
};

/** Response from a successfully updated body scan mode setting */
export type SetBodyScanModeSettingResponse = {
  __typename?: 'SetBodyScanModeSettingResponse';
  mode: BodyScanMode;
};

/** Input for setRelationConsent. */
export type SetRelationConsentInput = {
  /** Consent type identifier (e.g. `CONTACT_BOOK_UPLOADING`). */
  consentType: RelationsConsentType;
  /**
   * Qualifier scoping the consent within its type. The `consentType`
   * defines *what* the consent is for; the qualifier defines *for
   * whom/which*. Required when the consent type is scoped; MUST be
   * unset for unscoped types. Must not contain PII (e.g. no email
   * addresses, phone numbers, or access codes).
   */
  qualifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which system is capturing this decision (e.g. `noom-app`,
   * `buyflow`). Used for downstream auditing and analytics.
   */
  source: Scalars['String']['input'];
  /**
   * The consent decision. The schema accepts the full `ConsentStatus`
   * enum, but the server rejects `NOT_SPECIFIED` with HTTP 400 — only
   * `GRANTED` / `DENIED` actually persist. Represent the not-specified
   * state by not sending a `setRelationConsent` for the natural key.
   */
  status: ConsentStatus;
};

/** Response from a successfully updated show avatar setting */
export type SetShowAvatarSettingResponse = {
  __typename?: 'SetShowAvatarSettingResponse';
  showAvatar: Scalars['Boolean']['output'];
};

export type SetToolPinStateInput = {
  pinned: Scalars['Boolean']['input'];
  toolId: ToolId;
};

/** Represents biological sex */
export enum Sex {
  Female = 'FEMALE',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

export type ShareableImage = {
  __typename?: 'ShareableImage';
  mediaUrl: Scalars['String']['output'];
};

export type ShareableMedia = {
  __typename?: 'ShareableMedia';
  /** The actual item (image, video, etc) to share */
  item: ShareableMediaItem;
  /** The default string that the user will use as 'subject' if they choose to share through email */
  subject?: Maybe<Scalars['String']['output']>;
  /** The default string that the user will share in social media together with whatever media item they're sharing */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of the template that generated this shareable, so that we can send events to analytics */
  type: Scalars['String']['output'];
};

export type ShareableMediaItem = ShareableImage | ShareableToggleImage | ShareableVideo;

export type ShareableToggleImage = {
  __typename?: 'ShareableToggleImage';
  mediaUrl1: Scalars['String']['output'];
  mediaUrl2: Scalars['String']['output'];
  toggleButtonTitle1: Scalars['String']['output'];
  toggleButtonTitle2: Scalars['String']['output'];
};

export type ShareableVideo = {
  __typename?: 'ShareableVideo';
  mediaUrl: Scalars['String']['output'];
};

/** Common fields for all shipment records. */
export type Shipment = {
  /** Shipping carrier name (e.g. 'UPS', 'USPS', 'FedEx'). */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Current status of this shipment. */
  status: ShipmentStatus;
  /** Carrier tracking number.  */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Full carrier tracking URL. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Shipment history grouped by product type. */
export type ShipmentHistoryList = {
  __typename?: 'ShipmentHistoryList';
  /** Whether older shipment records exist beyond those returned. When the query is called with `includeOlderRecords: false`, this is true if there are additional, older records that would be returned by `includeOlderRecords: true`. Always false when the full history has already been returned (i.e. when called with `includeOlderRecords: true`). Clients use this to decide whether to offer a 'Show older shipments' action. */
  hasOlderRecords: Scalars['Boolean']['output'];
  /** Order history groups, one per product. */
  products: Array<ProductShipmentHistory>;
};

/** Common fields for all shipment-history order records. */
export type ShipmentOrder = {
  /** Date and time the order was placed. */
  orderDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Order identifier. */
  orderId: Scalars['ID']['output'];
  /** Product categories. */
  productCategories: Array<ShipmentProductCategory>;
  /** Shipments associated with this order. */
  shipments: Array<Shipment>;
  /** Shipping address for this order. Populated for Scale and OTC orders; null for all other product types. */
  shippingAddress?: Maybe<Address>;
  /** Current status of this order. */
  status: ShipmentOrderStatus;
  /** Fulfillment partner, pharmacy, or vendor name (e.g. 'Wells Dallas', 'Ash Labs'). */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** Order status values across all product types. */
export enum ShipmentOrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Failed = 'FAILED',
  InputInTransit = 'INPUT_IN_TRANSIT',
  InputReceived = 'INPUT_RECEIVED',
  IssueReported = 'ISSUE_REPORTED',
  OrderDelivered = 'ORDER_DELIVERED',
  OrderFulfilled = 'ORDER_FULFILLED',
  OrderPlaced = 'ORDER_PLACED',
  OrderReplaced = 'ORDER_REPLACED',
  Preparing = 'PREPARING',
  Prescribed = 'PRESCRIBED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Reshipped = 'RESHIPPED',
  ResultsReady = 'RESULTS_READY',
  Shipped = 'SHIPPED',
  Unknown = 'UNKNOWN',
  Voided = 'VOIDED',
  VoidRequested = 'VOID_REQUESTED',
  WaitingForInbound = 'WAITING_FOR_INBOUND'
}

/** Product category. */
export enum ShipmentProductCategory {
  /** Biomarker test kit. */
  LabKit = 'LAB_KIT',
  /** Over-the-counter supplement. */
  Otc = 'OTC',
  /** Prescription medication. */
  Rx = 'RX',
  /** Scale device. */
  Scale = 'SCALE',
  /** Supply item. */
  Supply = 'SUPPLY',
  /** Unknown product category */
  Unknown = 'UNKNOWN'
}

/** Shipment status values across all product types. */
export enum ShipmentStatus {
  Accepted = 'ACCEPTED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Pending = 'PENDING',
  Preparing = 'PREPARING',
  Prescribed = 'PRESCRIBED',
  Processing = 'PROCESSING',
  Received = 'RECEIVED',
  Reshipped = 'RESHIPPED',
  Shipped = 'SHIPPED',
  Unknown = 'UNKNOWN',
  Voided = 'VOIDED',
  VoidRequested = 'VOID_REQUESTED'
}

/**
 * Currently only listing the properties that we use,
 * see: https://shopify.dev/docs/api/admin-rest/2024-10/resources/order
 */
export type ShopifyOrder = {
  __typename?: 'ShopifyOrder';
  /** ISO 4217 currency code for the order */
  currency?: Maybe<Scalars['String']['output']>;
  /** The ID of the order */
  id?: Maybe<Scalars['String']['output']>;
  /** The line items in the order */
  lineItems?: Maybe<Array<ShopifyOrderLineItem>>;
  /** Human-friendly order name/number */
  name?: Maybe<Scalars['String']['output']>;
  /** Arbitrary key/value attributes captured on the order */
  noteAttributes?: Maybe<Array<ShopifyOrderNoteAttribute>>;
  /** When the order was processed */
  processedAt?: Maybe<Scalars['String']['output']>;
  /** Refund records associated with the order */
  refunds?: Maybe<Array<ShopifyOrderRefund>>;
  /** Comma-separated list of tags on the order */
  tags?: Maybe<Scalars['String']['output']>;
  /** Total price for the order in shop currency (stringified decimal) */
  totalPrice?: Maybe<Scalars['String']['output']>;
  /** Total tax charged on the order (stringified decimal) */
  totalTax?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderLineItem = {
  __typename?: 'ShopifyOrderLineItem';
  /** Line item title (product/variant name) */
  name?: Maybe<Scalars['String']['output']>;
  /** Line item price (stringified decimal, in order currency) */
  price?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderNoteAttribute = {
  __typename?: 'ShopifyOrderNoteAttribute';
  /** Attribute key/name */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute value */
  value?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderRefund = {
  __typename?: 'ShopifyOrderRefund';
  /** The ID of the refund */
  id?: Maybe<Scalars['String']['output']>;
  /** When the refund was processed */
  processedAt?: Maybe<Scalars['String']['output']>;
  /** Transactions created as part of this refund */
  transactions?: Maybe<Array<ShopifyOrderTransaction>>;
};

export type ShopifyOrderTransaction = {
  __typename?: 'ShopifyOrderTransaction';
  /** Refunded amount (stringified decimal, in order currency) */
  amount?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrdersList = {
  __typename?: 'ShopifyOrdersList';
  /** Shopify orders */
  orders?: Maybe<Array<ShopifyOrder>>;
};

/** A short URL that redirects to a destination URL */
export type ShortUrl = {
  __typename?: 'ShortUrl';
  /** When the short URL was created */
  createdAt: Scalars['OffsetDateTime']['output'];
  /** When the short URL was deleted (soft-delete), null if not deleted */
  deletedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The destination URL that this short URL redirects to */
  destinationUrl: Scalars['String']['output'];
  /** The full short URL (e.g., 'https://link.noom.com/r/abc12345') */
  shortUrl: Scalars['String']['output'];
  /** The unique slug identifier (e.g., 'abc12345') */
  slug: Scalars['ID']['output'];
  /** When the short URL was last updated */
  updatedAt: Scalars['OffsetDateTime']['output'];
};

/** Paginated list of short URLs */
export type ShortUrlList = Pageable & {
  __typename?: 'ShortUrlList';
  /** List of short URLs */
  nodes: Array<ShortUrl>;
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SideEffect = {
  __typename?: 'SideEffect';
  ctaDeepLink: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  sideEffectId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SideEffectsSection = {
  __typename?: 'SideEffectsSection';
  ctaDeepLink: Scalars['String']['output'];
  ctaTitle: Scalars['String']['output'];
  footer: Scalars['String']['output'];
  sideEffects: Array<SideEffect>;
  title: Scalars['String']['output'];
};

/** Content for an small ad in the hamburger menu. */
export type SideNavMenuSmallContent = {
  __typename?: 'SideNavMenuSmallContent';
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** The url of the image to show. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
  /** The title of this content. */
  title?: Maybe<Scalars['String']['output']>;
};

export type SimpleMealItem = {
  __typename?: 'SimpleMealItem';
  calories?: Maybe<Scalars['Float']['output']>;
  foodColor?: Maybe<FoodColor>;
  greenScore?: Maybe<Scalars['Float']['output']>;
  loggedUuid: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  nutritionBreakdown?: Maybe<NutritionBreakdown>;
  originUuid?: Maybe<Scalars['UUID']['output']>;
  portion?: Maybe<Portion>;
};

export type SimpleMealItemInput = {
  /** Calorie count */
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** Food color category */
  foodColor?: InputMaybe<FoodColor>;
  /** Green score */
  greenScore?: InputMaybe<Scalars['Float']['input']>;
  /** Client-generated UUID to track this logged item */
  loggedUuid: Scalars['UUID']['input'];
  /** Display name */
  name: Scalars['String']['input'];
  /** Detailed nutrient breakdown */
  nutritionBreakdown?: InputMaybe<NutritionBreakdownInput>;
  /** UUID linking to the food database */
  originUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Portion information */
  portion?: InputMaybe<PortionInput>;
};

/**
 * Lifecycle state of a SKU registry entry. INACTIVE entries reject new orders with 400 at the EF layer.
 * Maps to SkuLifecycleStateEnumProto.Value in noom_contracts/external_fulfillment/shared.proto.
 * Keep in sync with the proto.
 */
export enum SkuLifecycleState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

/**
 * Product type / category for a SKU registry entry.
 * Maps to ProductTypeEnumProto.Value in noom_contracts/external_fulfillment/shared.proto.
 * Keep in sync with the proto.
 */
export enum SkuProductType {
  OtcSupplement = 'OTC_SUPPLEMENT',
  Unknown = 'UNKNOWN'
}

/**
 * A mapping between a Noom-internal SKU and a vendor-specific product code.
 * Maps to SkuRegistryProto in noom_contracts/external_fulfillment/orders/model/sku_registry.proto.
 */
export type SkuRegistryEntry = {
  __typename?: 'SkuRegistryEntry';
  id: Scalars['ID']['output'];
  internalSku: Scalars['String']['output'];
  lifecycleState: SkuLifecycleState;
  productType: SkuProductType;
  vendor: SkuVendor;
  vendorSku: Scalars['String']['output'];
};

/**
 * Wrapper around the SKU Registry list response. The wrapper is required by the repo's no-top-level-lists
 * convention so pagination (cursor + pageInfo) can be added retroactively without breaking clients; the
 * underlying REST endpoint is unpaginated today and clients should treat `entries` as the full result set.
 */
export type SkuRegistryEntryList = {
  __typename?: 'SkuRegistryEntryList';
  /** All SKU registry entries matching the filter. Server-side sort: internalSku ASC, vendor ASC. */
  entries: Array<SkuRegistryEntry>;
};

/** Filter inputs for skuRegistryEntries. Empty fields are ignored; non-empty fields AND together. */
export type SkuRegistryFilter = {
  internalSku?: InputMaybe<Scalars['String']['input']>;
  lifecycleState?: InputMaybe<SkuLifecycleState>;
  productType?: InputMaybe<SkuProductType>;
  vendor?: InputMaybe<SkuVendor>;
};

/**
 * Vendor used for external fulfillment of a SKU registry entry.
 * Maps to VendorEnumProto.Value in noom_contracts/external_fulfillment/shared.proto.
 * Keep in sync with the proto — adding a value here without adding it there will break resolver mapping.
 */
export enum SkuVendor {
  Impilo = 'IMPILO',
  Noop = 'NOOP',
  PharmacyHub = 'PHARMACY_HUB',
  Unknown = 'UNKNOWN'
}

/** Required fields for client to recommend a SmartDose */
export type SmartDose = {
  __typename?: 'SmartDose';
  /** List of items appearing in the 'About your SmartDose' card */
  aboutSmartDoseFacts: Array<LabeledValue>;
  /** Descriptive text about user's weight/SmartDose trends */
  aboutYourSmartdoseMarkdown?: Maybe<Scalars['String']['output']>;
  /** The user's personalized dosage amount */
  dose: Scalars['Float']['output'];
  /** Available selectable doses, in order, and containing the recommended `dose`. */
  doseOptions: Array<SmartDoseOption>;
  /** Extra information about the dose (eg. drug, concentration, syringe type) */
  doseSubtitle?: Maybe<Scalars['String']['output']>;
  /** Server-calculated integer syringe injection units */
  doseSyringeUnits?: Maybe<Scalars['Int']['output']>;
  /** The units their personalized dosage is measured in */
  doseUnits: DoseUnits;
  /** URL of example syringe image showing correct dose amount */
  exampleSyringeImageUrl?: Maybe<Scalars['String']['output']>;
  /** URL for a website with injection instructions */
  injectionInstructionsUrl?: Maybe<Scalars['String']['output']>;
  /** The internal id of the drug they are prescribed */
  internalDrugId: Scalars['ID']['output'];
  /** Task card text shown when SmartDose is calculated but med not logged */
  smartDoseCalculatedTaskCardMarkdown?: Maybe<Scalars['String']['output']>;
};

/** Medication information for SmartDose and Product Switching flows */
export type SmartDoseMedication = {
  __typename?: 'SmartDoseMedication';
  /** Subtitle of the drug's medication change option; supports Markdown */
  displaySubtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the drug's medication change option; supports Markdown */
  displayTitle: Scalars['String']['output'];
  /** Prescription catalog drug identifier */
  internalDrugId: Scalars['ID']['output'];
  /** Color HEX code (#RRGGBB) for the medication background in the UI */
  medicationBackgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Product-level medication external ID for client reference */
  medicationExternalId: Scalars['String']['output'];
  /** URL of the image representing the medication */
  medicationImageUrl?: Maybe<Scalars['String']['output']>;
  /** Human readable medication name */
  medicationName: Scalars['String']['output'];
  /** The list of potential side-effects for this medication */
  potentialSideEffects: Array<MedicationSideEffect>;
};

export type SmartDoseMedications = {
  __typename?: 'SmartDoseMedications';
  /** Currently-prescribed SmartDose medication */
  current: SmartDoseMedication;
  /** Optional medication to ask the user to switch to in the Product Switching scenario */
  proposed?: Maybe<SmartDoseMedication>;
};

/**
 * Enumerated error reasons whose names will appear in `errors[].extensions.code`
 * in the response to [Mutation.calculateSmartDose].
 * An accompanying user-facing message should also appear at
 * `.extensions.userMessage`, to be displayed to the user.
 */
export enum SmartDoseMutationErrorCodes {
  /**
   * It is not safe to continue taking the medication.
   * Clients should show a CTA to contact their clinician.
   */
  DiscontinueMedication = 'DISCONTINUE_MEDICATION',
  /**
   * The user's app does not support product switching for smartdose.
   * The user will be sent a message to upgrade their app.
   */
  UpgradeRequired = 'UPGRADE_REQUIRED'
}

/** Dose amount paired with its corresponding syringe units, in `DoseUnits` of the parent. */
export type SmartDoseOption = {
  __typename?: 'SmartDoseOption';
  /** Dose amount, in `DoseUnits` of the parent */
  dose: Scalars['Float']['output'];
  /** Calculated injectable syringe units */
  syringeUnits?: Maybe<Scalars['Int']['output']>;
};

/** Defines the sorting implementation for a list */
export type Sort = {
  /** The key that the list will be sorted by. If not set, the backend will select a default sort key */
  sortKey?: InputMaybe<Scalars['String']['input']>;
  /** The order in which the results are returned */
  sortOrder?: SortOrder;
};

/** Defines the sorting order for a list */
export enum SortOrder {
  /** Ascending order. Ex: A->Z, 1->9 */
  Ascending = 'ASCENDING',
  /** Use the natural sorting order as defined by the backend */
  Default = 'DEFAULT',
  /** Descending order. Ex: Z->A, 9->1 */
  Descending = 'DESCENDING'
}

/** Classification of glucose spike potential for a specific food item */
export enum SpikeClassification {
  /** Food item is predicted to cause a moderate increase in blood glucose levels */
  Elevated = 'ELEVATED',
  /** Food item is predicted to cause a significant spike in blood glucose levels */
  Spike = 'SPIKE',
  /** Food item is predicted to have minimal impact on blood glucose levels */
  Stable = 'STABLE',
  /** Classification could not be determined due to insufficient data or analysis failure */
  Unknown = 'UNKNOWN'
}

/** Standalone content (e.g. static articles) served by url */
export type StandaloneContent = {
  __typename?: 'StandaloneContent';
  /** Analytics properties filled on the backend and forwarded by the mobile client in the analytics events */
  analyticsProperties?: Maybe<Array<AnalyticsProperty>>;
  /** Url for audio version of the content */
  audioSourceUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user has completed this content */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** Opaque payload for tracking content consumption state */
  contentConsumedPayload?: Maybe<Scalars['String']['output']>;
  /** Id for content analytics */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Url for standalone content */
  contentUrl: Scalars['String']['output'];
  /** Optional format of content - used with rewards toast */
  format?: Maybe<Scalars['String']['output']>;
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Optional label for the content (e.g. 'video', 'story', 'quiz') */
  label?: Maybe<Scalars['String']['output']>;
  /** ID of the recommendation from the Recommender system */
  recommendationId?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title: Scalars['String']['output'];
};

/** Groups standalone content into titled sections */
export type StandaloneContentSection = {
  __typename?: 'StandaloneContentSection';
  /** Optional label for refresh timing or status (e.g. 'Next in 12h') */
  refreshLabel?: Maybe<Scalars['String']['output']>;
  /** List of standalone content in the section */
  standaloneContentList: Array<StandaloneContent>;
  /** Optional subtitle for personalized content */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Section Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Task List assignment for the Home screen Standalone Content section. */
export type StandaloneContentSectionAssignment = {
  __typename?: 'StandaloneContentSectionAssignment';
  /** Section with a list of standalone content. */
  section: StandaloneContentSection;
};

/** Response from starting a single micro challenge. */
export type StartMicroChallengeResponse = {
  __typename?: 'StartMicroChallengeResponse';
  /** Human-readable error message if the operation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the challenge was started successfully. */
  success: Scalars['Boolean']['output'];
  /**
   * The newly created or resumed user micro challenge instance, including its
   * current state, template, available actions, and recipe (if any). Null when
   * the operation failed.
   */
  userMicroChallenge?: Maybe<UserMicroChallenge>;
  /** ID of the newly created or resumed user micro challenge instance. */
  userMicroChallengeId?: Maybe<Scalars['UUID']['output']>;
};

/** Per-challenge input for starting a micro challenge stack. */
export type StartMicroChallengeStackChallengeInput = {
  /** ID of the micro challenge to start. */
  microChallengeId: Scalars['String']['input'];
  /** Pre-populated recipe steps for challenges that include a recipe component. */
  recipeSteps?: InputMaybe<Array<MicroChallengeRecipeStepInput>>;
  /** ID of an existing user micro challenge instance to resume. If omitted, a new instance is created. */
  userMicroChallengeId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Response from starting a micro challenge stack. */
export type StartMicroChallengeStackResponse = {
  __typename?: 'StartMicroChallengeStackResponse';
  /** Human-readable error message if the operation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** Challenges skipped because the user already has an active instance */
  skipped: Array<UserMicroChallenge>;
  /** Successfully started challenge instances */
  started: Array<UserMicroChallenge>;
  /** Whether all challenges in the stack were processed without error. */
  success: Scalars['Boolean']['output'];
};

export type StepGoalMetadata = {
  __typename?: 'StepGoalMetadata';
  minStepCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Per-partner step-protocol thresholds, sourced from
 * PartnerProto.step_protocol_config (StepProtocolPartnerConfigProto)
 */
export type StepProtocolConfig = {
  __typename?: 'StepProtocolConfig';
  /** Window counts the user can choose from when ordering refills */
  availableWindowCounts: Array<Scalars['Int']['output']>;
  /** Number of days in each rolling engagement window */
  daysPerWindow?: Maybe<Scalars['Int']['output']>;
  /** Default window count to pre-select for the user */
  defaultWindowCount?: Maybe<Scalars['Int']['output']>;
  /** Number of engaged days required within a window */
  requiredEngagedDays?: Maybe<Scalars['Int']['output']>;
};

export type StepTarget = {
  minStepCount?: InputMaybe<Scalars['Int']['input']>;
};

export type StepsData = {
  __typename?: 'StepsData';
  measurementCivilDate?: Maybe<Scalars['LocalDate']['output']>;
  stepCount: Scalars['Int']['output'];
};

export type StepsDataInput = {
  measurementCivilDate: Scalars['LocalDate']['input'];
  stepCount: Scalars['Int']['input'];
};

export type Streak = {
  __typename?: 'Streak';
  /** The list of days with states representing the state history of this streak */
  dayHistory?: Maybe<Array<StreakDay>>;
};

/**
 * The animation type to show the user.
 * The backend determines if a user's streak has reached a milestone (e.g., 7 or 30 days)
 * and sets the appropriate animation type. Clients use this value to select a random
 * animation from the corresponding set.
 */
export enum StreakAnimationType {
  /** Default animation type */
  Default = 'DEFAULT',
  /** Milestone animation type */
  Milestone = 'MILESTONE'
}

export enum StreakDailyStatus {
  /** Indicates the streak was frozen */
  Frozen = 'FROZEN',
  /** Indicates that the streak was increased */
  Incremented = 'INCREMENTED',
  /** Indicates that the streak was not increased or frozen */
  Missed = 'MISSED',
  /** Indicates that the day is still in progress */
  Pending = 'PENDING',
  /** Indicates that the day was repaired by support team intervention */
  SupportRepaired = 'SUPPORT_REPAIRED',
  /** Indicates that the day was repaired by user through product redemption */
  UserRepaired = 'USER_REPAIRED'
}

export type StreakDay = {
  __typename?: 'StreakDay';
  /** The date of the StreakDay state */
  date: Scalars['LocalDate']['output'];
  /** The length of the streak on the current day */
  length: Scalars['Int']['output'];
  /** The status for the given date */
  status: StreakDailyStatus;
};

export type StreakFreeze = {
  __typename?: 'StreakFreeze';
  /** The number of streak freezes available */
  count: Scalars['Int']['output'];
};

/** Result metadata of a successful Streak Freeze purchase */
export type StreakFreezeResult = {
  __typename?: 'StreakFreezeResult';
  /** Number of available streak freezes after redemption */
  availableFreezesCount: Scalars['Int']['output'];
};

/**
 * Reason for the streak increase.
 * Used on clients to display different Welli animations and for analytics.
 */
export enum StreakIncreaseReason {
  /** User performed an art break */
  ArtBreak = 'ART_BREAK',
  /** User performed a body scan */
  BodyScan = 'BODY_SCAN',
  /** User read curriculum content */
  CurriculumContent = 'CURRICULUM_CONTENT',
  /** User performed a face scan */
  FaceScan = 'FACE_SCAN',
  /** User performed a facial blood scan. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** User logged food */
  FoodLogging = 'FOOD_LOGGING',
  /** User logged medicine ingestion */
  MedLogging = 'MED_LOGGING',
  /** User progressed micro challenge */
  MicroChallenge = 'MICRO_CHALLENGE',
  /** User logged mood */
  MoodLogging = 'MOOD_LOGGING',
  /** User logged movement */
  MoveLogging = 'MOVE_LOGGING',
  /** User read standalone content */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User banked steps */
  StepBanking = 'STEP_BANKING',
  /** User logged stress status */
  StressLogging = 'STRESS_LOGGING',
  /** User received a Treat Day streak increment */
  TreatDay = 'TREAT_DAY',
  /** User logged water ingestion */
  WaterLogging = 'WATER_LOGGING',
  /** User logged weight */
  WeightLogging = 'WEIGHT_LOGGING'
}

export type StreakIncreasedCelebration = {
  __typename?: 'StreakIncreasedCelebration';
  /** The animation type to show the user. */
  animationType?: Maybe<StreakAnimationType>;
  /** The streak data for the last 7 days, today inclusive */
  history?: Maybe<Array<StreakDay>>;
  /** Optional configuration for the intro experience */
  intro?: Maybe<StreakIncreasedIntroExperience>;
  /** Reason for the streak increase. */
  reason?: Maybe<StreakIncreaseReason>;
  /** The current value of the streak */
  streakAmount: Scalars['Int']['output'];
  /** The type of the streak */
  streakType: StreakType;
};

export type StreakIncreasedIntroExperience = {
  __typename?: 'StreakIncreasedIntroExperience';
  /** List of possible commitment lengths in days */
  commitmentLengths?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Wrapper type for streak milestone celebrations. */
export type StreakMilestoneCelebration = {
  __typename?: 'StreakMilestoneCelebration';
  /** The type of streak milestone celebration. */
  streakMilestoneCelebrationType: StreakMilestoneCelebrationType;
};

/**
 * Union type representing different types of streak milestone celebrations.
 * In older versions of the app that do not recognize the celebration type, the celebration will be ignored.
 */
export type StreakMilestoneCelebrationType = StreakMilestoneProgressCelebration | StreakMilestoneReachedCelebration;

/** Celebration shown when user makes progress towards a streak milestone. */
export type StreakMilestoneProgressCelebration = {
  __typename?: 'StreakMilestoneProgressCelebration';
  /** The user's current streak length. */
  currentStreakAmount: Scalars['Int']['output'];
  /**
   * List of streak milestones to display in the celebration.
   * This is typically the last reached milestone and the next 2 milestones, or the first 3 milestones if the user hasn't reached the first milestone yet.
   */
  milestones: Array<Scalars['Int']['output']>;
};

/** Celebration shown when user reaches a streak milestone. */
export type StreakMilestoneReachedCelebration = {
  __typename?: 'StreakMilestoneReachedCelebration';
  /** The streak milestone that was just reached. */
  reachedMilestone: Scalars['Int']['output'];
  /**
   * List of upcoming streak milestones to display in the celebration.
   * This is typically the next 2 milestones after the reached milestone.
   */
  upcomingMilestones: Array<Scalars['Int']['output']>;
};

/** Response containing the list of milestone values */
export type StreakMilestones = {
  __typename?: 'StreakMilestones';
  /** The list of milestone values */
  milestones: Array<Scalars['Int']['output']>;
};

/** Input parameters for the streakMilestones query */
export type StreakMilestonesInput = {
  /** The type of streak to get milestones for */
  type: StreakType;
  /**
   * The number of milestones to return. If null, returns all milestones.
   *
   * When provided, returns a sliding window of milestones that shifts by (window-1)
   * each time the user reaches the last milestone in their current window.
   *
   * Example progression with window=4:
   * - Streak 1-20: returns [3, 7, 14, 21] (window stays fixed as user progresses through each milestone)
   * - Streak 21+: returns [21, 30, 45, 60] (user reached 21, window shifts by (window-1))
   * - Streak 60+: returns [60, 90, 120, 150] (user reached 60, window shifts again)
   */
  window?: InputMaybe<Scalars['Int']['input']>;
};

/** Union of streaks specific processing results */
export type StreakProcessingResult = GamificationActionStreakFailure | GamificationActionStreakUpdated;

/** Result metadata of a successful Streak Repair */
export type StreakRepairResult = {
  __typename?: 'StreakRepairResult';
  /** The list of days with states representing the state history of the repaired streak */
  dayHistory: Array<StreakDay>;
  /** Length of the streak after the repair */
  streakLength: Scalars['Int']['output'];
  /** Type of the repaired streak */
  streakType: StreakType;
};

export enum StreakType {
  EngagementActionStreak = 'ENGAGEMENT_ACTION_STREAK'
}

/** Configuration for the streaks feature */
export type StreaksConfig = {
  __typename?: 'StreaksConfig';
  /** Enables streak calendar cohesion improvements */
  isStreakCalendarCohesionImprovementsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Status of the streaks processing step within a gamification action */
export enum StreaksProcessingStatus {
  /** An error occurred during streak processing */
  Error = 'ERROR',
  /** No streak action was provided or the request was validation-only, so streaks processing was skipped */
  Skipped = 'SKIPPED',
  /** Streak processing completed successfully — check individual streak results for per-streak failures */
  Successful = 'SUCCESSFUL',
  /** Default value when the status has not been set */
  Unknown = 'UNKNOWN'
}

/** Input for submitting a customer satisfaction survey */
export type SubmitCsatSurveyInput = {
  rating: Scalars['Int']['input'];
  submittedBy: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
  textFeedback?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Returns new state of an aggregated measurement on subscription and on any change detected by measurements-api.
   * fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded. Limit corresponds to pageSize, but we aren't enabling full pagination over
   * subscriptions yet. Most use-cases should provide a fromCivilDateTime with reasonable scope, a toCivilDateTime
   * of the present, and keep expected measurement count in the low-hundreds, well short of the max limit of 1000.
   * If you need more than 1000 data points at once, reach out to TNG to make pagination available externally!
   */
  aggregatedMeasurementDataList: AggregatedMeasurementDataList;
  /**
   * Returns the information needed by the client to draw a chart with the specified measurements and annotations.
   * - fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   *     future measurements) are unbounded
   * - Chronological or reverse chronological order is provided by the "from" and "to" dates: if "from" is earlier than "to",
   *     then it will be in chronological order; and if "to" is earlier than "from", it will go in reverse chronological order
   * - You can also optionally limit by a maximum number of measurements and/or maximum number of annotations. Whatever
   *     is reached earlier will set the limit of the graph, and no further measurements or annotations beyond those
   *     will be provided (e.g. if we limit to 10 annotations, and the 10th annotation happens on a certain date, then no
   *     annotations or measurements will be provided beyond that date, even if we still had a larger limit of
   *     measurements). If not provided, they are each limited to 100. The maximum limit accepted is 500: if a higher
   *     limit is provided, it will be ignored and 500 will be used. We still don't provide any mechanism for pagination,
   *     so if you need more elements than that, please reach out to the Program Content team!
   */
  annotatedMeasurementTrendChart: AnnotatedMeasurementTrendChart;
  /**
   * DEPRECATED (use bloodGlucoseOverviewDataV2 instead) Provides an overview of a user's blood
   * glucose data for a specified time period, starting from a given date and extending backward
   * to cover the defined period. For example, if the specified period is 'WEEK' and the date is
   * '2025-01-01', the overview data will cover the period from '2024-12-26' to '2025-01-01'
   */
  bloodGlucoseOverviewData: BloodGlucoseOverviewData;
  /**
   * Provides an overview of a user's blood glucose data for a specified time period, starting
   * from a given date and extending backward to cover the defined period. For example, if the
   * specified period is 'WEEK' and the date is '2025-01-01', the overview data will cover the
   * period from '2024-12-26' to '2025-01-01'.
   *
   * Deprecates bloodGlucoseOverviewData: Users with 1k+ blood glucose logs in a week/month
   * (mainly CGM users) may see incomplete chart data due to a 1k cap in the backend aggregation
   * logic. Fixing it requires backend and client breaking changes, so a new version of the endpoint
   * is necessary.
   */
  bloodGlucoseOverviewDataV2: BloodGlucoseOverviewData;
  /** Returns any changes to the user's current body scan status */
  bodyScanTrackerState: BodyScanTrackerState;
  /**
   * Returns events when users earn rewards currency.
   * This triggers UI on the client to notify the user of the currency earned.
   */
  currencyEarned: CurrencyEarnedEvent;
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /**
   * Returns the state of the user's face scan task.
   * Access code is optional to enable easier testing. If no access code is given it will be taken from AuthTokenProvider
   */
  faceScanTask: FaceScanTask;
  /** Returns state of the home screen carousel */
  homeScreenCarouselState: HomeScreenCarouselState;
  /**
   * Returns new state of a given measurement on new subscription and on any change detected by measurements-api.
   * fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded. Limit corresponds to pageSize, but we aren't enabling full pagination over
   * subscriptions yet. Most use-cases should provide a fromCivilDateTime with reasonable scope, a toCivilDateTime
   * of the present, and keep expected measurement count in the low-hundreds, well short of the max limit of 1000.
   * If you need more than 1000 data points at once, reach out to TNG to make pagination available externally!
   */
  measurementDataList: MeasurementDataList;
  /** Subscribes to real-time med refill eligibility updates, emitting new data when engagement changes */
  medRefillEligibility: MedRefillEligibility;
  /**
   * Subscribe to real-time updates of the user's micro challenges state.
   * This subscription will push updates whenever:
   * - A micro challenge is started
   * - Progress is made on a micro challenge
   * - A micro challenge is completed
   * - A micro challenge expires
   * - The tracker state changes (HIDDEN <-> INTRO <-> INACTIVE <-> ACTIVE)
   *
   * `challengeTypes` filters which kinds of challenges are returned. When null or
   * omitted (e.g. by older clients that predate this parameter) the backend
   * returns only `TIME_BOUND` challenges for backwards compatibility. New clients
   * that can render additional types must opt in explicitly, e.g.
   * `[TIME_BOUND, ONE_TIME]`.
   */
  microChallengesTrackerState: MicroChallengesTrackerState;
  /**
   * Pushes the refreshed nutrient-goal list when meal logging/measurements update a relevant goal.
   *
   * The `clientDateTime` argument is captured once at subscription start and is not re-evaluated on
   * subsequent push events. As a result, the subscription will continue emitting goals scoped to the
   * originally provided date even if the connection stays open past midnight. Clients should
   * re-subscribe at the day boundary to receive goals for the current local date.
   *
   * The `enabledOnly` argument mirrors the sibling `nutrientGoalsForDate` query and controls whether
   * only enabled goals are returned; when omitted, the resolver's default applies.
   */
  nutrientGoalsUpdatedList: UserGoalList;
  /** Returns a list of past medication doses. */
  pastMedicationDoseList: PastMedicationDoseList;
  /**
   * Used to preview the result of processing a gamification action - this will not make any updates to the state of the system.
   * It will immediately emit a value, and if the state of the system changes, a new result will be emitted to ensure clients always have the live state.
   */
  previewGamificationAction: GamificationActionResult;
  /** Listen for processing updates of the scanId */
  processingState: FaceScanImageProcessingState;
  /** Stream the list of relations and their activities (e.g., steps, green calories) for a user. The server resolves `extra_data` lazily; if the client does not select extra fields, no extra computation occurs." */
  relationActivitiesList: RelationActivitiesList;
  /**
   * Returns any changes to the user's rewards state.
   * This triggers a display update on the client to reflect the new rewards amount.
   */
  rewardsState: RewardsState;
  /** Returns the state of the streak for the currentDate */
  streakState?: Maybe<StreakDay>;
  /** Returns new state of SuccessKit on new subscription and on any change detected by tools-api */
  successKit: SuccessKit;
  /** Returns new state of tasks on subscription and on any change detected by task generators */
  taskList: TaskList;
  /** Returns successfully if x-noom-config-ref, x-noom-routing-id, and Accept-Language are successfully proxied */
  testHeaderProxying?: Maybe<Scalars['String']['output']>;
  /** Returns the message from TestMessageForGraphqlTriggeredProto every time it's fired for the specified access code */
  testSubscription: Scalars['String']['output'];
  /** Successfully returns three times before failing with an unauthorized API response */
  testUnauthorizedDuringConnection?: Maybe<Scalars['String']['output']>;
  /** Returns new state of tools on new subscription and on any change detected by tools-api */
  toolList: ToolList;
  /** Returns a list of upcoming medication doses. */
  upcomingMedicationDoseList: UpcomingMedicationDoseList;
};


export type SubscriptionAggregatedMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  datapointAggregation: MeasurementAggregationGrouping;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionAnnotatedMeasurementTrendChartArgs = {
  accessCode: Scalars['String']['input'];
  annotationType?: InputMaybe<TrendChartAnnotationType>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limitAnnotations?: InputMaybe<Scalars['Int']['input']>;
  limitMeasurements?: InputMaybe<Scalars['Int']['input']>;
  measurementType: TrendChartMeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionBloodGlucoseOverviewDataArgs = {
  accessCode: Scalars['String']['input'];
  period: BloodGlucoseOverviewPeriod;
  periodEndDate: Scalars['LocalDate']['input'];
};


export type SubscriptionBloodGlucoseOverviewDataV2Args = {
  accessCode: Scalars['String']['input'];
  period: BloodGlucoseOverviewPeriod;
  periodEndDate: Scalars['LocalDate']['input'];
};


export type SubscriptionBodyScanTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionCurrencyEarnedArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionFaceScanTaskArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type SubscriptionHomeScreenCarouselStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionMedRefillEligibilityArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  daysPerWindow: Scalars['Int']['input'];
  windowCount: Scalars['Int']['input'];
};


export type SubscriptionMicroChallengesTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  challengeTypes?: InputMaybe<Array<MicroChallengeType>>;
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type SubscriptionNutrientGoalsUpdatedListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programUuid: Scalars['String']['input'];
};


export type SubscriptionPastMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type SubscriptionPreviewGamificationActionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  data: GamificationActionDataInput;
};


export type SubscriptionProcessingStateArgs = {
  scanId: Scalars['UUID']['input'];
};


export type SubscriptionRelationActivitiesListArgs = {
  input: RelationActivitiesListInput;
  userAccessCode?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionRewardsStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionStreakStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  type: StreakType;
  userCurrentDate: Scalars['LocalDate']['input'];
};


export type SubscriptionSuccessKitArgs = {
  accessCode: Scalars['String']['input'];
  programUuid: Scalars['UUID']['input'];
};


export type SubscriptionTaskListArgs = {
  accessCode: Scalars['String']['input'];
  taskListInput?: InputMaybe<TaskListSubscriptionInput>;
};


export type SubscriptionTestSubscriptionArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionToolListArgs = {
  accessCode: Scalars['String']['input'];
  programUuid: Scalars['UUID']['input'];
};


export type SubscriptionUpcomingMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
  programUuid: Scalars['String']['input'];
};

/**
 * Encapsulates different reasons for subscription modification.
 * Passed in as a parameter to Orders API, to be used in analysis later.
 *
 * Should be kept in sync with SubscriptionModificationReasonProto
 */
export enum SubscriptionModificationReason {
  /** B2B user lost eligibility; subscription retains percentage-only partner discount */
  B2BSubscriptionDiscountEligibilityLost = 'B2B_SUBSCRIPTION_DISCOUNT_ELIGIBILITY_LOST',
  /** B2B-requested migration of a subscription to a different discount amount */
  B2BSubscriptionUpdateDiscountMigration = 'B2B_SUBSCRIPTION_UPDATE_DISCOUNT_MIGRATION',
  /** Migration of a clinical study participant from a paid subscription to a free subscription */
  ClinicalStudyPaidToFreeMigration = 'CLINICAL_STUDY_PAID_TO_FREE_MIGRATION',
  Counteroffer = 'COUNTEROFFER',
  DiscountApplied = 'DISCOUNT_APPLIED',
  Med_3MonthToWeeklyPlanMigration = 'MED_3_MONTH_TO_WEEKLY_PLAN_MIGRATION',
  /** A switch from one Med program to a different Med program */
  MedProgramSwitch = 'MED_PROGRAM_SWITCH',
  ModificationReverted = 'MODIFICATION_REVERTED',
  MultiuserUpgrade = 'MULTIUSER_UPGRADE',
  ReactivatedSubscription = 'REACTIVATED_SUBSCRIPTION',
  /**
   * Used when subscription sale item ID changes because of the way payment
   * schedule is set up, without external intervention such as switch order.
   * For example, this happens for 16-week plans for microdose-longevity
   * product. First billing cycle is 15-weeks, and all the following ones are
   * 16-weeks. On renewal after first billing cycle, a SUBSCRIPTION_MODIFIED
   * event is published with this reason.
   */
  Renewal = 'RENEWAL',
  SelfServe = 'SELF_SERVE',
  SupportlandImmediateSwitch = 'SUPPORTLAND_IMMEDIATE_SWITCH',
  SupportlandNextBillingCycleSwitch = 'SUPPORTLAND_NEXT_BILLING_CYCLE_SWITCH',
  SwitchedToInstallments = 'SWITCHED_TO_INSTALLMENTS',
  TierDowngrade = 'TIER_DOWNGRADE',
  TierUpgrade = 'TIER_UPGRADE',
  TrialFastForward = 'TRIAL_FAST_FORWARD',
  UnspecifiedReason = 'UNSPECIFIED_REASON'
}

/** Specifies the user subscription tier - FREE or PAID */
export enum SubscriptionTier {
  Free = 'FREE',
  Paid = 'PAID'
}

/** Contains the information to present the SuccessKit in the UI */
export type SuccessKit = {
  __typename?: 'SuccessKit';
  /** List of Sections sorted in order to be displayed */
  sections: Array<SuccessKitSection>;
};

export type SuccessKitArticle = SuccessKitSectionItem & {
  __typename?: 'SuccessKitArticle';
  /** Analytics tag tracked when Article item is clicked */
  analyticsTag?: Maybe<Scalars['String']['output']>;
  /** Article URL to be opened in the Web view */
  contentUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subhead?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upsellUrl?: Maybe<Scalars['String']['output']>;
};

/** A locked Success Kit section and the buyflow URL to open for that section. */
export type SuccessKitLockedSectionUpsell = {
  __typename?: 'SuccessKitLockedSectionUpsell';
  buyflowUrl: Scalars['String']['output'];
  sectionId: Scalars['String']['output'];
};

export type SuccessKitMetadata = {
  __typename?: 'SuccessKitMetadata';
  imageUrl?: Maybe<Scalars['String']['output']>;
  subheader?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitSection = {
  __typename?: 'SuccessKitSection';
  /** Section ID */
  id: Scalars['String']['output'];
  /** Section items of various types, sorted in order to be displayed */
  sectionItems: Array<SuccessKitSectionItem>;
  /** Subtitle for the Section on the UI */
  subhead?: Maybe<Scalars['String']['output']>;
  /** Title for the Section on the UI */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * DEPRECATED in favor of sectionItems
   * @deprecated Use `sectionItems` instead.
   */
  tools: Array<SuccessKitTool>;
};

export type SuccessKitSectionItem = {
  /** URL of the thumbnail image displayed as part of the item's UI */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Subtitle for the item on the UI */
  subhead?: Maybe<Scalars['String']['output']>;
  /** Title for the item on the UI */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * When present, the client should present this item in a locked state;
   * use this URL for the upsell/buyflow entry (e.g. aligns with ad CTA).
   */
  upsellUrl?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitTool = SuccessKitSectionItem & {
  __typename?: 'SuccessKitTool';
  /**
   * DEPRECATED Used only in legacy clients for Article Tools, no longer needed.
   * @deprecated Here for legacy clients, no longer needed.
   */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Tool ID */
  id: ToolId;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subhead?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upsellUrl?: Maybe<Scalars['String']['output']>;
};

/** Success Kit upsell: one placement with locked section IDs and a buyflow URL per section. */
export type SuccessKitUpsellContent = {
  __typename?: 'SuccessKitUpsellContent';
  /** Locked Success Kit sections; sectionId matches Success Kit section config keys (e.g. EAT_HEALTHIER). */
  lockedSections: Array<SuccessKitLockedSectionUpsell>;
};

export type SupportChatUnreadMessages = {
  __typename?: 'SupportChatUnreadMessages';
  /** Number of unread messages count with support chat */
  unreadMessagesCount: Scalars['Int']['output'];
};

/** Payload for a dashboard support request ticket. */
export type SupportRequestInput = {
  /** Optional attachments such as screenshots */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Category used to route the ticket to the right queue */
  category: Scalars['String']['input'];
  /** Detailed description from the dashboard user */
  description: Scalars['String']['input'];
  /** Member issue that best matches the scenario */
  memberIssue: Scalars['String']['input'];
  /** User access code for the affected member */
  userAccessCode: Scalars['String']['input'];
  /** Email address for the affected member */
  userEmail: Scalars['String']['input'];
};

/**
 * Wrapper for a single supported assessment metric. Mirrors the proto
 * `GetSupportedAssessmentMetricsResponseProto.SupportedAssessmentMetric`
 * wrapper so the gql-java resolver can pass values through without
 * unwrapping. Additional per-metric fields (e.g. units, reference ranges)
 * may be added here in the future without breaking existing clients.
 */
export type SupportedAssessmentMetric = {
  __typename?: 'SupportedAssessmentMetric';
  /** Health metric type supported for result entry. */
  metric: HealthMetricName;
};

/** Health metrics supported for admin assessment result entry. */
export type SupportedAssessmentMetrics = {
  __typename?: 'SupportedAssessmentMetrics';
  metrics: Array<SupportedAssessmentMetric>;
};

/**
 * Stores information related to the multi-user upgrade
 * plan switch that stores information about an additional user.
 */
export type SwitchMultiUserInfo = {
  __typename?: 'SwitchMultiUserInfo';
  /** Name of the additional user */
  additionalName?: Maybe<Scalars['String']['output']>;
  /** Email address of the additional user to send a signup email */
  additionalUserEmail: Scalars['String']['output'];
};

/**
 * Describes the operation in which the user is switched to a different
 * product, different tier of the same product or a different price option
 * for the same tier of the same product.
 */
export type SwitchOperation = {
  __typename?: 'SwitchOperation';
  /** Used to apply a discount to the subscription that the user wants to switch to */
  discountSummary?: Maybe<OrderDiscountSummary>;
  /** The sale item ID to which the user wants to switch to */
  saleItemId: Scalars['ID']['output'];
  /** New shipping address ID to be attached to the new subscription */
  shippingAddressId?: Maybe<Scalars['ID']['output']>;
  /** Reason for the subscription modification */
  subscriptionModificationReason?: Maybe<SubscriptionModificationReason>;
  /** Supplementary information needed to execute some types of switch orders. */
  supplementaryInfo?: Maybe<SwitchSupplementaryInfo>;
  /** Determines what type of switch operation this is. */
  switchType: SwitchOperationType;
  /** Optional trial sale item ID if the user is getting a trial before their switch */
  trialSaleItemId?: Maybe<Scalars['ID']['output']>;
};

/** Union type for different switch operations */
export type SwitchOperationType = ImmediateSwitch | NextBillingCycleSwitch;

/** Determines revert behavior for a next billing cycle switch operation */
export enum SwitchRevertBehavior {
  AllowRevert = 'ALLOW_REVERT',
  DisallowRevert = 'DISALLOW_REVERT',
  UnspecifiedRevertBehavior = 'UNSPECIFIED_REVERT_BEHAVIOR'
}

/** Contains information needed to execute some types of switch orders. */
export type SwitchSupplementaryInfo = {
  __typename?: 'SwitchSupplementaryInfo';
  /** Only populated if the subscriptionModificationReason is MULTIUSER_UPGRADE */
  multiUserInfos: Array<SwitchMultiUserInfo>;
};

/** Determines the trial behavior for an immediate switch operation */
export enum SwitchTrialType {
  /**
   * At any point during modification trial, user can cancel their trial and
   * revert to their old plan and old billing cycle. Additionally, if the
   * charge for the new plan fails after trial, the user will be reverted to
   * their old plan.
   */
  ModificationTrial = 'MODIFICATION_TRIAL',
  /** No trial (default) */
  NoTrial = 'NO_TRIAL',
  /** Regular trial with no option of reverting */
  RegularTrial = 'REGULAR_TRIAL',
  UnspecifiedTrialType = 'UNSPECIFIED_TRIAL_TYPE'
}

export enum TargetPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Task = {
  __typename?: 'Task';
  assignment?: Maybe<Assignment>;
  programUuid?: Maybe<Scalars['UUID']['output']>;
  taskCompletedEventMetadata?: Maybe<Scalars['String']['output']>;
};

export type TaskList = {
  __typename?: 'TaskList';
  additionalMetadata?: Maybe<ClientHints>;
  tasks: Array<Maybe<Task>>;
};

/**
 * Input parameters for the taskList subscription.
 *
 * These parameters are intended to replace the (now deprecated) clientDate and isForPast parameters.
 *   - selectedDate replaces clientDate. Both are LocalDates, but selectedDate is named to more accurately
 *     reflect that it depends on user selection.
 *   - isForPast is derived from (selectedDate < currentDateTime.date), and no longer needs to be set explicitly.
 */
export type TaskListSubscriptionInput = {
  /**
   * The current civil date and time on the user's device.
   * For debugging, this may also involve an offset to simulate the past or future
   */
  currentDateTime: Scalars['LocalDateTime']['input'];
  /** LocalDate that represents what day's tasks the user is requesting */
  selectedDate: Scalars['LocalDate']['input'];
};

export type TestResultInput = {
  /** Health Metric Type Name for this metric. */
  name: HealthMetricName;
  /** Numeric result as string. */
  result: Scalars['String']['input'];
};

export type Tool = {
  __typename?: 'Tool';
  awardsNoomcoin: Scalars['Boolean']['output'];
  contentUrl: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: ToolId;
  metadata?: Maybe<ToolMetadata>;
  pinned: Scalars['Boolean']['output'];
};

/** Graph provided by a specific tool */
export type ToolGraph = {
  __typename?: 'ToolGraph';
  /** Identifier of the tool that provides the graph */
  toolId: ToolId;
};

/** Header provided by a specific tool */
export type ToolHeader = {
  __typename?: 'ToolHeader';
  /** Identifier of the tool that provides the header */
  toolId: ToolId;
};

/**
 *  These values should be aligned with:
 *  - tool_configuration.proto (ToolConfigurationProto.Widget.Id)
 *  - tool_id_enum.proto (ToolIdEnumProto.Value)
 */
export enum ToolId {
  ActivityBrainDump = 'ACTIVITY_BRAIN_DUMP',
  ActivityCreatePositiveExperiences = 'ACTIVITY_CREATE_POSITIVE_EXPERIENCES',
  ActivityCreateSpace = 'ACTIVITY_CREATE_SPACE',
  ActivityDefuseThoughts = 'ACTIVITY_DEFUSE_THOUGHTS',
  ActivityFeelFeelings = 'ACTIVITY_FEEL_FEELINGS',
  ActivityFreeFeelings = 'ACTIVITY_FREE_FEELINGS',
  ActivityGametime = 'ACTIVITY_GAMETIME',
  ActivityGetGrounded = 'ACTIVITY_GET_GROUNDED',
  ActivityGratitudeRemix = 'ACTIVITY_GRATITUDE_REMIX',
  ActivityMove = 'ACTIVITY_MOVE',
  ActivityReframe = 'ACTIVITY_REFRAME',
  ActivityRideWaves = 'ACTIVITY_RIDE_WAVES',
  ActivitySelfCompassionBreak = 'ACTIVITY_SELF_COMPASSION_BREAK',
  ActivitySharpenToolkit = 'ACTIVITY_SHARPEN_TOOLKIT',
  ActivitySleep = 'ACTIVITY_SLEEP',
  ActivitySoothe = 'ACTIVITY_SOOTHE',
  ArticleConstipation = 'ARTICLE_CONSTIPATION',
  ArticleDiarrhea = 'ARTICLE_DIARRHEA',
  ArticleFatigue = 'ARTICLE_FATIGUE',
  ArticleHeadaches = 'ARTICLE_HEADACHES',
  ArticleHotFlashes = 'ARTICLE_HOT_FLASHES',
  ArticleIndigestion = 'ARTICLE_INDIGESTION',
  ArticleInjection = 'ARTICLE_INJECTION',
  ArticleMaintenanceHabits = 'ARTICLE_MAINTENANCE_HABITS',
  ArticleNausea = 'ARTICLE_NAUSEA',
  ArticleProteinGuide = 'ARTICLE_PROTEIN_GUIDE',
  ArticleScienceAm = 'ARTICLE_SCIENCE_AM',
  ArticleSleepCheatSheet = 'ARTICLE_SLEEP_CHEAT_SHEET',
  ArticleTaperingBestPractices = 'ARTICLE_TAPERING_BEST_PRACTICES',
  ArticleWorkoutsFitStrong = 'ARTICLE_WORKOUTS_FIT_STRONG',
  ArtBreak = 'ART_BREAK',
  Biomarkers = 'BIOMARKERS',
  BloodGlucose = 'BLOOD_GLUCOSE',
  BloodGlucoseTracking = 'BLOOD_GLUCOSE_TRACKING',
  BloodPressure = 'BLOOD_PRESSURE',
  BodyScan = 'BODY_SCAN',
  BreathingExercises = 'BREATHING_EXERCISES',
  CreateSpace = 'CREATE_SPACE',
  DailySteps = 'DAILY_STEPS',
  FitnessWorkouts = 'FITNESS_WORKOUTS',
  FoodColorLookUp = 'FOOD_COLOR_LOOK_UP',
  GroceryPlanner = 'GROCERY_PLANNER',
  Lessons = 'LESSONS',
  LogMeals = 'LOG_MEALS',
  Medication = 'MEDICATION',
  Meditation = 'MEDITATION',
  /**
   * Used to implement the Micro Challenges tool.
   * See TechDoc https://docs.google.com/document/d/1jff4LP18c-IwH5hXMpbqK42rQlB9a7WUz_UkKsR2E4I/edit?usp=sharing
   */
  MicroChallenges = 'MICRO_CHALLENGES',
  Mood = 'MOOD',
  Move = 'MOVE',
  MuscleDefense = 'MUSCLE_DEFENSE',
  PremiumMealPlans = 'PREMIUM_MEAL_PLANS',
  RapidRelief = 'RAPID_RELIEF',
  Recipes = 'RECIPES',
  Reframe = 'REFRAME',
  RideTheWave = 'RIDE_THE_WAVE',
  SelfCare = 'SELF_CARE',
  Sleep = 'SLEEP',
  Stress = 'STRESS',
  VideoMeditation = 'VIDEO_MEDITATION',
  WaterLogging = 'WATER_LOGGING',
  WeighIn = 'WEIGH_IN',
  Zumba = 'ZUMBA'
}

export type ToolList = {
  __typename?: 'ToolList';
  tools: Array<Tool>;
};

export type ToolMetadata = {
  __typename?: 'ToolMetadata';
  successKitMetadata?: Maybe<SuccessKitMetadata>;
};

export type ToolStatePatch = {
  newAwardsNoomcoin?: InputMaybe<Scalars['Boolean']['input']>;
  newEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  newIsInSuccessKit?: InputMaybe<Scalars['Boolean']['input']>;
  newPinned?: InputMaybe<Scalars['Boolean']['input']>;
  toolId: ToolId;
};

export type TrackerAssignment = {
  __typename?: 'TrackerAssignment';
  enabledOn?: Maybe<Scalars['LocalDate']['output']>;
  multiDayAssignment?: Maybe<MultiDayAssignment>;
  payload?: Maybe<TrackerAssignmentPayload>;
  title: Scalars['String']['output'];
  titleCompleted?: Maybe<Scalars['String']['output']>;
  type: TrackerTypes;
};

export type TrackerAssignmentPayload = ActivityDefaultPayload | BiomarkersTrackerPayload | BloodGlucoseTrackerPayload | BloodGlucoseTrackerV2Payload | DailyStepsPayload | FacialBloodScanTrackerPayload | LogMealsTrackerPayload | MedHomepageCardPayload | MedicationPayload | MedicationTrackerPayload | MicroChallengesTrackerPayload | WaterLoggingPayload;

/** A tool representing a tracker */
export type TrackerTool = {
  __typename?: 'TrackerTool';
  /** The tracker type. Reuses existing TrackerTypes enum from tasks/assignment. */
  type: TrackerTypes;
};

export enum TrackerTypes {
  ActivityBrainDump = 'ACTIVITY_BRAIN_DUMP',
  ActivityCreatePositiveExperiences = 'ACTIVITY_CREATE_POSITIVE_EXPERIENCES',
  ActivityCreateSpace = 'ACTIVITY_CREATE_SPACE',
  ActivityDefuseThoughts = 'ACTIVITY_DEFUSE_THOUGHTS',
  ActivityFeelFeelings = 'ACTIVITY_FEEL_FEELINGS',
  ActivityFreeFeelings = 'ACTIVITY_FREE_FEELINGS',
  ActivityGametime = 'ACTIVITY_GAMETIME',
  ActivityGetGrounded = 'ACTIVITY_GET_GROUNDED',
  ActivityGratitudeRemix = 'ACTIVITY_GRATITUDE_REMIX',
  ActivityMove = 'ACTIVITY_MOVE',
  ActivityReframe = 'ACTIVITY_REFRAME',
  ActivityRideWaves = 'ACTIVITY_RIDE_WAVES',
  ActivitySelfCompassionBreak = 'ACTIVITY_SELF_COMPASSION_BREAK',
  ActivitySharpenToolkit = 'ACTIVITY_SHARPEN_TOOLKIT',
  ActivitySleep = 'ACTIVITY_SLEEP',
  ActivitySoothe = 'ACTIVITY_SOOTHE',
  /**  Used to implement the new "Biomarkers Tracker" tool for lab test results. */
  BiomarkersTracker = 'BIOMARKERS_TRACKER',
  BloodGlucose = 'BLOOD_GLUCOSE',
  /**
   *  Used to implement the new "Blood Glucose Tracker" tool.
   *  See TechDoc https://docs.google.com/document/d/1mLjt1JYdjBeAY3aN7jSjH4O9pEv3zCsJFnVeYAls1rQ/edit?usp=sharing.
   */
  BloodGlucoseTracker = 'BLOOD_GLUCOSE_TRACKER',
  BloodPressure = 'BLOOD_PRESSURE',
  BodyScan = 'BODY_SCAN',
  DailySteps = 'DAILY_STEPS',
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /**
   * Used to implement the new "Future Me" task.
   * See Tech Note https://docs.google.com/document/d/1bA6IprqRmhm5JO8IInTS6s3eqVm5a4Tm_OeBCDWZFwk/edit?tab=t.0
   */
  FutureMe = 'FUTURE_ME',
  LogMeals = 'LOG_MEALS',
  Medication = 'MEDICATION',
  /**
   *  Used to implement the new "Med Tracker" tool.
   *  See TechDoc https://docs.google.com/document/d/1wNlCuGib9WphyjZKDxrUgIr-VA_wzdK9Syzllh-vS20/edit.
   */
  MedicationTracker = 'MEDICATION_TRACKER',
  /**  Server-driven UI card displayed on the Today tab for med status. */
  MedHomepageCard = 'MED_HOMEPAGE_CARD',
  /**
   * Used to implement the Micro Challenges tracker.
   * See TechDoc https://docs.google.com/document/d/1jff4LP18c-IwH5hXMpbqK42rQlB9a7WUz_UkKsR2E4I/edit?usp=sharing
   */
  MicroChallenges = 'MICRO_CHALLENGES',
  Mood = 'MOOD',
  Sleep = 'SLEEP',
  Stress = 'STRESS',
  WaterLogging = 'WATER_LOGGING',
  WeighIn = 'WEIGH_IN'
}

/** URL tracking parameters */
export type TrackingParams = {
  /** Buyflow features enabled by parameter */
  feature: Array<Scalars['String']['input']>;
  /** Initial URL */
  initialUrl?: InputMaybe<Scalars['String']['input']>;
  /** Referrer string */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** The campaign of the link */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** What was clicked */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** What medium the link came from */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Identifies which site sent the traffic */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** Search terms related to the link */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

/** Configuration for the Treat Day feature */
export type TreatDayConfig = {
  __typename?: 'TreatDayConfig';
  /** How treat days are earned. If null, treat as legacy weekly cadence for backward compatibility */
  earningMode?: Maybe<TreatDayEarningMode>;
  /** Enables treat day cohesion improvements */
  isCohesionImprovementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** When true, treat days can no longer be earned retroactively */
  retroactiveTreatDayDisabled?: Maybe<Scalars['Boolean']['output']>;
};

/** How treat days are earned. Exactly one mode applies */
export type TreatDayEarningMode = LegacyWeeklyCadence | NoomcoinBasedEarning;

/** A navigational action on the treatment detail surface. */
export type TreatmentActionLink = {
  __typename?: 'TreatmentActionLink';
  /** Icon URL (S3/CDN). Null when not configured. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** User-facing link text (English fallback; prefer translating via linkKey on clients). */
  label: Scalars['String']['output'];
  /** Stable key for client-side i18n. Null when not set (e.g. some runtime-only CTAs). */
  linkKey?: Maybe<TreatmentActionLinkKey>;
  /** Deeplink or HTTPS URL opened when tapped. */
  url: Scalars['String']['output'];
};

/** Stable key for a catalog or runtime treatment detail action link. */
export enum TreatmentActionLinkKey {
  AboutMedication = 'ABOUT_MEDICATION',
  BiomarkersTestKitInstructions = 'BIOMARKERS_TEST_KIT_INSTRUCTIONS',
  DosingGuide = 'DOSING_GUIDE',
  HowToUseMeds = 'HOW_TO_USE_MEDS',
  InjectionInstructions = 'INJECTION_INSTRUCTIONS',
  InjectionInstructionsFallback = 'INJECTION_INSTRUCTIONS_FALLBACK',
  ManageSideEffects = 'MANAGE_SIDE_EFFECTS',
  PrescriptionFulfillmentDetail = 'PRESCRIPTION_FULFILLMENT_DETAIL',
  ShippingAndRefills = 'SHIPPING_AND_REFILLS',
  TaperingOffMaintenance = 'TAPERING_OFF_MAINTENANCE',
  ViewTreatmentInfoInChat = 'VIEW_TREATMENT_INFO_IN_CHAT'
}

/** Base interface for all treatment overview card types. Fields present on every card regardless of treatment type. */
export type TreatmentOverview = {
  /** Action links for the full-screen treatment detail view. Empty when none apply. */
  actionLinks: Array<TreatmentActionLink>;
  /** Deeplink for the primary Chat with your doctor CTA on the detail view. Null when unavailable. */
  chatWithDoctorDeeplink?: Maybe<Scalars['String']['output']>;
  /** Deeplink opened when the treatment card is tapped. Null when not applicable. */
  deeplink?: Maybe<Scalars['String']['output']>;
  /** True when medication log/history is supported for this treatment (per-patient). */
  isMedicationLogSupported?: Maybe<Scalars['Boolean']['output']>;
  /** Treatment-specific background color as a hex code. Null when not configured. */
  productBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Product icon URL (S3/CDN). Null when not configured. */
  productIconUrl?: Maybe<Scalars['String']['output']>;
  /** Product image URL (S3/CDN). */
  productImageUrl: Scalars['String']['output'];
  /** Noom program associated with this treatment (e.g. 'GLP-1Rx PROGRAM'). Null when no program is associated. */
  programName?: Maybe<Scalars['String']['output']>;
  /** Internal code identifying the treatment product (e.g. 'GLP1_SEMAGLUTIDE', 'GH_SERMORELIN'). */
  treatmentCode: Scalars['String']['output'];
  /** User-facing treatment name (e.g. 'Compounded Semaglutide', 'Metformin ER'). */
  treatmentName: Scalars['String']['output'];
};

/** The lab has received the patient's completed kit. No additional data beyond the status type itself. */
export type TreatmentOverviewStatusCompletedKitReceived = {
  __typename?: 'TreatmentOverviewStatusCompletedKitReceived';
  /** Placeholder field required by the GraphQL spec. Always null; use __typename to identify this status variant. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Completed lab kit is in transit back to the lab. */
export type TreatmentOverviewStatusCompletedKitShipped = {
  __typename?: 'TreatmentOverviewStatusCompletedKitShipped';
  /**
   * Deprecated placeholder retained for backward compatibility; always null. Use the fields above or __typename. Superseded by shippedDate/trackingUrl.
   * @deprecated Superseded by shippedDate/trackingUrl; retained to avoid a breaking field removal.
   */
  _?: Maybe<Scalars['Boolean']['output']>;
  /** Date the completed kit was shipped back to the lab. Null when unavailable. */
  shippedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Tracking URL for the return shipment. Null when unavailable. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Order delivered. No additional data beyond the status type itself. */
export type TreatmentOverviewStatusDelivered = {
  __typename?: 'TreatmentOverviewStatusDelivered';
  /** Placeholder field required by the GraphQL spec. Always null; use __typename to identify this status variant. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Clinician is reviewing the patient's intake or refill. */
export type TreatmentOverviewStatusInReview = {
  __typename?: 'TreatmentOverviewStatusInReview';
  /** Deeplink to the clinician chat. */
  ctaDeeplink: Scalars['String']['output'];
  /**
   * Deprecated: use isRefill on RxTreatmentOverview instead.
   * @deprecated Use isRefill on RxTreatmentOverview instead.
   */
  isRefill?: Maybe<Scalars['Boolean']['output']>;
};

/** Patient has a new intake form that has not been completed. */
export type TreatmentOverviewStatusIntakeIncomplete = {
  __typename?: 'TreatmentOverviewStatusIntakeIncomplete';
  /** Deeplink to the intake form. */
  ctaDeeplink: Scalars['String']['output'];
  /** Date by which the refill intake should be completed. */
  deadlineDate?: Maybe<Scalars['LocalDate']['output']>;
};

/** Prescription is active and refills are available. */
export type TreatmentOverviewStatusRefills = {
  __typename?: 'TreatmentOverviewStatusRefills';
  /** Date of the next scheduled refill. */
  nextRefillDate: Scalars['LocalDate']['output'];
};

/** A replacement order has shipped and is in transit. */
export type TreatmentOverviewStatusReplacementShipped = {
  __typename?: 'TreatmentOverviewStatusReplacementShipped';
  /** Date the replacement order was shipped. Null when unavailable. */
  shippedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Tracking URL for the replacement shipment. Null when unavailable. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Results are available to the patient. No additional data beyond the status type itself. */
export type TreatmentOverviewStatusResultsAvailable = {
  __typename?: 'TreatmentOverviewStatusResultsAvailable';
  /** Placeholder field required by the GraphQL spec. Always null; use __typename to identify this status variant. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Order shipped and in transit. */
export type TreatmentOverviewStatusShipped = {
  __typename?: 'TreatmentOverviewStatusShipped';
  /** Date the order was shipped. Null when unavailable. */
  shippedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Tracking URL for the shipment. Null when unavailable. */
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

/** Order approved and being prepared for shipment. No additional data beyond the status type itself. */
export type TreatmentOverviewStatusShippingSoon = {
  __typename?: 'TreatmentOverviewStatusShippingSoon';
  /** Placeholder field required by the GraphQL spec. Always null; use __typename to identify this status variant. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Patient has a refill intake form that has not been completed. */
export type TreatmentOverviewStatusUpdate = {
  __typename?: 'TreatmentOverviewStatusUpdate';
  /** Deeplink to the clinician chat. */
  ctaDeeplink: Scalars['String']['output'];
};

/** Active treatment overviews for a patient. */
export type TreatmentOverviews = {
  __typename?: 'TreatmentOverviews';
  /** Program identity information for the Care Tab header. Null when not configured. */
  programInfo?: Maybe<ProgramInfo>;
  /** Active treatment overview cards in display-priority order. Empty when the patient has no active treatments. */
  treatments: Array<TreatmentOverview>;
};

/** Trend information comparing current value to a previous measurement. */
export type Trend = {
  __typename?: 'Trend';
  /** Numerical change between measurements. */
  delta?: Maybe<Scalars['Float']['output']>;
  /** Direction of the trend. */
  direction: TrendDirection;
};

export type TrendChartAnnotation = {
  __typename?: 'TrendChartAnnotation';
  date: Scalars['LocalDate']['output'];
  style: MeasurementSnapshotStyle;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** All supported annotations */
export enum TrendChartAnnotationType {
  Medication = 'MEDICATION'
}

export type TrendChartEntry = TrendChartAnnotation | TrendChartMeasurement;

export type TrendChartMeasurement = {
  __typename?: 'TrendChartMeasurement';
  date: Scalars['LocalDate']['output'];
  value: Scalars['Float']['output'];
};

/** All supported measurements */
export enum TrendChartMeasurementType {
  Weight = 'WEIGHT'
}

/**
 * Direction of trend change. Note that "improving" or "worsening"
 * depends on the specific metric context.
 */
export enum TrendDirection {
  /** Trend indicates improvement in health metric. */
  Improving = 'IMPROVING',
  /** Trend shows no significant change. */
  Stable = 'STABLE',
  /** Trend indicates worsening in health metric. */
  Worsening = 'WORSENING'
}

/** Trends tab presentation */
export type TrendsTab = {
  __typename?: 'TrendsTab';
  /** Graph widgets to display in the Trends surface. */
  graphs: Array<GraphWidget>;
  /** Header widgets to display at the top of the Trends surface. */
  headers: Array<HeaderWidget>;
};

export type TriggerFaceScanResponse = {
  __typename?: 'TriggerFaceScanResponse';
  scanId?: Maybe<Scalars['UUID']['output']>;
};

/**
 * Typed attribution input with explicit type discriminator. The `type` field
 * must be consistent with the populated detail field; consumers may reject
 * inputs where the discriminator and detail disagree.
 */
export type TypedAttributionDataInput = {
  /** Facial blood scan attribution detail. Required when type = FACIAL_BLOOD_SCAN. */
  facialBloodScan?: InputMaybe<FacialBloodScanAttributionDataInput>;
  /** Discriminator identifying which detail field is populated. Must be a non-UNKNOWN value. */
  type: TypedAttributionType;
};

/**
 * Variant of TypedAttributionDataInput with optional fields for matching.
 * Reuses TypedAttributionType to identify which detail payload to match.
 * The `type` field must be a non-UNKNOWN value consistent with the populated
 * detail field; consumers may reject inputs where the discriminator and detail
 * disagree.
 */
export type TypedAttributionDataMatchInput = {
  /** Facial blood scan match detail. Used when type = FACIAL_BLOOD_SCAN. */
  facialBloodScan?: InputMaybe<FacialBloodScanAttributionDataMatchInput>;
  /** Discriminator identifying which detail field to match against. Must be a non-UNKNOWN value. */
  type: TypedAttributionType;
};

/**
 * Typed attribution discriminator. Identifies which detail payload is populated
 * on TypedAttributionDataInput. New typed sources should be added to this enum
 * and to TypedAttributionDataInput in lockstep.
 */
export enum TypedAttributionType {
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  Unknown = 'UNKNOWN'
}

/** These values should be aligned with ufc types from noom-contracts/coaching/CoachUfcTypeEnumProto */
export enum UfcType {
  Careteam = 'CARETEAM',
  Clinician = 'CLINICIAN',
  CoachOnDemand = 'COACH_ON_DEMAND',
  Guide = 'GUIDE',
  MhtClinician = 'MHT_CLINICIAN',
  Nmc = 'NMC',
  Premium = 'PREMIUM',
  SeniorNmc = 'SENIOR_NMC',
  Unknown = 'UNKNOWN'
}

/** User is not enrolled in rewards program, e.g. before earning the first Noomcoin. */
export type UnenrolledRewardsState = {
  __typename?: 'UnenrolledRewardsState';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

export type UpcomingMedicationDose = {
  __typename?: 'UpcomingMedicationDose';
  /** Date the dose should be taken on */
  dueDate: Scalars['LocalDate']['output'];
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
};

/**  Upcoming medication doses that user should take */
export type UpcomingMedicationDoseList = {
  __typename?: 'UpcomingMedicationDoseList';
  /** Metadata for fetching the next page of upcoming doses, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** List of upcoming doses */
  upcomingDoses: Array<UpcomingMedicationDose>;
};

/** Input type for updating an art gallery (all fields optional for PATCH operations). */
export type UpdateArtGalleryInput = {
  /** The list of art piece IDs to associate with this gallery */
  artPieceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Updated URL to background music for the gallery experience */
  backgroundMusicUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated URL to the cover photo for the gallery */
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated reflection question associated with the gallery */
  reflectionQuestion?: InputMaybe<Scalars['String']['input']>;
  /** Updated URL to the thumbnail image for the gallery */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated title of the art gallery */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an art piece (all fields optional for PATCH operations). */
export type UpdateArtPieceInput = {
  /** Updated names of the artists who created this piece */
  artistNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Updated description of the art piece */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated display time period for the art piece */
  displayTimePeriod?: InputMaybe<Scalars['String']['input']>;
  /** Updated location hosting the art */
  hostedAt?: InputMaybe<Scalars['String']['input']>;
  /** Updated URL to the image of the art piece */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated medium/type of the artwork */
  medium?: InputMaybe<ArtPieceMedium>;
  /** Updated title of the art piece */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Updated year the art piece was created */
  yearCreated?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating an asset registry entry. */
export type UpdateAssetRegistryEntryInput = {
  /** The description of the asset. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A JSON string representing the metadata of the asset. */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /**
   * The storage path of the asset.
   * Note: Updating the storage path might be dangerous as it is managed by the asset manager.
   */
  path?: InputMaybe<Scalars['String']['input']>;
  /**
   * The public URL for accessing the asset.
   * Note: Updating the public URL might be dangerous as it is managed by the asset manager.
   */
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  /** The status of the asset. */
  status?: InputMaybe<AssetRegistryStatus>;
  /**
   * The storage bucket (empty means default bucket).
   * Note: Updating the storage bucket might be dangerous as it is managed by the asset manager.
   */
  storageBucket?: InputMaybe<Scalars['String']['input']>;
  /** The type of the asset (e.g. image vs agent artifact for UI filtering). */
  type?: InputMaybe<AssetRegistryType>;
};

export type UpdateInterstitialInput = {
  careTabHint?: InputMaybe<Scalars['LocalDate']['input']>;
  communityHint?: InputMaybe<Scalars['LocalDate']['input']>;
  communityIntroAnnouncement?: InputMaybe<Scalars['LocalDate']['input']>;
  communityMoved?: InputMaybe<Scalars['LocalDate']['input']>;
  successKitIntro?: InputMaybe<Scalars['LocalDate']['input']>;
};

/**
 * Partial update payload matching `UpdateNoomFlowExperimentRequestProto.body`. `identifier` and
 * `uuid` are not in the input—`uuid` is the mutation argument. Field order follows the proto
 * writable subset aligned with `NoomFlowExperimentProto`; omitted fields are unchanged (server-defined merge).
 */
export type UpdateNoomFlowExperimentInput = {
  /** Baseline flow for the experiment (`baseline_flow_identifier`). */
  baselineFlowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Other experiments that must not overlap in assignment. */
  conflictingExperimentIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Updated description; required when moving out of draft per server validation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Links to design docs, PRDs, or tickets. */
  designDocumentationLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional Meristem / experiment-engine key (`foreign_key`). */
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  /** Mixpanel funnel id for reporting links. */
  funnelId?: InputMaybe<Scalars['String']['input']>;
  /** When true, greedy allocation applies; only when allowed by Noom Flow validation. */
  isGreedyTargeting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for the experiment (`name`); distinct from immutable `identifier`. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner identity (email or service principal); required on save in Noom Flow validation. */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Owning team label for reporting and Slack context. */
  owningTeam?: InputMaybe<Scalars['String']['input']>;
  /** Optional pinned baseline flow instance (`pinned_baseline_flow_uuid`). */
  pinnedBaselineFlowUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional psychology / technique label for categorization. */
  psychTechnique?: InputMaybe<Scalars['String']['input']>;
  /** Target sample size per arm for power / Mixpanel checks. */
  sampleSizePerArm?: InputMaybe<Scalars['Int']['input']>;
  /** Planned end of the experiment window (`scheduled_end_at`). */
  scheduledEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Planned start of the experiment window (`scheduled_start_at`). */
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Funnel start events for analytics. */
  startEvents?: InputMaybe<Array<NoomFlowExperimentQueriedReferenceInput>>;
  /** Lifecycle state; transitions are validated server-side. */
  status?: InputMaybe<NoomFlowExperimentStatus>;
  /** Conversion / target events for analytics. */
  targetEvents?: InputMaybe<Array<NoomFlowExperimentQueriedReferenceInput>>;
  /** Targeting rows (e.g. `context_type`, `language_code`). Greedy targeting only when allowed by Noom Flow validation. */
  targeting?: InputMaybe<Array<NoomFlowExperimentTargetingCriteriaInput>>;
  /** Traffic share for this experiment (0–100 style; default 0 on save if omitted). */
  trafficPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Variation arms: `weight_percentage` per arm, flow diff, config, and stable variation identifiers when required by Noom Flow validation. */
  variations?: InputMaybe<Array<NoomFlowExperimentVariationInput>>;
  /** Whole number percent for experiment-level allocation (e.g. 30 means 30%). */
  weightPercentage?: InputMaybe<Scalars['Int']['input']>;
};

/** Partial update for an existing flow; the mutation carries `uuid`. */
export type UpdateNoomFlowInput = {
  /** Agent artifacts used to create the flow as a JSON object string (e.g. screenshots, PRDs). */
  agentArtifactsAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Preferred structured configuration as a JSON object string. */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** Legacy configuration as JSON text. Prefer `configuration` when patching. */
  configurationAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** The description of the flow. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The group name of flow configurations that may be chosen based on criteria when requested. */
  flowGroupName?: InputMaybe<Scalars['String']['input']>;
  /** The identifier for the flow. */
  flowIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The associated github pull request URLs for the flow. */
  githubPullRequestUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The associated jira ticket URLs for the flow. */
  jiraTicketUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Flow metadata as a JSON object string (e.g. annotations, todos). */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** The name of the flow. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The status of the flow configuration. */
  status?: InputMaybe<NoomFlowStatus>;
};

/** Update list metadata. At least one field should be set. */
export type UpdateNoomFlowListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** New declared type of item `value` for this list when supplied. */
  valueDataType?: InputMaybe<NoomFlowListValueDataType>;
};

/** Update a list item. At least one field should be set. */
export type UpdateNoomFlowListItemInput = {
  /** Optional JSON metadata for the item. */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Partial update for an existing page; the mutation carries `uuid`. */
export type UpdateNoomFlowPageInput = {
  /** Agent artifacts as a JSON object string (`NoomFlowPage.agentArtifactsAsJsonString`). */
  agentArtifactsAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Structured page configuration as a JSON object string. */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** Updated description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Page metadata as a JSON object string (`NoomFlowPage.metadataAsJsonString`). */
  metadataAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Updated display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New logical page id (if renaming). */
  pageIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Updated lifecycle status. */
  status?: InputMaybe<NoomFlowStatus>;
};

/** Payload for updating a page's status. */
export type UpdateNoomFlowPageStatusInput = {
  /** Target lifecycle status after this call. */
  status: NoomFlowStatus;
};

/** Input for updating a noom flow persona. */
export type UpdateNoomFlowPersonaInput = {
  /** The flowIdentifiers this persona is associated with. */
  associatedFlowIdentifiers: Array<Scalars['String']['input']>;
  /** The description of the persona. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the persona. */
  name: Scalars['String']['input'];
  /** A JSON string representing the persona configuration. */
  personaAsJsonString: Scalars['String']['input'];
  /** The type of the persona. */
  type: NoomFlowPersonaType;
};

/** Update a Noom Flow rule (partial merge). At least one field should be set. */
export type UpdateNoomFlowRuleInput = {
  /** Updated structured JSON for the ordered list of conditions. */
  conditionalsAsJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Updated description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated display name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for updating a flow's status. */
export type UpdateNoomFlowStatusInput = {
  /** The status of the flow. */
  status: NoomFlowStatus;
};

/** Input for updating a noom flow text translation. */
export type UpdateNoomFlowTextTranslationInput = {
  /** German (Germany) translation. */
  deDe?: InputMaybe<Scalars['String']['input']>;
  /** German (international) translation. */
  deInternational?: InputMaybe<Scalars['String']['input']>;
  /** English (Australia) translation. */
  enAu?: InputMaybe<Scalars['String']['input']>;
  /** English (Canada) translation. */
  enCa?: InputMaybe<Scalars['String']['input']>;
  /** English (Great Britain) translation. */
  enGb?: InputMaybe<Scalars['String']['input']>;
  /** English (Ireland) translation. */
  enIe?: InputMaybe<Scalars['String']['input']>;
  /** English (international) translation. */
  enInternational?: InputMaybe<Scalars['String']['input']>;
  /** English (Mexico) translation. */
  enMx?: InputMaybe<Scalars['String']['input']>;
  /** English (New Zealand) translation. */
  enNz?: InputMaybe<Scalars['String']['input']>;
  /** English (Pakistan) translation. */
  enPk?: InputMaybe<Scalars['String']['input']>;
  /** English (Singapore) translation. */
  enSg?: InputMaybe<Scalars['String']['input']>;
  /** English (United States) translation. */
  enUs?: InputMaybe<Scalars['String']['input']>;
  /** Spanish (international) translation. */
  esInternational?: InputMaybe<Scalars['String']['input']>;
  /** Spanish (Mexico) translation. */
  esMx?: InputMaybe<Scalars['String']['input']>;
  /** Whether the translation is shared across flows. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** The state of the translation. */
  translationState?: InputMaybe<NoomFlowTextTranslationStateType>;
};

/**
 * Input for updating the user's rewards settings.
 * All fields are nullable — only provided fields are updated; omitted fields remain unchanged.
 */
export type UpdateRewardsSettingsInput = {
  /** Set to true to suppress haptics in all gamification features. Omit to leave unchanged. */
  disableGamificationHaptics?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true to suppress reward modal celebrations. Omit to leave unchanged. */
  disableRewardModals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true to suppress reward toast celebrations. Omit to leave unchanged. */
  disableRewardToasts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true to suppress streak interstitials. Omit to leave unchanged. */
  disableStreakInterstitials?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input type for updating an existing scheduled content.
 * All fields are optional to support partial updates.
 */
export type UpdateScheduledContentInput = {
  /** Updated ID of the content to be scheduled (e.g., art gallery ID) */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated type of content being scheduled */
  contentType?: InputMaybe<ScheduledContentType>;
  /** Updated end date and time of the scheduled content */
  endDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Updated start date and time of the scheduled content */
  startDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Updated status of the scheduled content */
  status?: InputMaybe<ContentStatus>;
};

/** A hard-block error from a shipping address update attempt. */
export type UpdateShippingAddressError = {
  __typename?: 'UpdateShippingAddressError';
  /** A human-readable description of why the update was blocked. */
  message: Scalars['String']['output'];
  /** The reason the update was blocked. */
  reason: UpdateShippingAddressErrorReason;
};

/** Reason a shipping address update was blocked. */
export enum UpdateShippingAddressErrorReason {
  /** The address is not a US address. Only US addresses are supported for med users. */
  AddressNotSupported = 'ADDRESS_NOT_SUPPORTED',
  /** The intake encounter is already locked and the address cannot be changed. */
  IntakeLocked = 'INTAKE_LOCKED',
  /** No upcoming shipments were found for this user. */
  NoUpcomingShipments = 'NO_UPCOMING_SHIPMENTS',
  /** The order has already been placed with the pharmacy and can no longer be updated. */
  OrderAlreadyPlaced = 'ORDER_ALREADY_PLACED',
  /** The user's pharmacy does not support address changes. */
  PharmacyNotSupported = 'PHARMACY_NOT_SUPPORTED',
  /** The address update is blocked for an unknown reason. */
  Unknown = 'UNKNOWN'
}

/** Address fields for a shipping address update. */
export type UpdateShippingAddressFields = {
  /** The first address line. */
  addressLine1: Scalars['String']['input'];
  /** The second address line. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city or town. */
  city: Scalars['String']['input'];
  /** A 2-character country code (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code. */
  postalCode: Scalars['String']['input'];
  /** The recipient's full name. */
  recipient: Scalars['String']['input'];
  /** The state or region (2-letter code for US addresses). */
  zoneCode: Scalars['String']['input'];
};

/** Input for updating a short URL */
export type UpdateShortUrlInput = {
  /** The new destination URL */
  destinationUrl: Scalars['String']['input'];
};

/** Patch for updating an existing mapping. Only vendorSku and lifecycleState are mutable per OTC-2107. */
export type UpdateSkuRegistryEntryInput = {
  lifecycleState?: InputMaybe<SkuLifecycleState>;
  vendorSku?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a user's preferred shipping address. */
export type UpdateUserShippingAddressInput = {
  /** The user's access code. */
  accessCode: Scalars['String']['input'];
  /** The new shipping address. */
  address: UpdateShippingAddressFields;
  /**
   * When true, applies the address change to future fills only, skipping the
   * next scheduled fill if it is already locked. Only relevant for med users.
   * Pass this after receiving nextFillLocked: true on a previous call.
   */
  excludeUpcomingShipment?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of a shipping address update. */
export type UpdateUserShippingAddressResult = {
  __typename?: 'UpdateUserShippingAddressResult';
  /** Populated when the address update is fully blocked. The update was not applied. */
  error?: Maybe<UpdateShippingAddressError>;
  /**
   * True when the next scheduled fill is locked and the address was not applied.
   * The caller should prompt the user to confirm, then retry with
   * excludeUpcomingShipment: true to apply the change to future fills only.
   */
  nextFillLocked?: Maybe<Scalars['Boolean']['output']>;
};

/** Input type for uploading an art piece image. */
export type UploadArtPieceImageInput = {
  /** URL to the image to be uploaded (required) */
  imageUrl: Scalars['String']['input'];
};

/** Response type for art piece image upload. */
export type UploadArtPieceImageResponse = {
  __typename?: 'UploadArtPieceImageResponse';
  /** URL to the uploaded image */
  imageUrl: Scalars['String']['output'];
};

/** Union type for different upsell ad content types. */
export type UpsellAdContent = CrossSellPitchContent | HealthReportUpsellContent | HomeLargeContent | HomeScreenCarouselTileContent | MealFeedbackScreenContent | ModuleLibraryUpsellContent | NavigationButtonContent | SideNavMenuSmallContent | SuccessKitUpsellContent | UserportalHomePageContent | WeightGraphContent | WeightGraphInlineContent;

/** Payload for a location's ad placement. */
export type UpsellAdData = {
  __typename?: 'UpsellAdData';
  /** The content of the upsell ad. */
  content?: Maybe<UpsellAdContent>;
  /** The offer name that this ad references. */
  offerName?: Maybe<Scalars['String']['output']>;
  upsellAdIdentifier: Scalars['String']['output'];
  upsellAdLocation: UpsellAdLocation;
  upsellAdType: UpsellAdType;
};

export type UpsellAdDataList = {
  __typename?: 'UpsellAdDataList';
  upsellAdData: Array<UpsellAdData>;
};

export enum UpsellAdLocation {
  /** Large Ad placement in Body Scan */
  BodyscanLarge = 'BODYSCAN_LARGE',
  /** Small Ad placement in Body Scan */
  BodyscanSmall = 'BODYSCAN_SMALL',
  /** Ad placement in chat lobby */
  ChatLobby = 'CHAT_LOBBY',
  /** Ad that can be present in the coach chat (mostly at the top) */
  CoachChat = 'COACH_CHAT',
  /** Ad that can be present on the coach's profile page. */
  CoachProfilePage = 'COACH_PROFILE_PAGE',
  /**
   * Ad placement reached from a content article link (e.g. blog or marketing
   * content driving traffic to a PDP). The article owns rendering; this
   * location exists so deeplinks can attribute back to a registered offer.
   */
  ContentArticle = 'CONTENT_ARTICLE',
  /**
   * Ad placement reached via a CRM email link. The email itself owns rendering;
   * this location exists so deeplinks can attribute back to a registered offer.
   */
  EmailCampaign = 'EMAIL_CAMPAIGN',
  /** Ad placement in FitOn */
  Fiton = 'FITON',
  /** Ad placement in the hamburger menu */
  Hamburger = 'HAMBURGER',
  /** Ad placement for home screen carousel */
  HomeCarousel = 'HOME_CAROUSEL',
  /** Large Ad placement in Home */
  HomeLarge = 'HOME_LARGE',
  /** Ad placement in the in-app Health Insights tab. */
  InAppHealthInsightsTab = 'IN_APP_HEALTH_INSIGHTS_TAB',
  /** Ad placement during in-app face scan for health report upsells. */
  InAppHealthReport = 'IN_APP_HEALTH_REPORT',
  /** Ad placement in the meal feedback screen. */
  MealFeedback = 'MEAL_FEEDBACK',
  /** Ad placement in the meal feedback screen content. */
  MealFeedbackContent = 'MEAL_FEEDBACK_CONTENT',
  /** Upsell that is automatically triggered when meal logging is completed. */
  MealLoggingCompletionAutomatic = 'MEAL_LOGGING_COMPLETION_AUTOMATIC',
  /**
   * Ad placement in the meal logging method selector.
   * @deprecated Never used. Use button-specific locations below.
   */
  MealLoggingMethodSelector = 'MEAL_LOGGING_METHOD_SELECTOR',
  /** Ad placement in the meal logging method selector barcode button. */
  MealLoggingMethodSelectorBarcode = 'MEAL_LOGGING_METHOD_SELECTOR_BARCODE',
  /** Ad placement in the meal logging method selector history button. */
  MealLoggingMethodSelectorHistory = 'MEAL_LOGGING_METHOD_SELECTOR_HISTORY',
  /** Ad placement in the meal logging method selector search button. */
  MealLoggingMethodSelectorSearch = 'MEAL_LOGGING_METHOD_SELECTOR_SEARCH',
  /** Ad placement at the bottom of the Module Library. */
  ModuleLibrary = 'MODULE_LIBRARY',
  /** No known location. */
  None = 'NONE',
  /** Ad placement during onboarding face scan for health report upsells. */
  OnboardingHealthReport = 'ONBOARDING_HEALTH_REPORT',
  /** Upsell that is automatically triggered on step completion. */
  StepGoalCompletionAutomatic = 'STEP_GOAL_COMPLETION_AUTOMATIC',
  /** Ad placement for Success Kit (single ad; per-section URLs in SuccessKitUpsellContent). */
  SuccessKit = 'SUCCESS_KIT',
  /**
   * Ad placement reached via a support chat link (e.g. customer support
   * directing a user to a PDP). Support owns rendering; this location exists
   * so deeplinks can attribute back to a registered offer.
   */
  SupportChat = 'SUPPORT_CHAT',
  /** Ad placement with a button in the topnav */
  TopnavButton = 'TOPNAV_BUTTON',
  /** Default status for enums. */
  Uknown = 'UKNOWN',
  /** Ad placement in the user portal homepage. */
  UserportalHomepage = 'USERPORTAL_HOMEPAGE',
  /** Ad placement in weight graph (after weigh in is recorded) */
  WeightGraph = 'WEIGHT_GRAPH',
  /** Ad placement in the weight graph screen. */
  WeightGraphInline = 'WEIGHT_GRAPH_INLINE',
  /** Ad placement in the Welli meal insight component. */
  WelliMealInsight = 'WELLI_MEAL_INSIGHT'
}

/** Content for an ad testimonial. */
export type UpsellAdTestimonial = {
  __typename?: 'UpsellAdTestimonial';
  /** The author to attribute the testimonial to. */
  author?: Maybe<Scalars['String']['output']>;
  /** The url of the image to show. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The text of the testimony. */
  testimony?: Maybe<Scalars['String']['output']>;
  /** The amount of weight lost. */
  weightLostInKg?: Maybe<Scalars['Int']['output']>;
};

export enum UpsellAdType {
  /** Used for ads to purchase the baseline Healthy Weight program */
  HealthyWeight = 'HEALTHY_WEIGHT',
  /** Used for advertising ads to purchase med */
  Med = 'MED',
  /** No upsell ad id. */
  None = 'NONE',
  /** Used for advertising ads to purchase OTC products */
  Otc = 'OTC',
  /** Used for advertising ads to purchase premium */
  Premium = 'PREMIUM',
  /** Used for advertising ads to purchase premium plus is user is eligible for premium plus */
  PremiumPlus = 'PREMIUM_PLUS',
  /** Default status for enums. */
  Uknown = 'UKNOWN'
}

/** Input to update the active schedule for a CDU. */
export type UpsertActiveCduScheduledWorkHoursInput = {
  /** CDU access code for the coach. */
  cduAccessCode: Scalars['String']['input'];
  /** Whether the coach works on Friday. */
  friday: Scalars['Boolean']['input'];
  /** Whether the coach works on Monday. */
  monday: Scalars['Boolean']['input'];
  /** Whether the coach works on Saturday. */
  saturday: Scalars['Boolean']['input'];
  /** Whether the coach works on Sunday. */
  sunday: Scalars['Boolean']['input'];
  /** Whether the coach works on Thursday. */
  thursday: Scalars['Boolean']['input'];
  /** Whether the coach works on Tuesday. */
  tuesday: Scalars['Boolean']['input'];
  /** Whether the coach works on Wednesday. */
  wednesday: Scalars['Boolean']['input'];
  /** Per-weekday working hours for the schedule. */
  workingHours?: InputMaybe<WorkingHoursInput>;
};

/** Input to upsert a PTO record for a CDU. */
export type UpsertCduPersonalTimeOffInput = {
  /** CDU access code for the coach. */
  cduAccessCode: Scalars['String']['input'];
  /** PTO end date. */
  dateEnded: Scalars['LocalDate']['input'];
  /** PTO start date. */
  dateStarted: Scalars['LocalDate']['input'];
  /** PTO record ID for updates; omit for new records. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Tracks the user's challenge capacity and restrictions. */
export type Usage = {
  __typename?: 'Usage';
  /** Current number of active challenges the user has */
  activeCount: Scalars['Int']['output'];
  /**
   * Whether the user can start a new challenge.
   * False if they've reached the maximum number of active challenges or other restrictions apply.
   */
  canStartNewChallenge: Scalars['Boolean']['output'];
  /** Maximum number of active challenges allowed */
  maxCount: Scalars['Int']['output'];
};

/**
 * Per-action availability for surfaces that list users the requestor can act on
 * (contact matches, friend suggestions, search results, etc.).
 *
 * Concept guide: noom_contracts/social/USER_ACTION_MODEL.md (in noom-contracts repo).
 *
 * ## Three status categories
 *
 * 1. AVAILABLE — action may be taken.
 * 2. FRIENDS_* (zone) — friends relationship phase: this action is not the right
 *    next step (wait, respond with a different action, or done). Not a block.
 *    Only with ADD_FRIEND.
 * 3. UNAVAILABLE — action may not be taken due to a *restriction or policy*; see reason on UserActionState.
 *    Do not use for pending/established friendship — use FRIENDS_*.
 *
 * UI copy lives in product/stories, not in this schema. Enum descriptions are semantics only.
 */
export enum UserAction {
  /** Send a friend request to the target user. */
  AddFriend = 'ADD_FRIEND'
}

/**
 * One action's availability toward a target user. Lookup by action in actions[]; order is
 * not significant. reason is present only when status is UNAVAILABLE.
 */
export type UserActionState = {
  __typename?: 'UserActionState';
  /** The action this state describes. */
  action: UserAction;
  /** Present when status is UNAVAILABLE (detail). Absent for AVAILABLE and FRIENDS_*. */
  reason?: Maybe<UserActionUnavailableReason>;
  /** Whether the requestor may take this action; see UserActionStatus categories. */
  status: UserActionStatus;
};

/**
 * Whether a UserAction may be taken. See USER_ACTION_MODEL.md for decision trees.
 *
 * Generic (any action): AVAILABLE, UNAVAILABLE.
 * Friends zone (ADD_FRIEND only): FRIENDS_PENDING, FRIENDS_ESTABLISHED.
 * Future actions may add their own zone prefix (e.g. MESSAGING_*).
 */
export enum UserActionStatus {
  /** Generic: the action may be taken. */
  Available = 'AVAILABLE',
  /** Friends zone: an established friendship exists between the users. */
  FriendsEstablished = 'FRIENDS_ESTABLISHED',
  /** Friends zone: a pending friend request exists (either direction). */
  FriendsPending = 'FRIENDS_PENDING',
  /** Generic: the action cannot be taken due to a restriction or policy; see reason on UserActionState. */
  Unavailable = 'UNAVAILABLE'
}

/**
 * Why a UserAction is UNAVAILABLE. Forbidden/restricted/policy cases only — not friends
 * relationship phase (use FRIENDS_* statuses instead). Extensible across domains.
 */
export enum UserActionUnavailableReason {
  /** Unknown or unspecified unavailability reason. */
  Unknown = 'UNKNOWN'
}

/** Enumerates the policies that must be consented to */
export type UserConsentCheck = {
  __typename?: 'UserConsentCheck';
  /** Will be null if user consents are up-to-date */
  prompt?: Maybe<UserConsentInterstitial>;
  /** Will be empty if consents are up-to-date */
  requiredConsents: Array<Policy>;
};

/** Backend-driven content for home screen interstitial */
export type UserConsentInterstitial = {
  __typename?: 'UserConsentInterstitial';
  /** Markdown-formatted string containing links to the relevant policies */
  body: Scalars['String']['output'];
  positiveButtonText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** User-facing reasons for earning currency. */
export enum UserFacingReason {
  ArtBreakCompleted = 'ART_BREAK_COMPLETED',
  BodyScanned = 'BODY_SCANNED',
  CurriculumContentConsumed = 'CURRICULUM_CONTENT_CONSUMED',
  FacialBloodScanCompleted = 'FACIAL_BLOOD_SCAN_COMPLETED',
  FoodLogged = 'FOOD_LOGGED',
  FriendshipRelationCreated = 'FRIENDSHIP_RELATION_CREATED',
  FriendRewardShared = 'FRIEND_REWARD_SHARED',
  GreenCaloriesLogged = 'GREEN_CALORIES_LOGGED',
  GreenCalorieGoalAchieved = 'GREEN_CALORIE_GOAL_ACHIEVED',
  MedLogged = 'MED_LOGGED',
  MicroChallengeCompleted = 'MICRO_CHALLENGE_COMPLETED',
  MicroChallengeProgressed = 'MICRO_CHALLENGE_PROGRESSED',
  MoodLogged = 'MOOD_LOGGED',
  MoveLogged = 'MOVE_LOGGED',
  NoomcoinEarned = 'NOOMCOIN_EARNED',
  OnboardingStepsSeedsBanked = 'ONBOARDING_STEPS_SEEDS_BANKED',
  ProteinGoalAchieved = 'PROTEIN_GOAL_ACHIEVED',
  ProteinLogged = 'PROTEIN_LOGGED',
  StandaloneContentConsumed = 'STANDALONE_CONTENT_CONSUMED',
  StepsGoalAchieved = 'STEPS_GOAL_ACHIEVED',
  StepsGoalSeedsBanked = 'STEPS_GOAL_SEEDS_BANKED',
  StepsSeedsBanked = 'STEPS_SEEDS_BANKED',
  StreakMilestoneReached = 'STREAK_MILESTONE_REACHED',
  StressLogged = 'STRESS_LOGGED',
  Unknown = 'UNKNOWN',
  WaterLogged = 'WATER_LOGGED',
  WeighInCompleted = 'WEIGH_IN_COMPLETED'
}

export type UserGoal = {
  __typename?: 'UserGoal';
  enabled: Scalars['Boolean']['output'];
  goalId: GoalId;
  metadata?: Maybe<GoalMetadata>;
  userGoalId: Scalars['String']['output'];
};

export type UserGoalList = {
  __typename?: 'UserGoalList';
  userGoalList: Array<UserGoal>;
};

export type UserGoalPatch = {
  /** The source of user steps goal upsert action. If empty, then the action source will be empty in noom events */
  actionSource?: InputMaybe<UserGoalUpsertActionSource>;
  /** If true, then enable the tool; if false, then disable it. If empty, the enablement of the tool won't be affected */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The updated list of days of the week on which the goal is scheduled */
  scheduleDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  /** The new value that the goal target should have. If empty, then the target won't be affected */
  target?: InputMaybe<GoalTarget>;
};

/**
 *  These values should be aligned with:
 *  - shared.proto (GoalsEnumsProto.UserGoalUpsertActionSourceEnumProto.ActionSource)
 */
export enum UserGoalUpsertActionSource {
  Automated = 'AUTOMATED',
  Default = 'DEFAULT',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

/**
 * Represents a user's instance of a micro challenge.
 * This is a user-specific instance linking to the challenge definition.
 */
export type UserMicroChallenge = {
  __typename?: 'UserMicroChallenge';
  /**
   * Whether the user can record progress for the currently selected date.
   * False if the user has already recorded progress for that date or if the challenge is not active.
   * Used to enable/disable the "Did it" button in the UI.
   * @deprecated Use microChallenge.availableActions.start.isEnabled instead
   */
  canRecordProgress: Scalars['Boolean']['output'];
  /**
   * The date when the challenge was completed (user's local date).
   * Only present when status is COMPLETED.
   */
  completedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Current progress value (e.g., number of days completed) */
  currentProgress: Scalars['Int']['output'];
  /**
   * When the challenge ends (user's local date)
   * Used to calculate days remaining
   */
  endDate: Scalars['LocalDate']['output'];
  /**
   * The micro challenge definition (template) that this instance is based on
   * @deprecated Use instance fields from MicroChallenge.userContext.latestState; avoid nesting microChallenge on UserMicroChallenge.
   */
  microChallenge: MicroChallenge;
  /**
   * The user's personal recipe for this challenge.
   * Null when the challenge has no recipe.
   */
  recipe?: Maybe<UserMicroChallengeRecipe>;
  /** Current status of the challenge */
  status: MicroChallengeStatus;
  /**
   * Target progress needed for completion (e.g., number of required success days).
   * @deprecated Use microChallenge.targetProgress instead. This field is duplicated here for backwards compatibility.
   * @deprecated Use microChallenge.targetProgress instead
   */
  targetProgress: Scalars['Int']['output'];
  /** Unique identifier for this user's challenge instance */
  userMicroChallengeId: Scalars['UUID']['output'];
};

/**
 * A user's personal recipe for a micro challenge.
 * Separate from MicroChallengeRecipe (template-level) so user instances
 * can evolve independently.
 */
export type UserMicroChallengeRecipe = {
  __typename?: 'UserMicroChallengeRecipe';
  /** Unique identifier for this user recipe */
  id: Scalars['String']['output'];
  /** Ordered steps that define this user's recipe */
  steps: Array<UserMicroChallengeRecipeStep>;
  /** ID of the template recipe this was derived from */
  templateRecipeId: Scalars['String']['output'];
};

/** A step within a user's personal recipe instance. */
export type UserMicroChallengeRecipeStep = {
  __typename?: 'UserMicroChallengeRecipeStep';
  /** Unique identifier for this recipe step */
  id: Scalars['String']['output'];
  /** The part of the recipe this step belongs to */
  partType: MicroChallengeRecipePartType;
  /**
   * Step configuration data.
   * Null when the step has no payload.
   */
  payload?: Maybe<MicroChallengeRecipeStepPayload>;
  /** Position of this step in the recipe ordering */
  position: Scalars['Int']['output'];
};

export type UserModelSegment = {
  __typename?: 'UserModelSegment';
  /** User who created the segment */
  creator: Scalars['String']['output'];
  /** Segment's description */
  description?: Maybe<Scalars['String']['output']>;
  /** Segment ID */
  id: Scalars['ID']['output'];
  /** Whether the segment has been archived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the segment is locked for editing */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Segment name */
  name: Scalars['String']['output'];
  /** Server time created */
  serverTimeCreated?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Server time updated */
  serverTimeUpdated?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type UserModelSegments = {
  __typename?: 'UserModelSegments';
  segments: Array<UserModelSegment>;
};

/**  A record of the user's decision for a given policy */
export type UserPolicyOption = {
  __typename?: 'UserPolicyOption';
  accessCode: Scalars['String']['output'];
  /**  The specific policy the user acted upon */
  policy: Policy;
  /**  The user's response for the policy */
  status: PolicyOptionStatus;
};

/** Response containing multiple user preview profiles */
export type UserPreviewProfilesBatchResponse = {
  __typename?: 'UserPreviewProfilesBatchResponse';
  /** List of user preview profiles */
  profiles: Array<NoomUserPreviewProfile>;
};

/** Content for a single tile in the user portal homepage ad placement. */
export type UserportalHomePageContent = {
  __typename?: 'UserportalHomePageContent';
  /** The CTA button for the content block. */
  button?: Maybe<Button>;
  /** The text of the disclaimer, if applicable. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The text of the header pill. */
  heading?: Maybe<Scalars['String']['output']>;
  /** The url of the image to show in the header pill. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The text content of the banner. */
  subtitle: Scalars['String']['output'];
  /** The title of the content block. */
  title: Scalars['String']['output'];
};

/** Represents a URL that directs users to a utility flow within the application */
export type UtilityEntryPoint = {
  __typename?: 'UtilityEntryPoint';
  /** The address of the utility flow page */
  url: Scalars['String']['output'];
};

/** Identifies the application surface requesting utility entry points. */
export enum UtilityEntryPointSurface {
  FriendsPromo = 'FRIENDS_PROMO',
  ProfileSettings = 'PROFILE_SETTINGS',
  StreakPromo = 'STREAK_PROMO',
  Unknown = 'UNKNOWN'
}

/** Configuration containing entry points for utility flows within the mobile application */
export type UtilityEntryPointsConfig = {
  __typename?: 'UtilityEntryPointsConfig';
  /** Entry point for the add phone number account settings flow */
  addPhoneNumber: UtilityEntryPoint;
};

/** The response from an address validation request. */
export type ValidateAddressResponse = {
  __typename?: 'ValidateAddressResponse';
  /**
   * The validated address, potentially corrected. If invalid,
   * this returned address may not be populated and should not
   * be used.
   */
  address: ValidationAddress;
  /**
   * If the ValidationStatus is RECOMMENDED_FIX or INVALID, this
   * will be populated with the reason(s) that the validation failed.
   * This will not be populated if the address is VALID or CORRECTED.
   */
  errorReasons?: Maybe<Array<ValidationErrorReason>>;
  /** The validation status of the input address. */
  status: ValidationStatus;
  /** The validation service that was used for this request. */
  validationService: ValidationService;
};

/** A postal address used for validation purposes. */
export type ValidationAddress = {
  __typename?: 'ValidationAddress';
  /** The first address line, typically street number and street. */
  addressLine1: Scalars['String']['output'];
  /** The second address line, often for an apartment or house number. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city or town */
  city: Scalars['String']['output'];
  /** A 2-character country code using ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['output'];
  /** The zip code in the U.S. or other postal code */
  postalCode: Scalars['String']['output'];
  /** The state, region, or province */
  zoneCode: Scalars['String']['output'];
};

/** The postal address input for validation purposes. */
export type ValidationAddressInput = {
  /** The first address line, typically street number and street. */
  addressLine1: Scalars['String']['input'];
  /** The second address line, often for an apartment or house number. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city or town */
  city: Scalars['String']['input'];
  /** A 2-character country code using ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['input'];
  /** The zip code in the U.S. or other postal code */
  postalCode: Scalars['String']['input'];
  /** The state, region, or province */
  zoneCode: Scalars['String']['input'];
};

/** The reason an address validation failed. */
export type ValidationErrorReason = {
  __typename?: 'ValidationErrorReason';
  /** The reason. */
  reason?: Maybe<Reason>;
};

/** The external service used to perform the validation. */
export enum ValidationService {
  /**
   * Legacy USA address validation service. Also known as Thomson Reuters,
   * which acquired Sabrix.
   */
  Sabrix = 'SABRIX',
  /**
   * Legacy CA and International address validation service.
   * https://www.serviceobjects.com/
   */
  ServiceObjects = 'SERVICE_OBJECTS',
  /** https://www.smarty.com/docs/cloud/us-street-api */
  SmartyUsStreetApi = 'SMARTY_US_STREET_API'
}

/** The status of the validated address. */
export enum ValidationStatus {
  /**
   * The address passed in was automatically corrected by our validation
   * service, and the resulting address is valid.
   */
  Corrected = 'CORRECTED',
  /**
   * This address passed in was invalid and the user must input a valid
   * address. The user is blocked from proceeding.
   */
  Invalid = 'INVALID',
  /**
   * The address passed in had some issues with our validation, but the
   * address may still be valid. We will provide some recommended fixes that
   * the user can apply, but do not block the user from proceeding.
   */
  RecommendedFix = 'RECOMMENDED_FIX',
  /** The address passed in was completely valid. */
  Valid = 'VALID'
}

export type ValidicAttributionDataInput = {
  /** Manufacturer of the device. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model of the device. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the device. */
  sourceIdentifier: Scalars['String']['input'];
  /** Human-readable name of the source. */
  sourceName: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

/**
 * Variant of ValidicAttributionDataInput with all fields optional for matching.
 * Keep in sync with ValidicAttributionDataInput.
 */
export type ValidicAttributionDataMatchInput = {
  /** Manufacturer of the device. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model of the device. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the device. */
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name of the source. */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ValidicV2AttributionDataInput = {
  /** Manufacturer of the device. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model of the device. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the device. */
  sourceIdentifier: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

/**
 * Variant of ValidicV2AttributionDataInput with all fields optional for matching.
 * Keep in sync with ValidicV2AttributionDataInput.
 */
export type ValidicV2AttributionDataMatchInput = {
  /** Manufacturer of the device. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model of the device. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the device. */
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a value proposition for the health report upsell. */
export type ValueProps = {
  __typename?: 'ValueProps';
  /** Represents the image to be shown as part of the value proposition. */
  imageUrl: Scalars['String']['output'];
  /** Text explaining the value proposition. */
  text: Scalars['String']['output'];
};

export type WaterData = {
  __typename?: 'WaterData';
  measurementCivilDate: Scalars['LocalDate']['output'];
  waterInLiters: Scalars['Float']['output'];
};

export type WaterDataInput = {
  measurementCivilDate: Scalars['LocalDate']['input'];
  waterInLiters: Scalars['Float']['input'];
};

export type WaterGoalMetadata = {
  __typename?: 'WaterGoalMetadata';
  minWaterInLiters?: Maybe<Scalars['Float']['output']>;
};

export type WaterLoggingPayload = {
  __typename?: 'WaterLoggingPayload';
  targetInLiters: Scalars['Float']['output'];
};

export type WaterTarget = {
  minWaterInLiters?: InputMaybe<Scalars['Float']['input']>;
};

export type WeightData = {
  __typename?: 'WeightData';
  loggedInSignupFlow?: Maybe<Scalars['Boolean']['output']>;
  measurementCivilDate: Scalars['LocalDate']['output'];
  weightInKg: Scalars['Float']['output'];
};

export type WeightDataInput = {
  loggedInSignupFlow?: InputMaybe<Scalars['Boolean']['input']>;
  measurementCivilDate: Scalars['LocalDate']['input'];
  weightInKg: Scalars['Float']['input'];
};

/** Content for the bottom screen in weight graph flow. */
export type WeightGraphBottomScreen = {
  __typename?: 'WeightGraphBottomScreen';
  /** Primary button to respond to the bottom screen. */
  buttonFirst?: Maybe<Button>;
  /** Optional second button for the bottom screen. */
  buttonSecond?: Maybe<Button>;
  /** Text to display on the bottom screen. */
  text?: Maybe<Scalars['String']['output']>;
  /** Title of the bottom screen. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content for an ad that appears after the user logs a weigh in. */
export type WeightGraphContent = {
  __typename?: 'WeightGraphContent';
  /** The initial screen to show to the user. */
  initialScreenId: Scalars['String']['output'];
  /** A list of screens that can be navigated by the user. */
  screens: Array<WeightGraphContentScreen>;
};

/** A screen in the weight graph content flow. */
export type WeightGraphContentScreen = {
  __typename?: 'WeightGraphContentScreen';
  /** The content of this screen. */
  content: WeightGraphContentScreenContent;
  /** Id for this screen. */
  screenId: Scalars['String']['output'];
};

/** Union type for different weight graph screen content types. */
export type WeightGraphContentScreenContent = WeightGraphBottomScreen | WeightGraphPlateauAd | WeightGraphResourcesScreen;

/** Content for displaying a meal feedback screen upsell ad. */
export type WeightGraphInlineContent = {
  __typename?: 'WeightGraphInlineContent';
  /** Button configuration for the weight graph screen upsell ad. */
  button?: Maybe<Button>;
  /** Heading to display on the weight graph screen upsell ad. */
  heading: Scalars['String']['output'];
  /** URL of the image to display on the weight graph screen upsell ad. */
  imageUrl: Scalars['String']['output'];
  /** Text to display on the weight graph screen upsell ad. */
  text: Scalars['String']['output'];
};

/** Content for the plateau ad in weight graph flow. */
export type WeightGraphPlateauAd = {
  __typename?: 'WeightGraphPlateauAd';
  /** Button on the bottom left of the plateau ad. */
  buttonLeft?: Maybe<Button>;
  /** Button on the bottom right of the plateau ad. */
  buttonRight?: Maybe<Button>;
  /** Heading to display on the plateau ad. */
  heading?: Maybe<Scalars['String']['output']>;
  /** URL of the image for the plateau ad. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Date we advertise the medication weight can be achieved on. */
  medWeightDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Weight we advertise the user can achieve with medication. */
  medWeightInKg?: Maybe<Scalars['Float']['output']>;
  /** Text to place on the plateau ad. */
  text?: Maybe<Scalars['String']['output']>;
  /** Title to place on the plateau ad. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content for the resources screen in weight graph flow. */
export type WeightGraphResourcesScreen = {
  __typename?: 'WeightGraphResourcesScreen';
  /** List of plateau resources available. */
  resources: Array<PlateauResource>;
  /** Subtitle of the resources screen. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the resources screen. */
  title?: Maybe<Scalars['String']['output']>;
};

export type WeightMedsSnapshot = {
  __typename?: 'WeightMedsSnapshot';
  body?: Maybe<Scalars['String']['output']>;
  ctaTitle: Scalars['String']['output'];
  /** Encouragement text should be sent as markdown. Deep Links use supported. */
  encouragementMarkdown?: Maybe<Scalars['String']['output']>;
  graph: AnnotatedMeasurementTrendChart;
  headerAnimation: HeaderAnimation;
  sideEffectsSection?: Maybe<SideEffectsSection>;
  title: Scalars['String']['output'];
};

/** Input parameters specific to the Weight Revamp feature set. */
export type WeightRevampInput = {
  /** Placeholder field (weight revamp has no feature-specific input params) */
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Weight Revamp-specific opt-in details. */
export type WeightRevampOptInDetails = {
  __typename?: 'WeightRevampOptInDetails';
  /** Days to wait after opt-in interstitial dismissal before showing again (0 = do not repeat) */
  optInInterstitialPostponeDays: Scalars['Int']['output'];
};

/** Working hours time ranges for each weekday. */
export type WorkingHours = {
  __typename?: 'WorkingHours';
  /** Friday end time in local time. */
  fridayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Friday start time in local time. */
  fridayStartTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Monday end time in local time. */
  mondayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Monday start time in local time. */
  mondayStartTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Saturday end time in local time. */
  saturdayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Saturday start time in local time. */
  saturdayStartTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Sunday end time in local time. */
  sundayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Sunday start time in local time. */
  sundayStartTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Thursday end time in local time. */
  thursdayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Thursday start time in local time. */
  thursdayStartTime?: Maybe<Scalars['LocalTime']['output']>;
  /** IANA timezone identifier for the working hours. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Tuesday end time in local time. */
  tuesdayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Tuesday start time in local time. */
  tuesdayStartTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Wednesday end time in local time. */
  wednesdayEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Wednesday start time in local time. */
  wednesdayStartTime?: Maybe<Scalars['LocalTime']['output']>;
};

export type WorkingHoursInput = {
  /** Friday end time in local time. */
  fridayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Friday start time in local time. */
  fridayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Monday end time in local time. */
  mondayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Monday start time in local time. */
  mondayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Saturday end time in local time. */
  saturdayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Saturday start time in local time. */
  saturdayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Sunday end time in local time. */
  sundayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Sunday start time in local time. */
  sundayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Thursday end time in local time. */
  thursdayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Thursday start time in local time. */
  thursdayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** IANA timezone identifier for the working hours. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Tuesday end time in local time. */
  tuesdayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Tuesday start time in local time. */
  tuesdayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Wednesday end time in local time. */
  wednesdayEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** Wednesday start time in local time. */
  wednesdayStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type AssessmentPrivacyPolicyQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  assessmentType: HealthMetricSource;
}>;


export type AssessmentPrivacyPolicyQuery = { __typename?: 'Query', assessmentPrivacyPolicy: Policy };

export type FacialBloodScanIntroMetadataQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type FacialBloodScanIntroMetadataQuery = { __typename?: 'Query', facialBloodScanIntroMetadata: { __typename?: 'FacialBloodScanIntroMetadata', facialBloodScanCount: number, hasDateOfBirth: boolean, hasCompletedQuestionnaire?: boolean | null } };

export type GenerateInviteFriendLinkMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
}>;


export type GenerateInviteFriendLinkMutation = { __typename?: 'Mutation', generateInviteFriendLink: { __typename?: 'InviteFriendLink', code: string, link: string } };

export type GetRelationConsentsQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  queries: Array<GetRelationConsentsQueryInput> | GetRelationConsentsQueryInput;
}>;


export type GetRelationConsentsQuery = { __typename?: 'Query', getRelationConsents: { __typename?: 'RelationConsentsList', consents: Array<{ __typename?: 'Consent', userAccessCode: string, consentType: string, status: ConsentStatus, qualifier?: string | null, defaultBehavior: ConsentStatus }> } };

export type Glp1CompanionMedicationListQueryVariables = Exact<{
  context: Glp1CompanionMedicationContext;
}>;


export type Glp1CompanionMedicationListQuery = { __typename?: 'Query', glp1CompanionMedicationList: { __typename?: 'Glp1CompanionMedicationList', medications: Array<{ __typename?: 'Glp1CompanionMedication', medicationGroup: Glp1CompanionMedicationGroup, medicationExternalId?: string | null, medicationName: string }> } };

export type UpdateGlp1CompanionMedicationMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  trackedMedicationExternalId: Scalars['String']['input'];
  glp1MedicationStartedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
}>;


export type UpdateGlp1CompanionMedicationMutation = { __typename?: 'Mutation', updateGlp1CompanionMedication: { __typename?: 'Glp1CompanionMedicationResponse', trackedMedicationExternalId: string, glp1MedicationStartedDate?: string | null } };

export type HealthReportQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type HealthReportQuery = { __typename?: 'Query', healthReport: { __typename?: 'HealthReport', dateOfLastAssessment: string, assessments?: Array<{ __typename?: 'Assessment', assessmentId?: string | null, assessmentType?: HealthMetricSource | null }> | null, heartHealth?: { __typename?: 'HealthPillarReport', name: HealthPillarName, status?: HealthStatus | null, sections: Array<{ __typename?: 'HealthPillarSection', name: HealthPillarSectionName, metrics: Array<{ __typename?: 'HealthMetric', name: HealthMetricName, latestMetricValue: { __typename?: 'HealthMetricValue', value?: number | null, unit?: HealthMetricUnit | null, status?: HealthStatus | null, timestamp: string }, detail: { __typename?: 'HealthMetricDetail', source?: HealthMetricSource | null, weight?: number | null, healthLabels: Array<{ __typename?: 'HealthLabelRange', status: HealthStatus, min?: number | null, max?: number | null, unit?: HealthMetricUnit | null }> } }> }> } | null, metabolicHealth?: { __typename?: 'HealthPillarReport', name: HealthPillarName, status?: HealthStatus | null, sections: Array<{ __typename?: 'HealthPillarSection', name: HealthPillarSectionName, metrics: Array<{ __typename?: 'HealthMetric', name: HealthMetricName, latestMetricValue: { __typename?: 'HealthMetricValue', value?: number | null, unit?: HealthMetricUnit | null, status?: HealthStatus | null, timestamp: string }, detail: { __typename?: 'HealthMetricDetail', source?: HealthMetricSource | null, weight?: number | null, healthLabels: Array<{ __typename?: 'HealthLabelRange', status: HealthStatus, min?: number | null, max?: number | null, unit?: HealthMetricUnit | null }> } }> }> } | null, bodyAgeReport?: { __typename?: 'BodyAgeReport', bodyAge: number, realAge: number, trendSinceLastScan?: { __typename?: 'Trend', direction: TrendDirection, delta?: number | null } | null } | null } };

export type UpsellAdDataListQueryVariables = Exact<{
  accessCode: Scalars['String']['input'];
  adLocation?: InputMaybe<UpsellAdLocation>;
}>;


export type UpsellAdDataListQuery = { __typename?: 'Query', upsellAdDataList: { __typename?: 'UpsellAdDataList', upsellAdData: Array<{ __typename?: 'UpsellAdData', upsellAdType: UpsellAdType, upsellAdLocation: UpsellAdLocation, upsellAdIdentifier: string, content?: { __typename: 'CrossSellPitchContent', title: string, badgeText: string, benefits: Array<string>, headerImageUrl?: string | null, primaryButton?: { __typename?: 'Button', text: string, target: string, style?: ButtonStyle | null, size?: ButtonSize | null } | null, secondaryButton?: { __typename?: 'Button', text: string, target: string, style?: ButtonStyle | null, size?: ButtonSize | null } | null } | { __typename: 'HealthReportUpsellContent', productName: string, startsAtPriceText: string, disclaimers: Array<string>, healthReportUpsellPageTitle?: string | null, healthReportUpsellPageSubtitle?: string | null, headerImageUrl?: string | null, learnMorePageTitle: string, upsellAdUrl?: string | null, appendixText?: string | null, primaryButton?: { __typename?: 'Button', text: string, target: string, style?: ButtonStyle | null, size?: ButtonSize | null } | null, secondaryButton?: { __typename?: 'Button', text: string, target: string, style?: ButtonStyle | null, size?: ButtonSize | null } | null, biologicalAgeInfo?: { __typename?: 'HealthMetricUpsellBiologicalAge', currentAge: number, healthyBmiAge: number, faceScanAge?: number | null } | null, valueProps: Array<{ __typename?: 'ValueProps', imageUrl: string, text: string }>, healthMetricsOverview: Array<{ __typename?: 'HealthMetricOverviewContent', metricClaimFraming: string, arrowImageUrl: string }>, healthMetricUpsellContentGroups: Array<{ __typename?: 'HealthMetricUpsellLearnMoreContentGroup', subtitle: string, metrics: Array<{ __typename?: 'HealthMetricUpsellLearnMoreContent', metricType: HealthMetricName, label: HealthStatus, metricTitle: string, metricDescription: string, footnotes: string, labelDescription: string }> }> } | { __typename: 'HomeLargeContent' } | { __typename: 'HomeScreenCarouselTileContent' } | { __typename: 'MealFeedbackScreenContent' } | { __typename: 'ModuleLibraryUpsellContent' } | { __typename: 'NavigationButtonContent' } | { __typename: 'SideNavMenuSmallContent' } | { __typename: 'SuccessKitUpsellContent' } | { __typename: 'UserportalHomePageContent' } | { __typename: 'WeightGraphContent' } | { __typename: 'WeightGraphInlineContent' } | null }> } };

export type ProductSwitchOffersQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductSwitchOffersQuery = { __typename?: 'Query', productSwitchOffers: { __typename?: 'ProductSwitchOffersResponse', offers: Array<{ __typename?: 'ProductSwitchOffer', productName: string, switchOperation?: { __typename?: 'SwitchOperation', saleItemId: string, trialSaleItemId?: string | null, subscriptionModificationReason?: SubscriptionModificationReason | null, switchType: { __typename?: 'ImmediateSwitch', billingCycleBehavior: BillingCycleBehavior, prorationBehavior: ProrationBehavior, trialType: SwitchTrialType } | { __typename?: 'NextBillingCycleSwitch', revertBehavior: SwitchRevertBehavior } } | null }> } };

export type RecommendedBuyflowOffersQueryVariables = Exact<{
  input: RecommendedBuyflowOffersInput;
}>;


export type RecommendedBuyflowOffersQuery = { __typename?: 'Query', recommendedBuyflowOffers: { __typename?: 'RecommendedBuyflowOffersResponse', offers: Array<string>, recommendationId: string } };

export type SaveFacialBloodScanQuestionnaireMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: SaveFacialBloodScanQuestionnaireInput;
}>;


export type SaveFacialBloodScanQuestionnaireMutation = { __typename?: 'Mutation', saveQuestionnaire: boolean };

export type SetRelationConsentMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: SetRelationConsentInput;
}>;


export type SetRelationConsentMutation = { __typename?: 'Mutation', setRelationConsent: { __typename?: 'Consent', consentType: string, status: ConsentStatus, userAccessCode: string } };

export type SubmitConsentMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreedToPolicies: Array<Policy> | Policy;
}>;


export type SubmitConsentMutation = { __typename?: 'Mutation', submitConsent?: boolean | null };

export type ValidateAddressQueryVariables = Exact<{
  address: ValidationAddressInput;
  validationService?: InputMaybe<ValidationService>;
}>;


export type ValidateAddressQuery = { __typename?: 'Query', validateAddress: { __typename?: 'ValidateAddressResponse', status: ValidationStatus, validationService: ValidationService, address: { __typename?: 'ValidationAddress', addressLine1: string, addressLine2?: string | null, city: string, zoneCode: string, postalCode: string, countryCode: string }, errorReasons?: Array<{ __typename?: 'ValidationErrorReason', reason?: Reason | null }> | null } };

export type AutocompleteAddressQueryVariables = Exact<{
  queryString: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  autocompleteService?: InputMaybe<AutocompleteService>;
}>;


export type AutocompleteAddressQuery = { __typename?: 'Query', autocompleteAddress: { __typename?: 'AutocompleteAddressResponse', autocompleteService: AutocompleteService, addresses: Array<{ __typename?: 'AutocompleteAddress', fullAddress: string, addressLine1: string, addressLine2?: string | null, city: string, zoneCode: string, fullZoneCode: string, postalCode: string, countryCode: string, county?: string | null }> } };

export type ProductOffersQueryVariables = Exact<{
  input: ProductOffersInput;
}>;


export type ProductOffersQuery = { __typename?: 'Query', productOffers: { __typename?: 'ProductOffersResponse', offers: Array<{ __typename?: 'ProductOffer', productName: string, purchaseType: PurchaseType, orderOperation: { __typename?: 'PurchaseOperation', saleItemId: string, trialSaleItemId?: string | null, discountSummary?: { __typename?: 'OrderDiscountSummary', discounts: Array<{ __typename?: 'OrderDiscountEntry', promoCode?: string | null, b2bConsumerDiscountId?: number | null, discountEffect: { __typename?: 'OrderFixedDiscount', percentageDiscountConvertedToFixed: boolean, amount: { __typename?: 'Money', currencyCode: string, units: number, nanos?: number | null } } | { __typename?: 'OrderPercentageDiscount', percentage: string } }> } | null } | { __typename?: 'SwitchOperation', saleItemId: string, trialSaleItemId?: string | null, discountSummary?: { __typename?: 'OrderDiscountSummary', discounts: Array<{ __typename?: 'OrderDiscountEntry', promoCode?: string | null, b2bConsumerDiscountId?: number | null, discountEffect: { __typename?: 'OrderFixedDiscount', percentageDiscountConvertedToFixed: boolean, amount: { __typename?: 'Money', currencyCode: string, units: number, nanos?: number | null } } | { __typename?: 'OrderPercentageDiscount', percentage: string } }> } | null } }> } };


export const AssessmentPrivacyPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssessmentPrivacyPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HealthMetricSource"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentPrivacyPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"assessmentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentType"}}}]}]}}]} as unknown as DocumentNode<AssessmentPrivacyPolicyQuery, AssessmentPrivacyPolicyQueryVariables>;
export const FacialBloodScanIntroMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacialBloodScanIntroMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facialBloodScanIntroMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facialBloodScanCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasDateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedQuestionnaire"}}]}}]}}]} as unknown as DocumentNode<FacialBloodScanIntroMetadataQuery, FacialBloodScanIntroMetadataQueryVariables>;
export const GenerateInviteFriendLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateInviteFriendLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateInviteFriendLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<GenerateInviteFriendLinkMutation, GenerateInviteFriendLinkMutationVariables>;
export const GetRelationConsentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelationConsents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queries"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetRelationConsentsQueryInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRelationConsents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"queries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queries"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessCode"}},{"kind":"Field","name":{"kind":"Name","value":"consentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBehavior"}}]}}]}}]}}]} as unknown as DocumentNode<GetRelationConsentsQuery, GetRelationConsentsQueryVariables>;
export const Glp1CompanionMedicationListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Glp1CompanionMedicationList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Glp1CompanionMedicationContext"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"glp1CompanionMedicationList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicationGroup"}},{"kind":"Field","name":{"kind":"Name","value":"medicationExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"medicationName"}}]}}]}}]}}]} as unknown as DocumentNode<Glp1CompanionMedicationListQuery, Glp1CompanionMedicationListQueryVariables>;
export const UpdateGlp1CompanionMedicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGlp1CompanionMedication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackedMedicationExternalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"glp1MedicationStartedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGlp1CompanionMedication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackedMedicationExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackedMedicationExternalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"glp1MedicationStartedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"glp1MedicationStartedDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackedMedicationExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"glp1MedicationStartedDate"}}]}}]}}]} as unknown as DocumentNode<UpdateGlp1CompanionMedicationMutation, UpdateGlp1CompanionMedicationMutationVariables>;
export const HealthReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HealthReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateOfLastAssessment"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentId"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heartHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latestMetricValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"healthLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metabolicHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latestMetricValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"healthLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bodyAgeReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bodyAge"}},{"kind":"Field","name":{"kind":"Name","value":"realAge"}},{"kind":"Field","name":{"kind":"Name","value":"trendSinceLastScan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HealthReportQuery, HealthReportQueryVariables>;
export const UpsellAdDataListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpsellAdDataList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adLocation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsellAdLocation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsellAdDataList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"adLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adLocation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsellAdData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsellAdType"}},{"kind":"Field","name":{"kind":"Name","value":"upsellAdLocation"}},{"kind":"Field","name":{"kind":"Name","value":"upsellAdIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CrossSellPitchContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"badgeText"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"}},{"kind":"Field","name":{"kind":"Name","value":"headerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HealthReportUpsellContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"startsAtPriceText"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimers"}},{"kind":"Field","name":{"kind":"Name","value":"healthReportUpsellPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"healthReportUpsellPageSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"headerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"learnMorePageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"upsellAdUrl"}},{"kind":"Field","name":{"kind":"Name","value":"appendixText"}},{"kind":"Field","name":{"kind":"Name","value":"primaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"biologicalAgeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAge"}},{"kind":"Field","name":{"kind":"Name","value":"healthyBmiAge"}},{"kind":"Field","name":{"kind":"Name","value":"faceScanAge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueProps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthMetricsOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricClaimFraming"}},{"kind":"Field","name":{"kind":"Name","value":"arrowImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthMetricUpsellContentGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metricTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metricDescription"}},{"kind":"Field","name":{"kind":"Name","value":"footnotes"}},{"kind":"Field","name":{"kind":"Name","value":"labelDescription"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsellAdDataListQuery, UpsellAdDataListQueryVariables>;
export const ProductSwitchOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductSwitchOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSwitchOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"switchOperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saleItemId"}},{"kind":"Field","name":{"kind":"Name","value":"trialSaleItemId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionModificationReason"}},{"kind":"Field","name":{"kind":"Name","value":"switchType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImmediateSwitch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingCycleBehavior"}},{"kind":"Field","name":{"kind":"Name","value":"prorationBehavior"}},{"kind":"Field","name":{"kind":"Name","value":"trialType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NextBillingCycleSwitch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revertBehavior"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductSwitchOffersQuery, ProductSwitchOffersQueryVariables>;
export const RecommendedBuyflowOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendedBuyflowOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendedBuyflowOffersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendedBuyflowOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationId"}}]}}]}}]} as unknown as DocumentNode<RecommendedBuyflowOffersQuery, RecommendedBuyflowOffersQueryVariables>;
export const SaveFacialBloodScanQuestionnaireDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFacialBloodScanQuestionnaire"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveFacialBloodScanQuestionnaireInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveQuestionnaire"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SaveFacialBloodScanQuestionnaireMutation, SaveFacialBloodScanQuestionnaireMutationVariables>;
export const SetRelationConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetRelationConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetRelationConsentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setRelationConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessCode"}}]}}]}}]} as unknown as DocumentNode<SetRelationConsentMutation, SetRelationConsentMutationVariables>;
export const SubmitConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreedToPolicies"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Policy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"agreedToPolicies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreedToPolicies"}}}]}]}}]} as unknown as DocumentNode<SubmitConsentMutation, SubmitConsentMutationVariables>;
export const ValidateAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationAddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validationService"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"validationService"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validationService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationService"}}]}}]}}]} as unknown as DocumentNode<ValidateAddressQuery, ValidateAddressQueryVariables>;
export const AutocompleteAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutocompleteAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autocompleteService"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AutocompleteService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}}},{"kind":"Argument","name":{"kind":"Name","value":"autocompleteService"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autocompleteService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"fullZoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"county"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autocompleteService"}}]}}]}}]} as unknown as DocumentNode<AutocompleteAddressQuery, AutocompleteAddressQueryVariables>;
export const ProductOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOffersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseType"}},{"kind":"Field","name":{"kind":"Name","value":"orderOperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseOperation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saleItemId"}},{"kind":"Field","name":{"kind":"Name","value":"trialSaleItemId"}},{"kind":"Field","name":{"kind":"Name","value":"discountSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"b2bConsumerDiscountId"}},{"kind":"Field","name":{"kind":"Name","value":"discountEffect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPercentageDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFixedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDiscountConvertedToFixed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"nanos"}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwitchOperation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saleItemId"}},{"kind":"Field","name":{"kind":"Name","value":"trialSaleItemId"}},{"kind":"Field","name":{"kind":"Name","value":"discountSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"b2bConsumerDiscountId"}},{"kind":"Field","name":{"kind":"Name","value":"discountEffect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPercentageDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFixedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDiscountConvertedToFixed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"nanos"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductOffersQuery, ProductOffersQueryVariables>;